export type ChangeType =
  "feature" | "fix" | "improvement" | "breaking" | "security";

export type ChangeEntry = {
  type: ChangeType;
  text: string;
};

export type ChangelogVersion = {
  version: string;
  date: string;
  entries: ChangeEntry[];
};

export const changelogData: ChangelogVersion[] = [
  {
    version: "0.0.313",
    date: "2026-10-06",
    entries: [
      {
        type: "feature",
        text: "Маркиране: при „Въвеждане на брой гости“ = „При нова маса“ горе вдясно на картата на масата стои иконка с човече и броят гости (след името на сервитьора, когато то се вижда). При „При закриване“ и „Не“ иконката я няма.",
      },
      {
        type: "feature",
        text: "Справка сметки: нова колона „Брой гости“ — сортира се, а в реда „Общо“ е сборът на гостите за целия период; излиза и в Excel.",
      },
      {
        type: "feature",
        text: "Справка „Клиенти“: нова колона „Брой гости“ с филтър „от–до“, сбор в реда „Общо“ и в Excel.",
      },
    ],
  },
  {
    version: "0.0.312",
    date: "2026-10-06",
    entries: [
      {
        type: "feature",
        text: "Конфигурация → Маркиране → „Маси“: нова настройка „Въвеждане на брой гости“ — „Не“, „При нова маса“ или „При закриване“. Под избора стои скица „Поток на масата“, която показва къде се пита за гостите.",
      },
      {
        type: "feature",
        text: "Маркиране: нов модал „Брой гости“ с − / + и бърз избор от 1 до 8 (от клавиатурата: цифра за бърз избор, ↑ ↓ за промяна, Enter и Esc). При „При нова маса“ излиза преди модала „Нова маса“ (и преди бързото отваряне), при „При закриване“ — преди модала „Закрий“. Модалът е задължителен: с „Отказ“ масата не се отваря, съответно не се закрива. Броят се пази по сметката. В локален режим (без интернет) не се пита.",
      },
    ],
  },
  {
    version: "0.0.311",
    date: "2026-10-06",
    entries: [
      {
        type: "improvement",
        text: "Конфигурация → Устройства → POS принтер: нов модал за добавяне и редакция с две отделни секции — „Документи от касата“ (кои работни точки и потребители печатат бележките си тук) и „Кухненски билети“ (кои станции печатат тук и на какъв език). „Неактивно“ вече е в секцията с документите и казва ясно, че при запазване се махат само акаунтите, а кухненските билети по станции продължават да се печатат; докато е изключено, списъкът с акаунти е заключен — първо се включва „Активно“. Името се редактира направо в заглавието (и с моливчето до него).",
      },
      {
        type: "feature",
        text: "POS принтер → „Документи от касата“: списъкът с акаунти има търсене, филтри „Всички / Работни точки / Потребители / Избрани“, „Избери показаните“ и „Изчисти“; акаунт, който вече печата на друг POS принтер, стои най-долу с името на принтера. Нов превключвател „Всички акаунти“ закача всички свободни работни точки и потребители наведнъж (записват се свободните в момента на запазване). В „Кухненски билети“ има пример на билета на избрания език.",
      },
      {
        type: "improvement",
        text: "POS принтер на телефон: модалът е на цял екран, двете секции са раздели „Документи“ и „Кухня“ с броя на избраните, списъкът с акаунти тече със страницата (по един ред на акаунт), а филтрите са на един ред с хоризонтален скрол. На компютър под секциите стои обобщение „Документи: … · Кухненски билети: …“.",
      },
      {
        type: "improvement",
        text: "Конфигурация → Устройства → Фискален принтер: нов модал за добавяне и редакция в стила на POS принтера — името се редактира в заглавието, а на компютър трите секции стоят една до друга и се събират без скрол: „Касови бележки“ (кои работни точки и потребители фискализират тук, „Активно“/„Неактивно“), „Методи на плащане“ (слот на устройството, „БЕЗ ФИСКАЛИЗИРАНЕ“ или „Не се ползва“ за всеки метод, с броя на фискализираните) и „Касова бележка“ („Обобщени касови бележки“ с пример и „Нефискално копие на ПОС“). Списъкът с акаунти има търсене и филтри, а заетият на друго фискално устройство показва името му. Поведението не е сменено: при „Неактивно“ изборът на акаунт пак включва устройството, предупреждението казва кои акаунти ще паднат и има „Отмени“.",
      },
      {
        type: "improvement",
        text: "Фискален принтер на телефон: модалът е на цял екран с раздели „Акаунти“, „Плащане“ и „Бележка“; на таблет секциите са една под друга.",
      },
      {
        type: "improvement",
        text: "POS принтер на компютър: модалът се събира без скрол — заглавията на секциите са като при фискалния принтер (без подзаглавия), примерът с бележките е махнат, всички станции се виждат по 4 на ред (пълното име — при посочване). Обяснението до примерния кухненски билет е от истинските данни: името на принтера и станциите му, друг POS принтер със станциите му и дали поръчката се разделя на два билета.",
      },
      {
        type: "improvement",
        text: "Конфигурация → Устройства → Терминал за плащане: нов модал за добавяне и редакция в стила на POS и фискалния принтер — името се редактира в заглавието, секция „Картови плащания“ със списъка на работните точки и потребителите (търсене, филтри, „Избери показаните“, „Изчисти“; акаунт на друг терминал показва името му), обобщение във футъра; на компютър се събира без скрол, на телефон е на цял екран. Поведението не е сменено.",
      },
    ],
  },
  {
    version: "0.0.310",
    date: "2026-10-06",
    entries: [
      {
        type: "fix",
        text: "Склад → изписване и прехвърляне от избрана партида: ако партидата не стига (или е намаляла заради документ със задна дата), се взима първо цялата партида, а остатъкът — по FIFO от другите партиди. Досега остатъкът „увисваше“ извън партидите: наличността намаляваше, а партидите — не, следващото изписване ползваше стока, която я няма, а инвентаризация без разлика показваше липса. Цената на реда в листа се смята по същия начин.",
      },
      {
        type: "fix",
        text: "Склад → прехвърляне: стоката в получателя е на цената, на която е излязла от източника — и след корекция на доставна цена, анулиране или документ със задна дата (партидите в получателя се преизчисляват заедно с източника, а избраната от тях партида при изписване се запазва). Досега получателят оставаше със стойността от момента на прехвърлянето, а при прехвърляне със задна дата в ден с по-късно изписване можеше да получи друга партида от тази, която реално е излязла.",
      },
      {
        type: "fix",
        text: "Склад: две операции по един продукт в една и съща секунда (изписване и прехвърляне, автоматичният брак от сторно по време на ръчно изписване, две разнасяния на един отчет) вече се изпълняват една след друга — втората вижда наличността след първата и при недостиг отказва с „Недостатъчна наличност“. Досега и двете можеха да минат проверката: наличността излизаше на минус или „Наличности“ показваше грешно количество до следващата операция по продукта. Ако другата операция не приключи до 30 секунди: „Складът записва друга операция със същите продукти — опитайте отново“.",
      },
    ],
  },
  {
    version: "0.0.309",
    date: "2026-10-06",
    entries: [
      {
        type: "feature",
        text: "Склад → „Наличности“: ново поле „Към дата“ до склада — показва количествата към края на избран минал ден (празно = днес). Над таблицата и в Excel пише „Количества към края на … · стойности по текущи цени“: количествата са преизчислени по документите, които са активни сега, а Нето/Бруто са по днешните цени. Складовата карта на продукта се отваря с последните 30 дни до тази дата и партидите към нея. За наличността точно преди конкретен отчет — складовата карта на продукта, „Всички“ движения, салдото преди първото движение на отчета.",
      },
      {
        type: "improvement",
        text: "Склад → „Наличности“: количествата са подравнени по десетичната запетая и мерните единици започват на една линия, независимо от знаците на мярката (бр, кг, л…) и дължината на името ѝ. Дългите заглавия („Посл. доставна цена“) се пренасят на два реда, вместо да се застъпват, а „продадени без наличност“ остава в колоната си.",
      },
      {
        type: "improvement",
        text: "Склад → „Разнесени отчети“: справката се отваря на „Разнесени“, бутоните са „Разнесени / Анулирани / Всички“, а „Изчисти“ показва всички. Надписът „Общо за периода“ стои точно пред сумите (и в „Прехвърляния“, „Изписвания“, „Инвентаризации“), а „· без анулирани“ пише само когато в списъка има анулирани.",
      },
      {
        type: "improvement",
        text: "Склад → доставка: при „Запиши доставката“ (или Ctrl+Enter) с празна цена, количество, склад, партида или срок курсорът отива в първото празно поле на екрана, празните полета стават червени, а съобщението казва кои продукти са („Въведете ед. цена за: …“). Изрично въведената цена 0 и цената, изведена от Нето/Бруто, не се броят за празни. Важи и на телефон.",
      },
    ],
  },
  {
    version: "0.0.308",
    date: "2026-10-05",
    entries: [
      {
        type: "improvement",
        text: "Маркиране → търсене в каталога (компютър): след „+“ търсачката се зачиства и списъкът застава веднага на продукта, без превъртане. Досега при голямо меню (стотици продукти) списъкът се превърташе плавно през цялото меню до продукта, а на компютри с изключени анимации скачаше веднага — затова изглеждаше различно на различните машини. Същото важи и в редактора на обедно меню.",
      },
      {
        type: "fix",
        text: "Маркиране → търсене в каталога (компютър): клик с мишката на „+“, „−“ или върху ред, който не е първият резултат от търсенето, оставя фокуса и избора на цъкнатия продукт след зачистването на търсачката. Досега те отиваха на първия резултат от търсенето. С клавиатурата (стрелки и „+“) работеше правилно и досега. Същото важи и в редактора на обедно меню.",
      },
    ],
  },
  {
    version: "0.0.307",
    date: "2026-10-05",
    entries: [
      {
        type: "fix",
        text: "Склад → изписване на рецепти: под-рецептата се изписва по своето „Количество“ — ×0,5 изписва половината от продуктите ѝ, ×2 двойно, а под-рецепта, срещната на няколко места в рецептата (два реда „Сос“ или общ „Сос“ в две под-рецепти), се изписва навсякъде. Досега се изписваше винаги по веднъж, а повторенията изпадаха — наличностите и себестойността излизаха грешни. Важи за разнасяне и връщане на отчет, брак при сторно, „Продадени“, анализа и инвентаризацията на рецепти; вече разнесен отчет се поправя с „Коригирай и разнеси повторно“.",
      },
      {
        type: "fix",
        text: "Маркиране: задължителна добавка, чиито опции не са в менюто на ресторанта, вече не заключва „Добави“, а когато наличните опции са по-малко от изискваните, се изискват наличните (броячът показва колко). Същото правило важи и за гласовата поръчка. Досега продуктът не можеше да се добави към поръчката, без сервитьорът да вижда защо.",
      },
      {
        type: "fix",
        text: "Маркиране: каталогът се зарежда и когато в групите на Организацията е останал кръг (група, поставена под собствената си подгрупа). Досега менюто падаше с грешка за всички ресторанти; Организацията 0.0.133 вече не позволява такъв запис.",
      },
      {
        type: "improvement",
        text: "Склад: продуктите, изтрити в Организацията след обновяването ѝ до 0.0.133, остават с истинското си име и мярка в доставките, наличностите, складовата карта и справките (вместо „#номер“) и не се предлагат за нови документи.",
      },
    ],
  },
  {
    version: "0.0.306",
    date: "2026-10-05",
    entries: [
      {
        type: "fix",
        text: "Резервации на телефон: картата на предстояща резервация вече има „Откажи“ (иконата ✕, когато бутоните са три) с познатото потвърждение „Да откажем ли резервацията?“. Досега на телефон схемата не се показва, а „Откажи“ за резервация с маса беше само в поповъра на масата — резервацията нямаше как да се откаже. Тапът на картата на телефон вече не отваря невидимия поповър, затова първото Esc отново е „назад“.",
      },
      {
        type: "fix",
        text: "Маркиране → гласово „Настани“: настанява направо само ако името е казано точно — цяла дума от името („Здравко“, „Бонев“) или фамилия на -ов, -ев или -ски в семейна или женска форма („Иванови“ за „Николай Иванов“). Само приличащо име („Александър“ при „Александра Петрова“, „Иван“ при „Ивана Колева“ или „Николай Иванов“) отваря „Настани“ на тази резервация — Enter потвърждава, Esc се връща. Досега такава резервация на друг човек се настаняваше без въпрос и ѝ се отваряше сметка.",
      },
      {
        type: "fix",
        text: "Нова резервация / „Редактирай“: „Опитай пак“ при „Заетостта на масите за деня не се зареди“ пита наново и съседния ден (нужен за резервациите около полунощ), затова формата се отключва веднага. Досега бутонът питаше само избрания ден и при паднал съседен ден формата стоеше спряна до следващото опресняване (до 15 секунди).",
      },
      {
        type: "fix",
        text: "Работа без интернет (FiscalAPI 2.2.1 на главната каса): редакция на резервация без смяна на часа проверява само добавените маси, както в облака — само махане на маса не проверява нищо. Досега касата отказваше добавяне или махане на маса с „Маса 5 в момента е заета“, когато гостите вече седят на своята маса на сметка на сервитьора.",
      },
      {
        type: "fix",
        text: "Работа без интернет (FiscalAPI 2.2.1): „Настани“ на маса с празна сметка, останала от приключила резервация с „Отделна сметка за всяка маса“, поема сметката както в облака — всеки сервитьор я вижда, първата поръчка я прави негова, а „Отмени настаняването“ я маха. Досега без интернет сервитьорите не я виждаха, а „Отмени настаняването“ я оставяше — и след връщането на интернета на масата оставаше празна сметка 0.00 € на хостесата.",
      },
    ],
  },
  {
    version: "0.0.305",
    date: "2026-10-04",
    entries: [
      {
        type: "improvement",
        text: "Маркиране → „Закрий“: след „Закриване“ модалът се затваря веднага, вместо да стои отворен със спинер, докато принтерът издаде бона. Докато бонът се печата, кутийката на масата вляво е сива, на мястото на сумата пише „Закрива се“ със спинер и тя не се кликва — по масата не може нищо (нито поръчка, нито второ закриване), но сервитьорът може веднага да работи на друга маса. Важи за всеки начин на плащане. Таймаутите не са променени.",
      },
      {
        type: "improvement",
        text: "Докато масата се закрива, тя стои в списъка, каквато и да е настройката „Нефинализирани маси“. После всичко е както досега: с излязъл бон масата изчезва, а без бон (грешка или неотговорил принтер) се показва или крие според настройката. Ако сумата на масата се е сменила междувременно, модалът остава отворен с новата сума, както досега.",
      },
      {
        type: "improvement",
        text: "Изходът от закриването е известие с името на масата, което стои до ръчно затваряне (вижда се и ако сервитьорът вече е на друга маса): „Неуспешно плащане — маса 5: …“ при отказ (червено) и „Маса 5 — Принтерът не отговори…“, когато изходът е неизвестен (кехлибарено). Успешното закриване е кратко съобщение, както досега. Второ закриване на маса, която още се закрива (например „Фискализирай“ от „Възстановяване“), се отказва с „Тази маса още се закрива — изчакайте бона.“",
      },
      {
        type: "fix",
        text: "„Възстановяване“ на сметка, чийто бон още може да излезе (няколко минути след закриването — до около 4,5 минути в брой и 7,5 минути с карта), вече се отказва с „Бонът на тази сметка още се печата — изчакайте резултата и опитайте пак след малко.“ Досега възстановяването минаваше без сторно, а закъснелият бон излизаше на хартия без сторно. Изисква бекенд 0.0.305.",
      },
      {
        type: "fix",
        text: "„Сторнирай всичко“ (Справки → „Справка сметки“) на сметка, чийто бон още може да излезе, също се отказва с „Бонът на тази сметка още се печата…“. Досега сторното минаваше без кредитно известие и на хартия оставаше бон без сторно. Изисква бекенд 0.0.305.",
      },
      {
        type: "fix",
        text: "Повторното издаване на бон за закрита без бон сметка („Закрий“ на такава маса, „Фискализирай“ във „Възстановяване“, „Опитай пак“ във „Фискални проблеми“), докато бонът от първия опит още може да излезе, вече не издава втори бон. Пуска се само точното повторение — същият начин на плащане от същата каса, след като принтерът не е отговорил навреме. С друг метод, от каса, вързана към друг апарат, или докато първият опит още се чака, излиза „Бонът на тази сметка още се печата…“. Отказът при повторно издаване пише „Маса N — …“, а не „Неуспешно плащане“ — плащането е минало при първото закриване. Изисква бекенд 0.0.305.",
      },
    ],
  },
  {
    version: "0.0.304",
    date: "2026-10-02",
    entries: [
      {
        type: "improvement",
        text: "„Резервации“ има странично меню като „Конфигурация“: „Резервации“, „Таблица на резервациите“, „Схема на заведението“ и „Конфигурация на маси“. Всяка страница се вижда само с правото си — с едно право се вижда само една страница. Началният екран с двете плочки отпада: модулът се отваря направо на първата разрешена страница, „Към модулите“ е горе в менюто, а на телефон менюто се отваря от бутона ☰ в лентата.",
      },
      {
        type: "improvement",
        text: "„Схема на заведението“ и „Конфигурация на маси“ се преместиха от „Конфигурация“ в „Резервации“ заедно с правата си — при правата на потребителя вече са в групата „Резервации“. Който ги има, ги запазва и получава достъп до модула „Резервации“; ако в „Конфигурация“ не му остава друго право, този модул вече не му се показва. Същото важи и за предефинираните роли.",
      },
      {
        type: "improvement",
        text: "Схема на заведението: маса с 1 място вече е обикновена маса с един стол — с размера на останалите маси и „1“ под номера. Досега беше столче — по-малък плот без столове. Масите за един, които вече са в схемата, порастват и може да се наложи да се раздалечат.",
      },
      {
        type: "improvement",
        text: "Схема на заведението: столовете са по-тънки и по-близо до плота, а най-малкото разстояние между две маси (със столовете) е 10 см вместо 20 см — масите се събират по-плътно. Автоматичната подредба в „Конфигурация на маси“ също ги нарежда по-близо.",
      },
      {
        type: "feature",
        text: "Конфигурация → „Работно време“: за всеки ден от седмицата се задава „от – до“ или „Почивен ден“, а затварянето може да е и след полунощ (например 12:00–02:00). Линкът „Как работи?“ обяснява с примери какво прави. Работното време се ползва само за часовете по подразбиране в справките и за часовете, в които се приемат резервации.",
      },
      {
        type: "improvement",
        text: "Справки: периодът по подразбиране вече е от отварянето до затварянето на деня по работното време вместо 06:00 → 05:59. Сметка, платена след полунощ в ден, който работи до късно, е в справката за този ден, а почивният ден е целият календарен ден. Стрелките ← → вземат часовете на новия ден. „Картови плащания“ също минава на работното време, „Фактури“ остава по датата на фактурата. Докато работното време не е запазено, всичко е както досега.",
      },
      {
        type: "improvement",
        text: "Резервации: формата предлага часовете от работното време на избрания ден вместо 11:00–22:45, като последният час е 15 минути преди затварянето. При работа след полунощ (например 12:00–06:00) часовете на цялата смяна се виждат наведнъж, а избран час след полунощ сам сменя датата горе на следващия ден. В почивен ден резервации не се записват. „Таблица на резервациите“ показва работното време на деня — при работа след полунощ и нощта е на същия екран.",
      },
      {
        type: "improvement",
        text: "Справки: секция „Резервации“ (Дневник на резервациите, Натовареност, Гости) не се показва в менюто, докато в схемата на заведението няма нито една маса в нито един район. Секция „Фискални“ (Фактури, Картови плащания) не се показва, докато не е добавена поне една фирма в Конфигурация → Фирми. Щом се добави маса или фирма, секцията се появява (на друг терминал — след F5). Изисква бекенд 0.0.304 — със стар бекенд „Фискални“ остава видима.",
      },
      {
        type: "feature",
        text: "Обедно меню → Печат: до името на всяко ястие излизат номерата на алергените му (от асортимента или рецептата), а най-отдолу има легенда „Алергени“ — какво значи всеки номер. Номерата са по закона: 1 глутен, 2 ракообразни, 3 яйца, 4 риба, 5 фъстъци, 6 соя, 7 мляко, 8 ядки, 9 целина, 10 горчица, 11 сусам, 12 серен диоксид и сулфити, 13 лупина, 14 мекотели, 15 имитиращ продукт. В легендата са само номерата, които се срещат в отпечатаното меню. Номерата по закона идват с организация 0.0.132 — дотогава са други, но легендата пак казва кой номер какво е.",
      },
      {
        type: "fix",
        text: "„Налична е нова версия“: „Презареди“ вече зарежда новата версия от първия път. Досега (най-често от началния екран с модулите) страницата се презареждаше със старата версия и прозорецът изскачаше пак — оправяше се чак на втория-третия път. Сега прозорецът се показва, когато новата версия вече е изтеглена. Поправката важи от следващата нова версия нататък — при тази може още веднъж да се наложи повторно натискане.",
      },
      {
        type: "improvement",
        text: "„Налична е нова версия“ е в средата на екрана и по-голямо, като останалите прозорци. Бутонът „Презареди“ е избран веднага и Enter презарежда — за кухненските монитори, които са само с клавиатура. Докато прозорецът е отворен, клавишите не стигат до екрана отдолу (например „+“ на монитора не маркира продукт).",
      },
    ],
  },
  {
    version: "0.0.303",
    date: "2026-10-02",
    entries: [
      {
        type: "fix",
        text: "Кухненски монитор: поръчка, пристигнала точно докато мониторът се свързва (при отваряне, при върната връзка или при преминаване към работа без интернет) или докато се изпълнява „Опресни“, вече не изчезва от екрана секунда след като се е появила. По същата причина вече не се връща и стар статус на ред, нито сторниран ред като активен.",
      },
      {
        type: "fix",
        text: "Кухненски монитор: правата „Маркиране като изпълнено“, „Маркиране като в процес на изпълнение“ и „Връщане на поръчка в статус 'неизпълнена'“ вече се проверяват и от сървъра — облака и главната каса при работа без интернет (FiscalAPI 2.0.6), не само чрез скриване на бутоните. Потребител без тях не може да смени статуса на ред по никакъв начин.",
      },
    ],
  },
  {
    version: "0.0.302",
    date: "2026-10-02",
    entries: [
      {
        type: "security",
        text: "Маркиране: сервитьор без правото „Вижда сметките на всички“ вече не може да поръча, да смени маса или сервитьор, да раздели, сторнира или закрие, да отпечата предварителна сметка или да сложи отстъпка/цена в чужда маса — дори от неопреснен екран веднага след като колега е поел масата. Отговорът е „Маса 5 е на Мария Петрова — нямаш право да работиш с чужди маси“. Празната сметка от „Настани“ остава отворена за всички до първата поръчка. Същото важи и без интернет (FiscalAPI 2.0.5).",
      },
      {
        type: "feature",
        text: "Гласово „Настани“: „настани резервацията на Здравко Бонев“ (или „настани Иванови“) настанява направо, когато случаят е ясен — една такава резервация, на една маса, към моя отворена маса или към нова моя. Ако има какво да се уточни (няколко резервации с това име, чужда сметка, няколко маси, още е рано), се отваря „Настани“ на тази резервация. Иска и правото „Настани“.",
      },
      {
        type: "fix",
        text: "Резервации: „Раздели“ и „Раздели и плати“ от сметка на резервация — новата сметка остава към резервацията: сумата ѝ влиза в „Дневник“ и „Гости“, резервацията приключва, когато се платят всички сметки, а „Настанена от“ не се сменя от разделянето. Разделяне във вече отворена маса не се закача към резервацията.",
      },
      {
        type: "fix",
        text: "Резервации: „Смяна на маса“ на сметка на настанена резервация мести резервацията веднага, и при „Отделна сметка за всяка маса“ — гостите от маса 3 минават на 4 → резервацията е на маси 1, 2 и 4. Освободената маса вече не се заключва с „Разбрах“, а новата е заета за нови резервации.",
      },
      {
        type: "fix",
        text: "Маркиране: отказът „Маса N е към настанената резервация … — Разбрах“ излиза само когато гостите поръчват в сметка на друга маса на същата резервация. Сметка, преименувана на „За вкъщи“ или преместена извън масите на резервацията, вече не заключва масата — показва се обичайното „Отказ/Продължи“.",
      },
      {
        type: "fix",
        text: "Резервации: маса, на която седят гости от настанена резервация (отделени с „Раздели“ или преместени там), вече не може да се резервира за следващия час.",
      },
      {
        type: "fix",
        text: "Маркиране → „Смяна на маса“ при лична номерация: проверката „номерът е зает“ гледа масите на сервитьора, чиято е масата, а не на преименуващия — масата на Мария „5“ → „7“ минава, ако Мария няма маса „7“.",
      },
      {
        type: "fix",
        text: "Гласови поръчки при лична номерация: „отвори маса 1“ влиза само в моята маса 1; ако нямам такава — отваря нова моя (или празната от „Настани“), а не масата на колега със същия номер.",
      },
      {
        type: "fix",
        text: "„Настани“ от Маркиране точно в края на часа пише „Часът на резервацията изтече“ (и „Резервацията вече не е предстояща“, ако друг терминал я е настанил) вместо „Масите на резервацията са изтрити от схемата“.",
      },
      {
        type: "improvement",
        text: "Търсенето по телефон в „Резервации“, „Таблица на резервациите“ и „Настани“ приравнява +359 и 0 — „0888 123“ намира „+359 888 123 456“ и обратно.",
      },
      {
        type: "fix",
        text: "Работа без интернет (FiscalAPI 2.0.5): при „Отделна сметка за всяка маса“ главната каса знае за всички сметки на резервацията — празната сметка на другата маса се вижда от всеки сервитьор, масата ѝ не се заключва, резервацията приключва чак когато платят всички маси, „Смяна на маса“ я мести веднага, а „Отмени настаняването“ маха и празните сметки на другите маси.",
      },
    ],
  },
  {
    version: "0.0.301",
    date: "2026-10-01",
    entries: [
      {
        type: "improvement",
        text: "Конфигурация → Устройства → „Офлайн резерв“: панелът е на две части. „Обектът“ — резервът е един за целия обект: включва се веднъж, от който и да е терминал, а „Изключи“ пита, защото спира резерва за всички. „Това устройство“ — „Подготви това устройство“ и „Провери“, които се правят на всеки терминал и монитор поотделно. Когато всичко е наред, панелът е един ред с „Подробно“.",
      },
      {
        type: "fix",
        text: "Ако отговорът на „Поръчай“, „Сторно“ или служебен внос/износ се изгуби и екранът бъде презареден, повторното натискане със същите данни от същото устройство до 10 минути вече също не записва действието втори път.",
      },
      {
        type: "fix",
        text: "Връщане от работа без интернет към облака (FiscalAPI 2.0.4 на главната каса): ако отговорът на облака се изгуби, касата не започва веднага да приема записи, а пита облака наново — до около 20 секунди показва „Касата се връща към облака точно сега — нищо не е записано. Опитайте отново след секунда.“ Така касата и облакът не приемат закриване на една и съща сметка едновременно.",
      },
      {
        type: "fix",
        text: "Работа без интернет: планът на залата, който главната каса пази за аварията, вече се подрежда по часа на базата в облака — бавен отговор към един терминал не измества по-новия от друг.",
      },
    ],
  },
  {
    version: "0.0.300",
    date: "2026-10-01",
    entries: [
      {
        type: "improvement",
        text: "„Модули“ → „Резервации“, началният екран: макетът на плочката „Таблица на резервациите“ вече е наклонен само назад, леко и симетрично — като схемата в съседната плочка, вместо изкривен настрани. Таблицата не е отрязана вдясно, текстът се чете, а листът започва и свършва на нивото на залата до него, без празно място отгоре.",
      },
      {
        type: "feature",
        text: "Маркиране, лентата под масите: бутоните от „Опции“ (Раздели, Отчет, Клиенти, Предварителна сметка…) могат да се изнесат в самата лента. При отворени „Опции“ бутонът се хваща и се довлича където трябва — пред „Нова маса“, между основните бутони или след „Опции“; на тъч екран се задържа за миг и се влачи. Обратно — същото, от лентата към панела „Опции“. Подредбата е лична: следва акаунта на всяко устройство; бутон без право просто не се показва. Докато „Опции“ е затворен, лентата не може да се размести случайно. На телефон лентата остава както досега.",
      },
      {
        type: "improvement",
        text: "Маркиране, лентата под масите: изнесените бутони нямат ограничение за брой — когато мястото свърши, всички бутони в лентата се свиват на стъпки: по-малък отстъп, после по-дребен текст без клавиша в ъгъла, накрая текстът се реже с „…“ (пълното име се вижда при посочване с мишката).",
      },
      {
        type: "improvement",
        text: "Маркиране, екранът с масите: часовникът вече е долу вляво под списъка с маси, а „Обобщено“ — долу вдясно под поръчката, и двете точно над лентата. Така цялата лента остава за бутоните. На таблет „Обобщено“ вече не се показва два пъти — остава само до първия час на поръчката.",
      },
      {
        type: "feature",
        text: "Резервации и Маркиране, „Настани“ на резервация с няколко маси: прозорецът пита „Една сметка“ (по подразбиране — всички маси на една сметка) или „Отделна сметка за всяка маса“. Вляво е резервацията като билет — час, гости, телефон, маси, район и забележка; вдясно е изборът, а „Какво ще стане“ показва за всяка маса дали се закача към отворена сметка или се отваря нова и на кой сервитьор. Маса с отворена сметка се закача към нея, свободна маса се отваря нова. Когато на една маса има сметки на двама сервитьори, се избира към коя, и новите маси се отварят на същия сервитьор — никога една маса негова, а друга моя. Всички сметки са на резервацията и се виждат в справките. Без интернет „Отделна сметка“ не е достъпна и прозорецът казва защо.",
      },
      {
        type: "improvement",
        text: "Навсякъде в българския интерфейс „регион“ вече е „район“ — в схемата, в Резервации, в Таблица на резервациите, в новата резервация и в прозорците (например „Създай нов район“).",
      },
      {
        type: "feature",
        text: "Маркиране: масата с настанена резервация се разпознава веднага — на долния ред на картата, до сумата, стоят иконка календар и името от резервацията (при отстъпка — само иконката), без картата да става по-висока. В отворената маса над поръчаното има лента с резервацията: име, час, гости, маси и забележката.",
      },
      {
        type: "improvement",
        text: "Справки за резервации: забележката от резервацията (повод, алергии) вече е колона „Забележка“ в „Дневник на резервациите“ и в експорта към Excel. Дългият текст се чете целият при посочване с мишката.",
      },
      {
        type: "improvement",
        text: "Резервации и Таблица на резервациите: район без маси показва съобщение с бутон към „Схема на заведението“, който отваря същия район. Бутонът го виждат само хората с права за схемата.",
      },
      {
        type: "improvement",
        text: "Схема на заведението: маса не може да застане върху друга маса. Между масите се пази минимално разстояние, а преместена към съседна маса, тя се плъзга покрай нея и спира до нея.",
      },
      {
        type: "feature",
        text: "Нова резервация: при познат телефон името се попълва от последната резервация, а в полето за телефон се появява „◷ 2 резервации“. При клик се отваря картата „История“ — брой резервации, посещения, предстоящи и отказани, последно идване, средна сметка и последната забележка с датата ѝ. Червената точка значи, че гостът има отказани резервации или неявявания. По подразбиране картата е скрита и не заема място.",
      },
      {
        type: "improvement",
        text: "Резервации: масите на една резервация се виждат свързани винаги — и докато се мести часът по линията горе, не само при посочване с мишката.",
      },
      {
        type: "improvement",
        text: "Резервации: прозорчето с информацията за масата застава така, че да не закрива другите маси от същата резервация.",
      },
      {
        type: "improvement",
        text: "Резервации и Таблица на резервациите: контурът на резервираните маси е по-блед, за да отива окото към текста, а не към рамката — и в тъмната тема.",
      },
      {
        type: "feature",
        text: "Резервации и справките за резервации: телефонът на госта е връзка — на телефон кликът започва обаждане, на компютър отваря програмата за обаждания. В Маркиране нарочно не е така.",
      },
      {
        type: "improvement",
        text: "Таблица на резервациите: „Скрий до 1-ва резервация“ крие часовете преди първата предстояща или настанена резервация за деня, а не до часа сега — ако всички резервации са вечерта, таблицата започва от първата. „Покажи целия ден“ връща всички часове.",
      },
      {
        type: "feature",
        text: "Справка „Гости“: клик на ред отваря историята на госта за периода — посещения, средна сметка, среден престой, общо похарчено, отказани и неизпълнени резервации, и таблица с всяка резервация (час, гости, маси, статус, забележка, продължителност, реален престой и сметка) с ред „Общо“. Прозорецът е само за преглед.",
      },
      {
        type: "fix",
        text: "Редакция на резервация: при добавяне на още една маса системата вече не казва, че първата маса е заета, когато е заета от самата резервация (например гостите вече седят там). При същия час се проверяват само добавените маси, а при сменен час — всички, както досега.",
      },
      {
        type: "improvement",
        text: "Справки → „По сервитьори“: отново се виждат всички методи на плащане — както в „Продажби по периоди“. Таблицата има колона за всеки активен метод в реда от настройките (и за изключен метод, ако има пари в периода), а под кутийките стои лентата „По методи на плащане“ със сумата и дела на всеки метод. Смесеното плащане е разпределено в „В брой“ и „С карта“, затова „В брой“ е числото за сверка на касата, а колоните „Сума в брой“/„Сума с карта“ и „Смесено“, които повтаряха същите пари, отпадат. Нов метод на плащане се появява сам.",
      },
      {
        type: "improvement",
        text: "Справки → „По сервитьори“, прозорецът по дни (клик на сервитьор): плащанията са подредени ясно — Дата · Сметки · Средна сметка · методите в същия ред като отвън · Оборот, без повтарящи се колони. Прозорецът се разширява според броя методи, така че цялата таблица се вижда без скрол настрани.",
      },
      {
        type: "feature",
        text: "Справки → „По станции“: нов филтър „Сервитьори“ до търсачката — може да се изберат един или няколко сервитьора и справката показва само техните сметки. Сторното и сравнението с предходния период следват избора. Докато се зареждат новите числа, старите остават на екрана.",
      },
      {
        type: "improvement",
        text: "Справки → „По станции“: методите на плащане са като в „По сервитьори“ — колона за всеки активен метод в реда от настройките, а смесеното плащане е разпределено в „В брой“ и „С карта“, без отделна колона „Смесено“ (вкл. в лентата „По методи на плащане“ и в Excel). Колоните „Сума в брой“/„Сума с карта“ отпадат — числата им вече са в „В брой“ и „С карта“. Кликът на ред вече не отваря прозорец по дни.",
      },
      {
        type: "improvement",
        text: "Справки → „По сервитьори“ и „По станции“: колоните с броя сметки по метод („В брой · бр.“, „С карта · бр.“ и т.н.) са махнати от „Колони“ и от Excel.",
      },
      {
        type: "improvement",
        text: "Справки → „Продажби по периоди“: екранът е само таблицата — махнати са кутийките „Оборот / Сметки / Средна сметка / Артикули“, лентата „По методи на плащане“, графиката „Оборот по периоди“ и бутонът „Δ спрямо предишния период“, който служеше само на кутийките.",
      },
      {
        type: "improvement",
        text: "Справки → „Продажби по периоди“: филтърът „Всички станции“ горе е махнат — вместо него всяка станция (Бар, Кухня…) е колона в таблицата с оборота си в периода. Колоните се включват от „Колони“, влизат в реда „Общо“ и в Excel. Продуктът се брои към основната си станция, а добавката — към своята.",
      },
      {
        type: "improvement",
        text: "Справки: „По категории“ се казва „По групи“ — както в „Маркиране“; колоната е „Група“. Кликът върху реда вече не отваря прозорец по дни; името на групата продължава да отваря „По артикули“ с артикулите ѝ.",
      },
      {
        type: "improvement",
        text: "Всички справки, бутонът „Колони“: стрелките за подредба са махнати (колоните се подреждат с влачене на заглавията им). До 10 колони списъкът е в една колона, над 10 — в две колони по равно (16 → 8 + 8), без скрол до 24; над тях списъкът скролва. Ширината следва имената на колоните.",
      },
    ],
  },
  {
    version: "0.0.299",
    date: "2026-10-01",
    entries: [
      {
        type: "improvement",
        text: "Разнасяне на отчети: сервитьорите и станциите вече са при самия отчет, не в „Продадено“. Под избрания отчет в списъка има „Сервитьори“ (име · брой сметки · бройки) и „Станции“ (името и складът ѝ или „без склад“). Клик на ред показва какво е продадено. На таблет и телефон същото е в реда „Сервитьори и станции ▸“ под заглавието на отчета. „Продадено“ вдясно показва само рецептите — превключвателят „Рецепти · Сервитьори · Станции“ и колоната „Серв.“ ги няма.",
      },
      {
        type: "fix",
        text: "Разнасяне на отчети: продукт, за който не е избран склад, вече се показва в жълто като „N продукта без склад“, с подсказка откъде се задава складът (станциите в Организация → Меню или „Склад по продукт“ в Конфигурации). Досега в списъка пишеше „с недостиг“, а горе — „Всичко е налично“. Червено свети само истинският недостиг в избрания склад.",
      },
      {
        type: "feature",
        text: "Склад → „Целият списък“: количеството — а при доставка и цената — се въвежда направо в реда. Клик или Enter на ред слага курсора в количеството, Enter минава на следващия ред, Ctrl+Enter добавя всичко в листа. В инвентаризацията така се въвежда „Намерено“ (приема и „10+2“).",
      },
      {
        type: "improvement",
        text: "Склад → „Целият списък“: вече добавен продукт не се дублира — попълва се неговият ред, а попълнен ред се презаписва само след въпрос. Екранът е почти на цял монитор, по един ред на продукт, и се виждат почти двойно повече продукти. Нови са филтрите „Под минимума“ и „От този доставчик“, колоната „Мин.“ и сумата на избраните в долната лента.",
      },
      {
        type: "improvement",
        text: "Складова база: всички таблици и списъци са с еднаква височина на реда — справките, работните листове (доставка, изписване, прехвърляне, инвентаризация), разнасянето, „Целият списък“, плащането, излишъкът и началните екрани. Работните листове са по-сбити и на екрана се събират повече продукти. На таблет редовете и бутоните са по-едри за пръст.",
      },
      {
        type: "fix",
        text: "„Разнесени отчети“ и „Изписвания“: датата и часът са на един ред и редовете вече не са двойно по-високи от другите справки.",
      },
    ],
  },
  {
    version: "0.0.298",
    date: "2026-10-01",
    entries: [
      {
        type: "fix",
        text: "Ако отговорът на „Поръчай“, „Сторно“ или служебен внос/износ се изгуби (например „Не е сигурно дали поръчката е стигнала“) и натиснете отново със същите данни от същия терминал до 10 минути, действието не се записва втори път — в облака, а с FiscalAPI 2.0.3 и на главната каса.",
      },
      {
        type: "fix",
        text: "Връщане от работа без интернет към облака (FiscalAPI 2.0.3 на главната каса): за секунда-две главната каса не приема записи и казва „Касата се връща към облака точно сега — нищо не е записано. Опитайте отново след секунда.“ Така касата и облакът не могат да закрият една и съща сметка едновременно.",
      },
      {
        type: "fix",
        text: "Сметка, закрита без интернет, при която касата е спряла преди касовия бон, вече се вижда във „Фискални проблеми“ с причината, вместо да изглежда платена без бон.",
      },
      {
        type: "fix",
        text: "Действие от касата, което облакът е отказал (например сметката вече е затворена в облака), вече не се отбелязва само като качено при повторен опит — остава в „Чакат решение от човек“ на портала на касата, за да се провери дали няма два бона.",
      },
      {
        type: "fix",
        text: "Планът на залата на главната каса (FiscalAPI 2.0.3) вече не се връща към по-стар вид, когато бавен отговор от облака пристигне след по-нов — затворена в облака сметка не се появява отново на касата.",
      },
      {
        type: "security",
        text: "Без интернет терминалите вече не изпращат облачния си вход към главната каса по локалната мрежа — тя получава само своя локален билет.",
      },
    ],
  },
  {
    version: "0.0.297",
    date: "2026-10-01",
    entries: [
      {
        type: "improvement",
        text: "Складова база: редовете в списъците са по-ниски и на екрана се събират повече. На таблет редовете и бутоните са по-едри за пръст. Отрязано име се вижда цяло, когато посочите с мишката.",
      },
      {
        type: "improvement",
        text: "Складова база: червено свети само за спешното — незавършена инвентаризация (вижда се при всички), отчет, който чака разнасяне над 2 дни, задържана доставка и доставка, неплатена над 14 дни. Чакащите днешни отчети, неплатените и излишъкът са в меко жълто, а черновите — сив брояч. В менюто значките на „Инвентаризация“ и „Разнасяне“ светват червено при спешно, а „Табло“ взема най-силния цвят.",
      },
      {
        type: "feature",
        text: "Склад → Табло: най-горе се появява червена лента само когато има нещо спешно — до 3 реда, всеки с бутон, който води до него. Кутията „Инвентаризация“ показва незавършените броения („Бар · Мария · 12 преброени · вчера 18:40“) с „Продължи“ за вашето и „Поеми“ за чуждо.",
      },
      {
        type: "feature",
        text: "Инвентаризация: вижда се кой брои кой склад и колко е преброено, с „Продължи“ или „Поеми“. Ако започнете ново броене на склад, който колега вече брои, програмата пита — да продължите неговото или да започнете отделно. Не се забранява.",
      },
      {
        type: "feature",
        text: "Инвентаризация: нов бутон „Занули склада“ в нова инвентаризация, до „Целият списък“ и „Нов продукт“. Попълва „Намерено“ 0 за всички непреброени продукти с наличност — или само за тези на минус. Преди това пита и показва първите продукти и прогнозната липса. Нищо не се записва до „Потвърди инвентаризацията“, затова отделни редове могат да се поправят. Вече преброеното не се пипа, а празната причина става „Зануляване на склада“.",
      },
      {
        type: "improvement",
        text: "Разнасяне на отчети: „Изписване от склад“ е най-отгоре и на лаптоп се събира без страничен скрол. „Продадено“ на голям монитор стои вдясно, а на лаптоп и таблет се свива в една лента над таблицата — програмата помни дали сте я разгънали. Чакащите отчети са по-ниски карти, а закъснелият е с червена значка.",
      },
      {
        type: "feature",
        text: "Разнасяне на отчети: всяка съставка се изписва от своя склад — например лимонът за „Лимонада“ от Кухнята, а водата от Бара. Продукт, общ за рецепти от Бар и Кухня, се разделя сам на два склада с готови количества. До склада малка иконка подсказва откъде е дошъл: „Склад на продукта“ или „Склад на станцията на рецептата“.",
      },
      {
        type: "feature",
        text: "Склад → Конфигурации: нова секция „Склад по продукт“ — за всеки продукт може да се зададе от кой склад да се изписва. При разнасяне, щом смените склада на продукт, се появява бутон „Винаги от <склад>“, който след потвърждение го запомня.",
      },
      {
        type: "improvement",
        text: "Брак при сторно: съставките също се бракуват от техния склад. Ако рецептата е разделена между складове, в „Изписване/Бракуване“ излизат продуктови редове с бележка „от <рецепта> ×N“.",
      },
      {
        type: "feature",
        text: "Разнасяне на отчети: в заглавието се вижда колко сервитьори имат продажби в отчета (имената — при посочване). В „Продадено“ има превключвател „Рецепти · Сервитьори · Станции“: при рецептите колона „Серв.“ показва колко е продал всеки сервитьор, а „Сервитьори“ и „Станции“ групират продаденото. Това са само бройки, за информация — изписването от склада не се променя.",
      },
      {
        type: "feature",
        text: "Документ „Доставка“: бележката е най-горе (и при печат). Плащането се вижда и се променя направо от документа — „Промени“, „Отбележи като неплатена“ (с потвърждение) и „Отбележи като платена“. В „Плащане на доставки“ съобщението след плащане има „Отмени“.",
      },
      {
        type: "feature",
        text: "Стокова разписка във фактура: нов бутон „Извади от фактурата“ — стоката остава заприходена, а стоковата се връща в „Стокови без фактура“. Нов бутон „Приключи без фактура“ за стокова, за която фактура няма да дойде — с причина по избор и, ако искате, с отбелязване като платена. „Върни за фактуриране“ я връща обратно. На началния екран на доставките стоковите се приключват наведнъж по доставчик.",
      },
      {
        type: "improvement",
        text: "Справка „Доставки“: меню „⋯“ на всеки ред (Принтирай · Преглед · Редактирай · Анулирай, а за стокова във фактура — „Отвори фактурата“), колона „Бележка“ и нов филтър „Фактура“. Стоковите показват „чака фактура“ или „приключена без фактура“, а броячът „Стокови без фактура“ брои само чакащите.",
      },
      {
        type: "fix",
        text: "Плащане на доставки: стокова разписка, платена отделно, вече не се плаща втори път, когато влезе във фактура — сумата на фактурата е без нея, а отмяната на плащането на фактурата не я прави неплатена.",
      },
      {
        type: "improvement",
        text: "Доставка с дата след продажби „на минус“ вече влиза цялата — минусът от минали дни се отписва. Доставка с датата на продажбите ги покрива, както досега. Важи за доставки от 02.10.2026; по-старите не се преизчисляват.",
      },
      {
        type: "feature",
        text: "Складова база: до „Наличност: 0“ се вижда колко е продадено без наличност („−10 продадени без наличност“) — в листа на доставката, в търсачката, в „Целия списък“ и в „Наличности“. При запис на доставка с такъв продукт има подсказка какво ще стане при избраната дата и коя дата да сложите. Записът не се спира.",
      },
      {
        type: "improvement",
        text: "Складова карта: наличността не пада под нулата на екрана. Редът с продажбата без наличност е отбелязан с „⚠ 10 кг продадени без наличност“, а доставката, която я покрива — с „(10 покриват продаденото без наличност)“.",
      },
      {
        type: "feature",
        text: "Справка „Продадени рецепти“: нова колона „Последна продажба“ (дата и час). Тя е и в картата на телефон, в панела на рецептата и в Excel.",
      },
      {
        type: "improvement",
        text: "Справки „Продадени продукти“ и „Продадени рецепти“: винаги пише, че се броят само разнесените отчети, а при чакащи отчети има бутон „Разнеси“. Редовете имат стрелка „›“ и подсказка какво отваря кликът. Табът „По дни“ показва лента за всеки ден, за да се види кой ден е бил най-силен.",
      },
    ],
  },
  {
    version: "0.0.296",
    date: "2026-09-30",
    entries: [
      {
        type: "feature",
        text: "Схема на заведението: избраната маса или обект се върти с мишката или пръста — под нея има кръгче-дръжка, което се хваща и се върти около центъра плавно, на какъвто ъгъл трябва, а до дръжката се вижда ъгълът („37°“). Близо до 0°, 45°, 90°… ъгълът леко залепва, със Shift се върти през 15°. Записва се при пускане и се връща с „Отмени“. Бутонът за завъртане на 45° над елемента е махнат; клавишът R и завъртането в панела вдясно остават.",
      },
      {
        type: "feature",
        text: "Схема на заведението: при местене на маса или обект помощни линии подсказват подреждането — щом центърът или ръбът на плота мине на няколко пиксела от центъра или ръба на друг елемент, той залепва за него и през двата минава тънка полупрозрачна линия. Така масите се нареждат в една линия лесно; линиите изчезват при пускане.",
      },
      {
        type: "improvement",
        text: "Схема на заведението: масите и обектите вече не са ограничени в правоъгълника на региона — стоят навсякъде. Платното се мести с влачене по празното място или с колелцето, а Ctrl/⌘ + колелце (и щипане на тъчпада) го приближава под курсора. „Побери схемата“ (до − и +) показва всички елементи максимално едро, без да скрива нито един. Новите маси и обекти отиват около средата на видимото.",
      },
      {
        type: "improvement",
        text: "Резервации: схемата се вписва по масите и обектите на региона — показва ги всички възможно най-едро, дори да стоят извън старата граница на залата. След приближаване с + схемата се мести с влачене и с колелцето.",
      },
    ],
  },
  {
    version: "0.0.294",
    date: "2026-09-30",
    entries: [
      {
        type: "improvement",
        text: "Резервации, „Нова резервация“: лентата над схемата („Кликни свободна маса · Щрихованите са заети в този час“, ден/час/гости и „Избрани“) е премахната — схемата е по-голяма, а упътването за избора на маса остава в секцията „Маси“ на формата.",
      },
      {
        type: "improvement",
        text: "Резервации, „Нова резервация“: часът се избира от 11 до 22 (последният е 22:45). Отворена преди 11:00, формата предлага 11:00; след 22:45 — утре в 19:00. Старите резервации в други часове остават и се редактират както досега.",
      },
      {
        type: "improvement",
        text: "Резервации на телефон: схемата на заведението не се показва. На главния екран регионите са подредени по 3 на ред („Всички“ и всеки регион с броя резервации за деня) и филтрират списъка; избраният регион е и този, с който се отваря „Нова резервация“.",
      },
      {
        type: "feature",
        text: "Резервации на телефон, „Нова резервация“: масата се избира във формата — първо „Регион“ (по 3 на ред, с броя свободни маси за гостите в този час), после „Маси“ като плочки с номера и местата. Показват се само свободните, които побират гостите; „Покажи всички маси“ добавя и заетите (щриховани) и по-малките. Избраната маса е оцветена с отметка, а регион с избрана маса има точка. „Предложи маса“ превключва на региона на предложената.",
      },
      {
        type: "improvement",
        text: "Резервации на таблет: схемата е висока колкото самата зала — без празното място отгоре и отдолу.",
      },
      {
        type: "improvement",
        text: "„Нова резервация“: „Телефон“ и „Име“ са отбелязани с червена звездичка като задължителни, както „Маси“.",
      },
      {
        type: "improvement",
        text: "Резервации: горната лента е висока колкото на другите страници (60px).",
      },
      {
        type: "feature",
        text: "„Модули“ → „Резервации“ вече отваря начален екран на модула с две плочки: „Резервации“ (залата на живо — свободни, резервирани и заети маси, списъкът и настаняването) и „Таблица на резервациите“. Под всяка има макет с примерни данни, не с данните на заведението. „Назад“ и Esc от двете страници връщат на началния екран, а от него — в „Модули“.",
      },
      {
        type: "feature",
        text: "„Таблица на резервациите“: разписание маси × часове за избрания ден. Редовете са масите на избрания регион, колоните — часовете от 11 до 24 на половин час; всяка резервация е лента с името на госта и часа ѝ (предстояща, настанена, неизпълнена, приключила — отказаните не се показват), над всеки час пише колко резервации и гости има в него („2 | 6“), а линията „сега“ отбелязва момента. Регионите, денят и „Нова резервация“ са като на схемата; отгоре има и „Скрий до … часа“ (само за днес — скрива миналите часове), търсене по маса или гост и легенда. Клик на свободна клетка отваря „Нова резервация“ с масата и часа попълнени, клик на предстояща лента — редакцията ѝ; формата е същата като на схемата. Настаняването, отказът и връщането остават на схемата; таблицата показва само резервациите — маса със сметка без резервация тук изглежда свободна.",
      },
      {
        type: "fix",
        text: "„Таблица на резервациите“: „Нова резервация“ за друг ден се отваря от началото му (11:00), не от 22:45. Клетката е отворена, докато в нея има свободен четвърт час — клик на 19:00 в 19:10 отваря 19:15, от 19:15 клетката е затворена, 22:30 се затваря в 22:45 — така кликът вече не отваря друг час, нито утрешния ден.",
      },
      {
        type: "fix",
        text: "„Таблица на резервациите“: Esc в поле на формата само излиза от полето, втори Esc затваря — както в „Резервации“; написаното не се губи.",
      },
      {
        type: "improvement",
        text: "„Таблица на резервациите“: след запис таблицата отива на деня и региона на резервацията и огражда лентата ѝ; при смяна на деня решетката е затъмнена със „Зареждане…“ и не приема кликове, докато денят дойде.",
      },
      {
        type: "fix",
        text: "„Таблица на резервациите“: броячите „резервации · гости“ броят само резервациите с лента в деня — настанена от предишен ден, чиито гости още седят, не се брои; резервация преди 11:00 отваря разписанието по-рано. Търсенето е с правилата на списъка в „Резервации“: цяло име на маса („2“, „маса 2“, „м3“), гост по част от името или по цифри от телефона.",
      },
      {
        type: "fix",
        text: "„Таблица на резервациите“: в дните на смяна на часа (последната неделя на март и на октомври) лентите и линията „сега“ са на верния час; при смяна облак ↔ каса отворената форма се затваря, а без интернет заявките ѝ спират; след полунощ „Покажи целия ден“ не остава натиснат.",
      },
      {
        type: "fix",
        text: "„Нова резервация“ (схемата и таблицата): при „Създай“ с грешка формата се превърта до сгрешеното поле и то взима фокуса, а без избрана маса — до „Маси“; досега на компютър грешките оставаха под сгъвката.",
      },
      {
        type: "improvement",
        text: "„Таблица на резервациите“: по-четливи ленти — „Приключила“ с по-тъмен текст, редът с часа без избледняване, „Неизпълнена“ с отделен цвят на рамката. Началният екран: картата „Нова резервация“ в плочката на таблицата стои над листа, долният ѝ ляв ъгъл вече не се реже.",
      },
      {
        type: "feature",
        text: "Схема на заведението: маса с 1 място е столче (напр. на бара) — по-малък плот без столове около него; „1“ е сред бързите бутони за места в „Нова маса“ и в инспектора.",
      },
      {
        type: "improvement",
        text: "Схема на заведението, „Нова маса“: чекбоксът вече е „Остави прозореца отворен за следващата маса“ с пояснение, че след „Създай“ номерът се сменя със следващия свободен. Всяка създадена маса вади съобщение „Маса N е създадена“, а в самия прозорец се трупа списък „Създадени в тази серия (3): 12 · 13 · 14“, докато е отворен.",
      },
      {
        type: "improvement",
        text: "Резервации и „Таблица на резервациите“: редът под горната лента с деня, броя резервации и гости е премахнат — само заемаше място. Без интернет срещу касата „данни към 14:32“ се показва в лентата за връзката най-отгоре.",
      },
      {
        type: "improvement",
        text: "Схема на заведението и Резервации: нов изглед на схемата. Подът е бяла милиметрова хартия с едва видимо каре, а масите, столовете, барът, сцената, DJ пултът, растенията и стените са обемни — със страна и мека сянка, както в началния екран на „Резервации“. Рамката (външната стена) около залата е премахната.",
      },
      {
        type: "improvement",
        text: "Схема на заведението: „Вход“ се рисува като врата с две крила и етикет „Вход“ и се върти като всеки друг обект. Вход, пуснат до края на залата, сам застава така, че вратата да се отваря навътре; заварените входове са обърнати автоматично.",
      },
      {
        type: "improvement",
        text: "Схема на заведението, „Нов регион“ и „Редакция на региона“: изборът „Форма на залата“ е премахнат — регионът има само име. Съществуващите региони запазват размера и подредбата си.",
      },
      {
        type: "improvement",
        text: "Схема на заведението, „Редакция на региона“: „Фонов план“ (снимка под масите) е премахнат. Качените досега снимки вече не се показват.",
      },
      {
        type: "improvement",
        text: "Схема на заведението: докато местиш маса или обект, тънък пунктир показва докъде стига залата. Обект, пуснат от лентата извън нея, отива на най-близкото място вътре; пуснат обратно върху лентата — не се добавя.",
      },
    ],
  },
  {
    version: "0.0.293",
    date: "2026-09-30",
    entries: [
      {
        type: "feature",
        text: "„Складова база“ е изцяло нова. Началната страница е „Склад“ — табло с по една кутия за всяка операция (какво чака, колко е неплатено, кога е броено), а операциите са в сгъваема група на менюто, което помни дали е свито. Всички справки имат една и съща лента: период с пресети, които се прилагат веднага, филтри в самите колони, Excel (Ctrl+E) и „Опресни“.",
      },
      {
        type: "feature",
        text: "Доставка: фактура или стокова разписка. Фактура може да обобщи стоковите на доставчика — продуктите им се виждат в листа и в документа на фактурата, а сумата ѝ е заедно с тях. Доставчикът е задължителен, датата не може да е в бъдещето, сумата на реда се пази такава, каквато е въведена (ед. цената се извежда с до 5 знака), а „Общо“ най-долу може да се коригира до сумата от хартията — разликата отива в реда с най-голяма сума.",
      },
      {
        type: "feature",
        text: "„Плащане на доставки“: неплатените доставки по доставчик, плащане на няколко наведнъж (дата, в брой / банков превод / карта, основание). Следят се доставките, въведени от тази версия нататък.",
      },
      {
        type: "feature",
        text: "„Запази временно“ във всички операции — доставка, изписване, прехвърляне и инвентаризация. Черновата се пази на сървъра (вижда се и от друго устройство), колегите виждат кой какво въвежда, а заета чернова може да се поеме.",
      },
      {
        type: "feature",
        text: "Изписване: рецептата показва ед. цена, нето и бруто, без да се разделя. Когато не стига наличност, под реда пише кои съставки не стигат, колко трябват и колко има, с „Намали на N порции“ и „Раздели на продукти“.",
      },
      {
        type: "feature",
        text: "Инвентаризация: приготвени рецепти — рецептата се брои в порции, а съставките ѝ се прибавят към преброеното на всеки продукт („+0,600 в рецепти“). Съставка, която е само в рецепта, трябва да се преброи и отделно (или 0). Листът е по-тих: блокове „За броене“, „Преброени“, „Непреброени“.",
      },
      {
        type: "feature",
        text: "Документите се анулират с причина (не се изтриват) и пазят история на промените — кой, кога и какво е сменил, преди и след. Складова карта на продукт от „Наличности“; „Продадени“ показва теоретично (по рецепта), реално изписано и разликата, без нулевите редове.",
      },
      {
        type: "improvement",
        text: "Разнасяне на отчети: нулев отчет (без нищо за изписване) вече се разнася и излиза от чакащите. Справките в склада скролират до края; стойност в клетка не може да се завлачи с мишката в съседна клетка.",
      },
    ],
  },
  {
    version: "0.0.292",
    date: "2026-09-29",
    entries: [
      {
        type: "improvement",
        text: "Маркиране, изглед „Таблица“: редът е подреден като име · бутони · грамаж · станция · цена. Бутоните − N + вече се показват само при маркиран продукт (появяват се с клик по реда) и имат молив, който отваря редакцията на реда. Етикетът на станцията е висок колкото бутоните, а цифрата между − и + е с размера на цената.",
      },
      {
        type: "improvement",
        text: "Маркиране, изглед „Плочки“: бутоните − N + на маркирания продукт също имат молив за редакция на реда.",
      },
      {
        type: "feature",
        text: "Моливът (в „Преглед на поръчката“ и в каталога) вече сменя и количеството, освен модификаторите и коментара — с голямото поле за количество, както в „Промени“; добавките не се сменят оттук. Отворен от прегледа, курсорът е в коментара; отворен от каталога — в количеството (пишеш числото и Enter). От каталога се редактира последно маркираният ред на продукта.",
      },
    ],
  },
  {
    version: "0.0.291",
    date: "2026-09-29",
    entries: [
      {
        type: "feature",
        text: "„Резервации“ и „Настани“ работят и без интернет, срещу касата: резервациите на близките дни (от два дни назад до две седмици напред) се виждат, създават, редактират, настаняват, отказват и връщат, а „Настани“ от Маркиране отваря празната сметка на касата. Под заглавието пише „данни към 14:32“ — кога касата е видяла облака за последно, а лентата за връзката е и тук. Когато интернетът се върне, касата качва направеното; резервация, променена междувременно и в облака (напр. от телефон), остава за решение при касата, вместо да се презапише. Изисква обновена каса — с по-стара всичко е както досега („Недостъпно без интернет“). Снимките на залите без интернет не се показват. Одит: действията, направени без интернет, са отбелязани „Източник: Касата, без интернет“.",
      },
      {
        type: "improvement",
        text: "Резервации: линията на времето е в цвета на стените на схемата, а при избран час от нея списъкът вдясно вече няма лентата „Към 17:05 · … резервации на масите“ — активните карти пак са оградени.",
      },
    ],
  },
  {
    version: "0.0.290",
    date: "2026-09-29",
    entries: [
      {
        type: "feature",
        text: "Нов модул „Резервации“ (ново право „Резервации — преглед, създаване и настаняване“). Схемата на заведението е жива картина на деня: времева линия с плъзгач (Сега / Преглед към / По-рано) и за всяка маса — свободна, резервирана (пунктир и час) или заета (от колко време; заета е и маса, отворена в Маркиране без резервация), с чип за часа на следващата резервация. Клик на маса отваря карта с данните на госта и действията. Вдясно са Предстоящи / Настанени / Минали с търсене по име, телефон или маса, а над тях — смяна на деня с календар и „Нова резервация“; цял екран, зуум. Регионите (Зала, Тераса…) са сегментиран контрол над схемата с „27 маси · 122 места“, както в „Конфигурация на маси“ и „Схема на заведението“, и се превъртат, когато са много. На телефон денят и „Нова резервация“ са на един ред наполовина. Схемата се опреснява всяка минута и при връщане в прозореца — изтрита или нова маса се вижда веднага. Картите в списъка са ниски и еднакви: закъснението или „След 6 мин“ е ред под името, с цветна лента отляво (червена — закъснява, оранжева — скоро).",
      },
      {
        type: "feature",
        text: "Времевата линия е интерактивна: плъзнете (или стрелките, Home/End) до всеки час от деня и схемата показва масите към този момент — резервирани, свободни и часа на следващата резервация. Горе пише „Преглед към 21:15 · след 1 ч 30 мин“, по линията има точки за началата на резервациите и лека графика на натовареността, а „Сега“ връща на живо. Вдясно активните в този час карти са оградени, а останалите — приглушени. Действията („Настани“ и т.н.) винаги важат за истинското „сега“. Схемата е със заоблени ъгли, както всичко останало.",
      },
      {
        type: "feature",
        text: "Нова резервация: дата (следващите 7 дни или „Друга дата“), час от 00 до 23 на 15 минути — без ограничение, резервации и след полунощ (00:30 е в деня на своята дата), гости, продължителност (1 / 1,5 / 2 / 3 ч), масите се избират направо от схемата (побиращите гостите са зелени, заетите в този час — щриховани; „Предложи маса“), име (автоматично с главни букви) и телефон с проверка, бележка. Масата е свободна за следваща резервация от края на продължителността (15:00 за 1 час → от 16:00), а маса с отворена сметка в Маркиране не може да се резервира за следващите 60 минути. Предстояща резервация се редактира („Редактирай“); само смяна на данните минава винаги, дори гостите вече да седят. При редакция на закъсняла резервация началният ѝ час остава избираем (по-ранните са задраскани), а повторно докосване на избрания ден не мести часа.",
      },
      {
        type: "feature",
        text: "Настаняване: „Настани“ (най-рано 30 минути преди часа) отваря празна сметка с името на масата — тя се вижда от всички сервитьори и става на този, който поръча първи. Ако сервитьорът вече е отворил масата без резервация, резервацията се закача към неговата сметка. Сметка на предишна резервация, която още е отворена (гостите си тръгнаха, но сервитьорът не е закрил), не се закача — „Настани“ е изключен с „Сметката на предишната резервация на маса 2 (Иван) още не е закрита“, докато сервитьорът не я закрие; празна такава сметка (никой не е поръчал) се поема от новата резервация; при няколко отворени сметки на масата (лична номерация) хостесата избира при кой сервитьор, със сумата на всяка. Резервациите никога не закриват сметки: „Гостите си тръгнаха“ само приключва резервацията, а закрие ли сервитьорът сметката в Маркиране, резервацията сама отива в „Минали“; възстановена сметка остава на своята резервация. Има „Отмени настаняването“ (не и след края на часа на резервацията; ако никой още не е поръчал и сметката е 0.00, празната сметка се премахва от Маркиране, иначе остава — модалът казва предварително кое от двете), „Откажи“ (с потвърждение) и „Върни“ за отказана. Резервация, за която никой не е натиснал нищо до края на часа ѝ, сама става „Неизпълнена“ (пази се за справките) и освобождава масата. Смени ли сервитьорът масата на сметката, резервацията я следва. При преглед на друг ден (напр. „Утре“ около полунощ) „Настани“ знае за гостите, настанени в момента, и показва „Маса 2 е заета“.",
      },
      {
        type: "improvement",
        text: "Маркиране: при „Нова маса“, смяна на маса, разделяне към нова маса, бързото отваряне и гласовото „отвори маса“ върху маса с резервация излиза въпрос — „Маса 3 е резервирана за 19:30 — Иванов, 4 гости. Продължаваш ли?“ (Отказ / Продължи), а при бързото отваряне „Отказ“ предлага следващия свободен номер без резервация. При лична номерация „Нова маса N“ върху празната сметка от „Настани“ влиза в нея, вместо да отваря втора; същото прави „Раздели“. „Настани“ и отваряне на същата маса от два терминала в една и съща секунда оставят една сметка.",
      },
      {
        type: "feature",
        text: "Нова страница Конфигурация → „Конфигурация на маси“ (ново право „Конфигурация на маси“): масите се въвеждат само с номер и брой места — без схема. Всяка нова маса е малка и квадратна и се нарежда сама в залата с около 40 см разстояние, като заобикаля вече подредените маси, бара и входа; изтрита маса оставя място, което следващата запълва. Масите са същите като в „Схема на заведението“ и „Резервации“ — виждат се там веднага и после може да се преместят с влачене. Плочки с номер и точки за местата, търсене по номер, филтри по брой места; вдясно „Една маса“ или „Серия номера“ (напр. от 33 до 50 наведнъж, заетите се пропускат), клик на маса — редакция на номера, местата и залата, изтриване; няколко отметнати маси — места за всички, преместване в друга зала или изтриване наведнъж. Зала се създава ръчно с „Нов регион“. Маса с резервация или отворена сметка не може да се преименува или изтрие. Работи на таблет и телефон (панелите се отварят отдолу).",
      },
      {
        type: "improvement",
        text: "Схема на заведението: маса с предстояща или настанена резервация, или с отворена сметка, не може да се изтрие или преименува (съобщението казва защо и какво да се направи първо); име на маса не може да завършва на „*“ (запазено за офлайн режима). Платното на схемата е общо за редактора и за резервациите и е със заоблени ъгли; табовете на регионите в редактора се превъртат, когато са много, и са в същия сегментиран стил като в „Конфигурация на маси“; на телефон „Нов регион“ е на реда с „Отмени“/„Повтори“. Редакторът: „Отмени“ вече не пипа друг регион (историята се нулира при смяна на региона); нов обект или маса от лентата не пада върху друг елемент (свободното място се търси с реалния размер и столовете); масите се рисуват над бара и другите обекти; „Добави още една“ предлага следващия свободен номер; клавишите R, ⌘Z, ⌘D работят и на българска клавиатура; номерата на малките маси не се режат; лентата с обекти се превърта със стрелки. Двама, които трият или променят една и съща маса или регион едновременно, получават ясно съобщение вместо сървърна грешка. Одит: действията с резервации (създаване, редакция, настаняване, приключване, отмяна, отказ, връщане) се записват и се четат разбираемо.",
      },
      {
        type: "feature",
        text: "Справки → нова секция „Резервации“ с три справки, всяка със свое право: „Дневник на резервациите“ (право „Справка дневник на резервациите“) — всяка резервация с начало в периода: час и край, име, телефон, гости, маси, статус (Предстояща / Настанена / Приключила / Отказана / Неизпълнена), продължителност, настанени в, тръгнали в, реален престой, сметката от настаняването и сумата ѝ, създадена от / настанена от (който е направил първата поръчка по сметката — не се губи при прехвърляне на масата), забележка; търсене, филтри по колони, ред „Общо“, Excel. Показателите отгоре: резервации, гости и средна група, приключили, отказани, неизпълнени с процент неявяване, оборот от настанените (всяка сметка се брои веднъж; в „Гости“ също).",
      },
      {
        type: "feature",
        text: "„Натовареност“ (право „Справка натовареност на резервациите“) — кога идват резервациите, със същия екран като „Продажби по периоди“: Групирано (часове, дни от седмицата, месеци) или Във времето (часове, дати, месеци, години), филтри по статус и маса, графика „един стълб = един период“ и таблица с брой резервации, гости, разбивка по статус, средна продължителност и среден реален престой; изборът се помни както там. „Гости“ (право „Справка гости по резервации“) — един ред на телефон (записан както и да е — „+359 888…“ и „0888…“ са един гост): резервации, дошли, отказали, неявили се и процент неявяване, гости, похарчено, последно посещение; редовни и „с неявяване“ в показателите. Периодът на трите е по часа на резервацията и е календарен ден (резервацията за 00:30 е в деня на своята дата). Справките за резервации показват всичко — сметката, сумата и кой е настанил — със или без втори код.",
      },
      {
        type: "feature",
        text: "Маркиране → „Опции“ → „Настани“ (ново право „Настаняване на резервация от Маркиране“): списък с днешните резервации, подредени по часове, с търсене по име, телефон или маса. Всеки ред показва час, име, маси, гости и колко остава или колко закъснява (червено); избраната резервация се разгъва на място с телефона, залата, часовете и бележката. „Настани“ винаги пита: „Настани Иванов?“ — „Резервирани: Маси 1, 2“ → „Ще се отвори: Нова маса 1“, а ако масите вече са отворени — избор между своята отворена маса, нова своя маса и (само с правото да вижда сметките на другите) масата на друг сервитьор, със сумата ѝ. При обща номерация без това право маса на друг сервитьор не се предлага — „Маса 2 е заета от Мария“. След настаняването масата се избира сама и се отваря менюто за поръчка; сметката е като от „Резервации“ — на този, който поръча първи. Преди часа бутонът е изключен и казва „Може да се настани след 19:30“. Работи с мишка, пръст и клавиатура (↑ ↓ Enter Esc, писането отива в търсенето), на телефон, таблет и компютър; без интернет е заключен.",
      },
      {
        type: "improvement",
        text: "Резервация на няколко маси: в „Резервации“ масите ѝ се свързват с линия върху схемата — пунктирна, когато резервацията е избрана, и плътна, докато гостите седят. Докато е настанена, другата ѝ маса не може да се отвори в Маркиране (нито с „Нова маса“, нито с преименуване или разделяне на друга сметка към нея; самата сметка на резервацията може да се премести на другата ѝ маса) — излиза „Маса 2 е към настанената резервация на Иванов — сметката е на маса 1“ с бутон „Разбрах“. Навсякъде вместо „Може да се настани от 19:30“ пише „Може да се настани след 19:30“.",
      },
      {
        type: "improvement",
        text: "Маркиране: „Обедно меню“ се премести от горната лента в „Опции“, при останалите действия (правото и заключването без интернет са същите).",
      },
      {
        type: "feature",
        text: "Нова страница Конфигурация → „Схема на заведението“ (ново право „Управление на схема на заведението“). Заведението се описва по региони — Зала, Тераса, Бар… — всеки със своя форма (Квадрат, Правоъгълник, Широк, Дълъг) и по желание фонова снимка на плана. Във всеки регион се подреждат маси и обекти (бар, стена, растение, вход, сцена, DJ). Масата има номер, форма (кръгла, квадратна, правоъгълна), брой места и размер — плотът расте с местата, а столовете се рисуват около него. Номерът на масата е същото име като в Маркиране и е уникален за целия ресторант (без значение от главни и малки букви). Схемата ще се ползва за избор на маса в Маркиране и в резервациите.",
      },
      {
        type: "feature",
        text: "Редакторът на схемата работи с мишка и с пръст (таблет, телефон): масите и обектите се влачат и прилепват към мрежа, обектите се плъзгат върху схемата от лентата отдолу (или с тап отиват в свободно място), „+ Маса“ отваря формата с живо превю и „Добави още една след тази“. Избраният елемент се променя от панела вдясно — номер, форма, места, размер, завъртане, дублиране и изтриване — и всяка промяна се записва сама („Запазено“). Грешна стъпка се връща с „Отмени“ / „Повтори“ (⌘Z / ⇧⌘Z); клавиши: R завърта, ⌘D дублира, Del изтрива, Esc маха избора. Регионът има външна стена — нищо не може да се сложи върху нея, а вход до стената отваря отвор в нея. Регион се изтрива само празен. Без интернет страницата показва, че е недостъпна — схемата се пази в облака.",
      },
    ],
  },
  {
    version: "0.0.289",
    date: "2026-09-28",
    entries: [
      {
        type: "fix",
        text: "Мониторинг → Фискални проблеми: при статус „Неизвестен“ или „Изчаква“ бутонът „Опитай пак“ първо пита „Документът може вече да е излязъл“. Повторението печата на принтера на текущата сесия — ако той е друг апарат, би излязъл втори бон. Първо проверете лентата на апарата и „Бон №“ в „Справка сметки“. Подсказката на статуса е поправена.",
      },
      {
        type: "feature",
        text: "AI помощник: може да се пита за конкретна сметка или маса („маса 12 — излезе ли бонът?“) — вижда всички опити за фискален бон, късния успех след изчакване, картовото плащане, хронологията на сметката и отказаните действия. Изисква бекенд 0.0.289.",
      },
      {
        type: "improvement",
        text: "AI помощник: по-точни отговори — намира продукта и когато името е с член („Колата“), казва дали главната каса наистина се обявява, по-рядко пише „не мога да проверя“ при описана рецепта и не изпуска предупреждения при кратък отговор. Базата знания е обновена.",
      },
    ],
  },
  {
    version: "0.0.288",
    date: "2026-09-27",
    entries: [
      {
        type: "feature",
        text: "Модули → Мониторинг → нова карта „AI помощник“ (само за служебния акаунт на UnrealSoft). Пишете „как да…“ или „защо не…“ — отговорът идва от базата знания за CloudTS и FiscalAPI и от данните на живо на обекта (права на служител, артикул, станции и принтери, устройства, настройки, фискални проблеми). Всеки отговор започва със значка за сигурност: „Потвърдено“, „Почти сигурно, непотвърдено“, „Не знам“ или „Нужно уточнение“, и може да се оцени с 👍/👎. Помощникът само чете — нищо не променя. Изисква бекенд 0.0.288.",
      },
    ],
  },
  {
    version: "0.0.287",
    date: "2026-09-26",
    entries: [
      {
        type: "improvement",
        text: "Надбавка никога не се печата — нито клиентска („+5 %“), нито ръчно вдигната цена: на касовия бон, на ПОС бележката и на предварителната сметка редът излиза просто с по-високата цена (досега клиентската надбавка излизаше като „НАДБАВКА 5%“ под всеки ред на касовия бон).",
      },
      {
        type: "improvement",
        text: "Отстъпките се виждат по ред и на ПОС бележката и предварителната сметка: отстъпка в % на продукт — „Отстъпка 10%“ под реда; ръчно намалена цена — „Отстъпка“ със сумата (и на касовия бон, където досега излизаше само по-ниската цена); клиентската отстъпка — веднъж отдолу („Отстъпка клиент 10%“). Сумите се връзват до стотинка. Изисква бекенд 0.0.287; печатът по редове — FiscalAPI 2.0.1 на касата.",
      },
    ],
  },
  {
    version: "0.0.286",
    date: "2026-09-25",
    entries: [
      {
        type: "feature",
        text: "Конфигурация → Устройства → фискално устройство → нова настройка „Нефискално копие на ПОС“ (стъпка „Копие на ПОС“). Когато е включена, след всяка успешна касова бележка ПОС принтерът на същата каса печата нефискално копие със същите продукти и заглавие „КОПИЕ НА КАСОВ БОН № …“ — удобно при доставка, за да се види дали всичко е вътре. Важи при закриване, „Раздели и плати“ и повторно закриване. Сервитьорът не чака копието: ако ПОС принтерът липсва или е без хартия, закриването минава нормално. При неуспешна касова бележка и в офлайн режим копие не излиза. По подразбиране е изключена. Бекенд 0.0.286 — ново поле nonFiscalCopy на устройството; двете страни се качват заедно.",
      },
      {
        type: "improvement",
        text: "Маркиране → Операции → „X отчет (от дата / до дата)“: бързият избор на период е „Предходен месец / Този месец / Период“ — „Днес“ отпада (за деня има X отчет, а един ден се избира и в „Период“). До 7-о число на месеца по подразбиране е избран „Предходен месец“ (месечният отчет от фискалната памет се пуска дотогава), след това — „Този месец“; под избора се показват точните дати, които ще се отпечатат.",
      },
      {
        type: "improvement",
        text: "X отчет за период: таванът от 92 дни отпада. Подробен отчет за по-дълъг период вече не се спира, а пита — „това са метри хартия и няколко минути печат, да отпечатаме ли?“ — и излиза след потвърждение; съкратеният отчет само сумира фискалната памет и няма праг.",
      },
    ],
  },
  {
    version: "0.0.285",
    date: "2026-09-25",
    entries: [
      {
        type: "improvement",
        text: "„Отстъпки“: всеки ред показва какво ще му стане при „Запази“. Сменя ли се отстъпката, старият процент стои задраскан пред новия („−10% → −15%“); отпада ли — задраскан в червено, а до него пише „Без“. Етикетът „променена цена“ се задрасква, когато процентът ще замести собствената цена. Така размаркиран ред или сменена обща отстъпка вече не махат отстъпки незабелязано.",
      },
      {
        type: "improvement",
        text: "„Отстъпки“: бутонът с процента на реда е по-голям (32px) — по-лесно се улучва с пръст и на телефон, и на терминал.",
      },
    ],
  },
  {
    version: "0.0.284",
    date: "2026-09-25",
    entries: [
      {
        type: "improvement",
        text: "Маркиране → Опции → „Отстъпки“: всеки ред има собствен процент. Chip-ът до цената показва отстъпката на реда („−15%“ — общата, „−20% · ред“ — собствена, „−%“ — без отстъпка), а кликът върху него отваря „За този ред“ с „Обща“, „Без“ и 5–50%. Така в една сметка може да има няколко различни отстъпки и редове без отстъпка — с едно отваряне и едно „Запази“. „Обща отстъпка“ горе важи за избраните редове без собствен процент и не променя редовете със собствен. Модалът показва крайното състояние: неизбран ред е без отстъпка (размаркиран ред с отстъпка я губи при запис), а „Премахни всички“ само изчиства избора — записът е с „Запази“. Долу пише колко е отстъпката и сумата преди → след, а бутонът „Запази“ носи сумата след.",
      },
      {
        type: "fix",
        text: "„Отстъпки“: сумата след отстъпката в прозореца вече съвпада с бона. Преди понякога показваше стотинка повече (напр. 3,45 × 3 с 10 % — 9,32 на екрана, 9,31 на бона), защото закръгляше по друго правило от фискалното устройство.",
      },
    ],
  },
  {
    version: "0.0.283",
    date: "2026-09-25",
    entries: [
      {
        type: "feature",
        text: "Конфигурация → Маркиране → Каталог → нова настройка „Търсене при избрана група“ (под „Търсачка над каталога“): къде търси търсачката, когато е отворена група, напр. „Напитки“. „В цялото меню“ (по подразбиране, както досега) — първата буква излиза от групата и търси навсякъде. „Само в групата“ — търси само в отворената група, а след добавяне търсачката се изчиства и оставате в същата група за следващия продукт. Без избрана група се търси винаги в цялото меню. Важи еднакво и за редактора на обедно меню. Бекенд 0.0.283 — нов PUT /configuration/ordering-search-scope и поле orderingSearchScope в configuration; двете страни се качват заедно.",
      },
      {
        type: "improvement",
        text: "Маркиране: групата „Обедно меню“ се отличава — плочката ѝ е в цвета на бутона „Поръчай“ (избрана — плътна), а обедните продукти в каталога и лентата им в „Преглед на поръчката“ са в същия цвят, когато оцветяването е „По група“. Изчерпан обеден продукт остава сив при всяко оцветяване.",
      },
    ],
  },
  {
    version: "0.0.282",
    date: "2026-09-25",
    entries: [
      {
        type: "improvement",
        text: "„Средна сметка“ в справките вече не брои сметките с 0.00 € — те занижаваха средното. Засегнати са: Дашборд, „Справка сметки“, колоната „Средна сметка“ в „Сервитьори“ (и по дни, и в Excel) и „Продажби по периоди“ (кутийката, колоната, реда „Общо“ и Excel). Процентът спрямо предишния период се смята по същото правило. Броят „Сметки“ не се променя — сметките с 0.00 продължават да се броят там. В „Продажби по периоди“ 0.00 се гледа в рамките на реда и филтъра: сметка, чиито редове от избраната станция са на 0.00, не влиза в средната за тази станция.",
      },
    ],
  },
  {
    version: "0.0.281",
    date: "2026-09-25",
    entries: [
      {
        type: "feature",
        text: "Обедно меню → „Порции на ден“ за всеки продукт (асортимент или рецепта), в прозореца, където се сменя цената. 0 = без ограничение. Пример: 20 — след 20-ата продадена порция за деня продуктът става сив в „Маркиране“ и не може да се избира до края на деня; ако менюто се повтаря, на следващия ден отново има 20. Сторнирана порция се връща.",
      },
      {
        type: "feature",
        text: "Маркиране: при обеден продукт с лимит до мерната единица пише колко порции остават („3 бр“), а при изчерпване етикетът става червено „Изчерпано“ и продуктът е сив. Не може да се добави повече от останалото (и с „+“, и с „Поръчай пак“). Ако двама сервитьори вземат последната порция в една и съща секунда, вторият получава съобщение, че порциите са изчерпани, и поръчката му не се записва. Работи и без интернет (касата брои сама).",
      },
      {
        type: "feature",
        text: "Маркиране → бутон „Обедно меню“ в горната лента на масите (ново право „Обедно меню — създаване и управление“): обедните менюта на заведението се създават и управляват от терминала. Изберете продукти от каталога на маркирането (същите групи, търсачка, Плочки/Таблица и клавиатура), сменете им цената само за обедното (количеството и размерът остават тези на продукта), и задайте кога е активно — за една дата или повтарящо се по дни от седмицата, с часове. Началната дата е днес или по-късно (до 2 години напред), часовете по подразбиране са 11:00–14:59, а „до“ винаги завършва на :59, така че „до 12:59“ и „от 13:00“ не се застъпват. Цената е до 9 999,99 €. Списъкът е подреден на Днес / Предстоящи / Минали, с „Копирай“ за бързо ново меню от вчерашното, „Приключи сега“, „Изтрий“ и печат на A4. В един момент е активно само едно обедно меню — при застъпване се избира дали старото да приключи, или да се изтрие.",
      },
      {
        type: "feature",
        text: "Докато обедното меню е активно, в маркирането се появява първа група с името му и обедните цени. Продуктът може да е и в основната си група на основната цена — двата реда в сметката са отделни, а обедният носи етикет „Обедно“. Менюто се показва и скрива точно по графика — без презареждане и без интернет (часът се сверява със сървъра, когато има връзка). Кухненските монитори показват етикет „Обедно“ на тези редове. Работи и с асортименти, и с рецепти (със склад).",
      },
      {
        type: "feature",
        text: "Справки „Асортименти“ и „Категории“: продаденото от обедно меню е отделен ред с етикет „Обедно“ (в „Категории“ — отделен ред на същата категория). Обедните филтри се показват само когато в избрания период има продадено поне едно нещо от обедно меню: превключвателят „Всички / Без обедно / Само обедно“ до датата и (в „Асортименти“) стойността „Обедно меню“ във филтъра „Тип“. В период без обедни продажби изборът се връща на „Всички“.",
      },
      {
        type: "feature",
        text: "Приключило обедно меню: ако в количката има обеден продукт, а менюто вече е свършило (или е сменено от друг терминал), при изпращане поръчката не минава — продуктът се връща на редовната цена и се показва съобщение. „Поръчай пак“ на обеден ред от приключило меню също е спряно. Същата проверка има и на офлайн сървъра.",
      },
      {
        type: "fix",
        text: "Изглед „Обобщено“ на масата: обеден и редовен ред на един и същ продукт вече не се сливат в един.",
      },
      {
        type: "improvement",
        text: "Асортимент или рецепта, които имат цена само в обедно меню, вече могат да се изтрият — отпадат автоматично от обедното меню. Ако имат цена в друго (не обедно) меню, изтриването остава забранено, както досега.",
      },
      {
        type: "fix",
        text: "Модал „Кога е активно“: избраният час се запазва и когато падащото меню още е отворено при натискане на „Готово“; бутоните във футъра имат подсказки и клавиши (Esc / Enter).",
      },
      {
        type: "fix",
        text: "Разделяне на сметка: редовете пазят „сервирано“ и заключената цена.",
      },
      {
        type: "fix",
        text: "Прозорците за потвърждение с два бутона (разделяне на сметка, операции, прехвърляне, възстановяване): бутоните вече имат разстояние помежду си.",
      },
    ],
  },
  {
    version: "0.0.280",
    date: "2026-09-24",
    entries: [
      {
        type: "feature",
        text: "Мониторите: при продукт на няколко станции мониторът на едната вижда под името докъде е другата — например на Скарата „+ Студена кухня · готово ✓“ или „· чака“, за да знае кога да сервира. Станция само с принтер (без монитор) се показва само с името. Шпикерът с „всички статуси“ вижда кои станции са готови с ястието („Скара ✓ · Студена кухня …“). Изисква бекенд 0.0.280; без интернет — FiscalAPI 1.98.0 на касата.",
      },
    ],
  },
  {
    version: "0.0.279",
    date: "2026-09-24",
    entries: [
      {
        type: "fix",
        text: "Продукт, вързан към няколко станции (например „Пилешко филе“ на Скара и Студена кухня), вече отива на ВСИЧКИ свои станции — кухненският билет се печата на принтера на всяка от тях и поръчката се вижда на мониторите им. Досега излизаше само на първата станция от списъка.",
      },
      {
        type: "feature",
        text: "Мониторите: всяка станция отбелязва СВОЯТА част от такъв продукт — „Изпълни“ на Скарата не маркира частта на Студената кухня. Монитор, който гледа няколко от станциите, показва частите на отделни редове с името на станцията. Шпикерът вижда ястието веднъж и то става „Сготвено“ едва когато всички станции са готови; „Издай“ важи за цялото ястие. Продуктите с една станция работят както досега. Изисква бекенд 0.0.279; без интернет важи същото с FiscalAPI 1.97.0 на касата.",
      },
    ],
  },
  {
    version: "0.0.278",
    date: "2026-09-24",
    entries: [
      {
        type: "improvement",
        text: "Конфигурация → Устройства: изборът на работни точки и потребители е нов — редът показва колко и кои са избрани („2 работни точки · 1 потребител“), а „Промени“ отваря списък с търсачка (курсорът е в нея веднага), групи „Работни точки“ и „Потребители“ с „избери всички“ и брояч, отметки и лента „Изчисти · N от M избрани · Готово“. Акаунт, закачен към друго устройство от същия тип, се вижда сив с „на друго устройство“. Списъкът се отваря винаги надолу.",
      },
      {
        type: "improvement",
        text: "Устройства → редакция: „Статус“ е превключвател „Активно / Неактивно“. Изключването вече не пита с отделен прозорец — показва кои работни точки и потребители ще бъдат премахнати при запазване (с отделни бройки по вид) и дава „Отмени“; нищо не се губи преди „Запази промените“. Неактивно устройство се включва отново от превключвателя или просто като изберете работна точка или потребител отдолу. Секциите при редакция са подредени: Статус, после Работни точки и потребители.",
      },
      {
        type: "feature",
        text: "Модалите за добавяне и редакция в Конфигурация (устройства, монитори, фирми, видове плащания) питат „Незапазени промени — да затворите ли без запазване?“, когато ги затворите (X, „Отказ“, Esc или клик извън модала) след промяна. Ако нищо не е пипано или промяната е върната, модалът се затваря направо, както досега.",
      },
    ],
  },
  {
    version: "0.0.277",
    date: "2026-09-24",
    entries: [
      {
        type: "fix",
        text: "Без интернет: след ръчно превключване в локален режим лентата вече не остава завинаги на „интернетът се върна — изчаква се касата да изпрати направеното“. Касата пази ръчното решение на човека и не се връща сама, а терминалът чакаше тя да се върне първа — двете страни се чакаха взаимно, макар всичко вече да е било изпратено. Сега терминалът, от който е натиснато превключването, сам връща обекта към облака, щом отново има интернет и касата е изпратила всичко. На останалите терминали лентата казва, че касата е задържана в локален режим ръчно, и дава бутон „Върни към облака“ (за хора с право да управляват устройствата). Изисква FiscalAPI 1.96.1 на касата; с по-стара каса поведението е досегашното.",
      },
    ],
  },
  {
    version: "0.0.276",
    date: "2026-09-23",
    entries: [
      {
        type: "feature",
        text: "Конфигурация → Устройства → фискално устройство: нова настройка „Обобщени касови бележки“. Когато е включена, еднаквите продукти от сметката излизат на касовата бележка като един ред с общо количество — вода, кола, вода се печатат като „Минерална вода ×2“ и „Кола ×1“, дори да са маркирани в различни поръчки. Събират се само напълно еднакви продукти: различни добавки, модификатори, цена или отстъпка ги оставят на отделни редове. Сумата на бележката не се променя никога — ако събирането би я изместило със стотинка (заради закръглянето на отстъпка), редовете остават отделни. В настройката има пример „Изключено → Включено“. По подразбиране е изключена, така че съществуващите устройства печатат както досега.",
      },
      {
        type: "improvement",
        text: "„Обобщени касови бележки“ важи и без интернет, когато касовата бележка се издава от касата. Изисква бекенд 0.0.276 и FiscalAPI 1.96.0; по-стара каса печата ред по ред както досега.",
      },
    ],
  },
  {
    version: "0.0.275",
    date: "2026-09-23",
    entries: [
      {
        type: "fix",
        text: "Без интернет: когато касата вече се е върнала в облака, а терминалът е останал сам без връзка, лентата отгоре най-после го казва. Досега тя продължаваше да показва „без интернет, работиш срещу касата“ — сервитьорът натискаше „Закрий“ и получаваше отказ без обяснение и без изход. Сега лентата става червена и пише, че касата работи срещу облака, а това устройство още няма интернет — новите действия ще се отказват, провери Wi-Fi-а на този терминал. При обикновена авария лентата изглежда както досега (включително „влез с код или парола“ и броячът на неизпратените действия).",
      },
      {
        type: "fix",
        text: "Часовникът на терминала вече не изхвърля правото му да работи срещу касата. Касов компютър с изтощена батерия или таблет без сверяване на времето скачаше с часове напред и билетът, с който устройството се представя пред касата, се ИЗТРИВАШЕ — след което приложението отказваше всичко още преди мрежата и връщане назад нямаше (в аварията няма интернет, с който часът да се сверява). Сега грешният час може най-много да отложи заявката: сверяването на часа връща всичко, а самият билет се пази. Добавен е и същият 5-минутен толеранс, какъвто дава касата. Билет за друг обект или от друга версия продължава да се изхвърля, а отказът на касата се обработва както досега.",
      },
    ],
  },
  {
    version: "0.0.274",
    date: "2026-09-23",
    entries: [
      {
        type: "improvement",
        text: "Маркиране → „Сторно“: избраните продукти се сторнират с едно действие — кухнята и барът получават по ЕДИН билет за анулиране с всички сторнирани продукти, вместо по един билет на продукт. Сторното е „всичко или нищо“: ако един от редовете не може да се сторнира, не се сторнира нищо и прозорецът остава отворен с избора. Кухненските монитори получават една промяна за цялото сторно.",
      },
      {
        type: "improvement",
        text: "Справка „Сторно“: продуктите, сторнирани заедно от прозореца „Сторно“, се показват като „Сторнирани заедно“ (и без интернет — срещу касата). Изисква бекенд 0.0.274 и FiscalAPI 1.94.0 за локалния режим; срещу по-стар сървър сторното работи както досега — ред по ред.",
      },
    ],
  },
  {
    version: "0.0.273",
    date: "2026-09-23",
    entries: [
      {
        type: "feature",
        text: "Справка сметки: нова колона „Сума ФП“ до „Сума“ — с ред „Общо“, сортиране и в Excel износа, както в „Продажби по периоди“.",
      },
      {
        type: "improvement",
        text: "„Сума ФП“ в Справка сметки и в Продажби по периоди следва едно правило: в неархивиран ресторант или без втори код е равна на „Сума“ (1:1); в архивиран ресторант с втори код „Сума ФП“ са само сметките с касова бележка, а „Сума“ — всички. Досега в „Продажби по периоди“ „Сума ФП“ броеше само сметките с бон навсякъде, затова в неархивиран ресторант и без втори код числото в тази колона вече е равно на „Сума“ и за стари периоди.",
      },
      {
        type: "improvement",
        text: "Продажби по периоди: ДДС и нето се смятат винаги върху „Сума ФП“ (нето = Сума ФП − ДДС) — с втори код нефискализираното не влиза в ДДС и нето.",
      },
      {
        type: "improvement",
        text: "Продажби по периоди: изборът „Групирано / Във времето“ и единицата (часове, дни, дати, месеци, години) се запомнят в браузъра — справката се отваря така, както е оставена.",
      },
      {
        type: "feature",
        text: "Маркиране → маси: със стрелките вече се стига и до поръчаното вдясно. От последната маса в реда → минава на първия поръчан продукт, ↑ ↓ ходят по продуктите, ← (или Esc) връща към масите. „+“ върху избран продукт отваря „Промени“ за повторна поръчка — както двойният клик; работи и с клавиша „=/+“ без Shift (клавиатурата на MacBook), и с „+“ от цифровия блок. В „Обобщено“ продуктите не се избират, както досега.",
      },
      {
        type: "improvement",
        text: "Маркиране → каталог на компютър без поле за търсене: написаното вече не „изскача“ като надпис върху екрана — какво е намерено личи по оцветените букви в продуктите.",
      },
      {
        type: "fix",
        text: "Търсенето по име при английска подредба на клавиатурата: клавишите ` [ ] (на мястото на ч ш щ от българската фонетична) вече търсят като ч, ш и щ — „gore]“ намира „Горещ шоколад“, „ket`“ — „Кетчуп“. Каталогът на Маркиране ги приема от клавиатурата (без Cmd/Ctrl/Alt — Cmd+[ си остава „назад“). Освен това „ш“ вече не намира „щ“ и обратно (преди „ш“ хващаше и „щ“, „шт“ — и „щ“); на латиница „sht“ и „sh“ търсят както досега.",
      },
      {
        type: "improvement",
        text: "Маркиране → маси: до всеки поръчан продукт стои ПЛУ кодът му („Фалафел бургер | 123“), както в каталога при маркиране; продукт без код се показва както досега.",
      },
      {
        type: "improvement",
        text: "„История на операциите“ (прозорецът при клик на ред в Справка сметки, Сторно, Картови плащания, Отстъпки, Променени цени и от Дашборда) показва реда „Предварителна сметка“ само когато сесията вижда всичко: в архивиран ресторант — само след вход с втория код; без него печатите на предварителна сметка не се показват. В неархивиран ресторант нищо не се променя. Решава се на сървъра (Бекенд 0.0.273 — GET /bills/{id}/operations), не само на екрана.",
      },
    ],
  },
  {
    version: "0.0.272",
    date: "2026-09-23",
    entries: [
      {
        type: "fix",
        text: "Кухненският екран вече не олеква, когато интернетът спре. Мониторът показва отворените поръчки плюс затворените до два часа назад, а отменените ястия със знак — но в мига, в който обектът минаваше на касата, от дъската изчезваха поръчките на всичко, закрито през последните два часа, и всяко сторнирано ястие, за да се появят обратно чак когато интернетът се върне. Причината: касата се замразява от плана на залата, а той не носи нито затворените сметки, нито отменените редове, и няма как да ги възстанови — сметка, затворена преди аварията, никога не е влизала в този план. Сега мониторът праща собствения си списък към касата при всяка промяна, докато има интернет, а касата показва обединението на това, което знае, и това, което екранът последно е показвал. Покрит е и обратният преход: касата се връща в облака първа, а мониторът я напуска няколко секунди по-късно, и точно в този прозорец дъската олекваше. Важи и за трите станции поотделно. Изисква FiscalAPI 1.93.0; мониторът трябва да е бил онлайн поне веднъж, за да има какво да се задържи (Конфигурация → Устройства показва по станция колко поръчки са запазени и откога).",
      },
    ],
  },
  {
    version: "0.0.271",
    date: "2026-09-23",
    entries: [
      {
        type: "improvement",
        text: "„История на операциите“ (прозорецът при клик на ред в Справка сметки, Сторно, Картови плащания, Отстъпки, Променени цени и от Дашборда) вече показва модификаторите и коментарите — досега ги нямаше. Модификаторите са на един ред под продукта, червени, разделени със запетая и с удивителен отпред, подравнен по количествата на добавките. Коментарът към продукта стои до името му в червен курсив и кавички (Фалафел бургер – „без лук“). Коментарът към поръчката е на реда на операцията, до служителя, в курсив и кавички. Дългите коментари се пренасят на нов ред, не се режат. Работи еднакво със и без склад. Бекенд 0.0.271 — GET /bills/{id}/operations връща към всеки продукт modifier_names и comments, а към поръчката comment; двете страни се качват заедно.",
      },
    ],
  },
  {
    version: "0.0.270",
    date: "2026-09-22",
    entries: [
      {
        type: "fix",
        text: "Първото действие след спиране на интернета вече не пропада в празното. Дотук заявката тръгваше към облака, умираше там, а превключването към касата ставаше, докато тя виси — тоест лентата вече пишеше „локален режим“, действието беше пропаднало и терминалът трябваше да се презареди, за да проработи. Сега четене, което се е провалило точно в този прозорец, се повтаря ВЕДНЪЖ срещу касата и минава. Повтаря се само четене и само при мълчание от мрежата: отговорил сървър (включително всяка грешка) не се повтаря, а поръчка, закриване и сторно НЕ се повтарят сами никога — повторено закриване е втори бон. Проверката „заета ли е масата“ пък прави една заявка вместо две: при авария дотук се чакаше два пъти по 8 секунди, преди да се случи каквото и да е.",
      },
      {
        type: "fix",
        text: "Три места спряха да мълчат. Преименуване на маса: провалената проверка за свободно име се изписва в прозореца (и „Запази“ остава активно — заето име се отказва от самото преименуване), вместо да остане само в конзолата. Нова маса при бързо закриване: ако облакът не отговори, номерът се смята от масите на екрана — и това вече се казва, защото такъв номер може да е зает от колега. Сторно на артикули: пропадналото сторно вече НЕ затваря прозореца като при успех — остава отворено със селекцията и с причината, а при неизвестен изход пише изрично да се провери сметката, защото кредитното известие може и да е излязло.",
      },
      {
        type: "fix",
        text: "Кухненският монитор вече не удвоява поръчки при прекъсване на връзката. Дотук самоличността на поръчката на екрана беше „маса + час“: две копия на една поръчка се сливаха в ЕДНА картичка и количествата се СЪБИРАХА — „2 × Бургер“ ставаше „4 × Бургер“, а готвачът приготвяше двойно. Сега поръчката се познава по сметката и реда в нея, повторната доставка ЗАМЕСТВА старата (свежият статус бие), а два различни реда със същия продукт си остават два. Второто копие идваше от касата: тя известяваше екраните чак СЛЕД като отпечата кухненския билет, тоест монитор, свързал се в тези секунди, получаваше поръчката и в началния списък, и като нова. Сега известието и печатът тръгват едновременно, известието първо: екранът не чака хартия, а хартията не чака заспал таблет (при три станции това бяха до 15 секунди забавяне на кухненския билет).",
      },
      {
        type: "fix",
        text: "Общ терминал („Каса 1“, „Бар“) вече влиза без интернет. Касата искаше парола от поне 6 знака, а облакът пуска от 3 — тоест точно терминалните акаунти с къси пароли получаваха „Неуспешен вход“ без нито един ред в дневника на касата. Освен това на ПИН екрана вече има изход „Влез с потребител и парола“: дотук общият терминал нямаше как да стигне до този екран без интернет, защото единственият път минаваше през облака. Изисква FiscalAPI 1.92.4.",
      },
      {
        type: "fix",
        text: "Изход по време на авария вече не заключва входа до презареждане. Дотук след изход приложението оставаше в ограничен локален режим, входът отиваше към касата и получаваше локален билет — а щом облакът се върнеше, този билет се изхвърляше и човекът пак беше навън. Сега терминал, от когото е излязъл всеки, се връща към облака на ПЪРВАТА успешна проба, без да чака нищо. Служител, влязъл с ПИН ПО ВРЕМЕ на аварията, пак пада до ПИН екрана при връщането на интернета — но вече със съобщение защо, вместо мълчаливо. (Размяната на билета за истински облачен токен е написана, но остава ИЗКЛЮЧЕНА: билетът пътува по мрежата на ресторанта и включването ѝ би направило подслушването му ключ за облака. Решението е на собственика.)",
      },
      {
        type: "fix",
        text: "Терминал, чийто СОБСТВЕН интернет не се е върнал, вече не бива изхвърлян пет секунди след като е влязъл. Случваше се така: касата се връща в облака първа, този терминал още не вижда облака, но вижда касата — и понеже вече е влязъл с парола срещу нея, приложението решаваше да последва касата, изхвърляше човека и го пращаше на екран за вход, който сочи към недостижимия облак. Сега терминалът ОСТАВА при касата, сесията е жива, а лентата казва честно, че този апарат няма интернет. Излиза сам в мига, в който мрежата му проработи.",
      },
      {
        type: "fix",
        text: "Потвърждаването на изхода без интернет вече не заключва ВХОДА. Дотук пет сбъркани потвърждения на изхода вдигаха брояча на входа и терминалът получаваше „Твърде много опити“ за 15 минути — човек, който се опитва да излезе, оставаше заключен и отвън. Изисква FiscalAPI 1.92.4.",
      },
      {
        type: "fix",
        text: "Предварителната сметка вече излиза и без интернет на обект, чийто принтер за сметки е на втора машина. Дотук касата отказваше с „POS принтерът на този потребител не е на главната каса“, макар че при ЗАКРИВАНЕ същият чужд принтер просто се прескача и сметката се закрива. Сега предварителната сметка минава на POS принтер на тази каса, а отказ има само когато тук няма нито един. Поправено е и второто отказване („Не е конфигуриран POS принтер за този потребител“) при обект с два или повече споделени акаунта с принтери: облакът вече казва на касата чий принтер да ползва. Изисква FiscalAPI 1.92.4 и бекенд 0.0.270.",
      },
      {
        type: "fix",
        text: "Кухненски монитор, който изостава, вече не замръзва завинаги. Касата отписваше бавния екран, но не затваряше връзката — а жив монитор се обажда на всеки 25 секунди, тоест срокът, който трябваше да я затвори, никога не се палеше: екранът оставаше на последната картина и не се свързваше наново. Сега връзката се затваря и мониторът се връща сам. Трите страни се качват заедно, и ПЪРВО касите: FiscalAPI 1.92.4, бекенд 0.0.270.",
      },
    ],
  },
  {
    version: "0.0.269",
    date: "2026-09-22",
    entries: [
      {
        type: "improvement",
        text: "Локален резерв: терминалът вече казва какво става с връзката, а решението дали обектът да мине на работа срещу касата е НА КАСАТА, не на един терминал. Над „Маркиране“ и над мониторите има лента с четири нови състояния: „Бавна връзка“, „Проверявам връзката“, „Само това устройство“ (червено — касата и останалите терминали работят, провери Wi-Fi-а на този) и „Облакът се обновява“. Един терминал със счупен Wi-Fi вече не замразява целия обект, а наш деплой на облака се изчаква една минута, вместо да превключва обекта. За случая, в който автоматиката не превключи, а обектът стои, в лентата има бутон „Включи локален режим“ — виждат го само хора с правото за Конфигурация → Устройства и пита за потвърждение.",
      },
      {
        type: "fix",
        text: "Заявките към облака вече имат срок по маршрут. Дотук при спрян интернет екранът се въртеше между 35 и 90 секунди без никакво съобщение. Сега четенето се отказва на 8 s, обикновената промяна на 15 s, а документите чакат толкова, колкото и касата: закриване с карта до четири минути (гостът въвежда ПИН), сторно и отмяна на ред — 40 s, отчет от фискалната памет — три минути. И входът вече казва „няма връзка“ след 10 s, вместо да виси.",
      },
      {
        type: "fix",
        text: "Нова маса без интернет вече казва ясно, че НЕ е създадена, и какво може да направи управител. Също: хотелски или операторски прокси, който отговаря „всичко е наред“ със своя страница, вече не минава за жив облак — дотук обект зад такова нещо НЕ МОЖЕШЕ да превключи на касата. Бекенд 0.0.269 и FiscalAPI 1.91.0; трите страни се качват заедно, и ПЪРВО касите.",
      },
    ],
  },
  {
    version: "0.0.268",
    date: "2026-09-21",
    entries: [
      {
        type: "improvement",
        text: "Локален резерв: главната каса на обекта е една и облакът я запомня, вместо да я избира наново при всяко обаждане. Втора каса с включен резерв вече не я измества, не получава данните за офлайн работа и не отключва закриването на сметки, докато главната още праща направеното без интернет (дотук това можеше да даде два бона за една продажба). Смяна на главната: изключи резерва в портала на старата каса, или го изключи и включи в Конфигурация → Устройства. Преинсталирана главна каса си остава главна. Бекенд 0.0.268 и FiscalAPI 1.88.0 (портала на втората каса казва, че е излишна); двете страни се качват заедно.",
      },
      {
        type: "fix",
        text: "„Продажби по периоди“ — смесеното плащане вече се разделя между „В брой“ и „С карта“ (пропорционално, както във всички справки и в отчетите), вместо да стои в отделна колона „Смесено“. Колона „Смесено“ няма, дори методът да е активен; същото е в лентата с методите и в Excel износа. Смесената сметка се брои и при двата метода, ако има част и в двата. Бекенд 0.0.268 — в methods на GET /reports/analytics/sales-by-periods смесеното вече не идва като метод 3; двете страни се качват заедно.",
      },
      {
        type: "improvement",
        text: "Кухненските монитори в изглед „Списък“ — поръчките са отделени с тънка междина, за да се вижда къде свършва едната и почва другата, без да се губи място. Коментарът към поръчката (досега не се виждаше в списъка) стои на бледооранжева лента над първия ѝ ред — с масата и текста в курсив; няма ли коментар, лента няма. Лентата е само за четене — клик по нея не сваля избрания ред. Коментарът към продукт (в двата изгледа) вече е в курсив, а модификаторите от менюто — с прав шрифт, за да се различават. Логиката на мониторите (статуси, навигация, бутони) не е пипана. Бекенд 0.0.268 — без промяна за тази точка.",
      },
      {
        type: "improvement",
        text: "„История на операциите“ (прозорецът при клик на ред в справките) вече показва и всяка отпечатана предварителна сметка — отделен ред „Предварителна сметка“ с часа и служителя, без сума. Показват се само успешните печати; неуспешен опит (грешка на принтера) не се вижда. Работи и за старите сметки — данните идват от одита, където всеки печат вече се записваше. Предварителна сметка, отпечатана без интернет, не се показва. Бекенд 0.0.268 — GET /bills/{id}/operations връща нов тип събитие preliminary_bill; двете страни се качват заедно.",
      },
    ],
  },
  {
    version: "0.0.267",
    date: "2026-09-21",
    entries: [
      {
        type: "feature",
        text: "Полето за търсене над каталога в „Маркиране“ на компютър се връща — като настройка на ресторанта: Конфигурация → Маркиране → Каталог → „Търсачка над каталога“ (Скрита | Показана). По подразбиране е скрито и търсенето става както досега — с клавиатурата и плаващия надпис. Показано ли е, в полето се пише, а − и + вътре в него не се изписват, а сменят бройката на избрания продукт; ↑/↓, Enter (Поръчай), F9 и Esc също работят от полето, а ←/→ местят курсора в написаното (старият дефект, заради който полето беше махнато в 0.0.242). На телефон и таблет полето е винаги видимо. Бекенд 0.0.267 — нов PUT /configuration/ordering-search-field и поле orderingSearchField в configuration; двете страни се качват заедно.",
      },
    ],
  },
  {
    version: "0.0.266",
    date: "2026-09-21",
    entries: [
      {
        type: "improvement",
        text: "„Продажби по периоди“ — колоните са преподредени по това, което човек сверява. „Сума ФП“ (частта от сумата по сметки с касова бележка; досега „С бон“, скрита) стои до „Сума“ и е видима по подразбиране; „Артикули“ е „Брой асортименти“. „Отклонение“ и „Отклонение %“ са махнати — на тяхно място „Отстъпки“ и „Надбавки“ поотделно, така че ден с равни отстъпки и надбавки вече не изглежда без нито едно от двете. „Клиенти“ е „Клиенти брой“, до него нови „Клиенти сума“ (оборотът по сметки с клиент) и „Клиенти средна сума“. Отделните „В брой“/„С карта“ са махнати — дублираха колоните по метод на плащане, които вече са само с името на метода, без „(както е платено)“. Excel износът е в същия ред. Бекенд 0.0.266 — нови полета client_revenue, discount и markup във всеки ред и в обобщението; двете страни се качват заедно.",
      },
      {
        type: "improvement",
        text: "„Δ спрямо предишния период“ в „Продажби по периоди“ вече сравнява с това, което човек има предвид: един ден — със същия ден от седмицата преди 7 дни (понеделник с миналия понеделник, не с неделя), точно 7 дни — с миналата седмица, цял месец — с миналия месец; друг период — със същия брой дни назад. Тече ли още периодът, миналият се брои до същия час. Кутийките са по-ниски — заглавие и число, без описания, а на широк екран редът с тях е събран в средата вместо разпънат; при включено сравнение отдолу застават процентът и спрямо какво е: „пн 14.09 · 947.15 €“. Останалите справки сравняват както досега.",
      },
    ],
  },
  {
    version: "0.0.265",
    date: "2026-09-21",
    entries: [
      {
        type: "fix",
        text: "Гласовата поръчка вече работи на iPhone (Safari, Chrome и инсталираното приложение), Android, таблети и всички настолни браузъри — не само в Chrome на компютър. Досега речта се разпознаваше от самия браузър, а на телефон това API липсва или спира само: бутонът оставаше „натиснат“ и нищо не се случваше. Сега телефонът само записва звука, докато бутонът е задържан (брояч на секундите вместо текст на живо), а разпознаването става на сървъра; после върви същият преглед и „Поръчай“. Записът не тръгва сам — само при задържане, и се спира веднага при пускане или затваряне на прозореца. Имената от менюто се подават на разпознаването като подсказка, така че необичайни ястия („тарамосалата“, „куатро формаджи“) се чуват вярно. Бекенд 0.0.265 — нов POST /voice/transcribe (OpenAI gpt-transcribe, същият ключ; моделът се задава с OPENAI_TRANSCRIBE_MODEL), SDK openai 3.16.2 и нова зависимост python-multipart.",
      },
    ],
  },
  {
    version: "0.0.264",
    date: "2026-09-21",
    entries: [
      {
        type: "improvement",
        text: "Часовник чч:мм:сс долу вляво в лентата с бутоните на екрана с масите — в същия моно шрифт като сумите. Само на големи екрани; на телефон и таблет го няма. Бекенд 0.0.264 — само номер на версия.",
      },
    ],
  },
  {
    version: "0.0.263",
    date: "2026-09-21",
    entries: [
      {
        type: "feature",
        text: "Екранът „Въведете код“ на общ терминал вече има своя тема — бутон горе вдясно (слънце/луна) отваря същия избор Светла/Тъмна като в профилното меню. Темата е на самия общ акаунт и се помни на всяко устройство, където той е влязъл. Служителят, влязъл с код, продължава да вижда СВОЯТА тема, а след изхода му екранът се връща към темата на терминала. Досега ПИН екранът беше винаги светъл. Бекенд 0.0.263 — само номер на версия.",
      },
      {
        type: "improvement",
        text: "Дълга сметка в екрана с масите се показва от края — там е последната поръчка. Списъкът вдясно скролира до дъното при избор на маса и когато по нея се появят нови редове; опресняване без нови редове (сервиране, статус от кухнята) не го мърда, за да не дърпа сервитьора, докато го разглежда.",
      },
      {
        type: "improvement",
        text: "„Преглед на поръчката“ в Маркиране (и мобилният панел) при всяко маркиране докарва в полезрението реда с току-що добавеното, включително когато бройката се е сляла в последния ред. Степерът „+“ на ред по средата, редакцията от молива, намаляването и махането не скролират — ръката е на реда, който се пипа.",
      },
    ],
  },
  {
    version: "0.0.262",
    date: "2026-09-18",
    entries: [
      {
        type: "feature",
        text: "Нова справка „Продажби по периоди“ (Справки → Продажби) — оборотът, нарязан по време. Два режима: „Групирано“ слива всички дни от периода по час от денонощието, ден от седмицата или месец (кога през деня и седмицата се продава), а „Във времето“ върви хронологично по час, дата, месец или година. Над таблицата стоят филтри по станции, потребители, клиенти (вкл. „без клиент“) и артикули; всяка колона има сортиране и филтър, а кутийките, лентата по методи на плащане и графиката следват показаните редове. Клик върху ред отваря дните зад него, има Δ спрямо предходния период, Excel и мобилни карти. Пренесена от старата справка на TouchSale — без „заведение“, „работни точки“ и разбивка по маса, които в облака нямат смисъл.",
      },
      {
        type: "improvement",
        text: "Колоните на „Продажби по периоди“: сметки, количества, сума след отстъпки, ДДС и нето по ставката на артикула, средна цена и средна сметка са видими; в панела „Колони“ чакат клиенти, в брой/с карта (смесеното разпределено пропорционално), по метод както е платено, сума с бон, сума по базови цени и отклонението от тях (отстъпки и надбавки). Часът е реалният час от денонощието, а датата/денят/месецът са по работната дата — сметка в 01:00 е от предишната смяна.",
      },
      {
        type: "breaking",
        text: "Справката е зад НОВО право „Справка продажби по периоди“ (view_sales_by_periods_report), което идва от seed-а на организацията и се дава от org админа; пресетът „Управител“ го получава автоматично. Бекенд 0.0.262.",
      },
    ],
  },
  {
    version: "0.0.261",
    date: "2026-09-18",
    entries: [
      {
        type: "feature",
        text: "„Оптимизация с база“ (Конфигурация → Маркиране, с код 2) отново пренарежда номерата на сметките без дупки — но вече заедно с касите. Досега пренареждането беше спряно, защото касата помни издадените бонове и картовите плащания по СЪЩИЯ номер: върнатата номерация подаваше на чисто нова сметка бона на предишния носител, с чужда сума и без хартия. Сега операцията е в четири хода — пита всяка каса, изтрива сметките, зачиства историята на всяка каса и чак тогава пренарежда номерата. Откаже ли или не отговори някоя каса, номерата не се пипат и нищо не се разминава.",
      },
      {
        type: "breaking",
        text: "След „Оптимизация с база“ касите губят историята си: издадените бонове, картовите плащания, дневните приключвания на ПОС терминала и всичко от локалния режим. Настройките на принтерите и на самата каса ОСТАВАТ. Това значи, че сторно на бон отпреди оптимизацията след това не може да се направи от системата, а дневните приключвания, които банките искат назад във времето, вече няма да са там. Касата прави резервно копие непосредствено преди зачистването. Операцията отказва изцяло, ако някоя каса е в локален режим, държи неизпратени офлайн сметки, незавършен документ или неуредено картово плащане.",
      },
      {
        type: "improvement",
        text: "В локален режим бутонът „Оптимизация с база“ е заключен с обяснение защо: операцията минава през облака и през всяка каса. Бекенд 0.0.261, FiscalAPI 1.83.0 — и трите трябва да са обновени.",
      },
    ],
  },
  {
    version: "0.0.260",
    date: "2026-09-18",
    entries: [
      {
        type: "fix",
        text: "Справките „Продадени продукти“ и „Продадени рецепти“ вече показват САМО продажби от разнесени отчети. Досега продаденото се появяваше веднага след маркиране и закриване на сметка — без да е пускан отчет — което подвеждаше, защото от склада реално се изписва чак при разнасяне. Същото важи и за разбивката по дни зад клика върху ред. Анулирано разнасяне връща отчета в „неразнесени“ и редовете му изчезват от двете справки. Празният екран вече обяснява защо е празен. Бекенд 0.0.256.",
      },
      {
        type: "improvement",
        text: "Доставка и Изписване вече казват ясно, когато в организацията НЯМА създаден нито един склад: при натискане на „Заприходи“ / „Изпиши“ излиза „Няма създаден склад. Създайте склад в организацията, преди да записвате движения.“, а същият текст стои и в подсказката до бутона. Дотук и в двата случая пишеше „Изберете склад“ — което подсказва избор, какъвто няма откъде да се направи. Когато складове има, но не е избран, съобщението си остава „Изберете склад“.",
      },
      {
        type: "feature",
        text: "По време на доставка вече може да се създаде нов складов продукт, без да се излиза от документа. В десния край на търсачката има бутон „Нов продукт“, който отваря прозорче със същите полета, същата подредба и същите задължителни полета както екрана „Продукти“ в организацията: име, код за експорт, група, мерна единица, ДДС, фира, минимално количество, разфасовки и двете отметки за следене на партида и срок. Задължителни са име, мерна единица и ДДС — отбелязани са със звездичка. Записът отива в общия справочник на организацията, тоест продуктът се вижда веднага навсякъде, а в текущата доставка ред за него се добавя автоматично с курсор в количеството. Ако името или кодът за експорт вече се ползват, записът се отказва с обяснение. Продаваемото (частта „Като рецепта“) НЕ се създава оттук — то си остава работа на организацията.",
      },
      {
        type: "fix",
        text: "При доставка въведената стойност вече не се разминава със записаната. Досега, ако напишеш количество 48 и Нето 7.80 €, ед. цена ставаше 0.16 вместо точната 0.1625 и документът след запис излизаше 7.68 € — дванадесет стотинки по-малко от въведеното. Причината беше в закръгляването на ед. цената до два знака, докато базата я пази с четири, а сумата на реда се смята от нея. Сега цената се пази цяла (показва се 0.1625, а обикновената цена си остава с два знака, напр. 1.20), а Нето/Бруто при напускане на полето показват точно сумата, която ще се запише. Същото важи при редакция на стара доставка, при цена от последна доставка и при попълване от минал документ. При много голямо количество четирите знака може да не стигнат (1000 бр. за 7.77 € дава 7.80 €) — в такъв случай редът показва истинската сума веднага, вместо да я откриеш чак в документа.",
      },
      {
        type: "feature",
        text: "Справка „Наличности“ получи същия бутон „Скрий без наличност“ — горе, вляво от избора на склад. Натиснат, показва само продуктите, от които има нещо в склада; повторно натискане връща всички. Филтърът важи и върху резултата от търсачката. Понеже броячите горе и редът „Общо“ се смятат от показаните редове (както е и при търсене), при скрити нулеви редове броячът „Продукти“ показва колко реда виждаш; стойностите не се променят, защото нулева наличност не носи сума. Внимание: продукт с нулева наличност се крие и когато е под минимума си — за поръчките гледай справката с филтъра изключен.",
      },
      {
        type: "feature",
        text: "В инвентаризацията се появи бутон „Скрий без наличност“ горе вдясно, до полето за бележка. Натиснат, той маха от листа всички продукти, чието „Търсено“ е 0 — в склад с хиляди артикула остават само тези, които наистина се броят. Повторно натискане връща всички. Две неща остават видими независимо от бутона: ред, в който вече е писано в „Намерено“ (например излишък по продукт с нулева наличност), и продукт, избран от търсачката. Филтърът е само изглед: не влиза в черновата, не се помни между отварянията и не променя нито сумите, нито това, което се записва.",
      },
      {
        type: "feature",
        text: "В инвентаризацията полето „Намерено“ вече смята само. Ако си преброил 10 на рафта и после откриеш записка за още 5, пишеш „10+5“ и щом излезеш от полето вътре стои 15 — разликата, липсата и излишъкът се преизчисляват веднага. Работи и с изваждане („15-2“ става 13), и с дробни числа („10,5+2“ става 12,5), и с няколко части наведнъж. Тълкуват се само събиране и изваждане; ако сметката излезе отрицателна (напр. „2-5“), полето показва 0, защото преброено количество не може да е под нула.",
      },
      {
        type: "improvement",
        text: "В Склад → Конфигурация полето „Склад по подразбиране“ вече показва склада, който модулът РЕАЛНО ползва, вместо да стои празно. При един-единствен склад той се вижда избран, без да се налага да се задава ръчно; при няколко — вижда се кой се ползва, докато не бъде избран друг (това е първият създаден склад). Дотук показаното и действителното се разминаваха: модулът отдавна работеше с първия склад, а полето изглеждаше непопълнено.",
      },
      {
        type: "feature",
        text: "При доставка вече може да се запише нов доставчик, без да се излиза от документа. Първият ред в падащото меню „Доставчик“ е „Нов доставчик“ и отваря прозорче със същите три полета, както в „Доставчици“ на организацията — име, ЕИК и ДДС номер. Записът отива в същия общ списък на организацията, тоест новият доставчик се вижда веднага навсякъде, а в текущата доставка се избира автоматично. ЕИК-ът се проверява с контролната си цифра, а ако ЕИК или ДДС номер вече се ползва от друг доставчик, записът се отказва с обяснение. Важно за ДДС номера: доставчик БЕЗ ДДС номер значи доставка без начислено ДДС, тоест бруто остава равно на нето. Бекенд 0.0.256.",
      },
    ],
  },
  {
    version: "0.0.259",
    date: "2026-09-17",
    entries: [
      {
        type: "fix",
        text: "Заведение, в което „Оптимизация с база“ вече е пускана, продължаваше да раздава номера на сметки, които касата помни. Предишната версия спря пренареждането занапред, но броячът на номерата беше останал върнат назад от предишните пускания — тоест следващите сметки пак минаваха през вече използвани номера. Сега броячът се избутва еднократно над всичко, което базата още вижда някъде, и повторение няма откъде да дойде. Нищо не се изтрива и нищо не се преименува — просто следващата сметка получава номер над всички досегашни.",
      },
    ],
  },
  {
    version: "0.0.258",
    date: "2026-09-17",
    entries: [
      {
        type: "fix",
        text: "„Оптимизация с база“ вече НЕ пренарежда номерата на сметките. Досега операцията изтриваше закритите в брой без бон и след това преномерираше останалите без дупки — номерацията се връщаше назад и следващите сметки получаваха номера, които вече са живели. Касата обаче пази регистър на издадените фискални бонове точно по този номер: новата сметка получаваше бона на предишния носител, затваряше се с чужд номер и чужда сума, а на хартия не излизаше нищо. При изключен интернет беше още по-тихо — събитие за сметка, записано офлайн, можеше да легне върху съвсем друга сметка. Отсега оцелелите сметки пазят номерата си, в номерацията остават дупки (те не пречат на нищо — номерът на масата е друго нещо), а нова сметка никога не получава номер на изтрита. Текстът на картата и на потвърждението вече казват какво наистина прави операцията: изтрива безвъзвратно и иска бекъп.",
      },
    ],
  },
  {
    version: "0.0.257",
    date: "2026-09-17",
    entries: [
      {
        type: "improvement",
        text: "Устройствата се подготвят за работа без интернет сами, без обиколка. За да стигне един екран до касата в локалната мрежа, браузърът иска разрешение — и го иска САМО при действие на човек, затова досега всяко устройство трябваше да бъде посетено и да му се натисне „Подготви това устройство“ (а на телефон скриптът за компютрите изобщо не се пуска). Сега, ако проверката не намери касата, приложението изчаква първото докосване по екрана и я повтаря в него: подканата на браузъра излиза по време на обичайната работа, човекът натиска „Разреши“ и устройството е готово. Заедно с подканата излиза и ред на български какво се пита, защото „Блокирай“ е окончателно; ако разрешението вече е отказано, редът казва как се връща. При обект с пет-десет точки това е нула посещения вместо едно на устройство. Бутонът „Подготви това устройство“ остава за подготовка предварително, а за фирмени устройства под управление (GPO/MDM) разрешението може да се раздаде и централно.",
      },
    ],
  },
  {
    version: "0.0.256",
    date: "2026-09-17",
    entries: [
      {
        type: "improvement",
        text: "Включването на локалния резерв при обект става видимо и просто. Редът „Локален резерв“ в Конфигурация → Устройства вече показва и ГОТОВНОСТТА: колко различни устройства реално са ползвали касата през последните 24 часа, колко действия чакат да се качат, колко чакат човек и кога касата е била видяна за последно — дотогава единственият начин да се разбере дали едно устройство ще проработи офлайн беше да спре интернетът. Добавен е бутон „Подготви това устройство“ (в Конфигурация и на екрана на мониторите): натиснат от човек, той иска от браузъра достъп до локалната мрежа — подканата излиза само при действие на човек, затова кухненски екран не можеше да я получи — проверява дали касата отговаря и изтегля предварително менюто, плащанията и потребителите за този терминал. Отговорът е едно изречение: това устройство ще работи офлайн или какво да се направи. Изисква FiscalAPI 1.81.0 и бекенд 0.0.256.",
      },
      {
        type: "fix",
        text: "Сметка, закрита в брой БЕЗ касова бележка („Закриване на сметка(1)“ — трите клика), вече не може да се фактурира. Такава сметка няма фискален документ, срещу който да се издаде фактура, а и почистването на сметки без бон я трие. Отсега тя не се показва в списъка на „Фактуриране“ в Маркиране, нито в избора на сметки при фактуриране от справките, а в „История на операциите“ бутонът „Фактуриране“ стои сив и при натискане обяснява защо. Правилото важи и в бекенда (0.0.256) — заявка с такава сметка се отказва, дори да е пратена директно. Останалите закрити сметки без бон се фактурират както досега: „Плащане по сметка“, метод „БЕЗ ФИСКАЛИЗИРАНЕ“, както и карта или смесено плащане с неуспяла фискализация. Сметка в брой, чийто бон не е излязъл заради проблем с принтера, също е спряна, докато не бъде фискализирана от „Фискални проблеми“ или от „Възстановяване на сметка“ — след излизането на бона тя пак подлежи на фактуриране.",
      },
    ],
  },
  {
    version: "0.0.255",
    date: "2026-09-16",
    entries: [
      {
        type: "fix",
        text: "Кухненският екран вече казва, когато не е свързан. Досега празната дъска изглеждаше еднакво в двата случая — спокойна кухня и прекъсната връзка — и пишеше „Новите поръчки ще се появят автоматично“ дори когато нищо повече нямаше да пристигне. Сега при липса на връзка екранът е с червена икона, „НЯМА ВРЪЗКА“ и изречение, че нови поръчки НЕ пристигат и трябва да се извика отговорник. Освен това екран, чийто пропуск към касата е изтекъл (например останал включен през нощта), опитва пак сам на всеки 30 секунди вместо да чака някой да го презареди.",
      },
    ],
  },
  {
    version: "0.0.254",
    date: "2026-09-16",
    entries: [
      {
        type: "fix",
        text: "Още четири места, където сметка или ред, създадени БЕЗ интернет, не се разпознаваха веднага след връщането му: разделяне на сметка, разделяне с плащане, отстъпка по сметка и промяна на цена на ДОБАВКА. Всяко от тях отказваше с „не е намерена“ в първите секунди след превключването, докато екранът още показва временните номера. Сега облакът превежда и тях. Бекенд 0.0.254.",
      },
    ],
  },
  {
    version: "0.0.253",
    date: "2026-09-16",
    entries: [
      {
        type: "fix",
        text: "Сметка, отворена БЕЗ интернет, остава работеща и след като интернетът се върне. Докато обектът е на касата, новите маси получават временни номера от нея; при връщането облакът им дава истински, а терминалът продължаваше да иска стария — маркирането отговаряше „Сметка с номер 1000000000 не е намерена“, а екранът оставаше със заредена, но невидима сметка. Вече облакът приема и временния номер (превежда го към истинския при всяко действие — закриване, сторно, отстъпка, промяна на цена, смяна на статус), а терминалът при връщането пита под кой номер е сметката горе и продължава с него. Това важи и за втори терминал, за кухненски монитор и за предварителна сметка, отпечатана офлайн — всички те носят стария номер. Нищо не се губи: сметките и редовете, маркирани офлайн, вече бяха в облака, просто бяха недостижими със стария номер. Бекенд 0.0.253.",
      },
    ],
  },
  {
    version: "0.0.252",
    date: "2026-09-16",
    entries: [
      {
        type: "fix",
        text: "Връщане от локален режим в обект, чийто адрес на облака не следва обичайното име. Досега касата сама извеждаше адреса, на който да изпрати дневника си, от адреса на MQTT сървъра. Където бекендът стои на друго име, дневникът тръгваше към съвсем друго приложение и то отговаряше „не приемам такава заявка“: терминалът оставаше на „интернетът се върна — изчаква се касата да изпрати дневника си“, закриването от друго място продължаваше да е спряно, а на екрана нямаше нищо, което да каже защо. Вече облакът казва адреса си сам, в пакета с настройки към касата. Получи ли касата стар пакет без него, тя пробва вероятните адреси и проверява кой от тях наистина приема дневник — с истинска заявка, а не с „жив ли е сървърът“, защото на същия домейн може да отговаря друго приложение. Сгреши ли адресът, следващият опит го търси наново, а в панела на касата пише откъде е взет: получен от облака, открит и проверен, или изведен по име. Изисква FiscalAPI 1.79.0 на касата. Промяната е в бекенда (0.0.252) и в касата; в терминала няма нищо ново.",
      },
    ],
  },
  {
    version: "0.0.251",
    date: "2026-09-16",
    entries: [
      {
        type: "fix",
        text: "Обновяване до нова версия — инсталирано приложение (PWA) и браузър. Досега след качване на нова версия терминалът продължаваше да работи със старата: изходът и връщането до екрана с кода не помагаха, а известието „Налична е нова версия“ идваше чак час след отварянето на прозореца. Вече: при всяко връщане към екрана с кода (общ терминал) и към екрана за вход приложението само проверява дали има нова версия и, ако има, се презарежда тихо — там няма отворена работа, затова не пита никого. Докато се пише код или тече вход, не презарежда. На работните екрани известието с бутона „Презареди“ идва веднага при отваряне и при връщане към прозореца, не само веднъж на час; при отворена сметка нищо не се презарежда само — както досега, човекът решава кога. Проверката гледа самия качен пакет, а не настройка от сървъра, така че всеки нов деплой се засича без допълнителна конфигурация. Бекенд 0.0.251 е само номер на версия, без промени.",
      },
    ],
  },
  {
    version: "0.0.250",
    date: "2026-09-16",
    entries: [
      {
        type: "feature",
        text: "Локален резерв при спрял интернет. Когато връзката с облака падне, терминалите не спират: след три неуспешни опита (~15 секунди) те сами минават на касата по локалната мрежа и продължават да отварят маси, да маркират, да местят, да сторнират и да закриват с бон. Касата пази всяко действие в свой дневник и щом интернетът се върне, го изпраща в облака в реда, в който се е случило — сметките, бележките и бонът стигат горе сами, без никой да преписва нищо. Лента най-горе казва в кой режим е терминалът и колко действия чакат. Резервът е ИЗКЛЮЧЕН по подразбиране и се включва за всеки обект поотделно от Конфигурация → Устройства → „Локален резерв“; докато не се включи, всичко работи точно както досега. Изисква Chrome или Edge 142 и по-нов на терминала (веднъж се пита за достъп до локалната мрежа), бекенд 0.0.250 и FiscalAPI 1.78.0 на касата. iPhone и iPad не се поддържат — Safari няма нужното разрешение.",
      },
      {
        type: "improvement",
        text: "Докато терминалът е на касата, закриването на сметка от ДРУГО място е спряно: облакът отказва с ясен текст „Касата работи в локален режим без интернет. Закриването е възможно само от касата.“ Така една продажба не може да получи два бона — един от касата офлайн и един от телефон с мобилен интернет. Отварянето и маркирането от другите места си остават разрешени. Ограничението пада само след като касата обяви, че е изпратила дневника си.",
      },
      {
        type: "improvement",
        text: "Терминалът не се връща в облака, докато касата държи нещо неизпратено. Действие, което облакът е отказал и касата не може да качи сама, се показва на екрана „Локален режим“ в панела на самата каса с два бутона — „Опитай пак“ и „Отпиши“. Докато има такова, лентата предупреждава колко действия чакат човек, а терминалът остава на касата: продажбата съществува само в нейния дневник и не бива да изчезне с връщането.",
      },
    ],
  },
  {
    version: "0.0.249",
    date: "2026-09-16",
    entries: [
      {
        type: "improvement",
        text: "„Маркиране“: панелът с филтри вдясно (над „Преглед на поръчката“) вече помни дали е разгънат — точно както редът над каталога. Натиснеш ли „Всички“ вдясно, изборът се записва към потребителя и го следва на всяко устройство; досега се забравяше при всяко влизане в масата. Двете секции са напълно независими една от друга: горе може да е разгъната, а вдясно свита, и обратно. Свито вдясно остават видими два реда с плъзгане вътре, както досега. Изисква бекенд 0.0.249 и миграция на организационната база (4a7c2e9b1f36); досегашният избор за реда над каталога се запазва.",
      },
    ],
  },
  {
    version: "0.0.248",
    date: "2026-09-16",
    entries: [
      {
        type: "improvement",
        text: "„Маркиране“ → каталогът: след маркиране с „+“ или „−“ (клавиш или бутоните на брояча в реда/картата) търсачката се зачиства ВЕДНАГА — досега се изчакваше една секунда. Списъкът се връща към пълния каталог, а фокусът остава върху същия продукт, така че следващото „+“ добавя още бройка от него. При продукт със задължителни добавки зачистването изчаква прозореца „Промени“ и идва след „Добави“ — както досега.",
      },
      {
        type: "fix",
        text: "„Маркиране“ → „Преглед на поръчката“ (панелът вдясно на компютър): при по-тесен екран надписът на оранжевия бутон се пречупваше на два реда. Под 1280px ширина бутонът вече показва само „Поръчай“ — сумата пада, защото панелът е твърде тесен за нея. Общата сума си остава видима точно над бутона, в реда „Общо“. На по-широк екран бутонът е както досега („Поръчай · {сума}“), а на телефон сумата се вижда винаги.",
      },
      {
        type: "improvement",
        text: "Вход: паролата вече се приема от 3 символа нагоре — досега формата и сървърът отказваха по-къса от 6. Съществуващите пароли и начинът на влизане не се променят; изискването за потребителско име (поне 3 символа) е същото. Смяната важи само за влизането — правилата при създаване на потребител са в отделния модул за организации.",
      },
    ],
  },
  {
    version: "0.0.247",
    date: "2026-09-15",
    entries: [
      {
        type: "security",
        text: "Модули → „Складова база“: при заведение с архивиране модулът вече не се вижда и не се отваря без потвърден код 2 (пин 2) — плочката липсва в „Модули“, а директен адрес към която и да е страница на склада връща към „Модули“. След потвърждаване на кода (три натискания върху името в „Модули“) плочката се появява веднага; сваля ли се кодът (Esc в „Модули“), тя изчезва пак. При роли „Маркиране“ + „Складова база“ екранът „Модули“ вече не прескача автоматично към „Маркиране“, докато складът е скрит, за да остане достъпен входът за кода. При неархивирано заведение нищо не се променя. Без промяна по BE.",
      },
    ],
  },
  {
    version: "0.0.246",
    date: "2026-09-15",
    entries: [
      {
        type: "feature",
        text: "Локален резерв (режим без интернет): при загуба на интернет „Маркиране“ и мониторите продължават да работят срещу главната каса (FiscalAPI по адреса ѝ в локалната мрежа) — маркиране, кухненски билети, предварителна сметка и закриване с фискален бон. Приложението само разпознава липсата на интернет (три поредни неуспешни проверки), превключва към касата и показва лента „Локален режим — без интернет, работиш срещу касата“; връща се към облака автоматично, щом интернетът се появи и касата изпрати направеното без връзка. Служител, влязъл с код без интернет, при връщането въвежда кода си отново. Функциите извън обхвата на касата (справки, склад, фактури, отстъпки и клиенти, промяна на цена, разделяне, прехвърляне, възстановяване, гласови поръчки, каса/операции, отчети, повторно закриване на сметка без бон) са временно недостъпни с подсказка „Недостъпно без интернет“. Изисква бекенд 0.0.246 и FiscalAPI 1.78.0 с включен резерв на главната каса; работи в Chrome/Edge (iPhone/Safari остават на облака).",
      },
      {
        type: "feature",
        text: "Конфигурация → Устройства: нов ред „Локален резерв“ — дали този браузър стига до главната каса (Готов / Няма достъп / Касата не е на връзка / Изключен), адресът ѝ и бутон „Провери“ (при първото натискане Chrome/Edge пита за достъп до локалната мрежа); оттук резервът се включва и изключва за ресторанта, а при нужда облакът се връща от локален режим с „Върни към облака“.",
      },
      {
        type: "improvement",
        text: "Приложението вече се отваря и без интернет (кеш на самото приложение в браузъра; данните не се кешират) — при прекъсване на връзката екранът не остава бял, а продължава в локален режим срещу касата. Известията (push) работят както досега.",
      },
      {
        type: "improvement",
        text: "При включен локален резерв списъкът с маси в „Маркиране“ се опреснява на всеки 10 секунди (и в облака, и срещу касата), за да е касата винаги с пресен списък за случай на прекъсване.",
      },
      {
        type: "improvement",
        text: "Локален резерв, втора част: презареждане на страницата без интернет вече не губи кой е влязъл — ролите и правата се помнят в браузъра от последното успешно зареждане и терминалът тръгва направо срещу касата (по запомнения режим или още при първата неуспешна заявка), без да чака трите проверки; служител на общ терминал остава влязъл, а ПИН екранът работи срещу касата и от студен старт. При всяко превключване облак ↔ каса самоличността се презарежда от новия източник. Срещу касата вече работят и „Клиенти“ (вкл. клиент при нова маса), „Отстъпки“ по продукти, „Промяна на цена“, „Прехвърли“ на една сметка, „Операции“ (X/Z отчет, служебен внос/износ) и „Закрий“ на закрита без бон сметка (повторна фискализация). Остават недостъпни без интернет: „Раздели“, „Отчет“, „Фактуриране“, „Възстанови“, гласовите поръчки, отчетът от фискалната памет и „Прехвърли всичките ми маси“. Изисква бекенд и FiscalAPI с втората част на резерва.",
      },
      {
        type: "improvement",
        text: "Локален резерв, трета част: терминал, изгасен през нощта или уикенда, вече не е мъртъв без интернет. Той тръгва срещу главната каса дори когато „пропускът“ му за нея е изтекъл, и показва екрана за вход с лента „Локален режим — влез с код или парола“: служителят влиза с кода си, а личният акаунт — с потребител и парола (касата ги проверява от последното копие на данните и показва своите съобщения, включително при няколко поредни грешни опита). След успешния вход терминалът работи както обикновено срещу касата. При стартиране приложението вече пита ЕДНОВРЕМЕННО облака и касата и остава в облака, ако той отговаря — така един терминал не спира касата за целия обект. При вход с включен резерв касата тихо получава клиентите с отстъпка, методите на плащане, менюто и сервитьорите, за да не са празни в първия час без интернет. При ИЗКЛЮЧЕН резерв стартът на приложението е точно както преди — нищо не се помни в браузъра.",
      },
      {
        type: "improvement",
        text: "Локален резерв, четвърта част: и терминал, от когото е излязъл потребител (бутонът „Изход“), тръгва срещу главната каса без интернет — браузърът помни адреса ѝ и след изход, така че екранът за вход показва лентата „Локален режим — влез с код или парола“ и входът минава през касата; „пропускът“ за касата и запомненият режим продължават да се изтриват при изход. Връщането към облака вече не става само по преценка на приложението: то винаги пита касата дали е изпратила направеното без връзка и дали сама е излязла от локален режим, и чака това — така маси, отворени без интернет, не изчезват от екрана след презареждане на страницата. Ако касата не отговори два пъти подред (изгасена или недостъпна), терминалът се връща в облака без тази проверка и записва предупреждение в дневника на браузъра.",
      },
      {
        type: "fix",
        text: "„Маркиране“ → „Промени“ (F9): с Tab вече се стига и до редовете на добавките, не само до модификаторите — редът е пред всичко останало: количество, добавки (и броячът на избраните), модификатори, коментар, бутони. Интервал (Space) отбелязва или маха фокусираната добавка, Enter остава „Добави“. Редовете, блокирани от лимита на задължителна добавка, се прескачат. Изборът с мишка и цените са без промяна.",
      },
      {
        type: "improvement",
        text: "„Маркиране“ → редът с групите над каталога и панелът над „Преглед на поръчката“: група, която има подгрупи, вече носи малка стрелка „›“ в десния край на кутийката като подсказка, че натискането ѝ отваря следващото ниво. Групите без подгрупи и станциите са без стрелка. Навигацията и филтрирането са без промяна.",
      },
      {
        type: "improvement",
        text: "„Маркиране“ → „Промени“ (F9 или бутонът във футъра): при отваряне на модала курсорът вече е в полето „Коментар“, за да може бележката да се напише веднага, без щракване. Количеството се сменя със степера или с щракване в полето му. Enter в коментара добавя продукта, Shift+Enter прави нов ред, Esc затваря — както досега. Важи на компютър; на телефон и таблет полето не се фокусира само, за да не изскача екранната клавиатура върху добавките.",
      },
      {
        type: "improvement",
        text: "Справки → „История на маси“: колоната „№ сметка“ (номерът на сметката в базата, изключена по подразбиране) вече се показва и може да се включи от панела „Колони“ само когато сесията вижда всички сметки — при неархивирано заведение винаги, а при заведение с архивиране само след потвърден код 2 (пин 2). Без код 2 колоната изобщо не съществува в справката, а запомнено сортиране по нея се връща към подразбираното (по „Отворена“). Останалите колони и експортът в Excel са без промяна.",
      },
      {
        type: "improvement",
        text: "„Маркиране“ → футър: бутонът за подредбата на каталога вече показва „КОД“ вместо „PLU“, когато асортиментите/рецептите са подредени по код; при подредба по име остава „АБВ“. Сменен е само надписът — подредбата, търсенето по цифри и запомнената лична настройка са без промяна.",
      },
      {
        type: "fix",
        text: "Локален резерв, пета част (поправки след проверка в браузър): кухненският и барският монитор вече тръгват без интернет и когато екранът не е бил отварян, докато е имало връзка — при вход касата тихо получава и настройките на монитора (станциите му), без които той показваше „Недостъпно без интернет“. Всеки монитор държи по една връзка на станция вместо по две. След вход срещу касата ролите се зареждат надеждно: провали ли се първият опит, приложението пита касата пак, вместо да остави терминала влязъл, но без достъп до нито един модул. И облак, който отговаря с грешка (5xx — сървърът отговаря, но не работи), вече се брои за недостъпен: резервът се пуска, вместо терминалът да стои срещу мъртъв облак при работеща каса; единична грешка от един екран не сваля терминала — решава проверката на облака.",
      },
      {
        type: "fix",
        text: "Локален резерв, шеста част: „синхронизиран“ вече не може да значи „нещо се изгуби“. Ако облакът е отказал окончателно действие, направено без интернет (например маса, чието създаване не е прието), касата го държи като НЕРАЗРЕШЕНО и лентата в локален режим го казва: „N действия не са стигнали до облака — вижте касата“. Предупреждението не спира работата — маркирането и закриването продължават — но терминалът НЕ се връща към облака, докато има такива, за да не изчезнат от екрана продажби, които съществуват само на касата; разрешават се от човек на самата каса („Опитай пак“ или „Отпиши“ в портала ѝ). Същият брой се вижда и в Конфигурация → Устройства → „Локален резерв“. Изисква FiscalAPI с шестата част на резерва; по-стара каса се държи както досега.",
      },
    ],
  },
  {
    version: "0.0.245",
    date: "2026-09-15",
    entries: [
      {
        type: "improvement",
        text: "Конфигурация → „Маркиране“: страницата вече съдържа само настройките на ресторанта (общи за всички терминали). Картите „Какво стои над каталога“ (групите или станциите) и „По какво се оцветяват асортиментите/рецептите“ (по група, по станция, без оцветяване) са преместени от личните настройки в настройките на ресторанта — важат за всички сервитьори и се сменят с правото за настройките на „Маркиране“. Досегашните лични избори за тези две не се пренасят: заведението тръгва от „Групите над каталога“ и „По група“. Изисква бекенд 0.0.245 и организационна база 0.0.121.",
      },
      {
        type: "improvement",
        text: "„Маркиране“, лични настройки: „Изглед на продуктите“, „Групите при отваряне“, „Как са подредени асортиментите“ и „Вид клавиатура“ отпадат от Конфигурация и се управляват само от самия модул, за да не изискват права до Конфигурация. Всяка смяна се записва веднага в базата и се помни при следващо влизане на всяко устройство (нищо не се пази в браузъра): „Плочки | Таблица“ (F7) във футъра сменя изгледа; ъгълчето „Всички“ над каталога свива/разгъва редовете с групи или станции; „БДС | Фонетична | ABC“ на екранната клавиатура (F8) сменя подредбата на клавиатурата.",
      },
      {
        type: "feature",
        text: "„Маркиране“ → футър: нов бутон „АБВ“ / „PLU“ до „Клавиатура“ превключва подредбата на асортиментите/рецептите в каталога — по име или по PLU код (продаваемите без код остават накрая, по име). Бутонът се показва само ако поне един артикул в менюто има PLU код.",
      },
      {
        type: "improvement",
        text: "„Маркиране“: редовете с групи/станции над каталога вече са свити по подразбиране за нов потребител (досега разгънати). Който вече ги е разгъвал, запазва избора си.",
      },
      {
        type: "improvement",
        text: "Конфигурация → „Маркиране“, редизайн: настройките са подредени в секции „Маси“ (обща номерация, ред на масите, нефинализирани маси), „Поръчки“ (закриване веднага след поръчка), „Известия“ (съобщения за успешно действие) и „Каталог“ (лентата над каталога, оцветяване на асортиментите/рецептите). Всеки ред има име и кратко описание вляво, превключвател с опциите вдясно и подсказка какво прави избраното; под „Лентата над каталога“ има скица на екрана, която се сменя според избора. „Оптимизация с база“ е в секция „Поддръжка“. Всички избори и стойности са същите, само видът е нов.",
      },
    ],
  },
  {
    version: "0.0.244",
    date: "2026-09-14",
    entries: [
      {
        type: "improvement",
        text: "„Маркиране“ → цветове на групите: подгрупа без собствен цвят вече взема цвета на групата, в която стои (само на прекия ѝ родител, не по-нагоре по дървото). Ако и родителят е без цвят, подгрупата остава неутрална, както досега. Групите със свой цвят не се променят. Важи навсякъде, където се оцветява „По група“ — бутоните на групите над каталога, редът с групите над прегледа на поръчката, фонът на редовете/плочките в каталога и цветната лента вляво на редовете в поръчката.",
      },
    ],
  },
  {
    version: "0.0.243",
    date: "2026-09-11",
    entries: [
      {
        type: "feature",
        text: "Конфигурация → „Маркиране“, настройки на ресторанта: нова карта „Съобщения за успешно действие“ с две опции — „Включени“ (както досега) и „Изключени“. При „Изключени“ зелените съобщения „Успешно…“ в „Маркиране“ (добавени продукти, запазен клиент, закрита маса, приложена отстъпка, отпечатан документ и т.н.) вече не се показват. Грешките и предупрежденията се показват винаги, независимо от настройката. Настройката е обща за всички терминали на ресторанта. Изисква бекенд 0.0.243.",
      },
      {
        type: "fix",
        text: "Архивирано заведение, сесия без код 2: досега се криеше всяка закрита сметка без фискален бон, включително „По сметка“, „По банка“ и другите методи без фискализиране. Вече се крие само сметката, закрита в брой с трите клика („Закриване на сметка(1)“) — всички останали закрити без бон се виждат и без код: в плана на залата в „Маркиране“ (закритата в брой с трите клика вече изчезва от него без код), в „Опции → Фактуриране“, „Справка сметки“, Дашборда, „Клиенти“, „Продукти“, „Сервитьори“, „Станции“, „Сторно“, „Разделяния“, „Промени на цени“, в персоналните отчети и отчетите на заведението и в списъка сервитьори за „Генериране на отчет“. Изисква бекенд 0.0.243.",
      },
      {
        type: "fix",
        text: "Почистване на сметки без бон (Конфигурация): трие вече само закритите в брой с трите клика („Закриване на сметка(1)“). Сметки „По сметка“, „По банка“, с метод „БЕЗ ФИСКАЛИЗИРАНЕ“ и платени с карта с паднала фискализация остават. Изисква бекенд 0.0.243.",
      },
      {
        type: "feature",
        text: "Конфигурация → „Маркиране“, лични настройки: нова карта „Как са подредени асортиментите/рецептите“ с две опции — „По азбучен ред“ (както досега) и „По PLU код“. При „По PLU код“ продуктите в каталога на „Маркиране“ се редят от най-малкия код нагоре — и в списъка (вътре във всяка група; групите остават в своя ред), и в грида; продаваемите без PLU код стоят накрая, по име. Търсенето по цифри и досега показваше PLU съвпаденията най-отгоре — това не се променя. Настройката е лична и следва сервитьора на всяко устройство.",
      },
      {
        type: "fix",
        text: "Дашборд → „Оборот по работни дни“: при „7 дни“ и „Този месец“ графиката вече показва целия избран период. Досега рисуваше винаги 14 дни до края на периода, което при „Този месец“ даваше само бъдещите дни до 30-о число без нито един реален. Сега бъдещи дни не се рисуват, краят е днешният работен ден, а при кратък период („Днес“, „Вчера“, „7 дни“) се виждат и предходните дни до общо 14 за сравнение. Цял месец се показва изцяло (до 62 дни), при повече дни графиката скролва настрани в картата.",
      },
      {
        type: "improvement",
        text: "Справки: справката „Отстъпки и надбавки“ вече се казва „Клиенти“ — и в менюто вляво, и в заглавието, и в експорта. Адресът ѝ е /reports/clients (старият /reports/discounts вече не съществува).",
      },
      {
        type: "improvement",
        text: "„Маркиране“ → каталог: в изгледа „Таблица“ отпадат заглавията на категориите над всяка група („ТЕСТ“, „ЗЕЛЕНИ САЛАТИ“…) и разстоянието между групите — картите с редовете лягат една под друга без празнини. В изгледа „Плочки“ разстоянието между картите е намалено. Редът на продуктите, групирането, търсенето и клавишите не се променят.",
      },
    ],
  },
  {
    version: "0.0.242",
    date: "2026-09-11",
    entries: [
      {
        type: "improvement",
        text: "„Маркиране“ → „Отстъпки“: бутонът вече е активен при избрана маса, без да е нужно първо да се кликне ред. Модалът е като „Раздели сметка“: горе стои един общ процент (стъпка −/+ и бързи 5/10/15/20/25/50%), под него всички асортименти/рецепти на сметката, всеки със стъпка колко бройки да получат отстъпката (напр. 2 от 6). Отдолу са „Избери всички“, колко реда са избрани, „Общо преди“ (сумата по менюто) и „Общо след“ (какво ще се плати). Редовете с отстъпка се отварят избрани със своя процент; премахването е отделен линк „Премахни приложените отстъпки“. Частично количество разделя реда на два (с и без отстъпка). Ред със заключена цена стои с катинар и не се избира. Записът е една операция за всички избрани редове.",
      },
      {
        type: "improvement",
        text: "„Раздели сметка“ и „Отстъпки“: количеството по ред вече се показва както в „Сторно“ — избраното число отгоре и „от N“ отдолу. В „Промяна на цена“ количеството се чете заедно с цената („4 × 10.50 €“) вместо дребно „×4“ до нея.",
      },
      {
        type: "improvement",
        text: "На телефон: в „Раздели сметка“ превключвателят „По продукти / По равно“ и броят избрани са центрирани на два реда; в „Сторно“ подзаглавието с масата, сметката и сумата е на един ред под заглавието, а „Избери всичко“ / „Брак“ са на свой ред над „Причина“; в „Отстъпки“ обобщението е на два реда ляво/дясно. Сумите в подзаглавията на „Сторно“ и „Раздели сметка“ са в „€“.",
      },
      {
        type: "feature",
        text: "„Маркиране“: при закачен клиент над списъка с поръчаното на масата стои лента с клиента — етикет с процента (както на картата на масата), името му, какво прави процентът („отстъпка -50% на всички асортименти“, при работа със склад — „рецепти“) и колко е спестено по сметката (при надбавка — колко е добавено). Ако някой ред е с друг процент (отстъпка по ред или променена цена), лентата казва на колко от редовете е приложен клиентският процент, напр. „на 4 от 5 асортимента“. Клиент с 0% се показва с името си и „без отстъпка“, без сума.",
      },
      {
        type: "feature",
        text: "„Закрий“: същата лента с клиента стои под заглавието на модала, а при „В брой“ и „Смесено“ над „Общо“ вече се вижда и откъде идва сумата — „Сума без отстъпка“ (зачертана) и „Отстъпка на клиента (-50%)“ с отрицателната сума; при надбавка редовете са „Сума без надбавка“ и „Надбавка на клиента (+X%)“. Без клиент модалът изглежда както досега. Самото закриване, методите и сумите не се променят.",
      },
      {
        type: "fix",
        text: "„Маркиране“ на компютър: клик в полето за търсене вече не разваля клавишите. Досега, ако операторът кликнеше в търсачката, „+“ и „−“ се изписваха в полето вместо да добавят/махат от маркирания продукт, а стрелките спираха да местят маркера. Причината беше самото поле — щом е на фокус, клавиатурата пише в него. Затова на компютър полето за търсене е премахнато; на телефон и таблет си остава както досега, със системната клавиатура.",
      },
      {
        type: "improvement",
        text: "„Маркиране“ на компютър: написаното от клавиатурата се показва като плаващ надпис в горната част на каталога, върху леко замъглен полупрозрачен фон. Надписът стои само докато се пише и изчезва секунда след последния клавиш, а каталогът остава филтриран. Буквите след последното съвпадение са в ярко червено, за да е ясно, че за тях няма продукт. Търсенето с букви/цифри, Backspace, Esc и изчистването секунда след „+“/„−“ работят както досега; екранната клавиатура (F8) също.",
      },
    ],
  },
  {
    version: "0.0.241",
    date: "2026-09-10",
    entries: [
      {
        type: "improvement",
        text: "„Маркиране“: групите и станциите (над каталога и над прегледа на поръчката, независимо кое къде стои) вече са подредени в мрежа от кутийки с еднаква ширина, подравнени в колони. Височината на кутийките и отстоянието между тях са същите като досега. Над каталога се събират колкото кутийки има място (минимум 108px всяка), над прегледа са винаги 3 на ред. Къщичката е кутийка като останалите — над каталога с иконка и надпис „Всички“, над прегледа само с иконка — така под нея не остава празно място.",
      },
      {
        type: "improvement",
        text: "„Маркиране“: дълго име на група или станция вече не разширява кутийката. Име от две и повече думи минава на втори ред в същата височина, а каквото не се събере и на него, се реже с многоточие; име от една дума, която не се събира, се реже с многоточие без чупене по средата. Текстът е центриран, при станциите цветната точка стои непосредствено пред него.",
      },
      {
        type: "fix",
        text: "„Маркиране“: група без зададен цвят вече е неутрална (бяла кутийка с рамка), както и продуктите ѝ при оцветяване „По група“. Досега група без цвят наследяваше цвета на родителската си група, а без такъв получаваше измислен кехлибарен нюанс според мястото си в списъка — затова групи, на които никой не е задавал цвят, излизаха оцветени и цветът им се сменяше при разместване. Вече се ползва само цветът, зададен на самата група.",
      },
    ],
  },
  {
    version: "0.0.240",
    date: "2026-09-10",
    entries: [
      {
        type: "feature",
        text: "„Маркиране“ → „Клиенти“: клиент с 0% отстъпка вече е валиден и се показва в списъка. Досега нулата се четеше като „няма отстъпка“ и такъв клиент нито се виждаше, нито можеше да се закачи към сметка — а той е нужен за име по сметката и за „Плащане по сметка“. Закаченият клиент с 0% се вижда в панела на поръчката с „0%“ (без знак) и има ред „Премахни“ в модала; на картата на масата стои само името му, без етикет с процент. Цените не се променят.",
      },
      {
        type: "improvement",
        text: "Сметка без клиент вече се пази без процент (празно), а не като 0% — така „има ли закачен клиент“ вече не зависи от процента. Старите сметки се прекодират автоматично при обновяването: нула без закачен клиент става празно, нула със закачен клиент остава 0. Справките и отчетите четат това като „без отстъпка“, както досега.",
      },
      {
        type: "improvement",
        text: "Справка „Отстъпки“: процентът на клиента се показва без излишни нули — „0 %“ и „10 %“ вместо „0.0 %“ и „10.0 %“; „12.5 %“ остава с десетичната. И в таблицата, и в картата на телефон. Експортът в Excel не се променя.",
      },
      {
        type: "fix",
        text: "„Маркиране“, плочков изглед: при маркирано количество бутоните − N + вече не правят плочката (и целия ред плочки) по-висока. Степерът е със същия размер като в списъка и стои долу вдясно, на линията на цената; името не се свива и плочката пази точно същата височина и с, и без количество.",
      },
    ],
  },
  {
    version: "0.0.239",
    date: "2026-09-09",
    entries: [
      {
        type: "improvement",
        text: "„Маркиране“: асортименти и рецепти без група вече се показват в каталога — най-отдолу, в отделна секция „Без група“, след всички групи. Досега продукт без група изобщо не идваше в менюто. Секцията се вижда само при „Всички категории“ — избере ли се група, продуктите без група се крият, както и досега. В плочковия изглед (плосък азбучен списък) просто се появяват; оцветяване „по група“ за тях няма.",
      },
      {
        type: "improvement",
        text: "Дашборд („Закрити“) и „Справка сметки“ („Сметки“): при сесия с код 2 разбивката с двете кръгчета показва до всеки брой и сумата му, след разделител „|“ — запълнено кръгче: сметки с фискален бон, кръгче с контур: без бон (сборът на двете суми е оборотът). Има ли място в кутийката, двете стоят на един ред; на по-тесен екран втората пада отдолу. Без код 2 нищо не се променя — разбивката и досега не се показва.",
      },
      {
        type: "improvement",
        text: "Екран за вход и ПИН екранът на „Маркиране“: единен бранд-блок — логото, до него „UnrealSoft“ („Soft“ в основното оранжево на системата, същото като бутона „Вход“) и под него слоганът „Ресторантска система“ в моно шрифт. Отделният оранжев етикет над заглавието на екрана за вход отпада — текстът му е слоганът под логото. На телефон логото стои над словомарката, центрирано.",
      },
    ],
  },
  {
    version: "0.0.238",
    date: "2026-09-09",
    entries: [
      {
        type: "feature",
        text: "Възстановената сметка отпада от отчетите, в които е била. Ако старото ѝ приключване е влязло в личен отчет, сметката се изключва от него и той се преизчислява от оставащите сметки (брой, суми, по методи, сторнирани, продадени, времена). Ако личният отчет е в отчет на заведението, и той се преизчислява. Отчет, който остане без нито една сметка, се изтрива, както при почистването на сметки без бон. Досега (0.0.237) старото приключване оставаше в стария отчет и новото влизаше във втори — това вече не важи.",
      },
      {
        type: "improvement",
        text: "Складова база: ако отчетът на заведението вече е разнесен, продуктите на възстановената сметка се връщат в склада — количествата се вадят от самото разнасяне и наличностите се преизчисляват; замените не се пипат. Остане ли разнасянето без нито един ред, се маркира като изтрито. Правилото „стоката се изписва само в първия отчет“ от 0.0.237 отпада, защото сметката вече не стои в два отчета.",
      },
      {
        type: "improvement",
        text: "„История на операциите“: редът „Възстановяване на сметката“ показва „Изключена от личен отчет № X“ и, ако е било, „и от отчет на заведението № Y“. Номерата се пазят като снимка — отчетът може вече да е изтрит.",
      },
      {
        type: "improvement",
        text: "Почистване на сметки без бон: критерият е както преди 0.0.237 — всяка приключена нефискализирана сметка се трие, включително възстановена и неприключена с бон след това. Преизчисляването на отчетите при почистване и при възстановяване вече минава през един и същ код; при почистване се преизчислява и секцията „продадени“, ако отчетът я е имал.",
      },
    ],
  },
  {
    version: "0.0.237",
    date: "2026-09-09",
    entries: [
      {
        type: "feature",
        text: "Възстановяването на приключена сметка вече е „на място“: сметката пази същия номер, продуктите ѝ остават както са, а старото плащане, часът на приключване и фискалният бон се свалят от нея и се записват като отменено приключване. Досега старата сметка се сторнираше изцяло и се създаваше нова с нов номер, без връзка между двете — при последващо сторно или второ възстановяване проследимостта се губеше. Сторно бонът за стария фискален бон се издава както досега.",
      },
      {
        type: "improvement",
        text: "„История на операциите“ (модалът при клик на ред в справките) показва цялата верига по същия номер: старото плащане и затваряне, ред „Възстановяване на сметката“ с причина, сторнирания бон и личния отчет, в който е било, и после всичко след това — ново приключване, сторно, повторно възстановяване. В заглавието пише „възстановена N пъти“.",
      },
      {
        type: "improvement",
        text: "„Справка сметки“: нова тиха колона „Възстановена“ (стрелка, при повече възстановявания и брой; на телефон — чип). Плащането и бонът на реда са на текущото приключване.",
      },
      {
        type: "improvement",
        text: "Издадените отчети остават каквито са: старото приключване на възстановената сметка си стои в стария личен отчет и в отчета на заведението с първоначалните метод и сума, а новото приключване влиза в следващия отчет. Разбивката по методи, „фискалният изглед“ при архивиран ресторант и преизчисляването при почистване четат записаното при издаване, не текущото състояние на сметката.",
      },
      {
        type: "improvement",
        text: "Складова база: при разнасяне на отчет продуктите на възстановена и наново приключена сметка се изписват само в първия отчет, в който тя се е появила; следващият отчет изписва само поръчаното след възстановяването. Досега при разнесени и двата отчета стоката излизаше два пъти.",
      },
      {
        type: "improvement",
        text: "„Маркиране“ → модалът за възстановяване: бутонът „Смяна на плащане“ записва причина „Смяна на плащане“, а „Възстанови“ — „Възстановяване на сметка“; причината се вижда в „История на операциите“.",
      },
      {
        type: "improvement",
        text: "Възстановяването вече не сторнира продуктите, затова не се брои в справка „Сторно“ и в показателите за сторно — там остават само истинските сторна. Повторно възстановяване веднага след първото (докато сметката е още отворена) се отказва — възстановява се само приключена сметка.",
      },
    ],
  },
  {
    version: "0.0.236",
    date: "2026-09-08",
    entries: [
      {
        type: "feature",
        text: "Нова настройка на заведението в Конфигурация → Маркиране: „Подредба на масите“. „Хронологично“ (по подразбиране) е досегашният ред по време на отваряне. „По номер и име“ подрежда първо масите с номер по големина (1, 2, 10, 33), а след тях именуваните по азбучен ред („Тераса 2“ преди „Тераса 10“); закритите остават най-отдолу и в двата режима. Настройката важи за всички терминали и се вижда след нов вход или връщане в „Модули“.",
      },
      {
        type: "improvement",
        text: "„Маркиране“: масите се обхождат със стрелките на клавиатурата — ← → минават на предишната/следващата маса, ↑ ↓ отиват в реда отгоре/отдолу в същата колона, а избраната маса се скролва в полезрението. Работи и при филтрирана търсачка.",
      },
      {
        type: "improvement",
        text: "„Маркиране“: при отваряне на коментара от молива в „Преглед на поръчката“ полето вече е готово за писане — курсорът е в него, в края на текста.",
      },
      {
        type: "improvement",
        text: "„Маркиране“: след „+“/„−“ на продукт (или „Добави“ в модала с добавки) търсачката се зачиства след секунда както досега, но фокусът вече остава върху последно маркирания продукт и той се скролва в полезрението — където и да е в менюто — за да се добавят още бройки с „+“ от клавиатурата. Досега фокусът скачаше на първия продукт в списъка.",
      },
      {
        type: "improvement",
        text: "„Маркиране“: буква или знак без съвпадение в търсачката (например „кафе“ плюс случайно натиснат знак) вече не изпразва списъка — остават намерените до момента резултати, а рамката на търсачката и излишните букви светят в червено. Изтриете ли ги, всичко продължава както преди. Екранната клавиатура показва същото.",
      },
      {
        type: "improvement",
        text: "Персоналните отчети и отчетите на заведението при архивиран ресторант: отчетът вече се издава винаги с всички приключени сметки — с и без фискален бон — независимо дали сте с втори код. Досега без код нефискализираните сметки оставаха извън отчета и висяха неотчетени. Важи за персоналния отчет, за автоматично издаваните лични отчети при отчет на заведението и за списъка с потребители в „Генериране на отчет“.",
      },
      {
        type: "improvement",
        text: "Справките „Персонални отчети“ и „Отчети на заведението“ вече са винаги видими при архивиран ресторант — не изискват втори код. Без код списъкът, детайлът, прегледът, отговорът след издаване и печатът на POS показват отчета преизчислен само по фискализираните сметки (суми, брой, в брой/карта, времена, сторнирани, продадени, разбивки по станции и потребители); въведете ли втория код, същите отчети се показват с пълните записани числа. Записаният отчет не се променя — променя се само какво вижда текущата сесия. При неархивиран ресторант нищо не се променя.",
      },
      {
        type: "improvement",
        text: "Грешката при отчет на заведението с отворени сметки вече казва кой ги държи: „Има 5 отворени сметки в заведението: Иван Иванов (2), Петър Петров (3)“, подредени по брой. Досега имаше само общото число и при много сервитьори се гадаеше чии са.",
      },
      {
        type: "improvement",
        text: "Персоналните отчети и отчетите на заведението вече имат отделна номерация. Досега двата вида деляха една обща редица (личен №14 → заведенски №15); сега всеки вид се брои сам за себе си — личните продължават от последния личен, заведенските от последния заведенски, и личен №5 и заведенски №5 могат да съществуват едновременно. При предварителен преглед на заведенския отчет номерът вече не се измества от автоматично издаваните лични отчети. Заварените отчети са преномерирани по вид от 1 нагоре, в досегашния им ред — вече отпечатан отчет може да носи различен номер от този в системата.",
      },
    ],
  },
  {
    version: "0.0.235",
    date: "2026-09-08",
    entries: [
      {
        type: "improvement",
        text: "Футърите на всички модали в „Маркиране“ са в една схема: „Отказ“/„Назад“ е тесен (около една четвърт), а основното действие широко — Нова маса, Смяна на маса, Клиенти, Отстъпки, Промяна на цена, Отчет (вкл. генериране, преглед и потвържденията след нулиране на персоналния и на заведенския отчет — там Отказ и Печат са по 25%, Нулирай 50%), Фискални операции, всички фактурни модали, Възстановяване и Закрий. На телефон всички футър бутони са с еднаква височина 48px (бяха 52–54).",
      },
      {
        type: "improvement",
        text: "Модалът „Клиенти с отстъпки“ е в стила на останалите: търсачката и редовете са като при смяна на сервитьор, а редът „Премахни отстъпка/надбавка“ е в червено с иконка кошче, за да не се бърка с клиентите. Изборът, търсенето, стрелките и премахването работят както досега.",
      },
      {
        type: "improvement",
        text: "Нов вид на модала „Сторно“ в „Маркиране“: заглавието е „Сторно на асортименти“ (или „Сторно на рецепти“ при работа със склад), а под него стоят масата, номерът на сметката и общата ѝ сума. В редовете броячът показва избраното количество, а под него „от N“. „Избери всичко“ и „Брак“ са бутони с чекбокс-квадратче вдясно от заглавието „Причина“. Причината вече се избира от готови варианти — „Грешно маркирано“, „Отказ от клиент“, „Промяна на поръчката“, „Друго“ — нищо не е избрано по подразбиране и не е задължителна; полето за свободен текст се показва само при „Друго“. Редът „Избрани N от M“ със сумата отпада, бутонът е само „Сторнирай“, а „Отказ“ е по-тесен. Самото сторниране, „Брак“ и проверката срещу двойно потвърждение работят без промяна.",
      },
      {
        type: "feature",
        text: "„Прехвърли всичките ми маси“: в модала „Смяна на сервитьор“ има нов бутон „Прехвърли всичките ми N маси“ (показва се при две и повече ваши отворени маси). С един клик всички ваши отворени сметки минават към избрания сервитьор — една заявка, един запис в дневника, същите проверки за получателя. Ако получателят вече има маси с някои от вашите имена, системата пита преди да пипне каквото и да е — нищо не се прехвърля наполовина.",
      },
      {
        type: "improvement",
        text: "Нов вид на модала „Смяна на сервитьор“ (и на стъпката „избор на сервитьор“ при разделяне): под заглавието пише „Отговорността за X EUR се прехвърля“, отгоре стои лента „От <сервитьор> → На <избран>“, търсачката е запазена, а до всеки сервитьор има аватар с инициали и колко отворени маси има в момента. Отметка се показва само на избрания ред. Бутонът долу става „Прехвърли на <име>“, а „Отказ“ е по-тесен от него.",
      },
      {
        type: "improvement",
        text: "Нов вид на модала „Раздели сметка“ в „Маркиране“: заглавието е „Раздели сметка“, а под него стоят масата и общата ѝ сума („Маса 12 · 31.50 EUR“). Над продуктите има превключвател „По продукти | По равно“ (в стила на Плочки/Таблица): „По продукти“ е ръчният избор както досега, „По равно“ дели сметката на две — избира половината от количеството на всеки ред (1 бр. → 0.5, 3 бр. → 1.5), като редовете остават видими и количествата могат да се донастроят със степера. Вдясно на същия ред е „Избрани продукти: N“. „Избери всичко“ е бутон с чекбокс-квадратче, което светва в оранжево при активно; долу вдясно стои „Сума:“ с избраната сума. Бутоните във футъра са „Отказ“ (по-тесен), „Раздели“ и „Раздели и плати“ в пропорция 1:2:2. Разделянето, „Раздели и плати“, правата, клавишите Esc/⏎ и всички проверки работят без промяна.",
      },
    ],
  },
  {
    version: "0.0.234",
    date: "2026-09-07",
    entries: [
      {
        type: "feature",
        text: "Конфигурация → „Маркиране“ вече е разделена на две части: „Настройки на ресторанта“ (общи за всички терминали: бързо закриване, номерация, нефискални маси, оптимизация) и „Лични настройки на сервитьора“, които следват потребителя на всяко устройство, на което влезе. Личните са: изглед на продуктите (лист/грид), кое стои над каталога (групите или станциите — другото отива над поръчаните продукти), по какво се оцветяват асортиментите/рецептите (група/станция), вид клавиатура (БДС/фонетична/латиница) и дали групите са разгънати при отваряне на „Маркиране“. Последните три се пазят отсега и ще се използват от предстоящия редизайн на „Маркиране“.",
      },
      {
        type: "improvement",
        text: "Изгледът на продуктите (лист/грид) вече не е обща настройка на ресторанта, а лична на всеки сервитьор — старата обща стойност отпада и всеки започва с „Лист“, докато не си избере друго.",
      },
      {
        type: "improvement",
        text: "Всички настройки на „Маркиране“ (на ресторанта и личните) вече пристигат наведнъж заедно с данните на потребителя при вход, вместо с отделни заявки при всяко отваряне на екрана. Промяна, направена от друг терминал, се вижда при следващо влизане, презареждане, ПИН или връщане в „Модули“.",
      },
      {
        type: "improvement",
        text: "Темата (светла/тъмна) се помни за потребителя, а не за устройството: избраната от профилното меню тема се прилага на всяко устройство, на което влезете, включително при смяна на служител на общ терминал. Сменя се както досега — от иконката на профила, не от Конфигурация.",
      },
      {
        type: "improvement",
        text: "Свиването/разгъването на редовете с групи в „Маркиране“ (ъгълчето вдясно) продължава да помни последното ви действие на устройството, но началното състояние вече идва от личната настройка „Групите при отваряне на Маркиране“. При изход от акаунта — с потребител и парола или на служител към ПИН екрана — запомненото на устройството се изчиства, за да не го наследи следващият.",
      },
      {
        type: "feature",
        text: "Нов вид на екрана за маркиране на асортименти/рецепти (десктоп): горната лента отпада, а „Назад“, Backoffice, цял екран и профилът слизат във футъра при бутоните Инфо/Промени/Клиенти. Над каталога стоят групите или станциите според личната настройка „Какво стои над каталога“ (станциите филтрират по станция), а другото стои над „Преглед на поръчката“ и също филтрира каталога (групите са цветни кутийки с навигация по подгрупи, станциите — с цветна точка). Продукт в няколко станции се оцветява с избраната станция при филтър. Бутонът за свиване/разгъване на редовете с групи или станции се показва само когато редът прелива, а над прегледа свитите редове се скролират. Селекцията със стрелките е тънък контур: кехлибарен без оцветяване, тъмен върху оцветени редове; иконите − и + са по-едри, а минусът е блед при нула. Редовете и картите се оцветяват по станция, по група (нов цвят на групите в Backoffice) или без оцветяване — нова трета опция в Конфигурация; в прегледа всеки ред има цветна лента отляво (продукт с две станции — две половини). До „Преглед на поръчката“ стои броят добавени артикули, масата е във футъра. В таблицата има нова колона „Станция“, а в плочките грамажът отстъпва място на степер − N + при маркирано количество. Нови бутони във футъра: Плочки/Таблица (F7) и Клавиатура (F8) — екранна клавиатура за търсене с подредба БДС/фонетична/латиница по личната настройка и превключвател между трите направо от клавиатурата. Изгледът и свиването се помнят на устройството до изход; настройката в Конфигурация е само началното състояние.",
      },
      {
        type: "improvement",
        text: "Нов вид на страницата Конфигурация → „Маркиране“: две ленти с различен фон — първо „Лични настройки на сервитьора“ на светъл фон, под нея „Настройки на ресторанта“ на по-тъмен. Пъстрите цветове на картите (синьо, зелено, лилаво) са махнати — всичко е в нюанси на оранжевото на приложението (червен остава само бутонът „Оптимизация с база“, защото трие сметки). Картите са в подредба: Групи и станции, Редове с групи, Вид клавиатура, Изглед на продуктите, Оцветяване; ресторантските: Бързо закриване, Номерация на масите, Визуализиране на нефинализирани маси. Броят колони следва ширината на екрана (1 на телефон, 2 на лаптоп, 3 на широк монитор), картите в един ред са с еднаква височина, а по-късите центрират опциите си.",
      },
      {
        type: "improvement",
        text: "Адресът на страницата Конфигурация → „Маркиране“ е /configuration/ordering (беше /configuration/non-fiscal-display). Старият адрес продължава да работи — пренасочва към новия, така че запазените линкове не се чупят.",
      },
      {
        type: "improvement",
        text: "Правото за страницата Конфигурация → „Маркиране“ (трите настройки на ресторанта и „Оптимизация с база“) се казва „ordering-settings“ вместо „non-fiscal-display“. Преименуването е със запазен идентификатор в базата на организацията, така че никой потребител не губи правото си. Личните настройки и смяната на тема от профила остават без право — всеки пипа само своите.",
      },
    ],
  },
  {
    version: "0.0.233",
    date: "2026-09-06",
    entries: [
      {
        type: "fix",
        text: "Справките вече гледат РАБОТЕН ден, а не календарен. Сметка, закрита в 00:23, е от вчерашната смяна и вече не влиза в „днес“. Денят свършва в 06:00 на следващата дата; часът се сменя по заведение от конфигурацията, а стойност 0 връща старото поведение.",
      },
      {
        type: "improvement",
        text: "„Фактури“, „Картови плащания“, Складовата база и „Одит на действията“ нарочно остават на календарен ден — фактурата се търси по датата върху документа, картовите се сверяват с извлечението на банката, а складовите движения си имат своя дата.",
      },
      {
        type: "fix",
        text: "Δ „спрямо предишния период“ на Дашборда сравняваше с грешен отрязък при работен ден: един ден се броеше за два, а при още течащ период основата за сравнение се разпадаше. Поправено.",
      },
      {
        type: "fix",
        text: "Графиката „Оборот по работни дни“ вече се връзва с показателя „Затворени“ — оборотът след полунощ влиза в стълбчето на своята смяна, вместо да изпада от графиката.",
      },
      {
        type: "fix",
        text: "Хистограмата на активността в „Справка сметки“ отново е по часове за един ден, а разделянията и сметките след полунощ падат в деня на своята смяна.",
      },
    ],
  },
  {
    version: "0.0.232",
    date: "2026-09-04",
    entries: [
      {
        type: "improvement",
        text: "Кутийката „Открити“ показва СУМАТА на отворените сметки като главно число, точно както „Закрити“, а броят сметки стои под нея. Надписът „най-стара“ отпадна.",
      },
    ],
  },
  {
    version: "0.0.231",
    date: "2026-09-04",
    entries: [
      {
        type: "improvement",
        text: "В „Справка сметки“ колоната „№ сметка“ вече се сортира. Тя е изгасена по подразбиране — пали се с отметка от бутона „Колони“.",
      },
      {
        type: "improvement",
        text: "„Δ спрямо предишния период“ вече е изключено по подразбиране във всички справки и в Дашборда. Включва се с едно кликване, когато сравнението наистина трябва.",
      },
      {
        type: "improvement",
        text: "Показателите на Дашборда са преподредени по живота на сметката: „Открити“ (бившето „Отворени сега“) излиза най-отпред, следват „Закрити“ (бившето „Оборот“), „В брой / карта“, „Средна сметка“, „Сторно“ и „Отстъпки“.",
      },
    ],
  },
  {
    version: "0.0.230",
    date: "2026-09-04",
    entries: [
      {
        type: "improvement",
        text: "В „Маркиране“ и „Кухненски монитори“ първият клик (или докосване) на екрана автоматично вкарва браузъра в режим на цял екран — удобно за POS терминали и кухненски дисплеи. Админският акаунт е изключен от това поведение. Познатото отключване на звука на мониторите с първия клик продължава да работи както досега.",
      },
      {
        type: "improvement",
        text: "Прозорците „Генериране на отчет“ и „Генериране на отчет на заведението“ побират повече хора без скрол: списъкът с потребители показва до 6 реда (вместо 4), при повече от 6 души минава в 2 колони, а при повече от 12 — в 3, като прозорецът се разширява заедно с колоните и скрол се появява чак над 18 души (лентата на скрола е скрита, скролва се с пръст/колелце). Отпаднаха и жълтите обобщения „Избран потребител/Дата“ — същата информация се вижда в самия списък и в календара.",
      },
    ],
  },
  {
    version: "0.0.229",
    date: "2026-09-04",
    entries: [
      {
        type: "fix",
        text: "Фирми с определени ЕИК-ове не можеха да бъдат записани — нито като фирма издател, нито като получател на фактура, нито при фактуриране. Контролната сума се смяташе само с първия набор тегла и всеки единадесети напълно валиден ЕИК (около 9% от всички) излизаше „невалиден“ без обяснение. Проверката вече минава и през втория набор, както го описва НСИ.",
      },
      {
        type: "improvement",
        text: "В „Редакция на фирма“ под номерацията вече пише с кой номер ще излезе следващата фактура — сметнато от въведеното, докато пишеш. Валидният ЕИК се потвърждава с отметка още докато го въвеждаш, а ДДС номерът може да се попълни от него с едно кликване.",
      },
      {
        type: "improvement",
        text: "Справките „Разделени маси“, „Променени цени“ и „Монитори“ минаха на общия вид на модула: показатели в кутийки, филтри в самите колони вместо падащи менюта отгоре, пренареждане и скриване на колони, износ на видяното в Excel и четими карти на телефон.",
      },
      {
        type: "feature",
        text: "В „По артикули“ клик върху ред отваря разбивка по дни — количество, средна цена и оборот за всеки ден от периода. В „По категории“ кликът върху името на категорията води към артикулите ѝ, а клик другаде по реда показва същата разбивка по дни за цялата категория.",
      },
      {
        type: "feature",
        text: "„История на маси“ има нова колона „Фактура“ — вижда се кои сметки вече са фактурирани, може да се филтрира по признака и той излиза в Excel.",
      },
      {
        type: "improvement",
        text: "В таблиците на справките вече си личи, че колоните имат филтри: менюто за подредба, филтър и скриване стои видимо в заглавието, а границата между колоните се хваща за оразмеряване. Дотук всичко това работеше, но се появяваше само при посочване с мишка.",
      },
      {
        type: "improvement",
        text: "В Дашборда картата „За внимание“ остана само със заглавието си — броячът и подсказката отпаднаха.",
      },
      {
        type: "feature",
        text: "Във „Възстановяване на сметка“ нефискализираните редове (закрити без бон — заради проблем с принтера или нарочно) вече имат бутонче „Фискализирай“. То отваря познатия прозорец „Закриване на сметка“ с повторен избор на начин на плащане и издава бона сега, без да се възстановява и закрива наново.",
      },
      {
        type: "improvement",
        text: "Периодите във „Възстановяване на сметка“ (30 мин / 60 мин / 2 часа) вече са натрупващи се: сметка, закрита преди 15 минути, се вижда и в трите, а „2 часа“ показва всичко от прозореца.",
      },
    ],
  },
  {
    version: "0.0.228",
    date: "2026-09-04",
    entries: [
      {
        type: "feature",
        text: "Клиент може да се избере и при НОВА маса, още преди сметката да съществува. Бутонът „Клиенти“ в Маркирането вече е активен и там — изборът се запомня, цените в каталога и прегледа веднага се показват коригирани, а клиентът се закача за сметката в момента на откриването ѝ с „Поръчай“. Преди поръчката чакащият избор може да се смени или премахне от същия модал.",
      },
      {
        type: "improvement",
        text: "В грид изгледа на Маркирането кликът върху кутийка вече прави същото като клик върху ред в списъка: добавя +1 направо, а прозорецът „Промени“ се отваря само когато продуктът има задължителна добавка, задължителен модификатор или препоръчителна добавка.",
      },
      {
        type: "improvement",
        text: "Съвпаденията в търсачката на Маркирането се открояват само с цвят и удебеляване на текста — жълтият фон зад буквите отпадна.",
      },
    ],
  },
  {
    version: "0.0.227",
    date: "2026-09-04",
    entries: [
      {
        type: "feature",
        text: "„Одит на действията“ е преработен. Над списъка вече стоят обзор за периода — действия, проблеми, действия с пари, промени по настройки, брой хора и най-бавна заявка — и лента по часове, на която се вижда кога е било напрегнато и кога нещо се е счупило. Под нея са разбивките „по модул“ и „по потребител“; клик по ред от тях стеснява списъка до него.",
      },
      {
        type: "feature",
        text: "Проследяване на сметка и на маса: клик върху масата или номера на сметката в реда показва целия ѝ живот, подреден отпред назад и БЕЗ ограничение по период — сметка, отворена преди полунощ, вече не се разполовява от избрания ден.",
      },
      {
        type: "fix",
        text: "„Само проблеми“ вече хваща и неуспелите фискализации при HTTP 200. Досега затворена сметка без излязъл бон изглеждаше като успешна операция и се намираше само ако човек отвори записа; сега редът е червен и пише „Бонът не е излязъл“.",
      },
      {
        type: "feature",
        text: "Нови бързи филтри: „Пари“ (плащане, сторно, отстъпка, промяна на цени, каса, фактури), „Настройки“ (конфигурация, устройства, номенклатури), „Бавни над 1000 ms“ и „На живо“ — списъкът се обновява сам на всеки 10 секунди.",
      },
      {
        type: "improvement",
        text: "Списъкът мина на същия табличен вид като „Справки“: сортиране по всяка колона, показване, скриване и пренареждане на колони, плътност на редовете, Excel експорт на целия период по активните филтри и карти вместо хоризонтален скрол на телефон. Добавени са колони „Резултат“, „Модул“ и „Вид“.",
      },
    ],
  },
  {
    version: "0.0.226",
    date: "2026-09-04",
    entries: [
      {
        type: "security",
        text: "Без втори код дневните отчети вече ги НЯМА и на адрес. Досега менюто ги скриваше, но „/reports/personal“ и „/reports/establishment“ отваряха друга справка под тяхното заглавие — самото им съществуване изтичаше, а при пренасочване „към първата разрешена справка“ можеше и да се приземиш там.",
      },
      {
        type: "fix",
        text: "Бележката „Влезли сте без втори код — изгледът е ограничен“ на Дашборда отпадна. Тя сама обявяваше, че има скрито съдържание; ограниченият изглед просто не показва скритото.",
      },
      {
        type: "feature",
        text: "„Отчети на заведението“ и „Фактури“ минаха на новия табличен вид — сортиране по колона, показване и скриване на колони, филтри в самите колони, ред „Общо“ и Excel по видяното. Фактурите получиха Excel, какъвто досега нямаха, а анулираната фактура си личи на реда и може да се филтрира. Печатните документи (отчетът и самата фактура) остават непроменени — те са по задание.",
      },
    ],
  },
  {
    version: "0.0.225",
    date: "2026-09-04",
    entries: [
      {
        type: "fix",
        text: "Върнати са числата, по които се предава касата. „По сервитьори“ отново показва „Сума в брой“ и „Сума с карта“ — сумите с ПРОПОРЦИОНАЛНО разпределено смесено плащане, а не колоната „Смесено“, в която двете са слети. Същите две колони в „По станции“ вече се виждат без да се търсят в панела „Колони“, а броят сметки по всеки метод се върна в Excel и в детайла по дни.",
      },
      {
        type: "fix",
        text: "В „Отстъпки“ колоната се казва „Отстъпка / надбавка“, защото носи и двете посоки — редът „Общо“ под нея е НЕТО корекция и вече не противоречи на кутийката „Дадени отстъпки“ горе. Добавена е и отделна колона само за надбавките.",
      },
      {
        type: "fix",
        text: "В „По станции“ търсачката вече стеснява и кутийките, и лентата по методи, не само таблицата — досега един екран показваше три различни обхвата и изтегленият Excel не съвпадаше с числата отгоре.",
      },
      {
        type: "fix",
        text: "Δ в „Дневни отчети“ сравняваше с период, по-къс с цял ден, и рисуваше ръст, какъвто няма.",
      },
      {
        type: "fix",
        text: "Сторното по РАЗДЕЛЕНА сметка се броеше два пъти. Копието-следа, което разделянето оставя в оригиналната сметка, вече е изключено и от справка „Сторно“ — както е навсякъде другаде, където се сумират пари.",
      },
    ],
  },
  {
    version: "0.0.224",
    date: "2026-09-04",
    entries: [
      {
        type: "feature",
        text: "Менюто на „Справки“ вече следва работния поток, а не техническото деление: Дашборд, после „Контрол“ (Справка сметки, Сторно, Отстъпки, Разделени маси, Променени цени, Монитори), „Продажби“ (По сервитьори, По артикули, По категории, По станции), „Фискални“ (Фактури, Картови плащания) и накрая Отчетите. Дългите имена се скъсиха — справката вече не се казва „Справка по…“, а просто „По…“.",
      },
      {
        type: "feature",
        text: "Нова справка „По категории“: колко е продадено и на каква стойност във всяка категория, с дял от оборота и сравнение с предходния период. Клик върху категория отваря нейните артикули в „По артикули“.",
      },
      {
        type: "feature",
        text: "„По сервитьори“, „По станции“ (бившата „По обекти“), „Отстъпки“, „По артикули“ и „Дневни отчети“ минаха на новия табличен вид: сортиране по всяка колона, показване и скриване на колони, ред „Общо“, филтри в самите колони вместо падащи менюта над таблицата, и Excel, който изнася точно това, което е на екрана.",
      },
      {
        type: "feature",
        text: "Методите на плащане извън „в брой“ и „с карта“ вече не изчезват. Където справката показва разбивка, тя се строи от РЕАЛНО срещнатите методи за периода — включително персонализираните — вместо от две заковани колони.",
      },
      {
        type: "improvement",
        text: "Историята на операциите по сметка е пренаписана: бял прозорец, четири кутийки с числата на сметката и хронология, в която всяка операция е един ред — час, какво е станало, кой го е направил и на каква стойност. Долната лента с действията остава същата, включително правилото, че сторно се пуска само от „Справка сметки“.",
      },
      {
        type: "improvement",
        text: "„Справка сметки“ вече се сортира и по номер на бон, а в „Сторно“ редовете, сторнирани с едно натискане, се четат като една операция, а не като няколко отделни.",
      },
      {
        type: "fix",
        text: "Синьото на Ant Design си отиде от целия продукт. Приложението никога не беше задавало основния си цвят, затова всяка отметка, radio бутон и фокус рамка светваха в чуждото синьо; вече са във фирменото оранжево.",
      },
      {
        type: "improvement",
        text: "В „Картови плащания“ отпаднаха обяснителният абзац под кутийките, хинтът „клик отваря сметката“ и второто съобщение за празен период — същото се казваше два пъти.",
      },
    ],
  },
  {
    version: "0.0.223",
    date: "2026-09-04",
    entries: [
      {
        type: "feature",
        text: "„История на маси“ се казва „Справка сметки“ и показва САМО приключени сметки. Отворената маса още не е сметка — няма закриване, няма бон и няма как да участва в сверка. Затова отпаднаха и кутийката „Приключени“ (повтаряше същото число), и хистограмата „Сметки по час“, която не отговаряше на въпрос, който тази справка задава.",
      },
      {
        type: "feature",
        text: "Виждате ли с втория код повече сметки, отколкото без него, вече личи КОИ са в повечето. Под броя сметки стои разбивката с двете кръгчета — запълнено и с контур — а клик върху второто оставя в списъка точно тези сметки. Същата разбивка е и на Дашборда под оборота. Показва се само с втори код: без него тези сметки изобщо не стигат до екрана и нула там би значило „няма такива“.",
      },
      {
        type: "improvement",
        text: "Знакът на реда мина в оранжево — фирменият цвят, вместо зелено-сивото отпреди. Точката вече носи един-единствен смисъл: издаден ли е фискален бон.",
      },
      {
        type: "feature",
        text: "Нова колона „№ сметка“ в „Справка сметки“ — номерът в базата, по който се сверява с бекофиса или с подадена рекламация. Изгасена е по подразбиране и се пали от панела „Колони“.",
      },
      {
        type: "fix",
        text: "Клик по заглавие на колона вече само пренарежда списъка, вместо да го замени със зареждащо колело: старите редове остават на екрана, докато новите пристигнат. Същото важи и за смяна на страницата и на периода — в „Справка сметки“, „Картови плащания“ и Дашборда.",
      },
      {
        type: "fix",
        text: "Скролът в справка, стигнала до края си, вече не се предава на страницата отдолу.",
      },
    ],
  },
  {
    version: "0.0.222",
    date: "2026-09-03",
    entries: [
      {
        type: "fix",
        text: "Справките за четене вече не могат да пуснат фискален сторно документ. Лентата с „Сторнирай всичко“, „Възстанови“ и „Фактуриране“ се показва САМО в „История на маси“ — в „Сторно“, „Картови плащания“ и Дашборда модалът се отваря без нея, както беше преди редизайна.",
      },
      {
        type: "fix",
        text: "Филтрите в колоните на новата таблица наистина филтрират. Досега фунията отваряше меню, отметките се пазеха и не се случваше нищо (или списъкът се изпразваше). Заедно с това: при празен резултат заглавният ред остава на екрана, за да може филтърът да се махне; клик по заглавие ЗАМЕНЯ подредбата вместо да добавя втори ключ; и когато наборът се свие, страницата се притегля към последната налична, вместо да остане празна.",
      },
      {
        type: "fix",
        text: "Запомненото сортиране вече стига и до сървъра. Подредиш ли по „Сума“ и презаредиш, стрелката и редовете съвпадат — досега стрелката стоеше на „Сума“, а списъкът беше по дата.",
      },
      {
        type: "fix",
        text: "На телефон филтрите и подредбата се върнаха: над списъка има бутон „Подредба“ с всички сортируеми колони и наличните филтри. На таблет „Бон №“, „Плащане“, „Затворена“ и „Време“ вече не се крият насила — прагът е ПОДРАЗБИРАНЕ, а отметката в панела „Колони“ ги връща. Менюто на колоната стои видимо на тъч устройства, където няма hover.",
      },
      {
        type: "fix",
        text: "Δ спрямо предишния период сравнява равни отрязъци. Непълен ден вече не стои срещу цял предходен ден (сутрин всяка делта показваше срив, какъвто няма), а дашбордът чете периода по същия начин като останалите справки: „1–7 август, 18:00–23:00“ значи всяка вечер от седмицата и на двата екрана.",
      },
      {
        type: "fix",
        text: "„% от оборота му“ в „Сторно“ показва тире, когато сервитьорът няма ЗАТВОРЕН оборот за периода — досега сторно по още отворена маса даваше „100 %“ срещу името му. Количеството вече не се закръгля до цяло на екрана (0,750 кг беше „1“), а скобата „сторнирано заедно“ се смята върху реда, в който таблицата рисува, а не върху реда от сървъра.",
      },
      {
        type: "feature",
        text: "Върнати неща, които редизайнът беше изпуснал: филтърът „Само с фактура“ и хистограмата „по час / по ден“ в „История на маси“; търсачката, филтрите „брак/сторно“ и „кой е сторнирал“ и колоната „Ед. цена“ в „Сторно“; разбивката по терминал и тихият белег за прието плащане без документ в „Картови плащания“; разбивката по начин на плащане в Дашборда. Колоните „Поръчки“ и „Сторн. бр.“ са в панела „Колони“, изгасени по подразбиране.",
      },
      {
        type: "improvement",
        text: "Excel изнася ТОВА, което е на екрана — филтрирано и подредено, а не суровия отговор; файловете вече нямат двоен времеви печат в името. В „История на маси“ влизат и двете суми на смесеното плащане, а бутонът е неактивен при празен резултат. Пагинацията получи номера на страници и „10 на страница“, а в тулбара има „Изчисти всички филтри“, когато има какво да се чисти.",
      },
      {
        type: "improvement",
        text: "Показателите горе и редът „Общо“ долу отговарят на различни въпроси и това вече е изписано: при активен филтър по статус, плащане, фактура или търсене под лентата излиза ред, че показателите са за целия период. Дашбордът показва грешка с „Обнови“ вместо вечно въртящо се колело, а „За внимание“ дава място и на двата вида сигнал, вместо дългите маси да изядат целия списък.",
      },
    ],
  },
  {
    version: "0.0.221",
    date: "2026-09-03",
    entries: [
      {
        type: "feature",
        text: "Справка „Сторно“ вече има три изгледа върху едни и същи редове: „Списък“ (какво е станало), „По сервитьор“ (кой колко отписва спрямо СВОЯ оборот — колоната „% от оборота му“ показва дали 12 сторно са много, или са нормални за неговия обем) и „По продукт“ (кое отпада най-често). Превключването е мигновено — целият период се дърпа веднъж, без нова заявка при смяна на изгледа.",
      },
      {
        type: "feature",
        text: "Когато една сметка е сторнирана наведнъж (едно натискане на „Сторнирай всичко“), редовете вече не изглеждат като няколко отделни решения: свързани са с тънка скоба отляво, а на първия стои „×4“. Колоната „Заедно“ влиза и в Excel. Разпознаването е по самата операция, не по време на око — сървърът вижда, че редовете са писани в една транзакция.",
      },
      {
        type: "improvement",
        text: "Показателите на „Сторно“ са четири: сторнирани редове (в колко сметки), стойност (и какъв процент от брутото е), средно на ред и „След кухня“. Последният се появява САМО ако има какво да се твърди: етапът не е поле в базата, а се извежда от одита на кухненските преходи. Заведение без монитори няма такива записи и там кутийката просто липсва, вместо да показва „0“, което не е факт.",
      },
      {
        type: "improvement",
        text: "„Карти по терминал“ се преименува на „Картови плащания“ — в менюто, в заглавието, в таба на браузъра и в името на Excel файла. Справката получи и новия табличен вид: филтри и подредба по колони, ред „Общо“, а сверката в края на деня е изписана над списъка — „С бон“ = картата в отчета на заведението, „С бон + Висящи“ = „край на деня“ на терминала, банката вижда само „С бон“.",
      },
      {
        type: "fix",
        text: "Сторнирал ≠ сервитьор на сметката. Досега справката показваше само кой е натиснал сторното; сега двете са отделни колони, а групирането „по сервитьор“ върви по стопанина на сметката — иначе управителят търсеше отписаното при грешния човек.",
      },
    ],
  },
  {
    version: "0.0.220",
    date: "2026-09-03",
    entries: [
      {
        type: "feature",
        text: "Дашбордът вече следва ИЗБРАН ПЕРИОД, а не само днешния ден. Отгоре има същата лента като в другите справки — Вчера / Днес / 7 дни / Този месец, стрелки за местене и бутон „Δ спрямо предишния период“, който добавя процент спрямо равен по дължина период назад. Шестте показателя са Оборот, Средна сметка, В брой / карта, Сторно, Отстъпки и Отворени сега; клик върху Оборот, Сторно или Отстъпки отваря съответната справка. „Отворени сега“ е състояние в момента и затова се показва само когато периодът включва днес.",
      },
      {
        type: "feature",
        text: "„Натовареност по час“ отпадна и на нейно място е „Оборот по сервитьори“ — кой колко е направил, с дял от оборота и брой сметки. Това е числото, което води до действие; часът на затваряне беше любопитен, но не. До него стоят „По станции“ (с лента на дяловете) и „Топ 5 по оборот“, а всяка карта има линк към пълната си справка.",
      },
      {
        type: "feature",
        text: "Нова карта „За внимание“ със сигналите, които искат проверка: маса, отворена над час и половина, и сметка с отстъпка над 30 %. Клик върху сигнал отваря историята на операциите по сметката. Съзнателно НЯМА сигнал „сторно след кухня“ — етапът на сторниране не се съхранява никъде и такъв сигнал би бил догадка, представена като факт.",
      },
      {
        type: "improvement",
        text: "Графиката по дни слезе най-долу и показва две седмици вместо една. Дните от избрания период са акцентни, днешният е щрихован (още не е завършил), пунктираната линия е средният оборот, а клик върху ден отваря „История на маси“ за него. Топлинната карта по часове отпадна — заедно с нея отпада и сметката ѝ при всяка смяна на периода.",
      },
      {
        type: "fix",
        text: "Дашбордът вече казва, когато изгледът е ограничен. Влезли без втори код, виждате по-малко от това, което е станало за периода — дотук това не се обявяваше никъде и числата изглеждаха пълни. Сега има кратка бележка, а разбивките, които в този режим са нула по конструкция, не се показват изобщо, вместо да се четат като „няма такива“. Сторното следва същото правило: сторно по сметка, която не виждате, вече не се брои в числата.",
      },
      {
        type: "feature",
        text: "Справка „История на маси“ е преработена. Отгоре стоят показателите за ЦЕЛИЯ избран период, събрани в кутийки с различна големина: „Сметки“ (със затворени и отворени), „Оборот“, „Средна сметка“, „Средно време на маса“ и „Приключени“. Бутонът „Δ спрямо предишния период“ добавя към първите три зелен или червен процент спрямо равен по дължина период назад. Под тях е нова хистограма „Сметки по час“ — по час на ЗАТВАРЯНЕ, с подчертан пиков час, и вече работи за седмица и месец, не само за един ден.",
      },
      {
        type: "feature",
        text: "Списъкът със сметките е на нова таблица с работа по колони. Всяка колона има меню (иконката се появява при посочване): сортиране възходящо/низходящо, филтър и „Скрий колоната“. Филтърът е чеклист по стойности — статус, сервитьор, начин на плащане — и се прилага на СЪРВЪРА, тоест върху целия период, а не само върху видимата страница. Филтрирана колона си остава с оранжева фуния, за да личи защо списъкът е къс.",
      },
      {
        type: "feature",
        text: "Бутонът „Колони“ отваря панел за подредбата: включване и изключване на колони, преместване нагоре/надолу (или с влачене направо в заглавния ред) и плътност на редовете — сбита, нормална или широка. Подредбата се запомня за този браузър и стои така при следващото отваряне; „Върни подредбата по подразбиране“ я нулира. Колоните „Маса“, статусът и „Сума“ не могат да се скрият.",
      },
      {
        type: "feature",
        text: "Редът „Общо“ под таблицата вече сумира ЦЕЛИЯ период по активните филтри, а не само редовете на страницата — брой сметки, артикули, отстъпки, сторно и сума. Дотук този ред показваше сбора на видимото и се разминаваше с показателите отгоре.",
      },
      {
        type: "improvement",
        text: "Редът на сметката показва повече наведнъж: сервитьорът е отделна колона, добавени са „Арт.“ (продадени бройки), „Отстъпка“ и „Сторно“ — досега тези суми се виждаха чак след отваряне на сметката. Статусът е точка вместо цял чип (оранжева = отворена), а освободеното място отива за парите. „Бон №“ остава колона. Времето над час и половина е червено. Търсачката търси по име на маса през целия период, не само на страницата.",
      },
      {
        type: "fix",
        text: "Експортът към Excel вече работи и при повече от 200 сметки. Дотук при по-дълъг период сървърът отказваше заявката, спинърът спираше и файлът просто не се сваляше, без никакво съобщение. Сега периодът се сваля на части, а при истинска грешка излиза съобщение. Числата в клетките остават числа, за да работят сумите в Excel.",
      },
      {
        type: "improvement",
        text: "Статусът на реда в „История на маси“ носи и втори, тих признак: точката на приключена сметка е запълнена или с контур. Същият знак стои и в мобилната карта, и в разбивката на кутийката „Приключени“ — без нито един допълнителен надпис и без нова колона. Признакът се вижда само когато сте с втори код; без него редовете изобщо не стигат до екрана.",
      },
      {
        type: "improvement",
        text: "На телефон справката вече не се скролва настрани: всяка сметка е карта с масата, сумата, сервитьора, часовете, времето и бона. Цялата страница минава и в тъмна тема.",
      },
    ],
  },
  {
    version: "0.0.219",
    date: "2026-09-03",
    entries: [
      {
        type: "fix",
        text: "Маркиране: на телефон между списъка с масите/детайла и долната лента с бутоните стоеше празна ивица — резервираното място за лентата беше с десктопната ѝ височина. Вече съответства на реалната височина на всеки екран и съдържанието опира плътно в лентата.",
      },
      {
        type: "improvement",
        text: "Вход в системата: на телефон брандът над формата е по-компактен — по-малко лого, по-стегнат ред и малко повече въздух до картата.",
      },
    ],
  },
  {
    version: "0.0.218",
    date: "2026-09-03",
    entries: [
      {
        type: "improvement",
        text: "Маркиране → екран с масите: на по-малки екрани (1280×800, 1366×768) лявата секция с масите вече не изяжда една трета от екрана — свита е до пропорцията от големите монитори и детайлът на сметката получава повече място. Картите на масите остават в две колони и на тесния панел, а на големите екрани нищо не се променя.",
      },
      {
        type: "improvement",
        text: "Маркиране → картите на масите: по-едри и по-стегнати — името и сумата са с по-голям шрифт, вътрешният въздух е намален, сервитьорът се води по горния ръб на името, а баджът на отстъпката — по долния ръб на сумата. Името на клиента отпадна от картата (сигналът за закачен клиент остава акцентният цвят на името на масата). Закритата нефискализирана маса вече се различава от избраната и на светла, и на тъмна тема — с ново „угаснало“ сиво и приглушена рамка на тъмно, вместо да се слива с топлите нюанси.",
      },
      {
        type: "improvement",
        text: "Маркиране → детайл на маса: всяка поръчка (включително първата) има разделител с часа си, а легендата на статусите стои на първия. Текстовете в редовете са с 2px по-едри — име, количество × цена, отстъпка, сума, добавки, модификатори и коментари. На телефон екранът е разчистен: един разделител с часа, чекбокса „Обобщено“ и легендата; статус кръгчето е горе вдясно на реда с равни отстояния спрямо текста, а докосване в дясната третина на реда сервира/отсервира — вече не трябва да се улучва самата иконка.",
      },
      {
        type: "feature",
        text: "Маркиране → каталог: клик върху реда на асортимент/рецепта добавя +1 към поръчката, точно както бутонът „+“ — по-бързо маркиране без прицелване в малкия бутон. Продукт със задължителни или препоръчителни добавки продължава да отваря „Промени“ за избор, а „Промени“ за обикновен ред си остава на молива, бутона във футъра и F9.",
      },
      {
        type: "improvement",
        text: "Маркиране → каталог: по-едри текстове навсякъде на десктоп — групите горе, секционните заглавия, имената, грамажите, цените, отстъпките и броячите (телефонът пази досегашните си размери). Групите са разгънати по подразбиране, а свиването им се запомня на устройството и се възстановява при следващо влизане. В грид изгледа картите са по-широки (по-малко колони на ред), така че при клиент с отстъпка задрасканата цена, процентът и новата цена вече не се застъпват.",
      },
      {
        type: "fix",
        text: "Маркиране: между съдържанието и долната лента с бутоните прозираше тънка ивица в различен цвят (резервираното място за футъра беше с цвета на платното) — вече е в цвета на панела и преходът е безшевен.",
      },
    ],
  },
  {
    version: "0.0.217",
    date: "2026-09-02",
    entries: [
      {
        type: "improvement",
        text: "Маркиране → „Преглед на поръчката“: моливчето на ред от поръчката вече отваря прозорец за редакция в стила на „Промени“ — с предефинираните модификатори като списък с чекбоксове и поле за коментар. Досега моливът отваряше само малко поле за писане на ръка, в което предефинираните модификатори не се виждаха — при повече модификатори изборът беше неудобен. Количество и добавки в този прозорец няма: количеството се сменя от степера на реда, а добавките се избират при самото маркиране. При включено „Обобщено“ промяната се записва във всички слети редове, така че групата остава една.",
      },
    ],
  },
  {
    version: "0.0.216",
    date: "2026-09-02",
    entries: [
      {
        type: "feature",
        text: "Маркиране → Отчет на заведението: вече може да се пусне и когато има непуснати персонални отчети — нулирането първо издава автоматично личните отчети на всички сервитьори с неотчетени сметки (накуп, без да се вадят POS бележки за всеки от тях) и веднага след това издава отчета на заведението. С 10 сервитьора вече не се минава през всеки поотделно. В модала за генериране се показва нова секция „Има неприключени отчети на тези сервитьори“ със сумите им, прегледът на отчета включва и техните числа (обороти, разбивки, часове), а над бутоните стои червено предупреждение „Нулирането на Отчета на заведението ще приключи всички Персонални отчети за деня“. Текстът на потвърждението също казва, че ще се генерират и персоналните отчети. Остава единствено проверката за незакрити сметки — всички маси трябва да са закрити. Правилото за ограничения достъп се пази: без потвърден достъп се отчитат само сметките с касова бележка, с потвърден — и нефискализираните.",
      },
      {
        type: "fix",
        text: "Маркиране: след нулиране от отчета на заведението екранът с масите се опреснява веднага — закритите нефискализирани сметки изчезват от списъка, без да е нужен ръчен рефреш (както отдавна прави пускането на личен отчет).",
      },
      {
        type: "improvement",
        text: "Маркиране → Опции: „Операции“ вече се казва „Фискални операции“. Смяната е само на надписа — прозорецът и операциите в него работят както досега.",
      },
      {
        type: "improvement",
        text: "Маркиране: лентите на скрола в списъка с маси, каталога с продукти и прегледа на поръчката са скрити — самият скрол работи както досега, екранът просто е по-чист.",
      },
    ],
  },
  {
    version: "0.0.215",
    date: "2026-09-02",
    entries: [
      {
        type: "feature",
        text: "Маркиране: бутонът „Клиенти“ вече е и на втория екран — при самото маркиране (до „Промени“), а не само при списъка със сметки. Отваря същия прозорец за избор на клиент с отстъпка или надбавка, със същото право. При избран клиент всички цени в менюто се показват коригирани: старата цена е задраскана, до нея стоят процентът (напр. −10% или +10%) и новата цена, подравнени в спретнати колони за лесно четене — и в списъчния, и в грид изгледа. Продукти със заключена цена не се коригират, точно както при отстъпка, приложена от списъка със сметки.",
      },
      {
        type: "feature",
        text: "Маркиране → „Преглед на поръчката“: при активен клиент с отстъпка/надбавка панелът показва кой е избраният клиент с неговия процент, основата (сумата по стари цени) и колко точно се отнема или добавя, а „Общо“ и бутонът „Поръчай“ показват крайната сума — същата, която ще се запише по сметката. Вижда се и на телефон (в прегледа на поръчката и в оранжевата лента). При нова маса бутонът „Клиенти“ е неактивен — клиентът се избира, след като сметката вече съществува.",
      },
    ],
  },
  {
    version: "0.0.214",
    date: "2026-09-02",
    entries: [
      {
        type: "fix",
        text: "Общи каси: касата вече помни влезлия с код служител ОБЩО за всички отворени прозорци и табове — един влязъл човек на каса, независимо колко екрана са отворени. Преди два прозореца можеха да „държат“ двама различни служители: вторият вход тихо убиваше първия, а засегнатият прозорец изтриваше входа на цялото устройство и събаряше и невинния прозорец чак до екрана с парола. Сега вторият прозорец просто показва същия служител, „Изход“ излиза от всички прозорци наведнъж, а смяната на смени е първо изход, после новият код.",
      },
      {
        type: "improvement",
        text: "Общи каси: при отхвърлен вход програмата първо проверява жива ли е сесията на самата каса и чак тогава решава — жива → връща само до екрана за код; наистина прекратена (изгонена от друго устройство, спрян акаунт, изтекъл 30-дневен срок) → пълен изход с парола; неясно (паднал интернет, рестарт на сървъра) → никого не изхвърля. Мрежов проблем вече не може да свали касите до екрана с парола. Служителят остава влязъл без ограничение във времето, докато сам не излезе; изключена и пусната наново каса иска код, както досега.",
      },
      {
        type: "improvement",
        text: "Инсталираното приложение (PWA): повторно пускане от иконата или от известие само показва вече отворения прозорец, вместо да отвори втори — най-честият път към „два прозореца на една каса“ отпада от само себе си.",
      },
      {
        type: "fix",
        text: "Списък с промени: бутонът „Изход“ при потвърден ограничен достъп вече първо сваля достъпа (както на всички останали екрани), вместо да прави пълен изход, който оставяше мястото от лиценза заето до ръчна намеса.",
      },
    ],
  },
  {
    version: "0.0.213",
    date: "2026-09-01",
    entries: [
      {
        type: "improvement",
        text: "Маркиране → Операции: бутонът „X отчет (от дата / до дата)“ вече се казва „Справка отчети за дата“. Смяната е само на надписа — самият отчет (от фискалната памет, съкратен/подробен, избор на период) работи както досега.",
      },
    ],
  },
  {
    version: "0.0.212",
    date: "2026-09-01",
    entries: [
      {
        type: "improvement",
        text: "Ново име на приложението: „UnrealSoft“ навсякъде — горните ленти, страничните менюта, екрана за вход, ПИН екрана, заглавието на браузърния таб, банера „Инсталирай“ и инсталираното PWA приложение. Смяната е само на надписите — функционалността не се променя.",
      },
      {
        type: "improvement",
        text: "Вход: брандът е уголемен — голямо лого и „UnrealSoft“ на един ред (със „Soft“ в оранжево) и в левия панел, и на телефон, а версията се показва центрирана под списъка с отметки и вече се чете автоматично от последния запис в „Какво ново“ (не се обновяваше от ръка). На телефон формата е закотвена отгоре, за да не виси празно място над бранда.",
      },
      {
        type: "improvement",
        text: "ПИН екран: брандът в левия панел на компютър е уголемен в същия стил като екрана за вход; компактният хедър на телефон/таблет остава с досегашния размер.",
      },
      {
        type: "improvement",
        text: "Мониторинг: двете карти (Одит на действията и Фискални проблеми) са в стила на картите от началния екран — оранжев отблясък горе-дясно, голяма полупрозрачна икона долу-дясно и оранжева рамка при посочване. Действията им са същите.",
      },
      {
        type: "improvement",
        text: "Маркиране → детайл на маса: в долния десен ъгъл стои голям, едва доловим надпис „UnrealSoft“ — както иконите в картите на началния екран. Чисто декоративен е и не пречи на редовете и кликовете.",
      },
      {
        type: "fix",
        text: "Горна лента (Маркиране и начален екран): долните „опашки“ на буквите р/у/д в реда с името на ресторанта вече не се режат.",
      },
    ],
  },
  {
    version: "0.0.211",
    date: "2026-08-31",
    entries: [
      {
        type: "fix",
        text: "Плащане с карта: правилото „отказана карта = сметката се връща отворена“ вече важи и при „Раздели и плати“, и при повторно закриване — не само при нормалното закриване. При разделяне отворена се връща НОВАТА сметка (разделянето на продуктите остава), за да бъде закрита нормално с друго плащане. Изисква бекенд 0.0.211.",
      },
    ],
  },
  {
    version: "0.0.210",
    date: "2026-08-31",
    entries: [
      {
        type: "fix",
        text: "Плащане с карта: повторното закриване на сметка с висящо картово теглене вече повтаря СЪЩАТА операция към касата (същия request_id) — щом тегленето е потвърдено на касата, бонът за вече изтеглените пари излиза без картата да минава втори път. Уточнен е и текстът на статус „Без бон!“ в „Карти по терминал“: той значи „връщането не мина, парите МОЖЕ да са изтеглени“, не „със сигурност“ — истината я знае справката на самия терминал. Изисква бекенд 0.0.210.",
      },
    ],
  },
  {
    version: "0.0.209",
    date: "2026-08-31",
    entries: [
      {
        type: "feature",
        text: "Справки → нова страница „Карти по терминал“ (с правото на История на маси): всички тегления от картовия терминал за периода — с бон, висящи (пари без бон) и върнати — с RRN, маскирана карта, номер на бон и Excel експорт. Това е сверката в края на деня: „С бон“ трябва да е равно на отчета на заведението, а „С бон + Висящи“ — на „край на деня“ от самия терминал.",
      },
      {
        type: "improvement",
        text: "История на операциите по сметка: нов ред „Карта“ за платените с карта сметки — сума, маскирана карта, RRN, код на авторизация и номер на бона; при теглене без бон пише изрично „НЕ теглете повторно“. Същата информация се показва и във „Фискални проблеми“ към реда на проблемната сметка.",
      },
      {
        type: "improvement",
        text: "Възстановяване на сметка, платена с карта: модалът предупреждава, че сумата се връща от терминала, и дава поле за RRN на връщането (по избор) — вписва се в регистъра на картовите плащания. На плана на залата закрита сметка с взети от картата пари и без бон носи таг „Карта — без бон“.",
      },
    ],
  },
  {
    version: "0.0.208",
    date: "2026-08-31",
    entries: [
      {
        type: "improvement",
        text: "Маркиране → Операции → „X отчет (от дата / до дата)“: периодът вече се избира с тогъл „Днес / Този месец / Период“ в стила на темата, с обяснение под избора; при „Период“ — два календара От/До (бъдещи дати са изключени в самия календар) и таван 92 дни. „Съкратен / Подробен“ е същият тогъл елемент, а полетата се разгъват веднага под избраната опция.",
      },
      {
        type: "fix",
        text: "Плащане с карта (каси с терминал): ако терминалът изтегли сумата, а бонът не излезе, сметката вече се вижда във „Фискални проблеми“ и повторното закриване издава бона, без картата да минава втори път; ако гейтуеят върне сумата на картата, масата се отваря наново — както при отказана карта. Изисква бекенд 0.0.208 (с миграция на базата).",
      },
    ],
  },
  {
    version: "0.0.207",
    date: "2026-08-31",
    entries: [
      {
        type: "feature",
        text: "Маркиране → Операции: нов бутон „X отчет (от дата / до дата)“ — отчет от фискалната памет за период (месечен, годишен или произволен). Избира се вид: „Съкратен“ (по подразбиране — сумите за периода) или „Подробен“ (по един блок за всеки Z отчет в периода), а периодът се задава със същия избор на дати като в справките — бързи пресети „Днес / Вчера / 7 дни / Този месец“ и стъпка ◀ ▶ по месеци. Отчетът се печата от фискалната памет и не нулира нищо. Изисква FiscalAPI 1.68.0 на касата — по-стар гейтуей връща грешка, която се показва като принтерна.",
      },
      {
        type: "improvement",
        text: "Маркиране → Операции: бутоните вече казват какво правят — „X отчет (без нулиране)“ и „Z отчет (с нулиране)“. Съобщенията след печат също са ясни: „X отчетът е отпечатан“ / „Z отчетът е отпечатан“ вместо да повтарят името на бутона. Самите операции са без промяна.",
      },
    ],
  },
  {
    version: "0.0.206",
    date: "2026-08-31",
    entries: [
      {
        type: "improvement",
        text: "Маркиране → Продукти: редът с групите над каталога на десктоп вече показва по подразбиране само първия ред. Когато групите не се събират, вдясно се появява оранжева стрелка (в стила на къщичката), която разгъва всички редове и после ги свива обратно; при малко групи стрелката изобщо не се показва. Изборът на група, навигацията по подгрупите и подредбата им не се променят.",
      },
      {
        type: "feature",
        text: "Маркиране → Раздели: чекбокс „Избери всичко“ — същият като в сторното. Едно натискане селектира всички продукти с пълните им количества, повторното чисти селекцията, а махне ли се количество от ред, чекбоксът сам угасва. Разделянето и „Раздели и плати“ работят без промяна.",
      },
      {
        type: "improvement",
        text: "Маркиране → Опции: „Прехвърляне“ е преименувано на „Смяна на сервитьор“, а „Преименувай“ — на „Смяна на маса“. Само етикетите на плочките са сменени — самите действия и модалите им са същите.",
      },
      {
        type: "improvement",
        text: "Маркиране → Продукти: рецептите/асортиментите във всяка група от списъка вече се подреждат по азбучен ред на името (на текущия език). Самите групи и категориите горе остават подредени по сорт индекс, както досега.",
      },
    ],
  },
  {
    version: "0.0.203",
    date: "2026-08-21",
    entries: [
      {
        type: "improvement",
        text: "Маркиране → Закриване: докато се чака фискалният принтер (до ~20 секунди), модалът вече показва ясен екран „Закриване на сметката…“ с голям оранжев спинер — вляво остават масата, методът на плащане, операторът и общата сума. Досега нямаше никаква индикация и натискането изглеждаше като „нищо не се случва“. Екранът се задържа до пълното затваряне на модала, без да мига обратно към методите на плащане.",
      },
      {
        type: "fix",
        text: "Маркиране: бутоните в модалите (Закрий, Раздели и плати, запазване, печат и др.) вече показват въртящ се индикатор, докато операцията тече — досега само посивяваха, без видим знак, че се работи.",
      },
    ],
  },
  {
    version: "0.0.202",
    date: "2026-08-21",
    entries: [
      {
        type: "feature",
        text: "Персонален отчет: чекбокс „Покажи продадените рецепти/асортименти“ — същият като в отчета на заведението. Етикетът следва режима на работа: със склад — „рецепти“, без склад — „асортименти“. По подразбиране е изключен; включен ли е при генериране, отчетът получава секция с продаденото от сметките на сервитьора — по един ред на продаваем, продадените като добавка количества са слети към същия продаваем. Секцията се вижда в прегледа, остава в Справки → „Персонални отчети“ и излиза на POS билета по същия начин като при отчета на заведението. При изключен чекбокс отчетът се записва без нея — както досега.",
      },
    ],
  },
  {
    version: "0.0.201",
    date: "2026-08-21",
    entries: [
      {
        type: "fix",
        text: "Сторно на фискализирана сметка („Сторнирай всичко“ и „Възстанови“) вече изчаква отговора на фискалния принтер, преди да запише каквото и да е. При отказ от принтера (няма връзка, грешка от апарата) нищо не се сторнира — сметката остава непокътната, показва се постоянна грешка „Нищо не е сторнирано…“ и операцията просто се повтаря, когато принтерът е оправен. Досега сметката се сторнираше в системата дори когато сторно бонът не излезеше, което създаваше разминаване с фискалната памет и отчетите. Ако принтерът не отговори в срок (неизвестен изход), сторното се записва и сметката отива в „Мониторинг → Фискални проблеми“, откъдето „Повтори“ довършва документа без риск от двоен печат.",
      },
      {
        type: "fix",
        text: "„Фискални проблеми“: бутонът „Повтори“ за сторно вече проверява дали сметката реално е сторнирана в системата. Осиротял запис (например след прекъсване по време на сторно) вече не може да издаде кредитно известие без запис — вместо това се чисти и операторът повтаря сторното от справката; ако сторното още тече, бутонът изчаква резултата.",
      },
      {
        type: "improvement",
        text: "Грешките от фискалния и ПОС принтера (няма връзка, няма хартия, отворен капак, принтерът не отговаря…) вече не изчезват сами след 3 секунди, а остават на екрана като компактно известие и се затварят само ръчно с бутона ×. Важи навсякъде, където се печата: закриване на маса, „Раздели и плати“, възстановяване и сторно, предварителна сметка, дубликат на бон, фактура на ПОС принтер, X/Z отчет и служебно въвеждане/извеждане, личен отчет и отчет на заведението, „Фискални проблеми“ и обновяване на FiscalAPI. При изтекло време известието е жълто — изходът е неизвестен и документът може все пак да е излязъл; при отказ е червено. Успешните съобщения и всички останали известия са без промяна.",
      },
      {
        type: "fix",
        text: "Мониторинг → Фискални проблеми: резултатът от бутона „Повтори“ (успех, грешка или изтекло време) вече се показва — досега оставаше невидим и се разбираше само по опресняването на списъка.",
      },
      {
        type: "fix",
        text: "Отчет на заведението: когато Z-отчетът след отчета не излезе от принтера, вече се показва самата грешка — досега съобщението беше подвеждащо „успешно“.",
      },
      {
        type: "fix",
        text: "Справки → История на маси: при „Възстанови“ изходът от сторно бона вече се показва — досега се съобщаваше само „Готово“, дори принтерът да е отказал.",
      },
    ],
  },
  {
    version: "0.0.200",
    date: "2026-08-20",
    entries: [
      {
        type: "feature",
        text: "Известия при готова храна: телефонът или компютърът показва системно известие („Маса 5: Цезар — Сготвено“), когато кухнята отбележи продукт като „Сготвено“ или шпикерът го издаде — дори когато приложението е затворено. Известието стига до сервитьора на поръчката. Включва се от профилната икона → „Известия“, поотделно за всяко устройство; на общ терминал всеки служител се абонира, след като влезе със своя код, а от екрана за вход с код се вижда кой е абониран на устройството и може да бъде премахнат (например при смяна на смените). На iPhone работи само ако приложението е инсталирано на началния екран; на Android и компютър — и директно в браузъра. Изисква еднократна настройка на сървъра — докато я няма, бутоните не се показват.",
      },
    ],
  },
  {
    version: "0.0.199",
    date: "2026-08-20",
    entries: [
      {
        type: "feature",
        text: "Справки → История на маси: в прозореца „История на операциите“ има нов бутон „Дубликат на бон“. Печата копие на фискалния бон от електронния журнал (КЛЕН) на апарата, който го е издал — копието е нефискален документ и може да се вади колкото пъти трябва. Бутонът е активен само за затворени сметки с издаден фискален бон, ненулева сума и затворени днес; когато е сив, подсказката казва защо. Апарат от марка без такава команда отговаря „Това устройство не поддържа дубликат на бонове“. Изисква FiscalAPI 1.61.0 на касата.",
      },
      {
        type: "improvement",
        text: "Конфигурация → Устройства: колоната „FiscalAPI“ показва и модела на апарата зад GUID-а (напр. „datecs_fp700mx“), така че се вижда коя каса кой принтер кара, без да се отваря локалният портал. Появява се след обновяване на касата до FiscalAPI 1.61.0.",
      },
      {
        type: "fix",
        text: "Маркиране → Сторно: бързото двойно натискане на „Потвърди“ (или два пъти Enter) вече не може да пусне сторното два пъти. Прозорецът изчаква резултата и чак тогава се затваря, а бутонът стои неактивен през това време.",
      },
    ],
  },
  {
    version: "0.0.198",
    date: "2026-08-19",
    entries: [
      {
        type: "fix",
        text: "Складова база: датата на документа при редакция на Доставка и Инвентаризация — както и датата, с която „Излишък от продажби“ предзарежда нова доставка — вече се чете в местно време. Документ, създаден след полунощ, не се мести с ден назад при отваряне за редакция. Същото важеше и за срока на годност на партидата в двата работни листа — и той е поправен.",
      },
      {
        type: "fix",
        text: "Маркиране: „Закрий“ и „Раздели и плати“ вече сверяват сумата със свежи данни от сървъра в момента на самото натискане. Ако сметката междувременно е променена (друг сервитьор е добавил продукт, минало е сторно), закриването спира с предупреждение и екранът показва новата сума, вместо плащането да мине по старата; при „Раздели и плати“ изборът на продукти се връща за преглед. При „Смесено“ разпределението в брой / с карта се проверява срещу актуалния тотал, а не срещу този от отварянето на прозореца.",
      },
      {
        type: "fix",
        text: "Кухненски монитори: добавка към продукт от друга станция вече не изчезва, когато същата добавка от менюто стои и под продукт на тази станция. Разпознаването „коя добавка вече е показана“ става по конкретния ред от поръчката, а не по артикул от менюто — две порции от една и съща добавка към два различни продукта се показват и двете, всяка на мястото си.",
      },
      {
        type: "fix",
        text: "Справка „Фактури“: новоиздадена фактура вече се вижда веднага. Досега списъкът се смяташе за „свеж“ една минута и ако справката е била отваряна преди издаването, новата фактура се появяваше чак след изтичането на минутата или след презареждане.",
      },
      {
        type: "fix",
        text: "Складова база → Наличности: след записана инвентаризация хронологията на движенията се опреснява веднага, както при доставка, изписване и прехвърляне — прозорецът вече не показва за миг старото състояние, преди да заредят свежите редове.",
      },
      {
        type: "fix",
        text: "Складова база → Прехвърляне: при редакция на записано прехвърляне валидното количество вече не свети червено като „над наличното“. Наличността към датата е вече намалена със самия документ и проверката го броеше все едно стоката е излязла два пъти — сега собственото записано количество се връща обратно в сметката (освен ако датата се смени на по-ранна от тази на документа).",
      },
      {
        type: "fix",
        text: "Конфигурация → Фирми: при изтриване на текущата фирма следващата вече НЕ става автоматично текуща. Инсталацията остава без текуща фирма до изричен избор от оператора, а опит за фактуриране дотогава показва ясното „Няма зададена текуща фирма“ — фактури с чужди реквизити не тръгват мълчаливо.",
      },
      {
        type: "fix",
        text: "Складова база → Наличности: продукт без зададен минимум вече не влиза в групата „До 20% над минимума“ — показателят „почти свършващи продукти“ спира да брои артикули, които никой не следи по минимум. Отрицателната наличност си остава сигнал за проблем.",
      },
      {
        type: "fix",
        text: "Кухненски монитори: подсказките на бутона за звука („Включи звука“ / „Изключи звука“) вече са преведени и на двата езика — досега излизаха на английски и при български интерфейс.",
      },
      {
        type: "fix",
        text: "Английски интерфейс: трите предупреждения при опит за фактура върху неподходяща сметка (вече издадена, незатворена, изтекъл срок) и етикетът „ЕИК №“ във фактурния модал вече минават през преводите, вместо да стоят на български навсякъде.",
      },
      {
        type: "fix",
        text: "Конфигурация → Фирми: ДДС номер, написан с кирилско „БГ“, се поправя автоматично на латинско „BG“ още при писане (както прави и фактурният модал) — невалиден номер с кирилица вече не може да стигне до печатната фактура.",
      },
      {
        type: "improvement",
        text: "Маркиране: бутонът „Клиенти“ се отваря винаги, независимо кой ред от сметката е селектиран. Продукт със заключена цена и досега пазеше цената си при клиентска отстъпка (сървърът го прескача); махнато е само остатъчното предупреждение, което при случайно селектиран заключен ред отказваше избора на клиент за цялата сметка.",
      },
      {
        type: "fix",
        text: "Esc вече затваря „чисто“ и петте прозореца, които го обработваха сами (изборът на сесия при вход, потвърждението за изтриване в Конфигурация, фирмата, методите на устройство и методът на плащане) — натискането се брои за обработено и не може едновременно да затвори прозореца И да върне екрана назад.",
      },
      {
        type: "improvement",
        text: "Маркиране: етикетчетата с клавишни комбинации (Esc, F5–F10, ⏎) по бутоните и в „Опции“ вече са един и същ елемент навсякъде — еднакъв шрифт, размер и позиция, без разминаванията от пиксел-два между екраните.",
      },
      {
        type: "improvement",
        text: "Маркиране → Промени артикул: количеството вече има таван 200 — по-голямо число се сваля на 200 още при писане, а „+“ спира там. Долната граница си остава: с количество 0 „Добави“ е заключен.",
      },
      {
        type: "improvement",
        text: "Маркиране: съобщенията за грешка от сървъра (добавяне на продукти, нова маса, прехвърляне, клиенти, отстъпки, разделяне, закриване, гласова поръчка, възстановяване, анулиране на фактура, смяна на цена, преименуване, X/Z операции) вече излизат на езика на интерфейса. Неочакваните грешки показват преведено общо съобщение вместо суровия технически текст.",
      },
      {
        type: "fix",
        text: "Инсталираното на Android приложение вече има правилно оформена икона (добавена е „maskable“ икона в манифеста) — досега системата я изрязваше. Банерът „Инсталирай приложението“ е приведен към стандартите на кода без видима промяна.",
      },
      {
        type: "improvement",
        text: "Техническо: билдът вече произвежда source maps и докладите за грешки в Sentry показват истинските имена на функции и редове вместо минифицирани еднобуквени имена — дебъгването по сигнал от продукция става възможно.",
      },
      {
        type: "improvement",
        text: "Техническо: типовете на сумите в „История на сметки“ и справките вече казват истината — сървърът праща парите като текст (за точни стотинки) и декларациите вече съвпадат. Компилаторът посочи и две места, които смятаха на доверие (обобщението на „Асортименти“ и „Продадени асортименти“ в отчета) — вече парсват явно. Видима промяна няма; капанът за бъдещ код е обезвреден.",
      },
      {
        type: "improvement",
        text: "Техническо: видът на добавката (самостоятелно количество / задължителна / обикновена) вече е описан като число, каквото го праща сървърът — седемте сравнения през текст са изчистени. Без видима промяна.",
      },
      {
        type: "fix",
        text: "Кухненски монитори: правилото за подреждане на продуктите е поправено да е непротиворечиво — редове от много стари поръчки (без вътрешен номер) застават накрая, вместо да могат да разбъркат реда при опресняване. С днешни данни нищо не се променя.",
      },
      {
        type: "fix",
        text: "Кухненски монитори: при включени „агрегирани количества“ броячът „({общо})“ се показва само когато наистина събира от няколко реда — единичен продукт вече не се показва като „Бургер (1) … 1 бр.“. Важи и за колоната „Общо“ в списъчния изглед (единичен ред показва „—“).",
      },
      {
        type: "improvement",
        text: "Техническо: махнати са две „мъртви“ настройки на модалните бутони в Маркиране, които отдавна не правеха нищо (подредба на футър бутоните на телефон) — изчистени са от всичките ~20 извиквания. Видът на модалите остава точно същият.",
      },
      {
        type: "improvement",
        text: "Техническо: в „Детайли на маса“ локалната променлива „тесен екран“ (която там значи под 1024px) е преименувана, за да не се бърка с общата „isNarrow“ (под 640px) — копиране на код оттам вече не пренася грешния праг. Без промяна в поведението.",
      },
      {
        type: "improvement",
        text: "Техническо почистване на мъртъв код: премахнати са неизползваният от никой екран път „направи фирмата текуща“ (и от сървъра — смяната си остава през редакцията на фирма), неизползваното „запиши клиент“ (клиентът се записва от сървъра при издаване на фактура, както досега) и фантомното поле „една станция на продукт“ от стария модел (станциите са списък от години). Без промяна в поведението.",
      },
      {
        type: "improvement",
        text: "Складова база: печатните документи на Инвентаризация и Прехвърляне ползват общото форматиране на дата — датата излиза „19.08.2026“ без „ г.“, еднакво с всички останали екрани на модула.",
      },
      {
        type: "improvement",
        text: "Техническо: от фактурния модал е махната фалшива защита срещу „анулирани добавки“ — проверка срещу статус, който сървърът никога не издава, и флаг, който добавките нямат. Тя никога не е хващала нищо (сторно на продукт и досега маха целия ред с добавките му) — сумите на фактурата не се променят с нито стотинка.",
      },
    ],
  },
  {
    version: "0.0.197",
    date: "2026-08-18",
    entries: [
      {
        type: "fix",
        text: "Кухненски монитори: съобщението при смяна на статус вече носи и пояснението „към кой продукт (коя станция)“ за добавка, чийто основен продукт се приготвя на друга станция — както всички останали съобщения към монитора. Видимо поведение днес не се променя (екранът и досега запазваше пояснението), но данните вече са пълни и еднакви по всички канали.",
      },
      {
        type: "improvement",
        text: "Ако известието към кухненския монитор при смяна на статус не успее да се изпрати, грешката вече се записва в сървърния дневник, вместо да се преглъща мълчаливо — самата смяна на статус се запазва както досега.",
      },
      {
        type: "fix",
        text: "Инвентаризация: изравнен ред (преброеното съвпада с очакваното, включително когато липсата е покрита от замяна) вече се смята със стойност точно 0, вместо със знак минус — данните за печатния документ са чисти.",
      },
      {
        type: "improvement",
        text: "Справка „Продадени продукти“ с избран склад: изчислението на себестойността вече изрично изключва анулираните складови движения, както всички останали складови справки. Числата не се променят — филтърът е предпазен.",
      },
      {
        type: "improvement",
        text: "Отчет за заведението: сборът на сторнираните по станции вече изрично изключва следите от разделяне на сметки, по общото правило за всички суми в отчетите. Числата не се променят — филтърът е предпазен.",
      },
      {
        type: "security",
        text: "Организационният код (код 2) при архивиран ресторант вече се сверява само с кода на влезлия потребител. Досега кодът на който и да е потребител с права отключваше пълния достъп на чужда сесия — влязъл като А минаваше с кода на Б.",
      },
      {
        type: "fix",
        text: "Конфигурация → Монитори: двойно натискане на „Запиши“ при бавна връзка вече показва ясното съобщение „Вече съществува монитор за този потребител“ вместо сива грешка „Internal Server Error“.",
      },
      {
        type: "fix",
        text: "Маркиране: чипът на добавка вече показва задраскана цена от менюто и действащата цена и при отстъпка (досега само при ръчно сменена цена) — отстъпката се прилагаше вярно в сумата, но чипът показваше голата цена от менюто, все едно добавката не участва.",
      },
      {
        type: "improvement",
        text: "Маркиране: единен формат на реда при всяка корекция на цената — „1 × 5.00 (задраскана) 2.50“, при отстъпка следва баджът с процента, а накрая стои чистият тотал на реда заедно с добавките. Частта „1 × …“ вече се показва и при количество 1, а задраскан общ сбор няма — промяната се обявява там, където е станала: на единичната цена.",
      },
      {
        type: "improvement",
        text: "Изборът на принтер при печат вече е с гарантирано стабилна подредба — защита при заварени стари данни. Самата конфигурация „един акаунт на два принтера от един тип“ поначало е забранена и от екрана Устройства, и от сървъра.",
      },
      {
        type: "improvement",
        text: "Техническа чистка в „История на сметки“: премахнат е параметърът за език, който сървърът никога не е чел — имената идват с всичките си преводи и екранът сам избира езика. Без видима промяна.",
      },
      {
        type: "fix",
        text: "Печат на фактура: съобщенията за грешка („няма конфигуриран POS принтер“, „принтерът не отговори“, „грешка при печат“) вече излизат на езика на интерфейса. Конкретните хардуерни съобщения от принтера се показват както идват от него.",
      },
      {
        type: "improvement",
        text: "Конфигурация → Фирми: при редакция полето „Последен номер на фактура“ вече се попълва със записаната стойност — операторът вижда докъде е стигнала номерацията и я променя само при нужда (обръща нарочното „винаги празно“ от 0.0.186).",
      },
      {
        type: "improvement",
        text: "Техническо почистване на сървъра: премахнати са неизползвани остатъци (необявен канал за съобщения, неизползвано съобщение за грешка, излишни вътрешни зависимости) и тестовият адрес за проверка на следенето на грешки. Без промяна в поведението.",
      },
      {
        type: "improvement",
        text: "Складова база → Излишък от продажби: потвърдено е като окончателно продуктово решение, че инвентаризацията НЕ изчиства натрупания недостиг — преброеното е наличността занапред, а покритие дава единствено доставка със задна дата (на/преди отчета-причинител). Поведението не се променя; правилото е записано в документацията на сървъра, а вътрешният работен списък с дефекти е изведен извън кодовата база.",
      },
    ],
  },
  {
    version: "0.0.196",
    date: "2026-08-18",
    entries: [
      {
        type: "feature",
        text: "Приложението вече само открива, че на сървъра е качена нова версия: на всеки 60 минути се прави лека фонова проверка и при разлика излиза известие „Налична е нова версия“ с бутон „Презареди“. Известието не може да се затвори — единственият изход е презареждането, което зарежда новата версия без да чака ръчен рефреш.",
      },
      {
        type: "feature",
        text: "В детайлите на маса всеки продукт вече има кръгла статус-иконка до цветната лента отляво: празен кръг — незапочнато, полузапълнен светло оранжев — в процес, тъмно оранжев с „!“ — сготвено, син със стрелка — издадено, зелен с отметка — сервирано. Статус „В процес“ вече също се отличава с цвят (преди редът не се открояваше). На телефон иконката стои до името на продукта.",
      },
      {
        type: "improvement",
        text: "Сервирането става с докосване върху иконката или лентата от всякакъв кухненски статус, а повторно докосване връща сервирането — редът отново показва текущия статус от кухнята (ако тя междувременно е напреднала, се вижда новото състояние).",
      },
      {
        type: "improvement",
        text: "В края на първия разделител в детайлите на маса има въпросителен знак с легенда какво означава всяка статус-иконка — на компютър се показва при посочване, на телефон при докосване (там стои до „Обобщено“).",
      },
    ],
  },
  {
    version: "0.0.195",
    date: "2026-08-18",
    entries: [
      {
        type: "improvement",
        text: "„Фискални проблеми“: бутонът „Опитай пак“ се показва само за проблеми от текущия ден — фискален документ се издава само в деня на продажбата. За бон меродавен е денят на затварянето на сметката, за сторно — денят на първия опит; стар ред остава видим, но без бутон.",
      },
      {
        type: "security",
        text: "Същото ограничение се налага и на сървъра: повторното издаване на бон или сторно за минал ден се отказва с ясно съобщение, така че не може да се заобиколи извън екрана — включително при повторно закриване на стара сметка от модала „Закриване“.",
      },
      {
        type: "improvement",
        text: "Вътрешна подредба на модул „Мониторинг“: страниците „Одит на действията“ и „Фискални проблеми“ вече са събрани в общата му папка. Чисто техническа промяна — адресите, екраните и поведението са същите.",
      },
    ],
  },
  {
    version: "0.0.194",
    date: "2026-08-18",
    entries: [
      {
        type: "feature",
        text: "Нов служебен модул „Мониторинг“, видим само за администратора — с две карти: „Одит на действията“ и „Фискални проблеми“. Справката „Фискални проблеми“ е преместена там от модул Справки и вече е достъпна само за администратора. Esc връща стъпка по стъпка: от одита или фискалните проблеми — към Мониторинг, оттам — към Модулите.",
      },
      {
        type: "improvement",
        text: "При нулиране на личен отчет или отчет на заведението въпросът „Печат на отчет през POS принтер?“ се показва само ако заведението изобщо има POS принтер. Ако няма нито един, стъпката се прескача автоматично.",
      },
      {
        type: "improvement",
        text: "В справките „Персонални отчети“ и „Отчети на заведението“ вече се виждат и двете дати: „Дата на отчета“ и нова колона „Дата на създаване“ с точния час, минута и секунда на пускането — включително в Excel експорта.",
      },
      {
        type: "fix",
        text: "Модул Конфигурация вече се отваря директно на страницата, за която имате право — преди, ако нямахте право за „Монитори“ (първата страница), модулът връщаше обратно към началния екран.",
      },
    ],
  },
  {
    version: "0.0.193",
    date: "2026-08-17",
    entries: [
      {
        type: "improvement",
        text: "При разделяне на сметка към маса, която вече е заета, системата вече не отказва с грешка, а пита „Желаете ли да прехвърлите избраните продукти към вече отворената маса?“ — при потвърждение продуктите се сливат в съществуващата сметка. Заетостта се преценява според настройката „Обща номерация“ (обща за ресторанта или лична за всеки сервитьор).",
      },
      {
        type: "fix",
        text: "При право за прехвърляне на разделени продукти към друг сервитьор проверката дали масата е заета вече се прави при сервитьора, избран в стъпката след номера на масата, а не при този, който разделя — включително въпросът за прехвърляне към съществуващата маса се отнася за неговата маса.",
      },
      {
        type: "security",
        text: "Без правото за прехвърляне към друг сервитьор разделянето към маса, заета от друг сервитьор, се спира с ясно съобщение — „Масата е заета… Нямате право да прехвърляте разделени продукти към друг сервитьор“ — без опция за сливане. Забраната се налага и на сървъра, така че не може да се заобиколи.",
      },
    ],
  },
  {
    version: "0.0.192",
    date: "2026-08-17",
    entries: [
      {
        type: "feature",
        text: "Системата вече има тъмна тема. Превключва се от менюто на профила (аватара горе вдясно) — нов ред „Тема“ над „Език“ с избор Светла/Тъмна; изборът се запомня на устройството и се прилага веднага, без презареждане. Покрити са всички модули и екрани — Маркиране, Справки, Складова база, Конфигурация, Мониторите, Одитът и История на промените — включително модалите, менютата и падащите списъци.",
      },
      {
        type: "improvement",
        text: "В тъмната тема прозорците и менютата са по-светли от страницата под тях, с по-плътно затъмняване отзад — така ясно се вижда къде започва и свършва всеки прозорец. Пастелните редове на кухненските монитори имат тъмни еквиваленти в същите оттенъци.",
      },
      {
        type: "improvement",
        text: "Печатните документи — фактури, складови документи и отчетите от терминала — се печатат винаги като бяла хартия с тъмен текст, независимо от избраната тема.",
      },
      {
        type: "improvement",
        text: "Цветовата палитра на цялата система е уеднаквена: натрупаните с времето почти еднакви нюанси (няколко различни кремави фона, сиви текстове и дебелини на рамки) са слети към единни канонични цветове. Екраните изглеждат по-консистентни помежду си и в двете теми; оранжевият акцент е един и същ навсякъде, включително в Складова база.",
      },
    ],
  },
  {
    version: "0.0.191",
    date: "2026-08-14",
    entries: [
      {
        type: "feature",
        text: "В прозореца „Сторно сметка“ до „Брак“ има нов чекбокс „Избери всичко“ — избира всички редове с пълните им количества с едно натискане; повторното натискане чисти избора. Чекбоксът свети и когато всичко е избрано ръчно, и угасва, щом се махне количество от някой ред.",
      },
      {
        type: "fix",
        text: "На общ терминал (вход с код) опресняването на страницата вече не връща към екрана за код — оставате на екрана, на който сте били, включително при неволно опресняване с жест на телефона. Кодът се иска отново само при изход, нов раздел или ново отваряне на браузъра; ако междувременно друг е влизал с код на същия терминал, се показва екранът за код, без да се излиза от терминала.",
      },
    ],
  },
  {
    version: "0.0.190",
    date: "2026-08-14",
    entries: [
      {
        type: "improvement",
        text: "Целият модул Конфигурация е с обновения дизайн на секции-панели: „Устройства“, „Видове плащания“ и „Фирми“ вече изглеждат като „Монитори“ — заглавие с иконна значка и брояч, търсачка и бутон за добавяне в бледия цвят на секцията, и вложена заоблена таблица, която не се слива с фона. В „Маркиране“ всяка карта с настройка носи свой деликатен цветен акцент (оранжево, синьо, зелено, виолетово), за да не се сливат еднаквите елементи.",
      },
      {
        type: "improvement",
        text: "Страница „Устройства“ е разделена на три секции по тип — „ПОС устройства“, „Фискални принтери“ и „Терминали за плащане“ — всяка със свой бутон за добавяне, който определя и типа на новото устройство: колоната „Тип“ и филтърът по тип вече не са нужни. Станциите се показват само при ПОС, методите на плащане — само при фискалните.",
      },
      {
        type: "feature",
        text: "Създаването и редакцията на монитори и устройства вече става в един и същ широк модал с номерирани стъпки в бели секции-карти: на компютър всичко се вижда без превъртане, на таблет и телефон формата пада в една колона. Инлайн формите в горния край на страницата и старите тесни модали са премахнати. При шпикер до заглавието на модала стои бадж „Шпикер“ с обяснение при посочване.",
      },
      {
        type: "improvement",
        text: "Типът на устройството вече не може да се сменя при редакция — секцията, от която е създадено, определя типа му завинаги; в модала той се показва като фиксирано поле.",
      },
      {
        type: "feature",
        text: "Методите на плащане на фискален принтер вече могат да се задават още при създаването му, а не само при редакция. Списъкът с методите е подреден като таблица „Метод → Стойност“ с точка-маркер, която светва в оранжево при попълнен ред.",
      },
      {
        type: "fix",
        text: "В модала на монитора двете кутийки на един ред вече са с еднаква височина, чекбоксите в „Опции“ са по-големи и с нормално разстояние помежду си, а полето „Потребител“ не е по-дълго от нужното.",
      },
    ],
  },
  {
    version: "0.0.187",
    date: "2026-08-14",
    entries: [
      {
        type: "feature",
        text: "Кухненският монитор вече може да се разделя на две половини. Нова настройка „Екран“ при създаване и редакция на монитор: „Един екран“ (както досега) или „Разделен на 2“ — лявата и дясната половина слушат свои станции, като една станция може да е само в едната половина. Горната лента показва кои станции гледа всяка половина, разделени с „|“. Табовете „Неизпълнени/Изпълнени“ и долните бутони са общи: табът сменя двете половини едновременно, а бутоните действат върху реда в половината, в която последно е докоснато. Стрелките се движат само в активната половина.",
      },
      {
        type: "improvement",
        text: "Издадените от шпикера редове вече не изчезват от обикновения монитор — остават в таб „Изпълнени“ със синята иконка „Издадено“, само за гледане: не могат да се селектират и връщат, защото редът вече е при шпикера.",
      },
      {
        type: "improvement",
        text: "Конфигурация → Монитори е разделена на две секции — „Монитори“ и „Шпикери“ — със свои бутони за добавяне, за да не се бъркат видовете екрани: формата за монитор предлага само обикновени потребители, тази за шпикер — само шпикери. Таблиците са с нов, по-спокоен дизайн: вложени със заоблена рамка, компактен ред с колоните, неутрални станционни чипове с цветна точка, а разликата между секциите е подчертана деликатно — леко оранжево за мониторите и леко синьо за шпикерите.",
      },
      {
        type: "improvement",
        text: "Справката за кухненската работа вече се казва „Справка монитори“ (в менюто и в заглавието), а колоната „Тип“ показва „Рецепта“ или „Асортимент“ според режима на работа, съответно „Добавка“ — вместо общото „Основен продукт“.",
      },
      {
        type: "fix",
        text: "Заглавията в справките и конфигурацията вече не режат долните части на буквите (у, д, р, щ) — текстът се показваше подстриган отдолу в „Справка монитори“, „Отстъпки и надбавки“ и всички останали екрани със същото заглавие.",
      },
      {
        type: "fix",
        text: "Списъчният изглед на монитора използва цялата ширина на екрана — премахната е празната ивица вдясно от колоната „Поръчано“, и на цял екран, и при разделен на две.",
      },
      {
        type: "feature",
        text: "Нов вид кухненски екран — „Шпикер“. Шпикерът е монитор, който събира на едно място сготвеното от всички станции и го издава към сервитьорите: когато обикновеният монитор направи реда „Сготвено“, той се появява при шпикера, а „Изпълни“ там го прави „Издадено“. Настройка при създаването решава дали шпикерът вижда само от „Сготвено“ нататък, или всичко от „Незапочнато“ — във втория случай всеки ред носи иконка за точния си статус и може да бъде издаден направо. Кой потребител е шпикер се определя от организацията; в конфигурацията на мониторите шпикерите се виждат с бадж при избора на потребител и в отделна секция в списъка. Без шпикер всичко работи както досега — до „Сготвено“.",
      },
      {
        type: "feature",
        text: "„Сервирано“ вече е отделна отметка на сервитьора, независима от кухнята. Лентата на реда в „Маркиране“ се сервира с едно докосване при „Сготвено“ или „Издадено“ и става зелена, без да пипа какво виждат мониторите; „Издадено“ се показва в синьо. Старите сервирани редове са пренесени автоматично към новата отметка и изглеждат както преди.",
      },
      {
        type: "feature",
        text: "Всяка смяна на статус вече се записва — кой потребител, кога и от кой статус в кой е преместил реда, включително сервирането от сервитьора. Историята пази и работата на мониторите, и на шпикера, и позволява да се смята колко време е стоял всеки ред във всеки статус.",
      },
      {
        type: "feature",
        text: "Нова справка „Кухненски монитори“ в модул Справки — за всеки ред от поръчка показва кога е влязъл и колко време е минало до „В процес“, „Сготвено“, „Издадено“ и „Сервирано“, и кой оператор е направил всяка стъпка. Редовете са обозначени като основен продукт или добавка, има филтри по станция и оператор, средни времена за периода и експорт в Excel. Справката се вижда само с новото право „Справка кухненски монитори“.",
      },
      {
        type: "feature",
        text: "Нова настройка „Оцветяване“ за всички монитори: редовете могат да се оцветяват по маси (както досега), по сервитьор — всеки сервитьор със свой постоянен цвят — или изобщо без цветово групиране.",
      },
      {
        type: "improvement",
        text: "Поръчките в решетката на монитора вече са отделни карти — всяка със своя рамка, лека сянка и по-тъмна заглавна лента, с малко разстояние между картите. Къде свършва една поръчка и къде започва следващата се вижда от пръв поглед, включително от разстояние.",
      },
      {
        type: "improvement",
        text: "Селекцията на монитора вече може да се сваля: докосване встрани от редовете или стрелка нагоре от най-горния селектиран ред маха избора. В списъчния изглед автоматичният избор на първия ред се връща едва след следващо действие, а не насила.",
      },
    ],
  },
  {
    version: "0.0.186",
    date: "2026-08-13",
    entries: [
      {
        type: "fix",
        text: "Количеството в прозореца „Промени“ на „Маркиране“ вече разбира и запетая. Писането на „0,5“ досега се четеше като нула — сумата ставаше 0.00 и бутонът „Добави“ угасваше, макар „0.5“ с точка да работеше. Отсега запетаята се превръща в точка още докато се пише, а започне ли числото направо с разделителя, отпред се добавя нула: „,5“ и „.5“ стават „0.5“, „.543“ — „0.543“. Полето е и по-широко, така че „0.500“ се вижда цялото, без да се реже.",
      },
      {
        type: "fix",
        text: "„Преглед на поръчката“ вече показва точното количество, а не закръглено. Ред с 0.543 кг досега се показваше като „0.5“ — и до цената, и в брояча със знаците минус и плюс — което лъжеше за реално маркираното, макар сумата да се смяташе вярно. Отсега количеството се изписва с до три знака след разделителя, без излишни нули, и клетката на брояча се разширява, за да го побере. Важи и за десктоп панела, и за прегледа на телефон.",
      },
      {
        type: "improvement",
        text: "„Последен номер на фактура“ във фирмите (Конфигурация → Фирми) вече се въвежда съзнателно при всяко отваряне. Полето се отваря празно — и при нова фирма, и при редакция — със звездичка за задължителност и подсказващ пример „Напр. 0000000034“, вместо да идва предпопълнено и да се запазва по инерция. Номерацията на фактурите е фискална приемственост и грешно наследена стойност е скъпа. Оправено е и дребно неудобство: изтриеш ли съдържанието, полето оставаше „0000000000“ и не можеше да се изпразни.",
      },
      {
        type: "improvement",
        text: "Формата за фирма вече не се кара от прага. Текстовете „Полето е задължително“ и другите грешки под полетата се показват едва след натискане на „Запази“ с невалидни данни — дотогава задължителните полета се познават само по червената звездичка. Бутонът „Запази“ вече не стои угаснал без обяснение: натиска се винаги, а при проблем показва точно кои полета не са наред и грешките се чистят на живо, докато се попълват.",
      },
      {
        type: "fix",
        text: "На телефон прозорецът „Нова маса“ вече отваря клавиатурата на устройството при докосване на полето за номер — и само тогава. Досега полето беше просто изписване на въведеното: колкото и да се натискаше, клавиатурата не излизаше и номерът се набираше единствено от екранните цифри. Отсега полето е истинско поле за писане, но без да се фокусира само̀ — клавиатурата не изскача при отваряне на прозореца, а екранните цифри и физическата клавиатура продължават да работят както досега. Същото важи и при „Раздели“ — изборът на маса, към която се разделя, минава през същия прозорец.",
      },
    ],
  },
  {
    version: "0.0.185",
    date: "2026-08-13",
    entries: [
      {
        type: "fix",
        text: "Графиката „Последните 7 дни“ в Дашборда на Справки вече показва реалния оборот по дни. Досега тя се хранеше само от генерираните отчети на заведението — ден със закрити сметки, за който още не е пуснат отчет, стоеше като „няма оборот“, макар парите да се виждаха във всички останали справки. Отсега графиката сумира директно закритите сметки по деня на закриването им. При архивирано заведение важи и правилото за организационния код: с потвърден код графиката показва всичко — фискализирани и нефискализирани сметки, а без код — само фискализираните, точно както навсякъде другаде в Справки.",
      },
      {
        type: "improvement",
        text: "В „Маркиране“ продуктите с PLU код вече го показват дискретно в сиво след името — „Салата | 5“ — и в списъчния, и в грид изгледа на каталога. Така сервитьорът, който работи с кодове, вижда с един поглед кой продукт какъв код има, без да пита и без да отваря друг екран.",
      },
      {
        type: "improvement",
        text: "Търсенето с цифри в каталога на „Маркиране“ вече нарежда съвпаденията по PLU код най-отгоре. Ако салатата е с код 5, при търсене „5“ тя излиза първа — преди „Кола 500“ и „Вода 500“, които съвпадат само по цифрата в името си — а съвпадналата част от кода се оцветява, както се оцветява съвпадението в името. При няколко продукта с подходящ код по-краткият (точното съвпадение) е пръв.",
      },
      {
        type: "improvement",
        text: "Зареждането на „Маркиране“ вече посреща с очертанията на истинския екран вместо със синьото въртящо се колелце по средата на бяла страница. Горната лента се показва веднага, а отдолу, докато данните пътуват, стоят светли заготовки на масите отляво и на поръчаното отдясно, с оранжев индикатор в тон с останалата част от системата. Същите заготовки се показват и докато се зарежда списъкът с маси.",
      },
      {
        type: "improvement",
        text: "При включено „Закриване веднага след поръчка“ прозорецът за закриване вече има и трети бутон „Клиенти“ — по средата, между „Отказ“ и „Закриване“. При тази настройка прозорецът изскача веднага след поръчването и сервитьорът нямаше кога да мине през „Опции → Клиенти“, за да отбележи клиент с отстъпка или плащане по сметка. Отсега списъкът с клиенти се отваря направо върху прозореца за закриване; след избора сервитьорът остава в него, с приложения клиент и преизчислената сума. Бутонът се показва само на служители с правото „Избор на клиент от списък“.",
      },
    ],
  },
  {
    version: "0.0.184",
    date: "2026-08-13",
    entries: [
      {
        type: "fix",
        text: "Кухненският монитор вече не бави касата. Досега отварянето или опресняването на монитор при много отворени маси можеше да спре цялата система за няколко секунди — маркирането, плащането и печатът чакаха, без грешка и без обяснение. Причината беше, че мониторът събираше данните си с по няколко заявки за всяка поръчка и през това време не пускаше никого другиго. Отсега данните се събират наведнъж (около пет пъти по-бързо) и зареждането върви изцяло встрани от останалата работа, най-много четири монитора едновременно — колкото и екрана да се опреснят в един и същи миг, сервитьорите не усещат нищо.",
      },
      {
        type: "fix",
        text: "Премахнато е скритото задръстване от кухненските монитори. Всеки включен монитор досега незабелязано запазваше по едно „място“ към базата данни за цялото време, в което е отворен — а прекъснатите връзки от заспали таблети оставаха да висят и също държаха места. При няколко екрана и малко натрупани прекъсвания местата свършваха и всичко в ресторанта започваше да виси по половин минута. Отсега мониторът не заема нищо, докато стои в покой, а забравена връзка се разпознава и затваря автоматично до минута и половина. Отделно мониторът вече не се отказва след десетина неуспешни опита за връзка: опитва, докато мрежата се върне, и екранът се съживява сам, без ръчно презареждане.",
      },
      {
        type: "fix",
        text: "Подаването на поръчка вече не може да се провали заради монитора. Имаше рядък момент, в който натискането на „Подай“ можеше да върне грешка само защото точно тогава кухненски екран се е включвал или изключвал; известията „нова поръчка“ и „разделена сметка“ пък понякога се губеха тихо, ако застигнеха затварянето на заявката, която ги е породила. И двете са отстранени — известията вървят по свой независим път и каквото и да правят мониторите, поръчката минава и кухнята я вижда.",
      },
      {
        type: "improvement",
        text: "Резервът от връзки към базата данни е увеличен и настроен за пикове. При претоварване системата вече съобщава за проблема до десет секунди с ясна грешка, вместо всички да чакат мълчаливо по трийсет. Това е и предпазната мрежа за всичко описано по-горе: дори при най-натоварения обед мониторите и справките не могат да изядат местата на маркирането и плащането.",
      },
    ],
  },
  {
    version: "0.0.182",
    date: "2026-08-12",
    entries: [
      {
        type: "fix",
        text: "Отбелязаното от кухнята и бара по добавките вече не се губи при разделяне на сметка. Досега при разделяне продуктите си запазваха статуса, а добавките към тях се връщаха на „незапочнато“ — вече сготвен сос или гарнитура се появяваше отново на монитора като нещо, което тепърва трябва да се прави. Отсега статусът на добавката пътува заедно с този на продукта — и в новата сметка, и в остатъка от оригиналната. Същото важи и при сторниране на част от количеството на ред: и там добавката губеше отбелязаното.",
      },
      {
        type: "fix",
        text: "Ред, който постъпва без отбелязан статус на приготвяне, вече влиза като „незапочнато“. Досега такъв ред се записваше със знака „/“ — стойност извън четирите статуса — и в „Маркиране“ лентата отляво го оцветяваше в червено, все едно нещо е счупено, а подсказката показваше самия знак. През екраните това не се случваше, защото те винаги подават статус, но поръчка от външна интеграция изглеждаше като грешка. Отсега липсващият статус е „незапочнато“, непозната стойност изобщо не се приема, а старите редове със знака „/“ се пренасят на „незапочнато“ при обновяването.",
      },
    ],
  },
  {
    version: "0.0.181",
    date: "2026-08-12",
    entries: [
      {
        type: "feature",
        text: "В „Маркиране“ прозорецът „Възстановяване на сметка“ вече има трети бутон — „Смяна на плащане“. Виждат го само потребителите с правото „Смяна на начин на плащане“; за всички останали прозорецът изглежда както досега. Досега, за да се закрие сметка с друг начин на плащане, тя трябваше първо да се възстанови, после да се намери сред масите и да се натисне „Закрий“. Новият бутон прави абсолютно същото като „Възстанови“ — връща сметката с всички продукти и, ако тя е била фискализирана, издава сторно документ — но веднага след това сам отваря прозореца за закриване на върнатата сметка, за да се избере новият начин на плащане. Бутонът „Възстанови“ работи точно както преди.",
      },
      {
        type: "fix",
        text: "Кодът за потвърждаване на достъп до архивиран ресторант вече приема всичко, което може да се зададе като код в организацията — цифри, букви (включително на кирилица) и символи. Досега прозорецът „Организационен код“ приемаше само цифри: клавиатурата на екрана дава само цифри, а писането от истинска клавиатура игнорираше всяка буква, така че код като „123баба“ беше невъзможен за въвеждане. Дори кодът да бъдеше въведен по друг начин, системата го отхвърляше с грешка, защото изискваше само цифри. Отсега кодът се пише и от клавиатурата, точно както на екрана за вход с личен код, а бутоните на екрана и клавишите се държат еднакво. Не се приемат само интервалите и знаците, които и организацията не позволява в код, а дължината е до 64 знака — колкото е и в организацията. Клавишите вече не се прихващат, докато пишете в друго поле, а затварянето с Esc затваря само прозореца, без да задейства и връщането назад.",
      },
      {
        type: "fix",
        text: "Личният код за вход на общ терминал вече няма скрито ограничение от 4 цифри. Организацията отдавна позволява код с произволна дължина и с букви, но в ресторанта бяха останали стари проверки за „най-много 4 цифри“ — те са премахнати, а очакваната дължина е изравнена с тази в организацията. Влизането с код не се променя за никого, който вече го ползва.",
      },
      {
        type: "fix",
        text: "Складовите количества вече се пазят с четири знака след запетаята — толкова, колкото мерната единица може да поиска. Досега единица можеше да бъде настроена на 4 знака, полето приемаше четвъртия знак и екранът го показваше, но при запис той изчезваше безшумно: въведено „0,1234 кг“ се превръщаше в „0,123“ и никъде не пишеше защо. Отсега четвъртият знак се записва и се връща какъвто е въведен. Засегнати са всички количества в Складова база — доставки, изписване и бракуване, инвентаризация, прехвърляне, замяна и наличностите. За мерните единици с 0, 1, 2 или 3 знака нищо не се променя. Едновременно с това четирите знака вече са таван и в организацията: полето не приема пети знак, вместо да го приеме и да го изгуби после.",
      },
    ],
  },
  {
    version: "0.0.180",
    date: "2026-08-12",
    entries: [
      {
        type: "fix",
        text: "Гласовата поръчка вече казва какво е станало, когато разпознаването се провали — досега в такъв случай излизаше сива системна грешка „Internal Server Error“ без обяснение и без подсказка какво да се направи. Отсега всеки провал има свое съобщение на езика на терминала: че поръчката е твърде дълга и трябва да се раздели на няколко по-къси, че отговорът е неразбираем и си струва нов опит, че услугата за разпознаване е недостъпна в момента или че гласовите поръчки изобщо не са настроени и трябва да се потърси администратор. Едновременно с това границата, до която една продиктувана поръчка се обработва, е вдигната достатъчно, за да покрие най-дългата поръчка, която микрофонът приема — дълга поръчка в заведение с голямо меню вече минава, вместо да опира в невидим таван. Разпознаването на нормалната поръчка не се променя по никакъв начин.",
      },
    ],
  },
  {
    version: "0.0.179",
    date: "2026-08-12",
    entries: [
      {
        type: "security",
        text: "Одитът на действията вече записва всяко действие, което променя данни — досега цели модули оставаха невидими за него. Влизат всичките дейности в Складова база (доставки, изписване и бракуване, инвентаризация, прехвърляне, разнасяне на отчет, взаимозаменяеми продукти, складовите настройки и възстановяването на анулиран документ), печатът на предварителна сметка и на фактура, трите настройки на „Маркиране“ (изглед на каталога, бързо закриване, обща номерация), разпознаването на гласова поръчка, повторният опит за сторно и отдалеченото обновяване на каса. От четенията се записват само тези, които сами по себе си са действие на потребителя — петте складови справки; справочниците и списъците, които просто зареждат екрана, не пълнят одита с шум. Едновременно с това ПИН-ът на сервитьора и токенът при вход с код вече се маскират със звездички, вместо да се пазят в чист вид.",
      },
      {
        type: "feature",
        text: "В „Одит на действията“ отварянето на запис вече показва разчетена информация вместо само заглавие и суров технически запис. Доставката показва склад, доставчик, номер на фактура, редовете с количества и стойност; изписването — дали е бракуване или изписване, склада и причината; инвентаризацията — преброените количества; прехвърлянето — от кой към кой склад; разнасянето — кой отчет е разнесен. Настройките показват новата стойност, печатът и обновяването на каса — резултата и грешката, ако е имало, а гласовата поръчка — изреченото и разпознатите продукти, включително кои са останали двусмислени или без съвпадение в менюто. Когато документът е бил твърде голям, за да се запази целият, вече се показва поне номерът му, за да може да се намери в Складова база; досега в такъв случай записът изглеждаше празен.",
      },
      {
        type: "improvement",
        text: "В справка „История на маси“ двете отделни кутийки „Фискализирани“ и „Нефискализирани“ в картата с оборота са премахнати. Числата им вече стоят в кутийката „Затворени“, под процента, във вида „20/3“ — оранжевото число са фискализираните, черното нефискализираните. Процентът остава на мястото си, а разбивката се показва както досега само след потвърден достъп с код.",
      },
    ],
  },
  {
    version: "0.0.177",
    date: "2026-08-12",
    entries: [
      {
        type: "fix",
        text: "Справка „Фискални проблеми“ вече показва и неуспешните сторно операции — нова секция „Сторно без документ“ за сметки, чиято касова бележка Е излязла, но сторно документът към нея не е потвърден (принтерът е отказал или не е отговорил). Досега такъв случай беше невидим: системата вече е върнала продуктите по сметката, повторен опит за сторно от Маркиране е невъзможен, а липсващият сторно документ не се виждаше никъде — оборотът в касовия апарат оставаше завишен без никой да разбере. Секцията показва и номера на касовата бележка, по която е хартиеният документ, а бутонът „Опитай пак“ повтаря безопасно: ако принтерът все пак е отпечатал сторно документа (например при прекъснала връзка), системата го разпознава и не издава втори.",
      },
    ],
  },
  {
    version: "0.0.176",
    date: "2026-08-11",
    entries: [
      {
        type: "feature",
        text: "Търсачката на продукти в „Маркиране“ вече намира продукт и по PLU код — незадължителното цифрово поле, което се задава на продаваемия артикул от админ панела на организацията. Изпишат ли се само цифри, излизат продуктите, чийто код започва с тях („12“ намира код 123), още преди кодът да е изписан докрай; търсенето по име продължава да работи точно както досега и двете се допълват — цифрова заявка показва едновременно съвпаденията по код и по име. Затова цифрите вече не се тълкуват като букви на шльокавица — досега „4“ намираше „чедър“, „6“ — „шопска“, „9“ — „ягода“; отсега цифрата е или PLU код, или цифра от самото име („Пица 4 сирена“). Продукт без зададен код се търси само по име.",
      },
      {
        type: "fix",
        text: "Автоматичното бракуване, което сторно с отметка „Брак“ от Маркиране записва в Складова база, вече може да се редактира. Досега „Запази“ връщаше „Недостатъчна наличност“ дори при смяна само на коментара — този запис нарочно може да вкара наличността на минус (бракът вече е станал физически), а редакцията го проверяваше като ръчно изписване. Тези бракувания вече излизат със собствена причина „Брак от Маркиране“ (вместо общото „Несъответствие“), така в списъка „Изписване“ от пръв поглед се вижда кое бракуване е дошло от сторно. По причината системата и ги разпознава: при редакция видът и причината са заключени, а датата, коментарът, количествата и редовете се променят свободно, без проверка за наличност. Причината „Брак от Маркиране“ е запазена — ръчно бракуване не може да я избере. Заварените автоматични бракувания (с „Несъответствие“) не се различават от ръчните и остават със старото поведение.",
      },
      {
        type: "improvement",
        text: "Коментарът, написан при сторно с отметка „Брак“ в Маркиране, вече се пренася в Складова база — автоматичното бракуване го записва като свой коментар и той се вижда в колоната „Коментар“ на списъка „Изписване“ и в отворения документ. Досега текстът се пазеше само в справката за сторно, а движението в склада оставаше без коментар.",
      },
      {
        type: "improvement",
        text: "В справка „Сторно“ колоната „Причина“ е преименувана на „Коментар“ (и в Excel експорта) — тя показва точно текста от полето „Коментар:“ на сторно модала, което е свободен текст по избор, а старото име подвеждаше, че става дума за отделна причина.",
      },
      {
        type: "fix",
        text: "Изтриването на начин на плащане, с който вече е закривана сметка, показва нормално червено съобщение „Начинът на плащане е използван в сметки и не може да бъде изтрит“ — досега излизаше сива системна грешка „Internal Server Error“ без обяснение. Отказът и преди беше правилен (старите сметки не бива да остават без начин на плащане), но не се превеждаше на човешки език. Неползван собствен метод се трие както досега, а системните методи продължават да отговарят със своята ясна грешка.",
      },
      {
        type: "security",
        text: "Затворена е дупка в четенето на настройката на кухненски монитор. Адресът, от който екранът на монитора разбира кои станции да показва, проверяваше само че си влязъл в системата — с директна заявка извън приложението (например Postman) всеки служител можеше да прочете настройката на който и да е потребител: кои станции следи, имената им и режима на показване. Вече се допуска само собственият потребител — чужд отговаря с ясна грешка. Нищо видимо не се променя: кухненският екран винаги е питал за собствената си настройка, а Конфигурация → Монитори чете конфигурациите през своя защитен списък.",
      },
    ],
  },
  {
    version: "0.0.174",
    date: "2026-08-11",
    entries: [
      {
        type: "improvement",
        text: "Календарите за избор на период — в Справките и в Складова база, със и без час — вече започват седмицата от понеделник, а не от неделя. Избраният ден и дните между двете дати се оцветяват в оранжево и в Справките, както досега беше само в Склада.",
      },
      {
        type: "improvement",
        text: "Периодът „от – до“ вече се избира с по един клик на ден: първи клик за началния, втори за крайния, след което календарът се затваря сам. Досега календарите с час искаха по два клика на дата (датата и после „OK“). Часовете се попълват сами — 00:00 на началния ден и 23:59 на крайния, т.е. цели дни, както правят и бутоните „Вчера“, „Днес“, „7 дни“ и „Този месец“; конкретен час при нужда се дописва направо в полето с датата. При ръчно избран период маркировката на бързите бутони пада автоматично.",
      },
      {
        type: "fix",
        text: "В справката „История на маси“ плочките „Фискализирани“ и „Нефискализирани“ в картата „Затворени сметки“ вече се показват според това какво реално връща сървърът, а не според режима на влизане. Досега на обикновено (неархивирано) заведение списъкът показваше закрити маси без фискален бон, а плочките с разбивката липсваха — двете места се управляваха от различни проверки. Сега сървърът сам казва дали е скрил нефискализираните сметки и плочките се крият само тогава.",
      },
      {
        type: "improvement",
        text: "На началния екран трите докосвания върху името, които отварят клавиатурата за организационния код, вече не правят нищо, докато кодът е потвърден — повторно въвеждане няма смисъл, докато режимът е отключен. Жестът заработва отново след изход от режима, а името показва курсор за кликане само когато докосванията реално водят някъде.",
      },
    ],
  },
  {
    version: "0.0.173",
    date: "2026-08-11",
    entries: [
      {
        type: "improvement",
        text: "Модалът „Закриване“ на голям екран е с нова подредба: две колони в различни топли тонове, разделени с вертикална линия — вляво плащането, вдясно методите, а хедърът и футърът са в кремаво. При „В брой“ банкнотите станаха решетка от бутони „+5“ до „+100“ с нов бутон „Точно“, който попълва полученото едно към едно със сметката; докато сумата не стига, редът показва „Остава за доплащане“, а покрие ли я — зелен панел „Ресто за връщане“. При „Смесено“ същите бързи банкноти пълнят полето „В брой“, „С карта“ се допълва само, отдолу стои „Остава за доплащане“, а бутонът „Закриване“ е неактивен, докато не е разпределена цялата сума. При „С карта“ се показва едра сума „Общо за плащане“ и напомняне, че плащането минава през терминала. Промяната е само визуална — закриването, правата и клавишите работят точно както досега, а на телефон модалът остава едно към едно както си беше.",
      },
    ],
  },
  {
    version: "0.0.172",
    date: "2026-08-10",
    entries: [
      {
        type: "feature",
        text: "Екранът „Устройства“ вече може да обновява FiscalAPI отдалечено. Балончето в колоната FISCALAPI показва версията на всяка свързана инсталация; когато има публикувана по-нова версия, балончето светва в оранжево и вътре се появява бутон „Обнови до vX“ — командата тръгва по MQTT, гейтуеят сам сваля инсталатора от update сървъра, проверява подписа му, инсталира и се рестартира (при проблем се връща на старата версия сам). Обновима е само жива инсталация — на спряна машина бутонът не се предлага. До адреса на организацията (вече оформен като чип с копиране) стои и линк за сваляне на последния FiscalAPI инсталатор — за нови компютри, където още няма какво да се обновява.",
      },
    ],
  },
  {
    version: "0.0.171",
    date: "2026-08-10",
    entries: [
      {
        type: "feature",
        text: "Отметката „Обобщено“ стигна и до екрана с масите в Маркиране — на компютър стои долу вдясно в лентата с бутоните, на телефон в десния край на линията на първия разделител. По подразбиране е изключена. Включена, тя слива еднаквите редове от всички поръчки на масата в един със сборно количество и сума и маха разделителите по часове. Еднакви са само напълно еднаквите редове: същият продукт със същите добавки, модификатори и коментари, същата цена или отстъпка и същият статус — разлика в което и да е оставя отделни редове. Изгледът е само за преглед: обобщен ред не се избира за сторно или сервиране (при включване изборът се изчиства), а бързата повторна поръчка с двоен клик продължава да работи. Самата сметка не се променя по никакъв начин.",
      },
      {
        type: "feature",
        text: "Моливчето до продукта в „Преглед на поръчката“ вече добавя коментар към продукта — досега то беше само украса, а коментар се пишеше единствено през „Промени“. Натиснато, отваря малко поле точно под името с готов фокус, за да се пише веднага; Enter или докосване извън полето запазва, Esc отказва, а изтриването на текста маха коментара. Работи и на компютър, и на телефон, и в двата прегледа — коментарът излиза в червено под продукта и стига до кухнята по същия начин, както въведеният през „Промени“. Съобразено е с „Обобщено“: при обобщен ред коментарът се записва на всички слети редове наведнъж, а редове с различен коментар си стоят отделни.",
      },
      {
        type: "improvement",
        text: "На компютър панелът „Преглед на поръчката“ вече показва в заглавието си към коя маса отива поръчката — „Маса:“ и името ѝ с удебелен шрифт, на мястото на брояча продукти. Досега масата се виждаше само на телефон (в картата до категориите); при нова маса се показва въведеното ново име. Броячът на редовете не липсва — сумата и броят продукти стоят в „Общо“ и на бутона „Поръчай“.",
      },
      {
        type: "improvement",
        text: "На телефон и таблет редът с категориите и картата „МАСА“ вече е подравнен с търсачката и списъка с продукти — досега двете секции бяха с по-малки странични отстъпи и стърчаха по-широки от всичко под тях. Падащият панел с категориите също застава на новата линия.",
      },
      {
        type: "feature",
        text: "Модалът „Закриване“ на голям екран е преработен: при „В брой“ лявата страна е помощник за ресто в отделена карта — бутони с банкнотите 5/10/20/50/100, които се добавят към полученото, поле „Получено“ (клик върху реда пише направо в него, запетаята се приема като точка, до 2 знака, а „2“, „,5“ и „2,6“ стават 2.00, 0.50 и 2.60 при излизане) и ред „Остава“, който става оранжево „Ресто“, щом полученото покрие сметката. При „Смесено“ разпределението застава вляво в същата карта с „В брой“ и „С карта“ едно под друго, а при останалите методи се показва „Общо за плащане“ с избрания метод. Самият модал е по-широк и с по-едри бутони, за да се цели по-лесно. Помощникът е само визуално удобство — закриването, правата и трите клика на „В брой“ работят точно както досега, а на телефон модалът остава едно към едно както си беше.",
      },
      {
        type: "fix",
        text: "Трите клика на „В брой“ в модала „Закриване“ вече трябва да са последователни. Досега броячът не се нулираше при избор на друг метод — „В брой, С карта, В брой, С карта, В брой“ също отключваше режима. Сега клик на който и да е друг метод (включително със стрелките от клавиатурата) започва броенето отначало.",
      },
      {
        type: "feature",
        text: "Получателят на издадена фактура вече може да се коригира от Справки → Фактури → „Виж“ — бутон „Редактирай“ горе вдясно на секцията с получателя и издателя. Отваря се малко прозорче с попълнените данни: име, ЕИК, ДДС №, населено място, адрес и МОЛ, със същите валидации като при издаване. Има и „Изберете фирма“ както при издаването — избор от запазените клиенти попълва всичко наведнъж, а нова фирма се добавя в списъка с клиенти при записа. Редакцията пипа само данните на получателя върху самата фактура: суми, редове, номер, дати и издател не се променят (за тях пътят си остава „Анулирай“ + нова фактура), анулирана фактура не се редактира, бутонът не излиза на печата, а действието се записва в Одит на действията като „Редакция на получател на фактура“.",
      },
    ],
  },
  {
    version: "0.0.167",
    date: "2026-08-10",
    entries: [
      {
        type: "feature",
        text: "История на маси има нова колона „Фискален бон“ с номера на касовата бележка. Номер се показва само за закрита и успешно фискализирана сметка; отворена маса и закрита без фискализация (последната се вижда при архивирано заведение само с код 2) остават с тире. Колоната влиза и в Excel експорта.",
      },
      {
        type: "feature",
        text: "В прегледа на поръчката в Маркиране се появи отметка „Обобщено“ — до „Общо“, по подразбиране изключена. Включена, тя събира еднаквите редове в един със сборно количество, като еднакви са само редове със същия продукт, същите добавки (и техните количества), същите модификатори и същия коментар — салата с кола и салата със сок си остават отделни редове. Събирането е само за прегледа: поръчката се изпраща и стига до кухнята точно в реда, в който е маркирана.",
      },
      {
        type: "fix",
        text: "След разделяне на сметка бележката на основната маса вече съдържа само реално останалите продукти. В оригиналната сметка разделените редове остават като следа за историята и фискалният бон ги печаташе и таксуваше отново, въпреки че те се плащат на новата маса; нефискалният бон ги показваше в редовете, без да се събират до сумата. Сега и двата документа ги пропускат — точно както предварителната сметка винаги е правила.",
      },
      {
        type: "fix",
        text: "Нулирането на отчет от Маркиране при архивирано заведение вече работи и без код 2. Генерирането на отчета минаваше, но печатът на POS принтера отговаряше с „Access denied“ — печатът на вече генериран отчет погрешно беше в групата на справките, които при архивирано заведение искат код 2. Поведението е както се очаква: без код 2 персоналният отчет съдържа само фискализираните сметки, с код 2 — всички; модул Справки си остава достъпен само с код 2.",
      },
      {
        type: "fix",
        text: "Сметка без нито един продукт или с обща сума 0.00 вече не вади никаква бележка — нито фискална, нито от ПОС принтера. Досега при закриване на такава сметка излизаше фискален бон за 0.00 евро. Правилото важи навсякъде, откъдето може да тръгне бележка при закриване: обикновеното закриване, повторното закриване на нефискализирана сметка и разделянето с плащане; предварителна сметка за нулева маса също се отказва с ясно съобщение. Самото закриване си работи както досега — просто без празен документ.",
      },
    ],
  },
  {
    version: "0.0.166",
    date: "2026-08-09",
    entries: [
      {
        type: "fix",
        text: "Отчет на заведението вече не се отваря като личен. Досега адресът за личен отчет не проверяваше вида: подаден номер на заведенски отчет го отваряше успешно, но като празна черупка — без потребител и без нито едно от заведенските числа. Сега отговорът е „Отчетът не е намерен“, точно както при печата, който винаги е правил тази проверка. През самите екрани това не се случваше — номерът винаги идва с клик от списъка с лични отчети.",
      },
      {
        type: "fix",
        text: "Отговорът при създаване на личен отчет вече носи и разбивката по видове плащания. Тя се смята при четене, а не се пази в базата, и при създаването беше пропусната — прегледът преди генериране, списъкът и детайлът я връщаха, само създаването не. На екрана нищо не се променя (там разбивката идва от прегледа и от детайла); поправката маха капана за следващия екран, който реши да я покаже веднага след генериране.",
      },
      {
        type: "fix",
        text: "Изчистени са мъртвите полета за смесено плащане в отчетите. Четири колони стояха от времето, когато смесеното се е водело отделно — никога не са се пълнили и при всички отчети са нула, а сървърът се опитваше да ги подаде към отговор, който няма такива полета. Смесеното отдавна се разнася пропорционално в „В брой“ и „С карта“, тоест сумата му е вътре в тях и нищо не липсва. Смесените суми по самата сметка (виждат се в История на маси) не са засегнати — те са друго и работят.",
      },
      {
        type: "fix",
        text: "Разделена сметка вече показва верни числа в История на маси. При разделяне в оригиналната сметка остава копие на преместените редове — за да се вижда в историята какво е излязло от нея. Сумата ѝ се намаляваше правилно, но колоните „Поръчки“ и броят активни продукти брояха и това копие: маса с 0.00 лв. се показваше с две поръчки и два активни продукта. Сега броячите пропускат копието, а самата история на поръчките остава пълна. Като следствие маса, от която е разделено всичко, вече не се предлага за възстановяване (в нея наистина няма какво да се възстанови) и излиза с вида на изцяло приключена — задраскана първоначална сума и 0.00 до нея.",
      },
      {
        type: "breaking",
        text: "Настройката „Обща номерация на сервитьорите“ вече работи както се чете. Досега включена значеше точно обратното — че всеки сервитьор има СВОЯ номерация. Сега включена значи общи номера за цялото заведение (заета маса „1“ е заета за всички), а изключена — лична номерация, при която двама могат едновременно да имат маса „1“. Записаният ви избор се обръща автоматично при обновяването, тоест заведението продължава да работи както преди — сменя се само надписът, който вижда операторът.",
      },
      {
        type: "fix",
        text: "Прехвърлянето на маса към друг сервитьор вече предупреждава, ако той има маса със същото име. Досега това минаваше мълчаливо и получателят оставаше с две отворени маси „10“, без никакъв знак защо. Сега излиза „Масата ще се дублира“ с точното какво ще стане, и решението остава на оператора — може да продължи, ако наистина го иска.",
      },
      {
        type: "fix",
        text: "Същото предупреждение излиза и при възстановяване на сметка, чието име вече е заето — възстановената взима старото си име, без някой да го въвежда. Важи и от Маркиране, и от Справки.",
      },
      {
        type: "fix",
        text: "Справките с период, който минава през полунощ, вече връщат резултати. Досега „последните 2 часа“ в 00:40 или ръчно избраното от 23:00 до 01:00 връщаха празно — периодът се проверяваше като дата и час поотделно и след полунощ условието ставаше невъзможно. Засягаше История на маси, Разделени маси, Сторно, Отстъпки и надбавки и Променени цени, а оттам и списъка „Възстановяване“ в Маркиране, който всяка нощ до 02:00 беше празен.",
      },
      {
        type: "fix",
        text: "Разделянето на сметка вече спазва настройката за номерация. При лична номерация търсеше заето име сред масите на цялото заведение и отказваше номер, който сервитьорът законно може да ползва — а после предлагаше продуктите му да отидат в чуждата маса със същото име. Сега гледа само масите на този, на когото ще е новата маса.",
      },
      {
        type: "fix",
        text: "Филтрите „от маса“ и „към маса“ в справка „Разделени маси“ бяха объркани: „към маса“ връщаше разделянията ОТ нея, а „от маса“ добавяше и разделяния от други сметки, попаднали в същата целева маса. Екранът не ги ползва, но справката вече отговаря вярно на външно запитване.",
      },
      {
        type: "security",
        text: "Живият поток с поръчките към кухненските и барските монитори вече изисква вход. Досега този канал беше отворен: всеки, който достига сървъра и знае номера на станция, можеше да чете поръчките ѝ в реално време, без изобщо да е влизал в системата. Сега връзката носи токена на влезлия потребител. Ако токенът е изтекъл или сесията е закрита отдалеч, мониторът се връща на екрана за вход, вместо да опитва да се свърже наум и да замръзне с празен екран.",
      },
      {
        type: "fix",
        text: "Отчетът на заведението губеше плащанията, които не са „В брой“ или „С карта“ — например „По сметка“. Сумата им влизаше в общия оборот на отчета, но в нито една разбивка: сборът по станции и сборът по потребители излизаха по-малки от общия и разликата не се виждаше никъде. Станция, продала само по такъв метод, изобщо не се появяваше в списъка. Сега и двете таблици имат колона „Друго“, а общата сума на реда включва и нея.",
      },
      {
        type: "fix",
        text: "Броят сметки в разбивката по станции също не се връзваше — сметките по методи извън в брой и карта не се брояха на нито един ред, докато влизаха в общия брой на отчета. Вече влизат в „Друго“.",
      },
      {
        type: "improvement",
        text: "POS билетът на отчета вече носи разбивка по всички методи на плащане, а не само в брой / карта / общо, плюс ред за останалите. Важи и за личния, и за заведенския отчет. Дали ще се отпечата зависи от версията на печатащата програма на устройството.",
      },
      {
        type: "fix",
        text: "Веднага след генериране отчетът на заведението показваше празна таблица „Обороти по видове плащания“ — разбивката се появяваше чак при повторното му отваряне от Справки.",
      },
      {
        type: "fix",
        text: "„Оптимизация с база“ вече не изтрива разбивката по методи на плащане. Отчетите, съставени отсега нататък, пазят собствена снимка на плащанията по метод и я показват дори след като сметките зад тях са изчистени. За съставените преди това данните остават невъзстановими.",
      },
      {
        type: "fix",
        text: "Скриптът, който вкарва системните начини на плащане при инсталация или обновяване, вече се проваля видимо. Досега при грешка той печаташе съобщение, но се отчиташе като успешен — липсващите начини на плащане се откриваха чак когато закриването на сметка гръмне.",
      },
      {
        type: "fix",
        text: "Затварянето на една и съща сметка от две места едновременно вече не може да извади два касови бона. Досега двете заявки виждаха сметката още отворена, и двете минаваха проверката и всяка пращаше свой бон: в програмата сметката е една, а в касата има две продажби — разликата се откриваше чак при засичане на Z-отчета. Сега сметката се заключва за времето на затварянето и втората заявка не стига до принтера. Двойният клик в самия модал и досега беше блокиран; това пази другите пътища — втори таб, второ устройство на общ терминал, повторно изпращане при бавна мрежа.",
      },
      {
        type: "improvement",
        text: "Вторият опит за затваряне вече казва оранжево „Сметката вече е закрита“ вместо червена грешка. Модалът се затваря и списъкът с маси се обновява — точно както при успешно затваряне, защото сметката наистина е затворена.",
      },
      {
        type: "fix",
        text: "„Бар1“ и „бар1“ вече са едно и също име на маса навсякъде. Досега преименуването и проверката при въвеждане ги смятаха за еднакви, но самото създаване — не: върху вече отворена „Бар1“ можеше да се отвори и „бар1“ и в списъка стояха две маси, които изглеждат еднакво. Същото важи и при разделяне на сметка към съществуваща маса. Имената само от цифри не са засегнати.",
      },
      {
        type: "fix",
        text: "Отварянето на маса вече винаги иска име. Досега, ако заявката дойдеше без име — възможно е само извън интерфейса — сървърът си избираше номер сам и в два от случаите се спираше на „1“, без да провери дали такава маса вече е отворена: създаването се проваляше с „Маса с име/номер 1 вече съществува“, макар свободни номера да има. Предложеният номер вече идва само от едно място — същото, което ползва „Бързо закриване“, тоест най-малкият свободен номер, съобразен с „обща номерация“. Име само от интервали също се отхвърля, както е при преименуване. През интерфейса нищо не се променя: и модалът „Нова маса“, и бързото закриване, и гласовата поръчка винаги подават име.",
      },
      {
        type: "fix",
        text: "Сървърът вече етикетира правилно двете различни грешки при сметките. Досега затварянето с невалиден избор — например „Плащане по сметка“ без избран клиент за масата — се отчиташе като „сметката не е намерена“, а добавянето на продукти към вече изтрита сметка — обратното, като „грешни данни“. Текстовете, които вижда сервитьорът, са същите; вярното разграничение позволява на интерфейса да реагира според случая (например да презареди масите, когато сметката наистина я няма) вместо да показва еднаква червена грешка. Затварянето през „Разделяне и плащане“ и „Повторно закриване“ и досега разграничаваше правилно — трите пътя вече се държат еднакво.",
      },
    ],
  },
  {
    version: "0.0.165",
    date: "2026-08-08",
    entries: [
      {
        type: "feature",
        text: "Отчетът на заведението вече може да показва продаденото. В модала за генериране има отметка „Покажи продадените асортименти“ (в режим със склад — „…рецепти“), по подразбиране изключена. С нея отчетът получава секция с всичко продадено по сметките зад включените персонални отчети — по един ред на артикул, с количество и сума, подредено по сума низходящо, плюс ред „Общо“. Секцията се вижда в прегледа, в Справки и излиза на POS принтера. Изборът важи за самия документ: при изключена отметка нищо не се смята и не се записва.",
      },
      {
        type: "improvement",
        text: "Продукт, продаден и самостоятелно, и като добавка, е един ред в новата секция — това е един и същ асортимент. Анулираното не влиза, а при частично сторниране остава само живото количество; копията-следи от разделяне също не се броят, така че сборът на секцията е реалният оборот зад отчета.",
      },
      {
        type: "fix",
        text: "Смесеното плащане по станции вече се разпределя точно 100%.",
      },
      {
        type: "fix",
        text: "MQTT: неуспешен publish вече не изключва връзката трайно.",
      },
    ],
  },
  {
    version: "0.0.164",
    date: "2026-08-07",
    entries: [
      {
        type: "feature",
        text: "Закрита нефискализирана сметка вече се закрива повторно през същия модал за плащане. Досега бутонът „Закрий“ питаше само „Сигурни ли сте?“ и опитваше фискализация с метода, с който сметката е закрита — при трите клика на „В брой“ това винаги беше в брой и друг избор нямаше. Сега се отваря обичайният модал с методите: избираш с какъвто искаш и излиза бон от фискалното. Изборът може да е и нефискален (трите клика, „По сметка“, метод „БЕЗ ФИСКАЛИЗИРАНЕ“) — тогава сметката си остава нефискализирана и пак излиза бележка от ПОС принтера. Така се сменя и методът на плащане на вече закрита сметка.",
      },
      {
        type: "fix",
        text: "Повторното закриване вече казва истината за принтера. Досега след потвърждение се появяваше „Сметката е затворена успешно“ дори когато принтерът е върнал грешка или не е отговорил навреме — сметката оставаше нефискализирана, а операторът не разбираше.",
      },
      {
        type: "fix",
        text: "Справки → Сметки/маси: бутонът „Възстанови“ стоеше сив за почти всяка сметка. Изискваше сметката да има сторнирани продукти, а възстановяването работи точно с обратното — с активните. Затова нормално закрита сметка, без нищо сторнирано, не можеше да се възстанови. Сега бутонът работи за всяка затворена сметка, без ограничение във времето.",
      },
      {
        type: "fix",
        text: "Гласова поръчка: добавките се брояха два пъти. Редът се пращаше със сумата, която вече включва добавките, а те се събираха и отделно — сметката, справките и касовият бон излизаха завишени. Ръчното маркиране не беше засегнато.",
      },
      {
        type: "fix",
        text: "Анулирана фактура вече освобождава сметките си. Досега сметка, попаднала в анулирана фактура, оставаше заключена завинаги: преиздаването гърмеше с неясно „Конфликт при запис“, а сметката не се появяваше и в списъците за фактуриране. Кои сметки е покривал анулираният документ продължава да се пази.",
      },
      {
        type: "fix",
        text: "„Оптимизация с база“: фактурираните сметки вече са извън чистенето — досега изтриването им оставяше издадена фактура без нито една сметка. При работа със складови рецепти имената на сторнираните продукти се четат от рецептите, а не от артикулите (отчетът се презаписваше с чужди имена). Грешките излизат с ясно съобщение вместо с вътрешния текст на базата.",
      },
      {
        type: "fix",
        text: "Отчетите се записват на този, който ги е съставил. Досега всеки отчет се приписваше на потребител 1 и стойността можеше да се подправи отвън. Прегледът на личния отчет вече показва името на съставителя; отчетите отпреди промяната остават с номер, защото име не е било записвано.",
      },
      {
        type: "fix",
        text: "Предварителна сметка: валутата се печата след сумата („ЗА ПЛАЩАНЕ: 21.80 E“), а надписите „НЕ Е ФИСКАЛЕН БОН“ и „При плащане поискайте фискален бон“ отпаднаха по желание на клиента — банерът е само „ПРЕДВАРИТЕЛНА СМЕТКА“. Изисква FiscalAPI 1.38.4 или по-нова.",
      },
      {
        type: "fix",
        text: "Потвърждаване на достъп с код: интерфейсът се отключваше и когато достъпът реално не е бил записан — следващото действие връщаше „няма права“ върху отключен на вид екран. Сега отключване се показва само ако наистина е станало.",
      },
      {
        type: "improvement",
        text: "Преглед на фактура: „Анулирай“, „Печат на дубликат“ и „POS печат“ бяха видимо по-дребни от „Затвори“ и „Печат“. Петте бутона във футъра вече са еднакви.",
      },
    ],
  },
  {
    version: "0.0.162",
    date: "2026-08-07",
    entries: [
      {
        type: "fix",
        text: "Касов бон: ръчно сменената цена вече се печата като ЦЕНА, а не като отстъпка. Досега редът излизаше с цената от менюто и отстъпка отдолу, което обърква клиента и счетоводството — продуктът не е продаден с отстъпка, а на друга цена. Истинската отстъпка (клиентска или от „Отстъпки“) продължава да се вижда на бона, както трябва.",
      },
      {
        type: "improvement",
        text: "Промяна на цена: отпадна и последното ограничение нагоре. Цена, вдигната над двойно, се печата без проблем — досега се изразяваше като процент и не се събираше в ставката.",
      },
      {
        type: "fix",
        text: "Надбавка на касов бон: печаташе се като отстъпка от същия размер. Бонът не излизаше изобщо (принтерът отказваше сметката), вместо да отпечата грешна сума. Изисква FiscalAPI 1.38.0 или по-нова.",
      },
    ],
  },
  {
    version: "0.0.161",
    date: "2026-08-06",
    entries: [
      {
        type: "fix",
        text: "Справки: оборотът вече излиза един и същ навсякъде. Разделените сметки се брояха ДВА пъти — веднъж в оригиналната маса и веднъж в отделената — и надуваха „Оборот по обекти“ на дашборда, „Справка по обекти“ и „Справка по асортименти“, докато „Затворени днес“, „История на маси“ и „Справка по сервитьори“ показваха вярната сума. Сега всички съвпадат.",
      },
      {
        type: "fix",
        text: "Складова база → Разнасяне на отчет: отчет с разделена сметка изписваше ДВОЙНО количество от склада. Това е реална липса на стока, а не само крива справка — засегнати са разнасяния отпреди тази версия и наличностите им трябва да се изравнят с инвентаризация или с редакция на самото разнасяне.",
      },
      {
        type: "fix",
        text: "Справка по обекти: спираше да брои повторните маркирания. Ако един и същ продукт беше маркиран няколко пъти в една сметка (например две кафета, добавени поотделно), влизаше само първият ред, а останалите изчезваха от оборота на обекта.",
      },
      {
        type: "improvement",
        text: "Справка по асортименти вече показва РЕАЛНО ПЛАТЕНОТО, а не стойността по меню — тоест с отчетена отстъпка, надбавка и ръчно сменена цена. Колоната „Средна цена“ също е реалната. Дотук справката не се връзваше с оборота при всяка отстъпка.",
      },
      {
        type: "improvement",
        text: "Справка по асортименти и складовите справки „Продадени продукти/рецепти“ вече се водят по датата на ЗАКРИВАНЕ на сметката, както оборотът, дашбордът и История на маси. Маса, отворена преди полунощ и закрита след него, се брои цяла към деня на закриването, вместо да се разделя между двата дни.",
      },
      {
        type: "fix",
        text: "Отчет на заведението: разбивката по станции също включваше разделените сметки два пъти и сборът ѝ надвишаваше сумата на отчета.",
      },
    ],
  },
  {
    version: "0.0.160",
    date: "2026-08-06",
    entries: [
      {
        type: "feature",
        text: "Справки → „История на сметки“: в кутийката „Затворени сметки“ се появиха две малки плочки — колко от сметките са фискализирани и колко са закрити без фискален бон, всяка с процента си. Показват се само след вход с организационния код (код 2), защото без него закритите нефискализирани сметки изобщо не се виждат в справката.",
      },
      {
        type: "improvement",
        text: "Броят е за сметките, показани в списъка отдолу (текущата страница), а не за целия период — сметката е по същия признак, по който статусът на реда светва в оранжево, когато няма издаден фискален бон.",
      },
    ],
  },
  {
    version: "0.0.159",
    date: "2026-08-06",
    entries: [
      {
        type: "feature",
        text: "Справки → нова справка „Променени цени“: всеки ред показва датата и часа на смяната, потребителя, маса, продукт (или добавка), количество, стара и нова цена, разликата в евро и проценти и разликата за целия ред. Отгоре стоят три обобщения (брой промени, намаления и увеличения), има филтри по продукт, вид промяна и потребител, износ към Excel, а клик на ред отваря историята на сметката.",
      },
      {
        type: "improvement",
        text: "Справка „Променени цени“ се води по МОМЕНТА на смяната, а не по закриване на сметката — така се виждат и промените по още отворени маси. Достъпът е със собствено право „Справка променени цени“.",
      },
      {
        type: "improvement",
        text: "Маркиране → Промяна на цена: ограничението „не повече от двойна цена“ ОТПАДНА — новата цена вече няма горна граница. Единствената проверка е цената да е над нула.",
      },
      {
        type: "improvement",
        text: "Маркиране → Промяна на цена: въведената цена се допълва до два знака, щом излезеш от полето — „12“ става „12.00“.",
      },
      {
        type: "improvement",
        text: "Маркиране → Гласова поръчка: клавишът F1 вече НЕ отваря прозореца — микрофонът до търсачката на масите се натиска само с клик (баджът „F1“ върху иконата е премахнат). Комбинацията ALT + F1 за показване и скриване на закритите маси остава непроменена.",
      },
    ],
  },
  {
    version: "0.0.158",
    date: "2026-08-06",
    entries: [
      {
        type: "feature",
        text: "Маркиране → Опции → „Предварителна сметка“ вече ПЕЧАТА. Листът излиза на POS принтера на сервитьора и показва какво е поръчано, колко е всяко нещо и колко е общо. Отгоре пише „ПРЕДВАРИТЕЛНА СМЕТКА“ и „НЕ Е ФИСКАЛЕН БОН“ — това не е касова бележка и на него няма плащания.",
      },
      {
        type: "feature",
        text: "Предварителната сметка показва добавките под ястието, към което са, а еднаквите редове се сливат — четири води, поръчани една по една, излизат като „4 x“, а не като четири реда. Когато има отстъпка, се виждат междинна сума, отстъпка и сума за плащане.",
      },
      {
        type: "improvement",
        text: "Печатът може да се повтори колкото пъти трябва — нищо не се издава и нищо не се записва. Докато принтерът работи, бутонът е зает и на екрана стои съобщение, за да не се пусне втори лист по невнимание. Сметка, която вече е закрита, не издава предварителна сметка.",
      },
      {
        type: "fix",
        text: "Имена с „лв“ вече се печатат правилно на всички POS документи — „Силвия“ излизаше като „Си €ия“ (същото важеше за „Silvia“ и всяко ястие с тези букви). Замяната на „лв.“ с „€“ вече хваща само сумите.",
      },
    ],
  },
  {
    version: "0.0.157",
    date: "2026-08-06",
    entries: [
      {
        type: "feature",
        text: "Маркиране → Опции → „Промяна на цена“: нов прозорец, който показва всички продукти на масата и добавките към тях. До всеки ред стои молив — натискаш го и въвеждаш нова единична цена. Може да смениш една или наведнъж колкото искаш цени и да ги запишеш с един бутон. Действието се вижда само с правото „set_custom_price“.",
      },
      {
        type: "feature",
        text: "Маркиране → Промяна на цена: продукт или добавка със ЗАКЛЮЧЕНА цена не може да се пипа — вместо молив до реда стои катинар. Цена над двойната спрямо тази по меню също не се приема.",
      },
      {
        type: "improvement",
        text: "Маркиране: ред с ръчно сменена цена НЕ се показва като отстъпка — виждат се само задрасканата стара сума и новата (същото важи и за добавка: „＋ Пармезан 1 × 0.50 0.30“). Баджът с процент остава само за истинска отстъпка — от клиент или от „Отстъпки“.",
      },
      {
        type: "improvement",
        text: "Справки: ръчната смяна на цена не влиза в отстъпките — нито в „Отстъпки днес“ на Таблото, нито в обобщението на прозореца „История на операциите“. В същия прозорец промяната се вижда като отделно събитие „Промяна на цена на продукт“ със старата и новата цена („10.50 € → 12.00 €“).",
      },
      {
        type: "improvement",
        text: "Маркиране: смяната на цена по даден ред маха отстъпката от него (продукта и добавките му) — досега редът можеше да остане наполовина с отстъпка, наполовина с нова цена. Отстъпка или надбавка върху цялата сметка пък вече затваря записите за отделните продукти, вместо да ги оставя да висят.",
      },
      {
        type: "feature",
        text: "Маркиране → Опции → „Предварителна сметка“: добавен е бутонът (вижда се само с правото „preliminary_bill“). Самото отпечатване предстои — засега натискането не прави нищо. (Дописано в 0.0.158.)",
      },
      {
        type: "improvement",
        text: "Маркиране → Опции: с двата нови бутона менюто остава на ДВА реда на голям екран (по 6 кутийки), вместо да слезе на три. На таблет си остава по 4 на ред, а на телефон — по 2 на ред.",
      },
      {
        type: "feature",
        text: "Маркиране: търсачките за продукти и за маси разбират „шльокавица“ — „Шоколад“ излиза и на „shokolad“, и на „6okolad“, а „Минерална вода“ — на „мин“, „м в“, „min“ и „m v“.",
      },
    ],
  },
  {
    version: "0.0.156",
    date: "2026-08-06",
    entries: [
      {
        type: "improvement",
        text: "Складова база → Справки: „Продадени продукти“, „Продадени рецепти“, „Наличности“, „Взаимозаменени продукти“ и „Анулирани дейности“ вече изглеждат точно като списъците — една горна лента в цвета на страницата със заглавие вляво, период в средата и търсачка вдясно (при „Наличности“ до търсачката стои и изборът на склад), KPI карти под нея и олекотена таблица с номерирани редове.",
      },
      {
        type: "improvement",
        text: "Складова база → Справки: под таблиците се появи ред „Общо за периода“ със сумите нето и бруто, както в доставките и изписванията.",
      },
      {
        type: "improvement",
        text: "Складова база → Справки: часовникът, бутонът „Опресни“ и профилното меню горе вдясно отпаднаха — всичко това го има в лявото меню.",
      },
      {
        type: "improvement",
        text: "Складова база → Наличности: числата в колоните са подравнени вдясно като в останалите таблици, а филтърът на колона „Продукт“ вече има търсачка.",
      },
      {
        type: "improvement",
        text: "Складова база → Справки: прозорците с разбивка по дни („Продадени“) и с детайлите на анулиран запис са в стила на документните прозорци в модула.",
      },
      {
        type: "improvement",
        text: "Складова база → Взаимозаменени продукти: колоните са свити (най-вече количествата и сумите), за да се събира цялата таблица на екрана без влачене настрани.",
      },
      {
        type: "fix",
        text: "Складова база: заглавията на числовите колони във всички таблици на модула вече стоят точно над стойностите — досега иконката за сортиране ги избутваше наляво.",
      },
    ],
  },
  {
    version: "0.0.155",
    date: "2026-08-06",
    entries: [
      {
        type: "improvement",
        text: "Складова база → Прехвърляне: списъкът е в общия вид на модула — една горна лента в цвета на страницата със заглавие, период и бутон „Ново прехвърляне“, и олекотена таблица с колона „Направление“ („Кухня → Бар“), коментар, брой продукти и стойност нето/бруто, плюс ред „Общо за периода“.",
      },
      {
        type: "feature",
        text: "Складова база → Прехвърляне: създаването и редакцията са на ЦЯЛА СТРАНИЦА вместо в тесен прозорец — с полета Дата, От склад → Към склад и Бележка горе, голяма търсачка над таблицата и обобщение с бутоните „Отказ“ и „Прехвърли“ в долната лента, точно както при доставка и изписване.",
      },
      {
        type: "feature",
        text: "Складова база → Прехвърляне: продуктите се добавят от същата търсачка като в доставка и изписване — пишеш където и да е на страницата, стрелките избират, а Enter добавя реда и слага курсора направо в „Количество“. Досега всеки ред се избираше от падащо меню.",
      },
      {
        type: "feature",
        text: "Складова база → Прехвърляне: всеки ред вече показва и какво ще остане в склада-източник и какво ще стане в склада-получател след прехвърлянето — двете колони „Остава …“ и „Става …“ до количеството.",
      },
      {
        type: "improvement",
        text: "Складова база → Прехвърляне: при напускане с незапазени промени страницата пита, преди да изгуби работата, а Esc връща към списъка — както при останалите работни листове.",
      },
    ],
  },
  {
    version: "0.0.154",
    date: "2026-08-06",
    entries: [
      {
        type: "improvement",
        text: "Складова база → Взаимозаменяеми продукти: страницата е преработена в общия вид на модула — една горна лента в цвета на страницата със заглавие вляво и търсачка плюс бутон „Ново правило“ вдясно, а под нея правилата едно под друго, без излишни заглавия.",
      },
      {
        type: "improvement",
        text: "Складова база → Взаимозаменяеми продукти: всяко правило вече е отделен ред-карта, а не ред в таблица — продуктите са чипове със съотношението и мярката, свързани със знака ⇄ (всеки замества всеки), а вдясно стоят коментарът на групата и бутонът „Редактирай“.",
      },
      {
        type: "feature",
        text: "Складова база → Взаимозаменяеми продукти: създаването и редакцията са на ЦЯЛА СТРАНИЦА вместо в тесен прозорец. Продуктите се добавят от търсачка (пишеш, стрелки нагоре/надолу, Enter) вместо от падащо меню на всеки ред, а долу до „Отказ“ и „Запази правилото“ стои живото уравнение на правилото — например „1 кг Домати = 1.538 кг Доматено пюре“.",
      },
      {
        type: "feature",
        text: "Складова база → Взаимозаменяеми продукти: картата „Как ще се прилага“ обяснява какво прави правилото — при липса на някой продукт системата предлага изписване от останалите по показаните съотношения, при разнасяне на отчет и при инвентаризация.",
      },
      {
        type: "feature",
        text: "Складова база → Взаимозаменяеми продукти: в създаването и редакцията можеш да търсиш без да кликаш — щом започнеш да пишеш, буквите влизат направо в търсачката, както в доставка и изписване. Търсенето е по думи: „п с“ намира „Пил. Месо“ и „Порт. сок“, а съвпаденията са оцветени. Esc връща към списъка.",
      },
      {
        type: "improvement",
        text: "Складова база → Взаимозаменяеми продукти: правилото се чете като верига („1.00 кг Домати ⇄ 0.80 кг Картофи ⇄ 0.667 кг Краставици“), а при група с три или повече продукта редакцията показва и пример за двойка от останалите („1 кг Картофи = 0.833 кг Краставици“), за да е ясно, че всяка комбинация работи, не само спрямо първия продукт.",
      },
      {
        type: "improvement",
        text: "Складова база → Взаимозаменяеми продукти: секциите „Продукти в групата“, „Коментар“ и „Как ще се прилага“ са в топлия цвят на картите от „Разнасяне на отчети“, а долната лента вече не повтаря уравнението — то стои в „Как ще се прилага“.",
      },
      {
        type: "improvement",
        text: "Складова база → Взаимозаменяеми продукти: при напускане с незапазени промени страницата пита, преди да изгуби работата — както при доставка, изписване и инвентаризация. Анулирането на правило е в долната лента на редакцията.",
      },
    ],
  },
  {
    version: "0.0.153",
    date: "2026-08-06",
    entries: [
      {
        type: "improvement",
        text: "Складова база → Излишък от продажби: страницата е преработена и вече изглежда точно като Доставка, Изписване, Инвентаризация и Разнасяне на отчети — една горна лента в цвета на страницата със заглавие вляво и търсачка плюс бутон „Нова доставка“ вдясно, обобщаващи карти в същия размер и шрифт и олекотена таблица без вертикални линии, с по-едър шрифт и въздушни редове. Данните и сметките са същите.",
      },
      {
        type: "feature",
        text: "Складова база → Излишък от продажби: с чек-боксовете отляво избираш продуктите, а „Нова доставка“ отваря страницата за доставка вече попълнена с тях — количество колкото е недостигът, последната доставна цена и складът на всеки ред, а датата е на най-стария отчет, който е причинил недостига. Броят на маркираните се вижда в самия бутон.",
      },
      {
        type: "feature",
        text: "Складова база → Излишък от продажби: всеки ред има и линк „Доставка“ вдясно — за компенсиране само на този продукт, без да го маркираш.",
      },
      {
        type: "improvement",
        text: "Складова база → Излишък от продажби: обобщаващите карти станаха три — „Продукти в недостиг“, „Стойност нето“ и „Стойност бруто“ (досега брутото се виждаше само сумарно). Най-долу таблицата затваря с ред „Общо непокрит излишък · N продукта“ и двете суми.",
      },
      {
        type: "improvement",
        text: "Складова база → Излишък от продажби: количеството вече е ясен червен чип („+5,000 килограм“), а не число с минус, и се закръгля според мерната единица на продукта — „брой“ излиза цяло число.",
      },
      {
        type: "improvement",
        text: "Складова база → Излишък от продажби: търсачката е горе до заглавието и търси дума по дума по продукт, склад и категория. Разбивката по отчети при клик на ред е в същия нов вид.",
      },
    ],
  },
  {
    version: "0.0.152",
    date: "2026-08-06",
    entries: [
      {
        type: "improvement",
        text: "Складова база → Инвентаризация: списъкът вече изглежда точно като Доставка, Изписване и Разнасяне на отчети — горна лента в цвета на страницата със заглавие вляво, период в средата и „Нова инвентаризация“ вдясно, обобщаващи карти в същия размер и шрифт и олекотена таблица с ред „Общо за периода“ отдолу. Колоната „Статус“ отпадна: черновите вече не са записи и не се появяват в списъка.",
      },
      {
        type: "feature",
        text: "Складова база → Инвентаризация: над таблицата вдясно има чек-бокс „Групирай по склад“ — включен, редовете са разделени на ленти по склад („Кухня · 2 инвентаризации“); изключен, списъкът е плосък. Сортирането и филтрите по колони работят и в двата режима.",
      },
      {
        type: "feature",
        text: "Складова база → Инвентаризация: броенето вече е на ЦЯЛА СТРАНИЦА, не в тесен модал — с полета Дата, Склад (падащо меню) и Бележка / причина (по избор) горе, голяма търсачка над таблицата и обобщение с бутоните „Отказ“ и „Потвърди инвентаризацията“ в долната лента, точно както при създаване на доставка.",
      },
      {
        type: "feature",
        text: "Складова база → Инвентаризация: продуктите, в които си писал, се вдигат най-отгоре на таблицата — при три хиляди продукта десетте преброени вече не се търсят из целия списък. Блокът им се отличава по светлия фон и една тънка линия под него, без заглавия и броячи по средата на таблицата. Останалите вървят по азбучен ред, първо тези с наличност. Редът се мести горе чак когато излезеш от полето, за да не отскача, докато пишеш.",
      },
      {
        type: "feature",
        text: "Складова база → Инвентаризация: из полетата се ходи със стрелките нагоре/надолу/наляво/надясно и с Enter, както при доставка и изписване. Писането където и да е на страницата влиза направо в търсачката, а Enter върху намерен продукт слага курсора в колоната „Намерено“, готов за въвеждане.",
      },
      {
        type: "feature",
        text: "Складова база → Инвентаризация: черновата се пази сама, докато броиш, и при отваряне на нова инвентаризация те пита дали да продължиш откъдето си спрял — както при доставка. Бутонът „Запази чернова“ отпадна, вече не е нужен.",
      },
      {
        type: "fix",
        text: "Складова база → Доставка и Инвентаризация: въпросът „Искате ли да продължите откъдето спряхте?“ вече изброява количествата по мерната единица на продукта — с толкова знака след запетаята, колкото са настроени за нея, и със самата мярка („Домати — 4,250 кг“, „Кола — 9 бр“). При доставка се показва разфасовката, ако е избрана такава. Досега числата излизаха сурово, както са били набрани.",
      },
      {
        type: "feature",
        text: "Складова база → Инвентаризация: взаимозаменяемите продукти се върнаха — вече като секция „Взаимозамени“ вдясно от таблицата, вместо изскачащ прозорец накрая. Показва двойките (например −3 кг Домати и +3 кг Картофи) и с бутона „Замени“ ги изравнява до нула. Ако няма какво да се покрие, секцията не се показва и таблицата заема цялата ширина.",
      },
      {
        type: "improvement",
        text: "Складова база → Инвентаризация: редът под продукт с излишък вече казва какво прави — зелена лента „Заприходяване“ с количеството, което влиза като нова партида, и до нея полетата Партида и Срок. Задължителните са със звездичка и червена рамка, ако са празни. Отделно поле за доставна цена няма — цената на новата партида се въвежда в колоната „Ед. цена“ на самия ред.",
      },
      {
        type: "improvement",
        text: "Складова база → Доставка и Изписване: докато няма добавени продукти, празната карта под търсачката вече е в топлия цвят на страницата, а не ярко бяла — контрастът беше твърде силен. Щом се добави първият продукт, таблицата става бяла, както досега.",
      },
      {
        type: "improvement",
        text: "Складова база → Разнасяне на отчети: картите „Продадено“, „Изписване от склад“ и „Компенсиране на липси“ в работния лист вече са в топлия цвят на страницата, а не ярко бели — същия, който вече ползват празните таблици в Доставка и Изписване.",
      },
      {
        type: "improvement",
        text: "Складова база → Разнасяне на отчети: връзката „избери всички“ в „Компенсиране на липси“ се показва само когато има повече от една възможна компенсация — при една беше излишна.",
      },
      {
        type: "improvement",
        text: "Складова база → Инвентаризация: секцията „Взаимозамени“ е изчистена — обяснителният текст отгоре и числото „Ефект“ отпаднаха. Остават двойката, коефициентът и бутонът.",
      },
      {
        type: "improvement",
        text: "Складова база → Инвентаризация: натиснеш ли „Замени“, редовете се преизчисляват ВЕДНАГА — липсата спада с покритото, излишъкът на заместителя отива на нула и вече не иска партида, а броячите и сумите долу следват. Досега се променяха само иконките и разликата се виждаше чак в документа след записа. „Отмени“ връща числата обратно.",
      },
    ],
  },
  {
    version: "0.0.151",
    date: "2026-08-05",
    entries: [
      {
        type: "improvement",
        text: "Складова база → Доставка и Изписване: списъците вече изглеждат точно като „Разнасяне на отчети“. Горната лента е в цвета на страницата, обобщаващите карти горе са в същия размер и стил, а таблиците са олекотени — без вертикални линии между колоните, без сив фон на заглавния ред, с по-едър шрифт и по-въздушни редове. Стрелките за сортиране и фунийките за филтриране вече не шумят по заглавията — появяват се, щом минеш с мишката върху колоната, и си остават видими, докато филтърът е активен. Колоните и съдържанието им са абсолютно същите.",
      },
      {
        type: "feature",
        text: "Складова база → Доставка и Изписване: под таблиците вече има ред „Общо за периода“ със сумите нето и бруто за целия избран период — както е при Разнасяне на отчети. Досега общата стойност се виждаше само в картата горе, а нетната сума не се сумираше никъде.",
      },
      {
        type: "improvement",
        text: "Складова база → създаване и редакция на Доставка и Изписване: долната лента вече е ОТДЕЛНА под таблицата, а не залепена в нея, и е като при Разнасяне на отчет. Сумите са изнесени едро и се четат от разстояние — при доставка „Основа · ДДС · Общо“, при изписване „Нето · Бруто“, като крайната сума е в оранжево. Вдясно, до бутона за запис, вече има и бутон „Отказ“, който връща към списъка и пита, ако има незапазени промени.",
      },
    ],
  },
  {
    version: "0.0.150",
    date: "2026-08-05",
    entries: [
      {
        type: "feature",
        text: "Складова база → Разнасяне на отчети: страницата е преработена изцяло и вече работи като Доставка и Изписване. Първо се отваря СПИСЪК с вече разнесените отчети за избран период — с дата и час, потребителя, който е разнесъл, колко рецепти и продукта са продадени, колко продукта са изписани, колко липси са компенсирани и стойността нето и бруто, плюс ред „Общо за периода“. Всяка колона се сортира и филтрира, а горе стоят четири обобщаващи карти. Клик на ред отваря ДОКУМЕНТ на разнасянето — с всички изписани продукти, склад, количество, единична цена и стойност — откъдето може да се принтира, редактира или анулира. Досега тези данни ги нямаше никъде: разнесените отчети се виждаха само в едно падащо меню за редакция, без история и без документ.",
      },
      {
        type: "feature",
        text: "Складова база → Разнасяне на отчети: създаването и редакцията вече са на ОТДЕЛНИ цели страници, а не в тесен панел. При „Ново разнасяне“ първо излиза списък с всички неразнесени отчети на заведението (номер, дата, брой сметки и оборот), за да се избере кой да се разнесе — досега отчетът се избираше от падащо меню и се хващаше автоматично най-старият. След избора се отваря работният лист: вляво продаденото от отчета, вдясно продуктите за изписване със склад, количество, наличност и стойност нето/бруто, а долу общата сума и бутоните за отказ и разнасяне.",
      },
      {
        type: "improvement",
        text: "Складова база → Разнасяне на отчети: компенсирането на липси вече е директно в екрана, а не в отделен модал. Най-горе се показва по един ред за всяка възможна компенсация — „липсващ продукт (колко не достига) → заместител (колко ще се вземе)“ — и се отмята с едно кликване; има и „избери всички“. Веднага се вижда колко от липсите са покрити и колко остават, а отметнатите намаляват количеството за изписване. Секцията се показва само когато наистина има какво да се компенсира.",
      },
      {
        type: "breaking",
        text: "Складова база → Инвентаризация: при потвърждаване вече НЕ излиза предложение за покриване на липси от взаимозаменяеми продукти. Инвентаризацията се записва директно и липсата си остава липса. Досега, ако имаше липса с наличен заместител, се отваряше модал, който предлагаше да се изпише заместителят вместо липсващия продукт. Тази стъпка е премахната, докато не бъде заменена с новия начин на компенсиране (както е вече в Разнасяне на отчети).",
      },
      {
        type: "improvement",
        text: "Складова база → Разнасяне на отчети: изписването вече е винаги по реда на постъпване (FIFO) и колоната за избор на конкретна партида отпадна, заедно с колоната „Остава“. Така таблицата е по-четима, а себестойността се смята по същия начин както досега — от най-старите партиди към новите.",
      },
    ],
  },
  {
    version: "0.0.149",
    date: "2026-08-04",
    entries: [
      {
        type: "feature",
        text: "Маркиране → Сторно: отметката „Брак“ вече бракува и в Складова база. Сторнира ли се продукт с нея, автоматично се записва бракуване с причина „Несъответствие“ и продуктите от рецептата излизат от склада — досега отметката се пазеше само в справката за сторно, а стоката оставаше в наличност, макар физически да е изхабена. Складът се определя от станцията на реда: салата от Кухня се бракува от склада на Кухнята, а добавка Кола, която се приготвя на Бар, излиза от склада на Бара (тогава се създават два отделни документа). При частично сторно се бракува само сторнираното количество и съответната част от добавките. Бракуванията се виждат в „Изписване“ като всяко ръчно — с потребителя, който е сторнирал — и се редактират или изтриват оттам. Сторно БЕЗ отметката „Брак“ не пипа склада. Важи само за заведения със склад.",
      },
    ],
  },
  {
    version: "0.0.148",
    date: "2026-08-04",
    entries: [
      {
        type: "fix",
        text: "Складова база → Разнасяне на отчети: разнасянето вече изписва и продаденото като ДОБАВКА, а не само основните продукти — досега добавките оставаха в наличност и складът се разминаваше с реално продаденото. За изписването няма значение дали продуктът е поръчан самостоятелно, или като добавка към друго ястие. Сторнираните позиции продължават да не се изписват.",
      },
      {
        type: "fix",
        text: "Складова база → справки „Продадени продукти“ и „Продадени рецепти“: количествата и сумите вече включват и продаденото като добавка (включително в разбивката по дни при клик на ред). Досега тези справки броеха само основните продукти и показваха по-малко от реално продаденото.",
      },
    ],
  },
  {
    version: "0.0.145",
    date: "2026-08-03",
    entries: [
      {
        type: "fix",
        text: "Справки → Справка по обекти: оборотът вече включва и продадените добавки — досега справката броеше само основните продукти и сумите по обекти излизаха по-малки от реално платеното по сметките. Добавката се брои към СВОЯ обект: сос, който се приготвя на Бар към ястие от Скара, влиза в оборота на Бара, а не на Скарата — досега такава добавка не се появяваше никъде. Разпределението в брой / с карта / смесено, бройките сметки и разбивката по дни при клик на обект работят по същите правила както за продуктите. Сумите в отчета на заведението и в „Оборот по обекти“ на дашборда открай време включват добавките — сега и тази справка се връзва с тях.",
      },
      {
        type: "feature",
        text: "Справки → Асортименти/Рецепти: справката вече показва и ПРОДАДЕНИТЕ ДОБАВКИ, а не само основните продукти — досега те липсваха от нея изцяло. Всяка добавка е собствен ред с ново поле „Тип“ (Продукт / Добавка), по което може да се сортира и филтрира — с падащото меню „Тип“ до „Категория“ и „Станция“ може да се гледат само добавките, само продуктите или всичко. Така оборотът и количествата в справката вече включват и продаденото като добавка. Един и същ артикул може да се появи на два реда — веднъж като самостоятелна продажба и веднъж като добавка — защото цените в двата случая се различават. Колоната „Тип“ влиза и в експорта към Excel.",
      },
      {
        type: "improvement",
        text: "Справки: когато заведението работи със склад, справката „Справка по асортименти“ вече се казва „Справка по рецепти“ — така името отговаря на това, което всъщност се продава в този режим. Новото име се вижда навсякъде: в менюто отляво, в заглавието на самата справка, в заглавието на таба на браузъра и в името на изтегляния Excel файл. Самата справка, данните в нея и правата за достъп остават непроменени; при заведение без склад името си остава „Справка по асортименти“.",
      },
      {
        type: "fix",
        text: "Маркиране: при продукт с количество под единица (например 0,500 кг) редът на сметката вече показва сметката „количество × единична цена“ — досега тя се появяваше само при количество над 1 и при половин килограм се виждаше единствено крайната сума.",
      },
    ],
  },
  {
    version: "0.0.144",
    date: "2026-08-03",
    entries: [
      {
        type: "feature",
        text: "Монитори: добавка, чийто основен продукт се приготвя на друга станция (например Кола от Бар към Бургер от Скара), вече показва от кой продукт идва — под името ѝ стои подтекст „(към Бургер от Скара)“, в същия формат като на кухненския бон. Работи и в списъчния, и в решетъчния изглед; когато мониторът гледа и двете станции и основният продукт е точно над добавката, подтекстът не се показва, за да не се дублира информацията.",
      },
      {
        type: "improvement",
        text: "Монитори: дървовидната линия, която свързва добавка с основния ѝ продукт в списъчния изглед, е прерисувана векторно — плавна извивка със стрелка към продукта, с еднаква дебелина по цялата дължина и остра картина при всякакъв мащаб на екрана (досега изглеждаше пикселизирана, а на места по-тъмна и по-дебела).",
      },
    ],
  },
  {
    version: "0.0.143",
    date: "2026-07-31",
    entries: [
      {
        type: "improvement",
        text: "Маркиране → Гласова поръчка: слушането вече е „задръж и говори“ — при отваряне на прозореца микрофонът не тръгва сам, а в средата стои кръгъл бутон, който слуша само докато е натиснат (работи и с мишка, и с пръст на touch екран). Паузите в говора вече не прекъсват слушането — то приключва чак когато пуснете бутона, след което казаното веднага се обработва. Бутонът „Спри“ отпада — пускането на бутона е стопът.",
      },
    ],
  },
  {
    version: "0.0.142",
    date: "2026-07-31",
    entries: [
      {
        type: "security",
        text: "Общ терминал: вход с код вече никога не наследява потвърдения ограничен достъп на предишния служител — сървърът го нулира при всеки вход с код (включително след опресняване на страницата). Досега при изход с Esc към екрана за код достъпът оставаше активен и всеки следващ служител влизаше с него.",
      },
      {
        type: "improvement",
        text: "Общ терминал: клавишът Esc вече „бели“ състоянията слой по слой — от модул към „Модули“, после (при активен ограничен достъп) първият Esc прави изход от ограничения достъп и оставате на „Модулите“, а чак следващият Esc води към екрана за код. Същата логика като бутона „Изход от ограничен достъп“ в профилното меню.",
      },
      {
        type: "fix",
        text: "Справки: след „Изход от ограничен достъп“ (или смяна на служител с код) вече не се показват за секунда старите стойности от предишния режим (например нефискализирани обороти в Дашборда), преди да се опреснят — кешираните данни се изчистват незабавно при всяка смяна на достъпа или на влезлия потребител.",
      },
    ],
  },
  {
    version: "0.0.141",
    date: "2026-07-30",
    entries: [
      {
        type: "feature",
        text: "Маркиране → Гласова поръчка: вече може да казвате и коментар към продукт — например „добави една кола с коментар за бара“. Коментарът се показва в прегледа на реда на продукта (както при ръчното маркиране), може да се редактира през „Промени“ и заминава с поръчката към кухнята/бара.",
      },
      {
        type: "improvement",
        text: "Маркиране → Гласова поръчка: разпознаването е по-устойчиво на грешки от преобразуването на реч в текст — ако системата чуе „експресо“ или „експрес“, а в менюто има „Еспресо“, продуктът вече се разпознава по звучене вместо да се показва „няма съвпадение в менюто“.",
      },
    ],
  },
  {
    version: "0.0.140",
    date: "2026-07-29",
    entries: [
      {
        type: "improvement",
        text: "Маркиране → Гласова поръчка: разпознаването на казаната поръчка вече се обработва от нов езиков модел (OpenAI gpt-5.6-luna вместо Claude). Потокът на работа, прегледът за потвърждение и правата остават без промяна.",
      },
      {
        type: "improvement",
        text: "Маркиране: методът „По сметка“ в прозорците „Закрий“ и „Раздели и плати“ вече се показва само когато е избран клиент с право на плащане по сметка — без такъв клиент методът е скрит изцяло (досега стоеше видим, но неактивен с подсказка).",
      },
      {
        type: "improvement",
        text: "Маркиране → Закрий: когато на сметката има избран клиент с право на плащане по сметка, прозорецът „Закрий“ се отваря с предварително избран метод „По сметка“ вместо „В брой“. Ръчният избор на друг метод не се променя автоматично.",
      },
      {
        type: "improvement",
        text: "Маркиране: вътрешна реорганизация на файловете на модула за по-лесна поддръжка и развитие — компонентите са групирани по екраните „Маси“ и „Продукти“, а функционалностите (плащане, разделяне, клиенти, фактуриране, отчети, гласови поръчки) са в отделни подпапки. Няма никакви видими или функционални промени за потребителите.",
      },
    ],
  },
  {
    version: "0.0.139",
    date: "2026-07-29",
    entries: [
      {
        type: "feature",
        text: "Маркиране: нова функционалност „Гласова поръчка“ — икона с микрофон вдясно от търсачката на масите (или клавиш F1) отваря прозорец, в който казвате поръчката свободно, например „Отвори маса 1 и добави 2 пъти салата цезар с 2 коли“. Системата разбира маса, продукти, количества, модификатори („водката да е малка“) и добавки („със сос кетчуп“) и показва преглед за потвърждение — нищо не се изпраща към кухнята без натискане на „Поръчай“. Ако маса с казаното име вече е отворена, продуктите се допоръчват към нея; ако не — се отваря нова. Работи в Chrome и Edge.",
      },
      {
        type: "feature",
        text: "Маркиране → Гласова поръчка: при двусмислие системата пита — ако казаното съвпада с няколко продукта (например „кола“ при няколко вида коли) или с няколко модификатора/добавки, се показва избор между кандидатите преди прегледа. Продукт без съвпадение в менюто се показва зачертан и не се поръчва.",
      },
      {
        type: "improvement",
        text: "Маркиране → Гласова поръчка: името на масата в прегледа е редактируемо поле — предпопълва се с чутото, но може да се смени (например ако масата е заета от друг оператор) или да се напише ръчно, ако маса не е спомената. Продукт с непокрита задължителна добавка или задължителен модификатор се отбелязва и отваря познатия прозорец „Промени“ (предпопълнен с чутото) за довършване — „Поръчай“ е блокиран, докато всичко задължително не е избрано. Клавиши: Enter потвърждава (включително от полето на масата), Esc затваря.",
      },
      {
        type: "security",
        text: "Маркиране → Гласова поръчка: цялата функционалност е зад ново право „Отваряне и допоръчване в маса с гласова команда“ (open_bill_voice). Без него иконата с микрофона не се показва, клавишът F1 не действа, а сървърът отказва заявката дори при директно извикване извън приложението.",
      },
    ],
  },
  {
    version: "0.0.137",
    date: "2026-07-29",
    entries: [
      {
        type: "fix",
        text: "Маркиране → Отчет: бутонът „Печат“ в прегледа на персоналния отчет и на отчета на заведението отново отпечатва само самия отчет като документ — на чист бял лист, без екрана отдолу, заглавната лента и бутоните на прозореца. Отпечатва се целият отчет, включително частта извън видимата област при превъртане, а браузърът не добавя дата и адрес върху разпечатката. Печатът към POS принтер не е променен.",
      },
      {
        type: "improvement",
        text: "Складова база → Доставка: единичната цена в работния лист „Нова доставка / Редакция“ вече винаги е с 2 знака след десетичния разделител. Закръглянето важи навсякъде — при обратното смятане (когато пишете в „Нето“ или „Бруто“ и цената се изчислява от тях), при автоматичната цена от последната доставка, при зареждане от „Излишък от продажби“, при редакция и темплейт „От минала доставка“. Ръчно въведена цена с повече знаци се закръгля при излизане от полето, а Нето/Бруто се преизчисляват.",
      },
    ],
  },
  {
    version: "0.0.136",
    date: "2026-07-28",
    entries: [
      {
        type: "feature",
        text: "Маркиране: нова настройка „Обща номерация на сервитьорите“ (Конфигурация → Маркиране). Когато е включена, всеки сервитьор има собствена номерация на масите — двама сервитьори могат едновременно да имат маса „1“, а проверката „масата вече е заета“ (при отваряне, преименуване и в прозореца „Нова маса“) гледа само собствените маси. Важи за всички потребители, включително тези с право да виждат чуждите маси — чуждата маса със същия номер се различава по името на сервитьора върху картата. Изключена по подразбиране — номерата остават уникални за целия ресторант, както досега.",
      },
      {
        type: "improvement",
        text: "Маркиране → Бързо закриване: предложеният номер за „Нова маса“ вече се смята от сървъра и се съобразява с настройката за номерация — при обща номерация се предлага най-малкият свободен номер сред собствените маси, а при изключена — свободен за целия ресторант. Така сервитьор, който няма право да вижда чуждите маси, вече не може да получи номер, зает от колега.",
      },
      {
        type: "feature",
        text: "Маркиране: плащането „По сметка“ вече е позволено само за клиенти с изрично право за това (нова настройка на клиента в организационната база). В прозорците „Закрий“ и „Раздели и плати“ методът остава видим, но е неактивен с подсказка — „(Изберете клиент)“ при липсващ клиент или „(Клиентът е без плащане по сметка)“ при клиент без правото; сървърът също отказва такова закриване. В списъка „Избор на клиент“ клиентите с правото се отличават с маркер „По сметка“ до името си.",
      },
    ],
  },
  {
    version: "0.0.135",
    date: "2026-07-28",
    entries: [
      {
        type: "improvement",
        text: "Вход с организационен код (код за потвърждение на достъп): вече може да се въвежда код с произволна дължина — по-малко или повече от 6 цифри — точно както при вход с код на сервитьорите. Кодът вече не се изпраща автоматично на шестата цифра, а с бутон „Вход“ (или Enter), а точките под кода растат с дължината му.",
      },
      {
        type: "improvement",
        text: "Складова база → Доставка: при напускане на нова или редактирана доставка с незапазени промени системата пита за потвърждение, за да не се губят данни по погрешка. Клавишът Esc в работния лист вече е стъпка назад към списъка с доставки (а не изход от целия модул) и също минава през това потвърждение.",
      },
      {
        type: "improvement",
        text: "Складова база → Доставка: списъкът с доставки е преработен в дизайна на работния лист „Нова доставка“ — плътна таблица с разделители между колоните, номерация на редовете и същите топли цветове и шрифтове, за да изглеждат двата екрана еднакво. Заглавието, изборът на период и бутонът „Нова доставка“ вече са на един ред (периодът в средата), а дублиращите се бутони от горната лента са премахнати — те са налични в страничното меню. Колоната „Продукти“ от таблицата е премахната.",
      },
      {
        type: "improvement",
        text: "Складова база: анулирането вече е в единен по-мек червен цвят навсякъде в модула — иконката и бутонът в потвърждаващия прозорец „Анулиране на записа?“ са в един и същи тон, както и бутоните „Анулирай“ в документите на Доставка, Изписване, Прехвърляне, Инвентаризация и Взаимозаменяеми продукти.",
      },
    ],
  },
  {
    version: "0.0.134",
    date: "2026-07-28",
    entries: [
      {
        type: "improvement",
        text: "Маркиране: търсачката на продукти вече се самозачиства около секунда след като добавите продукт, независимо как е добавен — с бутоните „+“/„−“ (с мишка/докосване), с клавиатурата „+“/„−“ или с „Добави“ от прозореца „Промени“. Досега мишката/докосването не зачистваше търсенето, а само клавиатурата.",
      },
      {
        type: "improvement",
        text: "Маркиране на телефон: след добавяне на продукт търсачката се зачиства и фокусът остава в нея, така че клавиатурата не се затваря и веднага може да се търси следващият продукт. Бутоните „+“/„−“ вече не открадват фокуса от полето за търсене.",
      },
    ],
  },
  {
    version: "0.0.133",
    date: "2026-07-28",
    entries: [
      {
        type: "improvement",
        text: "Складова база: количествата вече се показват според мерната единица на продукта. Единица „брой“ (без дробна част) излиза като „1 бр“, а не „1,000“; „килограм“/„литър“ остават с обичайните си знаци след запетаята. Прилага се навсякъде в модула — списъци, документи за печат, редактори (полетата за въвеждане също) и всички справки (Наличности, движения, недостиг, продадени, замени, анулирани). Броят знаци се задава от организацията за всяка мерна единица.",
      },
      {
        type: "improvement",
        text: "Складова база: навсякъде в модула „изтриване“ е преименувано на „анулиране“ — бутоните вече казват „Анулирай“, потвържденията са „Анулиране на записа?“, а справката „Изтрити дейности“ стана „Анулирани дейности“ (колони „Анулирано на/от“, „Анулирани записи“). Самото поведение е непроменено (записът се анулира, наличността се преизчислява и следата остава за възстановяване).",
      },
    ],
  },
  {
    version: "0.0.132",
    date: "2026-07-27",
    entries: [
      {
        type: "feature",
        text: "Складова база → Разнасяне на отчети: всеки продукт вече получава автоматично избран склад според станцията на рецептата (рецепта → първата ѝ станция → складът на тази станция за заведението). Ако станцията няма склад за заведението, колоната „Склад“ стои празна и се избира ръчно, а разнасянето се блокира с подсказка кои продукти чакат склад. Рецепта с няколко станции ползва първата; вложените рецепти — станцията на крайната (продадената) рецепта.",
      },
      {
        type: "feature",
        text: "Маркиране: нова настройка „Бързо закриване“ (Конфигурация → Маркиране). Когато е включена, „Нова маса“ не пита за номер, а взима автоматично най-малкия свободен номер сред отворените маси (ако 1 и 3 са заети, отваря 2), а веднага след „Поръчай“ се отваря модалът „Закрий“ за същата сметка. Изключена по подразбиране — иначе поведението е както досега.",
      },
      {
        type: "feature",
        text: "Устройства: за POS принтер вече може да се избере език на печат. Кухненските бележки (имена на продукти, модификатори, станции) излизат на избрания език — напр. кухня с украински персонал печата на украински. Езиците идват от организацията; празно = български, а настройката е само за POS принтери.",
      },
      {
        type: "improvement",
        text: "Конфигурация → „Маркиране“: страницата е преработена в компактен двуколонен изглед (по-малко празно място, по-плътни избори) и събира настройките на модула — „Изглед на продуктите“ и „Визуализиране на нефинализирани маси“ горе, „Бързо закриване“ и „Оптимизация с база“ отдолу.",
      },
      {
        type: "improvement",
        text: "Маркиране: „Опции“ на десктоп/таблет вече е решетка от плочки (иконка в кръгче + етикет), подредени ляво-подравнено; в средния диапазон широчини плочките и колоните са по-малки, за да се събира менюто без да се реже. На телефон „Опции“ остава както е.",
      },
      {
        type: "fix",
        text: "Маркиране: в „Закрий“ и „Раздели и плати“ методът „По сметка“ без избран клиент вече ясно изглежда неактивен (сив), вместо да прилича на избран.",
      },
      {
        type: "improvement",
        text: "Складова база: бутонът за изход в страничния панел показва просто „Изход“ — дългият надпис „Изход от ограничен достъп“ разместваше реда с иконите.",
      },
    ],
  },
  {
    version: "0.0.131",
    date: "2026-07-24",
    entries: [
      {
        type: "feature",
        text: "Маркиране: продукт със задължителен модификатор вече отваря модала „Промени“ още при маркиране — точно както продуктите със задължителни или препоръчителни добавки. Кой модификатор е задължителен се задава от организацията в Backoffice (нова настройка на модификатора); правилото важи и за модификатори, закачени през категорията на продукта, и се прилага еднакво при „+“ от картата/реда и при клавиатурния „+“.",
      },
      {
        type: "feature",
        text: "Отстъпки: клиентска отстъпка вече може да е и „надбавка“ — процент, който се ДОБАВЯ към цената вместо да я намалява (видът се задава от организацията в Backoffice). В „Избор на клиент“ отстъпките се показват с „−X%“, а надбавките с „+X%“; редът за премахване и съобщенията за успех също казват изрично „надбавка“ („Надбавката е приложена/премахната успешно“). Приложената надбавка увеличава цените на редовете и общата сума на сметката и се вижда със знак „+“ навсякъде — баджа на масата, историята на поръчките в „Маркиране“, разбивките при Сторно/Раздели и одит лога.",
      },
      {
        type: "improvement",
        text: "Справка „Отстъпки“ стана „Отстъпки и надбавки“: отделни KPI кутийки за „Отстъпки“ (−сума, оранжево) и „Надбавки“ (+сума, синьо) вместо едно нетно число, нова колона „Тип“ с чип Отстъпка/Надбавка и филтър по тип, знакови колони „Процент“ (−10.0% / +20.0%) и „Корекция“ (−1.00 € / +2.40 €), колона „Тип“ и в Excel експорта. „История на операциите“ показва събитие „Надбавка върху сметката“ и клетка „Надбавки +X €“ в обобщението (вместо „Отстъпки“ с плюс). Поправен и показът на вида „Кешбек“ (излизаше суров ключ cash_back).",
      },
      {
        type: "improvement",
        text: "Монитори: в изглед „Лист“ колоната „Станция“ е заменена с „Оператор“ — показва се името на служителя, маркирал поръчката (същото, което изгледът с колони показва в заглавието на поръчката). Станцията и без това се вижда от филтъра на монитора, а кой е пуснал поръчката липсваше в списъчния изглед.",
      },
      {
        type: "feature",
        text: "Устройства: стойността на всеки метод на плащане за фискалния принтер вече се избира само от падащо меню — конфигурираните слотове, прочетени от самия принтер, плюс новата опция „БЕЗ ФИСКАЛИЗИРАНЕ“. Ръчното въвеждане на стойност е премахнато. Метод със стойност „БЕЗ ФИСКАЛИЗИРАНЕ“ не издава фискален бон при закриване — бележката излиза на POS принтера на потребителя, ако има назначен, а без POS принтер не се печата нищо; такава сметка не подлежи и на повторна фискализация.",
      },
      {
        type: "improvement",
        text: "Маркиране: „По сметка“ вече е винаги видимо в модалите „Закрий“ и „Раздели и плати“ (стига да е конфигурирано за устройството). Без избран клиент редът е неактивен — леко избледнен, с подсказка „(Изберете клиент)“ до името — и се активира веднага щом се избере клиент от „Опции → Избор на клиент“.",
      },
      {
        type: "feature",
        text: "Маркиране: продуктовият каталог вече има два изгледа — „Лист“ (сегашните компактни редове) и „Грид“ (върнатият изглед с карти отпреди редизайна: име до два реда, бадж „×N“ с маркираното количество, цена и грамаж, бутони „−“ и „+“ директно на картата). В грид изгледа продуктите са подредени по азбучен ред в една обща решетка, без разделители по категории — категорията остава като филтър през лентата отгоре. Клавиатурата работи еднакво и в двата изгледа (стрелки, +/−, търсене с директно писане), а клик върху карта отваря „Промени“, както при ред. На телефон каталогът винаги остава списък.",
      },
      {
        type: "improvement",
        text: "Конфигурация: страницата „Визуализиране на нефинализирани маси“ се казва „Маркиране“ и събира настройките на модула — досегашният избор за нефинализираните маси (вече като секция със старото си име) и новата настройка „Изглед на продуктите в Маркиране“ (Лист / Грид). Изборът се пази за цялото заведение и не изисква ново право — страницата е достъпна както досега.",
      },
      {
        type: "improvement",
        text: "Маркиране: поръчка, направена днес, вече не носи етикет „Днес“ в историята на масата — показва се само часът (напр. „10:52“). „Вчера“ и пълните дати за по-стари дни остават непроменени.",
      },
      {
        type: "improvement",
        text: "Маркиране: продуктовите редове в каталога са по-тънки и с еднаква височина — колкото редовете в историята на масата. Броячът „− / +“ е по-компактен, така на екрана се виждат значително повече продукти без скролване.",
      },
      {
        type: "improvement",
        text: "Горната лента на всички екрани: „Цял екран“ вече е самостоятелна икона до профила (на мястото на предишната QR икона) — включва се и се изключва с един клик. QR кодът на заведението се премести в профилното меню, на реда под „Език“.",
      },
      {
        type: "feature",
        text: "Маркиране: продуктите вече показват „Единица и размер“ (напр. „300 гр“, „32 cm“, „330 ml“) — в каталога стойността стои в подравнена колонка вдясно, със същия размер като цената и отделена от нея с тънка вертикална линия с еднакво отстояние от двете страни; в Инфо прозореца на продукта стои до името. Показва се на езика на интерфейса — на български при БГ и на английски при EN, както е въведена за съответния език.",
      },
      {
        type: "improvement",
        text: "Маркиране: цените в продуктовия каталог и в Инфо прозореца вече са със знака „€“ (напр. „12.00 €“) вместо без валута или с текста „EUR“ — така сумата се отличава ясно от грамажа.",
      },
      {
        type: "feature",
        text: "Клавишът Esc вече води „назад“ в цялото приложение. На терминал с общ акаунт: от който и да е модул Esc връща към страницата „Модули“ (когато влезлият с код служител има повече от един модул), а от „Модули“ още едно Esc връща към екрана с ПИН кода — същото като „Изход“ от профилното меню. Служител с единствен модул (който не вижда „Модули“) излиза с Esc направо към ПИН екрана. На личен акаунт Esc само връща към „Модули“ — изход не се прави никога. Esc никога не прескача нива: първо затваря отворен прозорец или меню, чисти търсачката или връща от продуктите към масите, и чак когато няма какво повече да затвори — излиза едно ниво нагоре.",
      },
      {
        type: "feature",
        text: "Мониторите вече не могат да бъдат спрени случайно или самоволно: на монитор акаунт (личен акаунт само с модул „Монитори“) бутонът „Изход“ първо иска паролата на акаунта — същият прозорец като при пълния изход от ПИН екрана. При грешна парола мониторът си остава на екрана. Акаунт с повече модули (напр. администратор) излиза свободно, без парола.",
      },
    ],
  },
  {
    version: "0.0.130",
    date: "2026-07-23",
    entries: [
      {
        type: "feature",
        text: "Фактурите вече могат да се печатат и на POS принтера — както отчетите. Веднага след запис на фактура излиза въпрос „Печат на фактурата през POS принтер?“; при „Да“ тя излиза на ролката в два екземпляра — ОРИГИНАЛ за клиента и КОПИЕ за заведението, отрязани един от друг. Същият бутон „Печат (POS)“ стои и в прегледа на фактурата, включително от Справки → Фактури — оттам печатът излиза маркиран като ДУБЛИКАТ, за да не се появи втори оригинал. На хартията излизат всички реквизити: номер и дата, дата на данъчното събитие и място на сделката, пълните данни на доставчика (включително банкова сметка) и на получателя, артикулите, ДДС разбивката и общата сума — точно както са записани във фактурата. Анулирана фактура не се печата.",
      },
    ],
  },
  {
    version: "0.0.129",
    date: "2026-07-23",
    entries: [
      {
        type: "feature",
        text: "Складова база — Доставки: „Нова доставка“ и „Редакция“ вече са цяла страница (работен лист), а не модал. Таблицата показва само добавените продукти — намирате продукт през голяма търсачка отгоре (пишете откъдето и да е, напр. „дом“ показва всички домати с наличност, последна доставка и единична цена; при избран доставчик — неговите цени и последна доставка). Enter добавя продукта и фокусът отива направо в „Количество“, с Tab или стрелка минавате на „Ед. цена“, а Esc връща в търсачката за следващия продукт — цяла доставка се въвежда без мишка. Под таблицата залепен ред сумира количествата по мерни единици (общо килограми, литри, бройки), а черновата се пази автоматично докато пишете. Всички полета на страницата са с еднаква височина.",
      },
      {
        type: "improvement",
        text: "Складова база — Доставки: полето „От минала доставка“ показва прегледно съдържанието на всяка доставка — вляво компактен списък с датите и сумите, а вдясно таблица с продуктите, количествата и цените на посочената доставка. И при 20+ продукта всичко се чете, без нищо да се реже.",
      },
      {
        type: "fix",
        text: "Складова база — Доставки: ДДС вече се начислява само когато избраният доставчик има ДДС номер (ново поле на доставчика). Досега критерият беше ЕИК, което не е вярно — фирма с ЕИК може да не е регистрирана по ДДС. Без ДДС номер „Бруто“ остава равно на „Нето“.",
      },
      {
        type: "improvement",
        text: "Складова база: часовникът в страничната лента е премахнат, а „Изход“ вече е компактен бутон в оранжевата гама на реда с иконите (вместо червен текст на отделен ред).",
      },
    ],
  },
  {
    version: "0.0.128",
    date: "2026-07-22",
    entries: [
      {
        type: "feature",
        text: "Складова база — Доставки: незавършена доставка вече може да се запази като чернова. При затваряне на нова доставка с промени диалогът „Незапазени промени“ има три бутона — „Отказ“ (оставате в документа), „Запази и излез“ (записва докъдето сте стигнали) и „Напусни“ (излиза без запазване). При следващо отваряне на „Нова доставка“ системата пита „Незавършена доставка от {име}“ с подробности — кога е запазена, от кого, доставчикът, продуктите с количества и общата сума. „Продължи“ връща всичко откъдето сте спрели (включително цените, както са били), а „Започни наново“ изтрива черновата и започва на чисто. Черновата се изтрива автоматично и след успешно заприходяване.",
      },
      {
        type: "improvement",
        text: "Складова база — Доставки: падащото меню за избор на продукт вече показва повече от името. Под всеки продукт стоят наличността в избрания склад и последната доставка — кога е била, какво количество е доставено и на каква единична цена. При избран доставчик информацията е за неговата последна доставка (същата цена, която се попълва автоматично), а без доставчик — за последната изобщо. Менюто е разширено, за да се вижда цялата информация.",
      },
    ],
  },
  {
    version: "0.0.125",
    date: "2026-07-21",
    entries: [
      {
        type: "feature",
        text: "Конфигурация → Устройства — нова колона „FiscalAPI“ показва кой компютър печата на съответното устройство (име, машина, версия). Ако на едно устройство се появят две връзки, колоната светва в червено с предупреждение: това значи, че два компютъра са настроени с един и същи уникален номер и един бон ще излезе два пъти. Тире в колоната значи само, че на този компютър FiscalAPI още не е обновено — не че нищо не е закачено.",
      },
      {
        type: "improvement",
        text: "Складова база — Доставки: ДДС вече се начислява само когато има насрещна фактура — тоест фирмата е регистрирана по ДДС И е избран доставчик с попълнен ЕИК. При доставка без доставчик, с доставчик без ЕИК или при нерегистрирана фирма сумите „Нето“ и „Бруто“ са равни. Правилото важи на живо в редактора (редовете „Основа“ и „ДДС“ и ставките по продуктите се скриват, когато не се начислява ДДС) и се записва в документа при запазване и редакция.",
      },
      {
        type: "improvement",
        text: "Складова база — Доставки: при избран доставчик единичната цена на продукта се попълва с последната цена ОТ ТОЗИ доставчик, а не с последната доставка изобщо — трима доставчици на домати могат да са на три различни цени и чуждата цена не е ориентир. Ако избраният доставчик не е доставял продукта, полето остава празно за ръчно въвеждане. Смяната на доставчика презарежда цените и на вече добавените редове с неговите цени; без избран доставчик поведението е както досега — последната доставна цена изобщо. Редакцията на запазена доставка не променя записаните цени.",
      },
      {
        type: "feature",
        text: "Складова база — Доставки: нова доставка може да се попълни от минала доставка като шаблон. При избран доставчик под полето „Доставчик“ се появява падащо меню „От минала доставка“ с последните му доставки (дата, брой продукти, сума и номер на фактура). Изборът попълва редовете — продукти, разфасовки, количества и единичните цени ТОЧНО ОТ избраната доставка (не последните цени) — и остава само да се коригират количества и цени. Партида и срок на годност не се копират — новата доставка е нова партида и се въвеждат наново. Изборът може да се откаже с кръстчето на менюто (връща празен ред), а смяната на доставчика го отказва автоматично.",
      },
    ],
  },
  {
    version: "0.0.124",
    date: "2026-07-21",
    entries: [
      {
        type: "feature",
        text: "Изцяло нов дизайн на страницата с модулите: на десктоп вляво стои топъл информационен панел с поздрав, жив часовник с датата и версията на системата, а модулите вдясно са едри карти с икона, описание и стрелка за отваряне. Модулите в разработка носят видим етикет „Очаквайте скоро“ още преди да ги отворите. Подредбата се напасва по броя модули (3, 4, 5 или повече) — редовете се разпределят така, че страницата да изглежда завършена и без самотна карта на последния ред. На таблет панелът става лента над модулите, а на телефон картите са компактни редове, така че всичко се вижда почти без превъртане.",
      },
      {
        type: "improvement",
        text: "Страницата с модулите се мащабира според големината на екрана: на голям монитор картите, шрифтовете и панелът растат пропорционално с един общ коефициент (както екрана за вход с код), вместо да остават дребни с празно поле около тях. На лаптоп и по-малки екрани изгледът е непроменен.",
      },
      {
        type: "feature",
        text: "Избор на клиент с отстъпка — търсачката вече намира и по номер на клиентска карта, освен по име. Така при четец на карти или ръчно въведен номер клиентът излиза веднага.",
      },
      {
        type: "feature",
        text: "Избор на клиент с отстъпка — управление от клавиатурата: стрелка надолу маркира първия клиент и след това със стрелки нагоре/надолу се движите по списъка (маркираният ред се вижда автоматично). Enter прилага маркирания клиент, а ако още няма маркиран — прилага директно първия резултат. По подразбиране няма избран клиент.",
      },
      {
        type: "improvement",
        text: "Избор на клиент с отстъпка — когато вече има приложена отстъпка, първият ред („Премахни отстъпка“) вече показва името на конкретната отстъпка (напр. „Премахни отстъпка - Здравко (12.00)“) и нейния процент. Досега се виждаше само сумата и при няколко отстъпки с еднакъв процент не беше ясно коя точно е приложена.",
      },
      {
        type: "improvement",
        text: "Маркиране — при право „Вижда сметки на всички потребители“ картата на чужда маса вече показва името на сервитьора ѝ (дискретно, вдясно от името на масата), за да е ясно чия е масата. Собствените маси остават без етикет, а търсачката продължава да намира маси и по име на сервитьор — съвпадението се откроява и в етикета.",
      },
      {
        type: "improvement",
        text: "Екранът за вход с код — левият информационен панел вече е с еднаква ширина, фон и декорация (топъл тон, меки отблясъци и фина мрежа) като панела на страницата с модулите. Така при преминаване от въвеждане на код към модулите панелът остава визуално на мястото си, без да променя размер или цвят.",
      },
      {
        type: "improvement",
        text: "Екранът за вход с код — статус картата долу вляво (име на терминала и бутон „Изход“) вече е полупрозрачна и се слива с топлия фон на панела, а бутонът „Изход“ е с прозрачен фон и лек контур — досега открояващото се бяло изпъкваше прекалено.",
      },
      {
        type: "improvement",
        text: "Страницата с модулите — горната лента е с топлия кремав фон на страницата вместо плътно бяло, за да не контрастира със страничния панел и съдържанието.",
      },
    ],
  },
  {
    version: "0.0.123",
    date: "2026-07-20",
    entries: [
      {
        type: "feature",
        text: "Изцяло нов дизайн на екрана за вход с код (при акаунт за общ достъп): вляво — информационен панел с логото, жив часовник с датата, името на заведението и статус на терминала (име + „Онлайн“) с бутон „Изход“ и версията на системата; вдясно — карта „Въведете код“ с точки-индикатор (запълват се с всяка въведена цифра и растат при по-дълъг код), едра цифрова клавиатура с „Изчисти“ и изтриване, бутон „Вход“ и подсказка, че кодът може да се въвежда и от клавиатурата. Долу вдясно — „Powered by UnrealSoft“. На телефон панелът се свива до компактен хедър с името на терминала и „Изход“.",
      },
      {
        type: "improvement",
        text: "Екранът за вход с код се мащабира плавно според големината на екрана: всички елементи — от логото и часовника до клавишите и подсказката — растат и се свиват заедно, с един и същ коефициент, без прагове. Така изгледът е с еднакви пропорции на малък лаптоп и на голям монитор, при всяко ниво на мащаба (zoom) на браузъра.",
      },
      {
        type: "improvement",
        text: "Съобщенията при вход с код („Кодът е верифициран успешно“, „Невалиден код“) вече се превеждат според избрания език, а неизползвани стари текстове от предишния екран са премахнати.",
      },
      {
        type: "feature",
        text: "Нов бутон „Backoffice“ във всеки хедър и навбар на приложението (до QR иконката, в същия стил) — отваря административния портал на организацията (https://име.unrealsoft.cloud) в нов раздел. Вижда се само от акаунти с достъп до организацията и е скрит на телефон.",
      },
    ],
  },
  {
    version: "0.0.122",
    date: "2026-07-17",
    entries: [
      {
        type: "improvement",
        text: "История на маси — справката вече брои сметките по датата на ЗАКРИВАНЕ, а не на отваряне: маса, отворена вчера и затворена днес, се вижда в днешния ден. Отворена маса се вижда винаги, докато е отворена (към текущия момент), и минава към деня на закриването си, когато бъде закрита. Графиката за активност следва същата логика.",
      },
      {
        type: "improvement",
        text: "Дашборд — „Топ 5 продадени артикула“ и „Оборот по обекти“ вече се смятат по сметките, ЗАКРИТИ днес (както всички останали показатели), а не по момента на маркиране. Така сметка, отворена вчера и затворена днес, се брои изцяло за днес и разбивката по обекти съвпада с оборота от „Затворени за днес“.",
      },
      {
        type: "fix",
        text: "Отворените маси вече се виждат ВИНАГИ — в Дашборда, История на маси, Сторно и Разделени сметки — независимо от потвърдения достъп при архивиран ресторант. Ограничението без потвърден достъп важи само за закритите сметки: от тях се показват единствено фискализираните (с издаден бон), както досега. Преди отворените маси изчезваха, защото още нямат фискален бон и филтърът погрешно ги третираше като нефискализирани.",
      },
      {
        type: "fix",
        text: "Устройства — падащото меню „Работни точки и потребители“ отново показва работните точки: списъкът вече включва всички акаунти (без мониторите), подредени в две озаглавени групи — първо „Работни точки“, после „Потребители“. Досега се виждаха само потребителите с роля „Маркиране“, а работните точки (които вече нямат роли) липсваха.",
      },
      {
        type: "improvement",
        text: "Устройства — един акаунт (работна точка или потребител) може да бъде закачен само към ЕДНО устройство от даден тип: заетите от друг POS принтер акаунти са неизбираеми при POS, същото важи и за фискалните. Проверката е и на сървъра.",
      },
      {
        type: "feature",
        text: "Устройства — нова секция „Статус“ (Активно/Неактивно) в редакцията на POS и фискален принтер: изключването пита за потвърждение и премахва наведнъж всички работни точки и потребители от устройството (станциите на POS принтера се запазват). Вече е позволено и ръчно да се премахнат всички избрани — „Запази промените“ не блокира.",
      },
      {
        type: "feature",
        text: "Устройства — адресът на организацията (напр. https://ime.unrealsoft.cloud) се показва до търсачката в списъка с устройства; клик върху него го копира в клипборда.",
      },
    ],
  },
  {
    version: "0.0.121",
    date: "2026-07-16",
    entries: [
      {
        type: "feature",
        text: "Наличности — клик върху продукт вече показва пълната хронология на движенията му в склада: доставки, изписвания, бракувания, инвентаризации, прехвърляния (вход и изход), замени и разнасяния на отчети, всяко със знаково количество (+ в зелено / − в червено), партида/срок, ед. цена и стойност Нето/Бруто. Редът „Общо“ показва текущата наличност и стойността ѝ. Досега прозорецът показваше само наличните партиди (само прихода).",
      },
      {
        type: "improvement",
        text: "Разнасяне на отчети — бутонът „Изпиши и затвори деня“ е преименуван на „Разнасяне на отчет“, а потвърждението („Разнеси отчета“) вече е винаги в оранжевия стил на темата — и при недостиг (преди беше червено, а това е основното действие, не деструктивно).",
      },
      {
        type: "feature",
        text: "Складова база — изтриването на доставка, изписване/бракуване, инвентаризация, прехвърляне и разнасяне вече оставя следа: количествата се връщат както досега, но записът се пази и се вижда в нова справка „Изтрити дейности“ — кога и от кого е изтрит, какъв вид е бил документът, с кои продукти и на каква стойност.",
      },
      {
        type: "feature",
        text: "Изтрити дейности — клик върху ред отваря целия изтрит документ: при инвентаризация се виждат Търсено/Намерено и разликата по продукти (излишък в зелено, липса в червено), а при прехвърляне — от кой към кой склад е било. Бутонът „Възстанови“ връща записа в нормалните списъци и прилага количествата му наново (с потвърждение).",
      },
      {
        type: "feature",
        text: "Продадени продукти и Продадени рецепти — клик върху ред отваря разбивка по дни за избрания период: за всеки ден се вижда колко бройки са продадени (при рецептите — и стойността), включително дните без продажби, с общ сбор най-отдолу.",
      },
      {
        type: "feature",
        text: "Складова база — нова колона „Потребител“ в Доставка, Изписване, Инвентаризация, Прехвърляне и Взаимозаменени продукти: вижда се кой е извършил всяка операция (вкл. кой е направил замяната), със сортиране и филтър.",
      },
      {
        type: "improvement",
        text: "Складова база — колоната „Дата“ в списъците вече показва и час (напр. 15.07.2026 14:28). Новите записи пазят реалния час на въвеждане дори при избрана задна дата.",
      },
      {
        type: "improvement",
        text: "Складова база — подредбата на колоните в петте списъка е уеднаквена: текстът вляво, всички числа вдясно, без разнобойни ширини; иконите за сортиране и филтър вече не се режат, а на тесен екран таблиците скролват хоризонтално вместо да смачкват колоните.",
      },
      {
        type: "improvement",
        text: "Складова база — модулът се показва само на организации, които работят със склад: ако складовият режим е изключен, ролята „Склад“ не се дава на никого (независимо от правата на акаунта) и плочката/страниците на модула са скрити. При включване на режима достъпът се връща автоматично.",
      },
      {
        type: "improvement",
        text: "Складова база — всички цени и суми в модула вече се изписват с десетична точка (напр. 12.50 вместо 12,50): в списъците, обобщените показатели, прозорците и печатните документи. Количествата остават със запетая и 3 знака, както досега.",
      },
      {
        type: "improvement",
        text: "Доставка и Инвентаризация — полетата Ед. цена, Нето и Бруто приемат и запетая, и точка при писане (запетаята се превръща в точка автоматично) и са с 2 знака след десетичния знак. Коефициентът при взаимозаменяемите продукти също приема запетая и точка и се показва с точка.",
      },
      {
        type: "feature",
        text: "Складова база — нова колона „Коментар“ в списъците Доставка, Изписване/Бракуване и Прехвърляне: вижда се бележката към записа, със сортиране и филтър с търсачка, за да се намират записи по коментара.",
      },
      {
        type: "feature",
        text: "Нова доставка — при фирма, регистрирана по ДДС, кутията „Общо“ показва и „Основа“ и „ДДС“ под общата сума, а до избрания продукт на всеки ред стои неговата ДДС ставка (напр. 20%, 9%). При нерегистрирана фирма нищо от това не се показва.",
      },
      {
        type: "improvement",
        text: "Доставка — подравняването на колоните в таблицата е уеднаквено: текстовите колони са вляво, а числовите (Продукти, Нето, Бруто) — вдясно, заедно с иконките за сортиране и филтър.",
      },
    ],
  },
  {
    version: "0.0.120",
    date: "2026-07-14",
    entries: [
      {
        type: "improvement",
        text: "Справки — всяка справка вече е отделна страница със собствен адрес (напр. /reports/bills-history, /reports/discounts), както е в Складова база. Адресът може да се запази като отметка или да се сподели, презареждането на страницата остава на същата справка, а заглавието на таба в браузъра показва името на отворената справка. При липсващо право за конкретна справка автоматично се отваря първата разрешена, а старият адрес /reports води към Таблото.",
      },
      {
        type: "improvement",
        text: "Справки — избраният период (дата или диапазон) се пази в адреса (?date=) и остава при превключване между справките: избираш период в „История на сметки“, отваряш „Отстъпки“ — периодът е същият. Пази се и при презареждане. Ако период не е избран, всяка справка тръгва от днешния ден, както досега; справките с избор на час пазят часа в рамките на страницата.",
      },
      {
        type: "feature",
        text: "Дашборд — нови показатели за деня: „Среден бон“ със сравнение спрямо същия ден от миналата седмица (изписано е спрямо кой ден и дата, до същия час), „Средно време на маса“, „Сторнирания днес“ и „Отстъпки днес“ (с брой сметки и пояснение какво включва сумата — отстъпки на цяла сметка и на отделни артикули), както и „Топ 5 днес“ — най-продаваните по оборот.",
      },
      {
        type: "feature",
        text: "Дашборд — нова карта „Натовареност“: закритите сметки по час за последните 8 дни (от вторник до вторник), като всеки ред е конкретен ден с дата и днешният е най-отгоре. Посочването на клетка показва деня, часа, броя сметки и оборота.",
      },
      {
        type: "feature",
        text: "Дашборд — нова карта „Оборот по обекти“: разпределение на дневния оборот по обекти/станции с кръгова диаграма и списък с процент и сума за всеки обект. Общото съвпада точно с оборота за деня (включени са и добавките към продуктите).",
      },
      {
        type: "improvement",
        text: "Методи на плащане навсякъде: Дашборд („Затворени днес“), Справка по сервитьори, Справка по обекти, Персонални отчети и Отчети на заведението показват разпределение с отделна кутийка за всеки активен метод на плащане — същите методи, които се виждат в Маркиране при закриване (неактивен метод с пари в периода също се показва, за да не изчезват суми). Кутийките се подреждат в балансирани редове без празни места (напр. 4 метода → един ред, 5 → 2+3). В справките по сервитьори и обекти клик върху ред показва същите методи и в разбивката по дни, а сумите в „Отчети на заведението“ се сверяват коректно и за стари отчети.",
      },
      {
        type: "fix",
        text: "Справка по обекти — плащания с персонализирани методи (напр. „По банка“) влизаха само в колоната „Общо“ и не се виждаха в разпределението. Вече всеки метод се показва със собствената си сума.",
      },
      {
        type: "improvement",
        text: "Справки — всички суми в целия модул вече се показват с валутата евро (напр. „151.50 €“): обобщените показатели, таблиците, разпределенията по методи на плащане и детайлните прозорци. Знакът стои ненатрапчиво след числото и не се пренася на отделен ред. Проценти и бройки остават без знак, а Excel експортите — чисти числа, за да се смятат в Excel.",
      },
      {
        type: "improvement",
        text: "Фискални проблеми — премахнато е автоматичното сортиране на колоната „Затворена“ (сортира се само при клик), а бутонът „Опитай пак“ вече стои на един ред и не се пречупва.",
      },
    ],
  },
  {
    version: "0.0.119",
    date: "2026-07-13",
    entries: [
      {
        type: "feature",
        text: "Справки — нова страница „Фискални проблеми“: показва затворените сметки, при които касовата бележка не е потвърдена от фискалния принтер (отказани от принтера или с неизвестен изход), с филтър за последните 24 часа / 7 дни / 30 дни, грешката от принтера и бутон „Опитай пак“ за ръчно повторно издаване на бона.",
      },
      {
        type: "improvement",
        text: "Фискализация — повторният печат вече е безопасен: сървърът пази всяка фискализация в опашка и при повторен опит не дублира бон, който вече е излязъл. Ако принтерът не отговори навреме, резултатът се отчита като „неизвестен“ (а не като отказан), за да не се издаде втори бон погрешка. Връзката с принтерите е по-устойчива при кратки прекъсвания.",
      },
    ],
  },
  {
    version: "0.0.118",
    date: "2026-07-10",
    entries: [
      {
        type: "feature",
        text: "Профил — нова иконка за QR код в горния десен ъгъл, до името на потребителя, на всички екрани и модули. Натискането ѝ отваря прозорец с QR код, който при сканиране отваря адреса на ресторанта (началната страница, без конкретния модул) — удобно за бързо отваряне на системата от телефон или друго устройство. Под кода се показва и самият адрес.",
      },
    ],
  },
  {
    version: "0.0.117",
    date: "2026-07-09",
    entries: [
      {
        type: "fix",
        text: "Маркиране (iPhone) — долните ленти („Преглед на поръчката“, бутоните под масите и отвореният прозорец с поръчката) лягаха точно под системната линия за прибиране на iPhone и тя се падаше върху бутоните. Съдържанието им вече се вдига умерено над линията (лентите остават оцветени до ръба на екрана), а списъците отдолу получават съответния допълнителен отстъп.",
      },
      {
        type: "fix",
        text: "Маркиране → Продукти (телефон) — лентата „Преглед на поръчката“ при празна поръчка беше полупрозрачна и скролнатите продукти прозираха под нея. Лентата вече е плътна — бледият ѝ вид се запазва, но отдолу не се вижда нищо.",
      },
      {
        type: "improvement",
        text: "Маркиране → Маси — баджът с отстъпката (-X%) в картата на масата вече започва отляво, подравнен с началото на името на масата (досега при маса с клиент стоеше след името на клиента).",
      },
      {
        type: "fix",
        text: "Маркиране → Раздели сметка / Сторно (телефон) — бутоните − и + на редовете понякога оставаха оцветени (с фона на курсора) след натискане. Вече са винаги бели — оцветяване при посочване има само на компютър с мишка.",
      },
      {
        type: "improvement",
        text: "Маркиране → Продукти — категориите (лентата с категории и падащият селектор) и продуктите/рецептите в списъка вече се подреждат по зададения сорт индекс от администрацията; тези без сорт индекс отиват най-отзад.",
      },
      {
        type: "fix",
        text: "Маркиране → прозорецът „Промени“ — ако въведете количество и затворите прозореца без „Добави“, при повторно отваряне количеството оставаше. Вече прозорецът се отваря винаги чист: количество 1, без добавки, модификатори и коментар.",
      },
      {
        type: "improvement",
        text: "Маркиране → търсачката на продукти — търсене с няколко думи: всяка дума (разделена с интервал) се търси навсякъде в името и продуктът се показва само ако съдържа всичките. Напр. „гр са“ намира „Гръцка салата“ и „Градинска салата“. Съвпаденията на всяка дума се оцветяват в резултатите.",
      },
      {
        type: "improvement",
        text: "Маркиране → Маси — името на сервитьора е премахнато от картите на масите: цялата широчина остава за името на масата, което стои на един ред и при нужда се съкращава с „…“, без да излиза от картата. Търсенето по име на сервитьор продължава да работи.",
      },
      {
        type: "improvement",
        text: "Маркиране → Продукти (телефон) — екранът е преработен да пести място: редът „Назад / Добави · {маса}“ най-отгоре е премахнат. Името на масата вече е стилна карта вдясно от селектора на категориите (на един ред, с етикет МАСА и оранжева лента), а „Назад“ е стрелката в най-горната лента, която в този екран се показва винаги. Селекторът на категориите, картата с масата и търсачката са с еднаква височина.",
      },
      {
        type: "improvement",
        text: "Маркиране → Продукти (телефон) — при влизане в екрана търсачката се фокусира автоматично и клавиатурата е готова — пишете веднага, без да докосвате полето. Шрифтът на полето е уголемен до 16px, за да не приближава iPhone екрана при фокус.",
      },
      {
        type: "fix",
        text: "Маркиране — прозорци с 3 бутона долу (напр. „Раздели сметка“) на телефон: бутоните не се събираха на един ред и текстът им се режеше. Вече действията („Раздели“ и „Раздели и плати“) са един до друг, а „Откажи“ е сам на цял ред под тях. Важи за всички прозорци в модула с 3 и повече бутона.",
      },
      {
        type: "improvement",
        text: "Маркиране → Маси (телефон) — търсачката в списъка с маси е без текст-подсказка (остава само иконата лупа), за да не се засича текстът в тясното поле.",
      },
      {
        type: "improvement",
        text: "Вход (телефон) — логото и текстът над формата вече са подредени: логото е центрирано отгоре, а под него на един ред стоят „UnrealSoft“ и името на заведението (всяко със собствения си стил). Досега логото и текстът бяха един до друг и изглеждаха изместени встрани, а името на заведението стоеше на отделен ред. На компютър екранът за вход е без промяна.",
      },
      {
        type: "fix",
        text: "Език — приложението вече се отваря ВИНАГИ на български, на всяко устройство (телефон, таблет, компютър). Досега при първо влизане езикът се взимаше от настройките на устройството/браузъра — телефон на английски отваряше приложението на английски. Езикът на устройството вече изобщо не се гледа: български по подразбиране, а английски — само ако изрично е избран от превключвателя (на екрана за вход или в менюто на профила). Изричният избор се запомня на устройството и се зарежда при следващо влизане.",
      },
    ],
  },
  {
    version: "0.0.116",
    date: "2026-07-08",
    entries: [
      {
        type: "feature",
        text: "Маркиране → Маси — бърза повторна поръчка: двоен клик върху ред от поръчката на масата отваря прозореца „Промени“ за същия продукт. Избирате количество, добавки, модификатори и коментар, а бутонът „Поръчай · {сума}“ изпраща поръчката ДИРЕКТНО към масата — без да минавате през екрана за добавяне на продукти. Прозорецът се отваря чист (количество 1, без пренесени добавки от реда).",
      },
      {
        type: "improvement",
        text: "Маркиране → Продукти — клик върху продукт (рецепта или асортимент) вече отваря директно прозореца „Промени“ и на компютър (досега само на телефон; на компютър кликът само селектираше). Бутонът за потвърждение в прозореца се казва „Добави · {сума}“ вместо „Готово · {сума}“ — по-ясно е, че добавя продукта към поръчката. Клавиатурата (стрелки, цифри, +/−, F9) работи както досега.",
      },
      {
        type: "improvement",
        text: "Маркиране — стрелката „Назад“ в горната лента вече връща стъпка по стъпка: от екрана с продуктите първо връща към масите (както бутона „Назад“ долу), и чак от масите — към модулите. При маркирани продукти пита за отказ от поръчката, както досега.",
      },
      {
        type: "improvement",
        text: "Маркиране → Маси — коментарът към поръчка (до часа на поръчката) вече е ЧЕРВЕН — да се набива на очи, както коментара към продукт.",
      },
      {
        type: "improvement",
        text: "Маркиране → Маси — цветната лента за статус на ред се оцветява САМО при сготвено (кехлибарено) или сервирано (зелено); незапочнатите редове са без цвят и не се отличават (досега бяха сиви).",
      },
      {
        type: "improvement",
        text: "Маркиране — козметика: полето за търсене в „Прехвърляне на сметка на друг сервитьор“ е с еднаква височина с редовете под него, а знаците − и + в броячите (продуктовия списък и прозореца „Промени“) са центрирани хоризонтално и вертикално — вече са същите икони като в останалите броячи.",
      },
      {
        type: "feature",
        text: "Профил — изборът на език и „Цял екран“ са преместени вътре в менюто на профил иконката, на ВСИЧКИ екрани и модули, и на телефон, и на компютър. Отделните бутони за език и цял екран в горните ленти са премахнати (само екранът за вход пази избора на език). Менюто съдържа: име на потребителя, „Език“, „Цял екран“/„Изход от цял екран“ и „Изход“.",
      },
      {
        type: "improvement",
        text: "Маркиране → Раздели сметка — редът „Налично: X“ под името на продукта е премахнат; наличното количество вече се вижда директно в брояча между − и + като „избрано/налично“ (напр. 0/4, при избор 1/4) — редовете са по-компактни и подравнени.",
      },
      {
        type: "feature",
        text: "Маркиране → Сторно — изцяло нов поток: вече НЕ е нужно да избирате продукт предварително. „Опции → Сторно“ отваря прозорец с всички поръчани продукти (както „Раздели сметка“) с брояч „избрано/налично“ на всеки ред — избирате кои продукти и по колко и сторнирате един или няколко наведнъж. Коментарът (причината) и отметката „Брак“ са общи за избраните; „Избрани продукти“ брои количествата (4 коли = 4), а сумата за сторниране се вижда на живо.",
      },
      {
        type: "improvement",
        text: "Маркиране → Сторно — ако при сторниране се сторнират ВСИЧКИ продукти и в сметката не остане нищо (0.00), тя се ЗАКРИВА автоматично и изчезва от списъка с маси — без плащане и без касов бон (няма какво да се фискализира). Частично сторно оставя сметката отворена. Партиди, в които всичко е сторнирано, не оставят празен ред с дата в детайла.",
      },
      {
        type: "improvement",
        text: "Маркиране → Маси — закритите нефискализирани сметки (закрити без касов бон) се отличават по-ясно от отворените: картата им е с приглушен фон и сиви име и сума.",
      },
      {
        type: "improvement",
        text: "Профил → Език — езикът не се изрежда в самото меню: редът „Език“ показва текущия избор и отваря малък прозорец „Изберете език“ със списъка (активният е отбелязан). Така менюто остава компактно и при повече езици.",
      },
      {
        type: "improvement",
        text: "Общ терминал с влязъл служител — директният бутон „Изход“ до името е заменен с профил икона с меню (както при личен акаунт): името на служителя стои до иконата, а „Изход“ (връщане към ПИН екрана), езикът и цял екран са в менюто.",
      },
      {
        type: "improvement",
        text: "Горна лента (телефон) — името до профил иконката вече се вижда и на телефон (дългите имена се съкращават с „…“), а текстът „UnrealSoft“ се крие — остава само логото. Важи за Маркиране, ПИН екрана, Отстъпки, Доставки и Резервации.",
      },
      {
        type: "feature",
        text: "Маркиране — изцяло нов дизайн на модула (без функционални промени). Отделният екран „Преглед на поръчката“ отпада: на десктоп прегледът е постоянен панел вдясно от продуктите с „Общо“ и бутон „Поръчай · {сума}“ (подава директно, Enter също), а на телефон — лента най-долу с брой продукти и сума, която отваря плъзгащ се прозорец със същото съдържание.",
      },
      {
        type: "improvement",
        text: "Маркиране → Продукти — категориите са хоризонтални бутони над списъка, ниво по ниво: къщичката връща към всички, стрелката назад — една стъпка нагоре, а при влизане в категория с подкатегории се виждат само те. Продуктите са списък от редове (име · цена · − брой +) с маркиране на избраните, групирани по категория при търсене.",
      },
      {
        type: "improvement",
        text: "Маркиране → Маси — детайлът на сметката е преработен: статусът на всеки ред се показва само чрез цветната лента вляво (кликът върху нея при „сготвено“ сервира); сметката е подредена „количество × ед. цена · задраскана сума · -% · крайна цена“ (количеството се показва само при повече от 1); коментарът към продукт е на самостоятелен червен ред, модификаторите — на свой ред, а коментарът към поръчка стои до часа на конкретната поръчка. Картите на масите са по-компактни, а всички второстепенни действия са събрани в бутон „Опции“.",
      },
      {
        type: "improvement",
        text: "Маркиране — прозорецът „Промени“ е с нов изглед: голям брояч за количество, ясно групирани добавки (изберете / препоръчани / по избор) и модификатори като редове с отметки, и бутон „Добави · {сума}“. Цялата логика (задължителни добавки, броячи, лимити) е непроменена.",
      },
      {
        type: "fix",
        text: "Маркиране — „Общо“ и бутонът „Поръчай“ вече включват и добавките без променена цена за групата (гледа се основната цена на асортимента, както при маркирането). Досега такива добавки не се брояха в показаната обща сума, макар да се маркираха коректно в сметката.",
      },
      {
        type: "improvement",
        text: "Маркиране → Маси — лентата с името на масата и общата сума над списъка с поръчки е премахната (дублираше избраната карта вляво). Остава само на телефон при скрит списък с маси, защото там носи бутона за връщането му и името/сумата на сметката.",
      },
      {
        type: "improvement",
        text: "Маркиране — модификаторите на продукт са в червено като коментара, и в детайла на масата, и в „Преглед на поръчката“.",
      },
      {
        type: "improvement",
        text: "Маркиране — коментарите и модификаторите вече не се отрязват с „…“: когато един ред не стига, текстът се пренася на следващ. Важи за детайла на масата (вкл. коментара към поръчка до часа) и за „Преглед на поръчката“.",
      },
      {
        type: "improvement",
        text: "Маркиране → Продукти (телефон) — долната лента с бутони Назад/Инфо/Промени е премахната: назад е стрелката в горния ляв ъгъл, „Промени“ се отваря директно с докосване на продукт, а „Инфо“ е бутон в заглавието на прозореца „Промени“. Отдолу остава само лентата „Преглед на поръчката“. На компютър лентата с трите бутона си остава без промяна.",
      },
      {
        type: "improvement",
        text: "Маркиране — всички прозорци в модула (нова маса, преименуване, закриване, отстъпки, сторно, разделяне на сметка, прехвърляне, клиенти, отчети, фактуриране и др.) са преоблечени в стила на прозореца „Промени“: заоблени ъгли, топла цветова гама, заглавие с икона, еднакви бутони отдолу. Само визия — без промяна в поведението.",
      },
    ],
  },
  {
    version: "0.0.115",
    date: "2026-07-07",
    entries: [
      {
        type: "improvement",
        text: "Складова база → Конфигурации — настройката „Единична цена при доставка“ (С/Без ДДС) е заменена с „Регистрация по ДДС“: посочва се дали фирмата (ресторантът) е регистрирана по ДДС („Да, регистрирана“ / „Не“, по подразбиране „Да“). Настройката определя как се изчисляват сумите бруто и нето в складовия модул; записаният избор от старата настройка се пренася автоматично.",
      },
      {
        type: "improvement",
        text: "Складова база → Доставка — въведената ЕД. ЦЕНА вече е ВИНАГИ нето (без ДДС). „Сума без ДДС“ = количество × ед. цена; „Сума“ (бруто) = нето + ДДС-ставката на продукта при регистрирана по ДДС фирма, а при НЕрегистрирана бруто = нето. Важи за нова доставка и редакция; вече записаните доставки не се променят.",
      },
      {
        type: "feature",
        text: "Складова база → Доставка — в полетата „Сума без ДДС“ и „Сума“ вече може да се пише, както в ЕД. ЦЕНА: попълването на което и да е от трите полета изчислява автоматично другите две според количеството и настройката „Регистрация по ДДС“ (напр. писане в „Сума“ при регистрирана фирма първо сваля ДДС-то, после определя ед. цената). Полетата са активни след избор на продукт и количество.",
      },
      {
        type: "improvement",
        text: "Складова база → Доставка — колоните „Сума без ДДС“ и „Сума“ са преименувани на „Нето“ и „Бруто“ навсякъде на страницата: в таблицата с доставки, в прозореца за нова доставка/редакция и в документа на доставката (след запазване или при клик върху ред).",
      },
      {
        type: "feature",
        text: "Складова база — страниците „Изписване“ и „Бракуване“ са ОБЕДИНЕНИ в една страница „Изписване“: списъкът показва и двата вида с нова колона „Тип“ (Изписване / Бракуване) със сортиране и филтър, а в прозореца за ново изписване/редакция се избира типът на операцията. Старите бракувания се виждат в общия списък като „Бракуване“.",
      },
      {
        type: "improvement",
        text: "Складова база → Изписване — причината зависи от типа: при „Изписване“ е свободен текст по избор (както досега), а при „Бракуване“ е ЗАДЪЛЖИТЕЛНО поле с предефинирани причини (изтекъл срок / развалена стока / счупен-разсипан / несъответствие) — без опция „Друг“ и без свободен текст; без избрана причина записът се отказва.",
      },
      {
        type: "improvement",
        text: "Складова база → Изписване — колоните „Сума без ДДС“ и „Сума“ са преименувани на „Нето“ и „Бруто“ навсякъде на страницата (таблицата, прозорецът за ново изписване/редакция и документът), а изчисленията следват настройката „Регистрация по ДДС“: себестойността е винаги нето, „Бруто“ = нето + ДДС-ставката на продукта при регистрирана фирма, а при НЕрегистрирана бруто = нето. Вече записаните изписвания не се променят.",
      },
      {
        type: "improvement",
        text: "Складова база → Недостиг — колоната „Недостиг“ (стойност) е заменена с две колони „Нето“ и „Бруто“ (последни в таблицата, в червено, сортируеми), изчислени по настройката „Регистрация по ДДС“ — при НЕрегистрирана фирма са равни. В разбивката при клик на ред колоните „Сума без ДДС“/„Сума“ също станаха „Нето“/„Бруто“, а ЕД. ЦЕНА и „Последна доставна цена“ са винаги нето.",
      },
      {
        type: "improvement",
        text: "Складова база → Инвентаризация — колоните „Системно“ и „Преброено“ са преименувани на „Търсено“ и „Намерено“, разликата е оцветена (+ зелено / − червено, и в документа), а ЕД. ЦЕНА е винаги нето и се отнася само за разликата (цената на новата партида при излишък / FIFO себестойността на липсата).",
      },
      {
        type: "feature",
        text: "Складова база → Инвентаризация — колоните „Сума без ДДС“/„Сума“ станаха „Нето“ и „Бруто“ и показват СТОЙНОСТТА НА РАЗЛИКАТА (само излишъка или липсата), по настройката „Регистрация по ДДС“. При излишък в тях може да се пише (както при доставка) — стойността определя ед. цената на излишните бройки (напр. 2 бр. излишък и 14 в „Нето“ → цена 7). Същите колони са и в документа след запис, с „Нетна стойност“ = нетираните разлики; в таблицата на инвентаризациите до „Нетна стойност“ има нова „Брутна стойност“.",
      },
      {
        type: "improvement",
        text: "Складова база → Взаимозаменяеми продукти — клик върху ред отваря прозореца за редакция (иконките от реда са премахнати), изтриването е в самия прозорец (долу вляво, както при другите документи), а съотношението в таблицата се показва ясно, нормализирано към първия продукт (напр. „1 Кола = 2 Кафе“ вместо „×0,5“).",
      },
      {
        type: "improvement",
        text: "Складова база — страницата „Недостиг“ е преименувана на „Излишък от продажби“ (в менюто, заглавието и таба на браузъра).",
      },
      {
        type: "improvement",
        text: "Складова база → Прехвърляне — колоните „Сума без ДДС“/„Сума“ станаха „Нето“/„Бруто“ навсякъде (таблицата — на мястото на „Стойност“, прозорецът за ново прехвърляне и документът), изчислени по настройката „Регистрация по ДДС“ (при НЕрегистрирана фирма са равни); ЕД. ЦЕНА е винаги нето (FIFO себестойността от склада-източник). В прозореца има и ред „Общо“ с двете суми.",
      },
      {
        type: "improvement",
        text: "Складова база → Наличности — количеството никога не се показва отрицателно: продукт на минус (от разнесен отчет) излиза като 0, както „Търсено“ при инвентаризация; недостигът се вижда в „Излишък от продажби“.",
      },
      {
        type: "improvement",
        text: "Складова база → Излишък от продажби — натрупаният недостиг се нулира САМО от доставка със задна дата (преди отчета-причинител). Инвентаризацията изравнява наличността занапред, но вече НЕ изчиства историческия недостиг от разнесени отчети.",
      },
      {
        type: "improvement",
        text: "Складова база → Разнасяне на отчети — бутонът „Компенсирай“ и баджът към него броят само липсите, които реално могат да се покрият (продуктът има взаимозаменяема група с наличен донор в склада). Продукт на минус без взаимозаменяема конфигурация вече не подвежда, че може да се компенсира; ако няма нито една покриваема липса, бутонът е неактивен.",
      },
      {
        type: "improvement",
        text: "Складова база → Разнасяне на отчети — колоната „Себест.“ е заменена с „Нето“ и „Бруто“ (по настройката „Регистрация по ДДС“; при НЕрегистрирана фирма са равни), включително при разпределение по няколко склада, а долната лента показва двете общи суми. Разнасянията вече записват и снимките Нето/Бруто на редовете си (както останалите складови операции).",
      },
      {
        type: "fix",
        text: "Складова база — заглавията на страниците (напр. „Взаимозаменяеми продукти“) вече не се подрязват отдолу: опашките на буквите у/д/р се режеха съвсем леко на всички страници от модула. В документа на инвентаризацията колоната „Нето“ е с плътен шрифт като „Бруто“.",
      },
      {
        type: "improvement",
        text: "Складова база → Справки — навсякъде колоните „Сума без ДДС“/„Сума“ станаха „Нето“/„Бруто“ по настройката „Регистрация по ДДС“ (Наличности, Взаимозаменяеми продукти, Продадени продукти и Продадени рецепти); ЕД. ЦЕНА и последната доставна цена са винаги нето, а „Ср. цена“ (в Наличности и Продадени продукти) вече се показва в БРУТО — при НЕрегистрирана фирма бруто = нето. С това целият складов модул е на новата сметка нето/бруто.",
      },
      {
        type: "improvement",
        text: "Складова база → Наличности — прозорецът „Наличност по партиди“ (при клик на ред) е преработен: нови колони „Дата“ и „Източник“ (откъде идва партидата — доставка / инвентаризация / прехвърляне / замяна) най-отпред, партидата и срокът са компактно на един ред с разделител, прозорецът е по-широк, а „Сума без ДДС“/„Сума“ станаха „Нето“/„Бруто“ по настройката „Регистрация по ДДС“ (ед. цената е винаги нето; при НЕрегистрирана фирма нето = бруто).",
      },
      {
        type: "improvement",
        text: "Складова база → Прехвърляне — количеството приема и точка, и запетая и се показва с 3 знака (0,200), както при доставка; количествата в документа след прехвърляне също са с 3 знака. Прозорецът е разширен, а при по-тесен екран таблицата показва видим хоризонтален скрол (преди колоните вдясно се отрязваха и „Бруто“ не се виждаше). Полето „Бележка“ по редовете е премахнато (коментарът към цялото прехвърляне остава).",
      },
    ],
  },
  {
    version: "0.0.114",
    date: "2026-07-06",
    entries: [
      {
        type: "fix",
        text: "Менюто не се зареждаше — заявката GET /menu връщаше грешка 500 (в браузъра изглеждаше като CORS грешка), след като ДДС ставките в организационната база останаха без име (колоната vat_name е премахната). Бекендът вече не чете старата колона.",
      },
      {
        type: "improvement",
        text: "ДДС ставките се показват с процента си вместо с име — „20%“, „9%“, „0%“ (в менюто и в Складова база → продукти). Полето vatName остава в API-то, но стойността му вече е процентът.",
      },
      {
        type: "fix",
        text: "Монитори — поръчка с продукти на две или повече станции (напр. рецепти на кухня и бар) се показваше групирана по станция, а не в реда на маркиране. Редовете вече се подреждат точно както са накликани — както в прегледа преди поръчване (напр. Рецепта А ×1, А ×1, А ×2, Б ×1, А ×3, Б ×2).",
      },
      {
        type: "improvement",
        text: "Вход — потребителското име вече не зависи от малки/главни букви: „Admin“, „ADMIN“ и „admin“ влизат с един и същ акаунт. Паролата остава чувствителна към регистъра.",
      },
      {
        type: "improvement",
        text: "Маркиране — поредните еднакви добавяния се сливат в един ред: 3 натискания на „+“ върху Продукт А дават един ред „А ×3“ вместо 3 отделни реда. Слива се САМО с последния ред и САМО ако е абсолютно същият (същият продукт, същите модификатори, същите добавки, същият коментар) — А, А, А, Б, А дава 3 реда: „А ×3, Б ×1, А ×1“, редът на маркиране се пази. Важи и за „Добави“ от прозореца „Промени“, еднакво за артикули и рецепти; мониторите показват редовете в същия ред.",
      },
      {
        type: "improvement",
        text: "Маркиране — редове с добавка с брояч (тип „по избор“, напр. 3× пармезан) НИКОГА не се сливат и винаги остават отделни редове, защото количеството на такава добавка е общо за реда и сливането би било двусмислено.",
      },
    ],
  },
  {
    version: "0.0.113",
    date: "2026-07-02",
    entries: [
      {
        type: "feature",
        text: "Маркиране — всяко добавяне вече е ОТДЕЛЕН ред в поръчката: 3 натискания на „+“ дават 3 реда по 1 брой, а добавяне на 4 броя наведнъж от „Промени“ дава 1 ред с 4 броя (преди всичко се събираше в един общ ред „×7“). Важи и за продукти с добавки/модификатори — всяко отделно добавяне си остава отделен ред.",
      },
      {
        type: "improvement",
        text: "Маркиране — бутонът „−“ маха от последно добавените редове назад (първо от редовете без добавки, после от тези с добавки/модификатори); прегледът преди поръчка и сметката на масата показват редовете както са маркирани.",
      },
      {
        type: "improvement",
        text: "Монитори — поръчките се показват ред по ред, както са маркирани (напр. 3 реда по 1 + 1 ред с 4), вместо събрани на един ред с общо количество.",
      },
      {
        type: "improvement",
        text: "Монитори — „Изпълни“ / „В процес“ / „Върни“ действат само върху конкретния избран ред: когато един и същ продукт е на няколко реда в поръчката, се маркира само редът, който готвачът е избрал (включително при синхронизация между няколко монитора).",
      },
      {
        type: "fix",
        text: "Маркиране — клавишите „+“ / „−“ на клавиатурата смятаха количеството само от първия ред на продукта; вече правилно събират всички редове.",
      },
      {
        type: "feature",
        text: "Прозорецът „Промени“ — добавките вече са ВЕРТИКАЛНИ редове (чекбокс · име · цена), вместо хоризонтална лента с плъзгане. Всяка група добавки носи етикет според вида си: „⚠ изберете“ (задължителна), „★ препоръчани“ (препоръчителна) или „по избор“ (обикновена).",
      },
      {
        type: "feature",
        text: "Прозорецът „Промени“ — обикновените добавки („по избор“) имат брояч „−/+“ на реда: избираш количеството на добавката (напр. 3× пармезан), вместо да е по 1 на избран асортимент. Слизане под 1 маха добавката.",
      },
      {
        type: "improvement",
        text: "Количеството на обикновена добавка е ОБЩО за реда — не се умножава по бройката на продукта (2 салати с 3× пармезан = 3 бр. пармезан общо, не 6). Задължителните и препоръчителните добавки остават по 1 на продукт, както досега. Прегледът, сумите и кухненските монитори смятат по новото правило.",
      },
      {
        type: "improvement",
        text: "Максималният брой (maxQty) важи САМО за задължителните добавки — при обикновените и препоръчителните няма лимит колко асортимента можеш да избереш (полето е премахнато от админ панела за тези видове).",
      },
      {
        type: "feature",
        text: "Нови права в Маркиране: „Вижда сметки на всички потребители“ (view_all_users_bills) и „Вижда отчети на всички потребители“ (view_all_users_reports). Досега само администраторът виждаше всичко — вече зависи изцяло от правото.",
      },
      {
        type: "feature",
        text: "С право „Вижда сметки на всички потребители“ — в Маркиране се виждат масите/сметките на всички; „Възстанови“ и фактурирането работят върху чужди сметки. Без правото — само своите.",
      },
      {
        type: "feature",
        text: "С право „Вижда отчети на всички потребители“ — в „Генериране на отчет“ се виждат всички сервитьори с неотчетените им суми и може да се пуска отчет за всеки. Без правото — само собственият (списъкът вече не показва другите).",
      },
      {
        type: "improvement",
        text: "Справките не искат новите права: достъпът до „История на сметки“, „Сторно“, „Отстъпки“ и „Фактури“ показва сметките на всички, а достъпът до „Персонални отчети“ — отчетите на всички (гледащият справките може да няма достъп до Маркиране).",
      },
      {
        type: "improvement",
        text: "Строго разделение по контекст: правата за справки НЕ отварят чужди сметки в Маркиране — „Възстановяване на сметка“ и „Фактуриране – Избор на сметка“ показват чуждите сметки само с правото „Вижда сметки на всички потребители“.",
      },
      {
        type: "fix",
        text: "Мониторите, кухненският принтер и сметката на масата показват продуктите ТОЧНО в реда на маркиране (напр. Продукт А, А, А, Б, А) — редът вече е гарантиран и не може да се разбърка след смяна на статус или други промени по поръчката. Добавките и модификаторите също излизат в реда на избирането им.",
      },
      {
        type: "improvement",
        text: "Монитори (Grid) — уголемени шрифтове за четимост от разстояние: име на продукт 17px (беше 13.5), брой 16.5px, маса 18px, коментар 14.5px, модификатори 15.5px. Редовете и колоните са леко по-големи (56px ред, 340px колона), за да не лепне текст до текст; пренасянето към следваща колона е преизчислено и тествано.",
      },
      {
        type: "improvement",
        text: "Монитори (Grid) — премахната иконата за незапочнат продукт: името започва от левия ръб и има повече място. Иконите „в процес“ (⚡) и „готово“ (✓) остават и са уголемени.",
      },
    ],
  },
  {
    version: "0.0.112",
    date: "2026-06-30",
    entries: [
      {
        type: "feature",
        text: "Наличности — две нови колони „Сума без ДДС“ и „Сума“ (наличност × себестойност, с/без ДДС според конфигурацията); всички колони се сортират; „Категория“ е преименувана на „Група“ (с филтър), а филтри има на „Продукт“, „Група“ и „Наличност“.",
      },
      {
        type: "feature",
        text: "Наличности — при клик на ред се отваря прозорец с наличността по ПАРТИДИ: партида · срок на годност · наличност · ед. цена · сума без ДДС · сума, плюс общо.",
      },
      {
        type: "feature",
        text: "Взаимозаменяеми продукти (справка) — нова колона „Ед. цена“ и „Сума без ДДС“; „Стойност“ е преименувана на „Сума“. Справката вече показва замените от ВСИЧКИ складове (не зависи от избрания склад).",
      },
      {
        type: "fix",
        text: "Инвентаризация — ако наличността е отрицателна, системното количество се показва като 0 (физически не може да имаш под 0 на рафта), затова при преброяване търсим 0.",
      },
      {
        type: "improvement",
        text: "Продадени рецепти — показват се ВСИЧКИ продадени рецепти (без значение колко съставки имат); „Стойност“ → „Сума“ + нова „Сума без ДДС“ (по ДДС на рецептата).",
      },
      {
        type: "improvement",
        text: "Продадени продукти — показват се ВСИЧКИ изписани продукти от продадените рецепти (напр. салата → домати и краставици се виждат тук), оценени по себестойност; „Стойност“ → „Сума“ + нова „Сума без ДДС“.",
      },
      {
        type: "improvement",
        text: "Разнасяне на отчети — при няколко неразнесени отчета по подразбиране се избира най-старият (подредени от стар към нов), за да се разнасят по ред.",
      },
      {
        type: "feature",
        text: "Конфигурации — нова секция „Склад по подразбиране“. Изборът на склад вече НЕ е в страничното меню, а се задава тук; ако не е зададен, се ползва първият склад. Справките „Наличности“ имат собствен избор на склад вляво.",
      },
      {
        type: "improvement",
        text: "Дизайн — по-подреден ред с филтри (дата/склад/търсачка) в справките, по-добър изглед на мобилен телефон; премахната излишна празнина под логото в разпънатото странично меню.",
      },
      {
        type: "feature",
        text: "Акаунт за общ достъп — при влизане веднага се иска ПИН код (преди се искаше само в „Маркиране“). След кода се показват само модулите на съответния служител, а всичко, което се прави в модулите, се води на него. Свободният (личен) вход остава непроменен.",
      },
      {
        type: "improvement",
        text: "Акаунт за общ достъп — горе вдясно във всички модули се вижда името на служителя, влязъл с код, и има бутон „Изход“ на един клик, който връща на екрана за ПИН (смяна на служител). Общият акаунт продължава да заема само един лиценз, без значение колко служители се сменят през кода.",
      },
      {
        type: "fix",
        text: "Акаунт за общ достъп — при презареждане на страницата (F5) терминалът се връща на екрана за ПИН за нов вход, вместо да излиза напълно.",
      },
      {
        type: "fix",
        text: "Акаунт за общ достъп — отстранена грешката „Невалиден код“, която се появяваше при изход с парола (клавиатурата за ПИН вече не прихваща въведената в полето парола).",
      },
      {
        type: "improvement",
        text: "Акаунт за общ достъп — на екрана за ПИН вече се показва името на терминала (напр. „Бар“/„Кухня“) до профил иконата, за да е ясно на кой общ акаунт сте. Остава видимо и след презареждане на страницата.",
      },
      {
        type: "feature",
        text: "Монитори — трите действия във footer-а вече изискват отделно право: „Изпълни“ (право „Маркиране като изпълнено“), „В процес“ (право „Маркиране като в процес на изпълнение“) и „Върни“ (право „Връщане на поръчка в статус неизпълнена“). Без съответното право бутонът е неактивен, а и клавишите „+“ / „−“ не заобикалят ограничението.",
      },
      {
        type: "improvement",
        text: "Маркиране — при писане на коментар към продукт (прозорец „Промени“) натискането на Enter вече добавя продукта (както бутонът „Добави“), вместо да прави нов ред. За нов ред използвайте Shift+Enter.",
      },
      {
        type: "improvement",
        text: "Поръчка — в прегледа преди поръчка натискането на Enter в полето за коментар вече потвърждава поръчката („Поръчай за…“), вместо да прави нов ред. За нов ред използвайте Shift+Enter.",
      },
      {
        type: "improvement",
        text: "Монитори — включеният звук вече се помни при презареждане на страницата (F5). Тъй като браузърът изисква действие, за да пусне звук, при първо кликване където и да е звукът се активира автоматично отново. Дотогава иконата за звук е със сива камбанка (на същия фон като при включен звук — подсказва, че клик ще активира звука), а след клика камбанката става обичайната оранжева. Ако звукът е бил изключен, това не се случва.",
      },
    ],
  },
  {
    version: "0.0.111",
    date: "2026-06-29",
    entries: [
      {
        type: "feature",
        text: "Изписване и бракуване — колоната „Наличност“ вече показва наличността към ИЗБРАНАТА дата, а не към сегашния момент. При задна дата виждаш колко е имало в склада към края на този ден (включително какво е било изписано/доставено дотогава), а при изписване без избрана партида FIFO взема само партидите, съществували до тази дата, с техните цени тогава.",
      },
      {
        type: "fix",
        text: "Изписване и бракуване — проверката „не може повече от наличното“ вече е спрямо наличността към избраната дата. Пример: ако до 10-ти е имало 100 кг, не можеш да изпишеш 150 кг с дата 10-ти, но със следваща дата, на която вече има 200 кг — можеш. Важи и при редакция.",
      },
      {
        type: "feature",
        text: "Изписване и бракуване — нова колона „Сума без ДДС“ до „Сума“ (в списъка, в документа и в прозореца за ново/редакция). Въведената/изчислената ед. цена се тълкува „с ДДС“ или „без ДДС“ според настройката от „Конфигурации“ (както при доставка), а двете суми се смятат спрямо ДДС-ставката на всеки продукт и се запазват като снимка — затова по-късна смяна на настройката не променя стари записи.",
      },
      {
        type: "fix",
        text: "Изписване на рецепта — от склада вече се вади БРУТОТО количество на съставките, а не нетото. Пример: ако за домат в рецептата брутото е 2 кг, а нетото 1,600 кг, изписваме 2 кг (реално излязлото от склада с обелките/фирата), не 1,600. Важи и при „Раздели на продукти“. Ръчното изписване не е засегнато (там сам избираш количеството).",
      },
      {
        type: "improvement",
        text: "Изписване и бракуване — в документа (след запис и при клик на ред) има нова колона „Мерна единица“ до количеството, за да е ясно в каква единица е (килограм, литър, брой…), а количеството се показва винаги с 3 знака (0,165 / 0,250 / 0,100).",
      },
      {
        type: "improvement",
        text: "Складова база — полето „Количество“ при ново/редакция (изписване, бракуване и доставка) вече показва винаги 3 знака след запетаята (напр. 0,200 вместо 0,2), със запетая като разделител; докато пишеш не пречи. В документа на доставката колоната „Мярка“ е преименувана на „Мерна единица“.",
      },
      {
        type: "improvement",
        text: "Изписване и бракуване — таблицата вече показва записите от ВСИЧКИ складове (а не само от избрания), с нова колона „Склад“ със сортиране и филтриране (както при доставките). „Ново изписване“ продължава да ползва избрания вляво склад.",
      },
      {
        type: "fix",
        text: "Разнасяне на отчет — преди да се изпише, отчетът се сверява с актуалните рецепти. Ако някой е променил рецепта (напр. бруто от 400 на 300 г) между прегледа и „Изпиши и затвори деня“, разнасянето спира с подкана да се презареди, за да не се изпише по остаряло количество.",
      },
      {
        type: "improvement",
        text: "Изписване и бракуване — единичната цена вече не се въвежда ръчно; идва автоматично от партидата (а при FIFO — претеглена спрямо взетото количество от всяка партида, ако се пълни от няколко). Сумите със и без ДДС се изчисляват от нея.",
      },
      {
        type: "feature",
        text: "Инвентаризация — нова колона „Сума без ДДС“ до „Сума“; единичната цена се тълкува с/без ДДС според настройката от „Конфигурации“ (както при доставка/изписване).",
      },
      {
        type: "feature",
        text: "Инвентаризация — при избор на дата наличностите се показват КЪМ тази дата (системното количество е балансът към края на избрания ден), а липсите/излишъците се смятат спрямо нея, не спрямо сегашния момент.",
      },
      {
        type: "improvement",
        text: "Инвентаризация — продуктите са подредени: тези с наличност (по азбучен ред) най-горе, а нулевите най-долу.",
      },
      {
        type: "feature",
        text: "Инвентаризация — при излишък може да се въведат партида, срок на годност и ед. цена на новата партида (на втори ред под продукта); ако продуктът следи партида/срок, те са задължителни (както при доставка). При липса единичната цена идва автоматично от FIFO (претеглена по количествата на партидите).",
      },
      {
        type: "fix",
        text: "Инвентаризация — взаимозаменяемите продукти вече работят правилно: донор може да е само продукт, преброен с излишък, и се покрива най-малкото от (липсата на единия, излишъка на другия). Пример: ако А е −2, а Б е +2 → стават 0 и 0; ако Б е +1 → А става −1, Б 0. Балансите се изравняват към системното (Б→А). Разнасянето на отчети не е променяно.",
      },
      {
        type: "improvement",
        text: "Инвентаризация — количествата (системно, преброено, разлика) се показват винаги с 3 знака след десетичния знак; в „Преброено“ точката и запетаята се тълкуват еднакво (117.345 = 117,345). В прозореца за покриване от взаимозаменяеми се вижда и наличността, и свободният излишък на донора, а текстовете са по-ясни.",
      },
      {
        type: "improvement",
        text: "Доставка — в колона „Разфасовка“ мерната единица по подразбиране се показва както е записана, без главна буква (напр. „кг“, „брой“).",
      },
      {
        type: "feature",
        text: "Инвентаризация — в прозореца (при нова и при редакция) вече има избор на склад до датата; продуктите и наличностите се взимат от него. Така не зависи от избрания склад в страничното меню.",
      },
      {
        type: "improvement",
        text: "Инвентаризация — таблицата показва инвентаризациите от ВСИЧКИ складове, с нова колона „Склад“ със сортиране и филтриране (както при доставки и изписвания).",
      },
      {
        type: "improvement",
        text: "Взаимозаменяеми продукти — групите вече са ОБЩИ за всички складове: създават се веднъж и важат навсякъде, а списъкът е общ (не зависи от избрания склад).",
      },
      {
        type: "feature",
        text: "Прехвърляне — в прозореца (нова и редакция) вече има колони „Ед. цена“ (само за четене, изчислена точно по партидите/FIFO), „Сума без ДДС“ и „Сума“ (с/без ДДС според конфигурацията); същите суми се виждат и в документа.",
      },
      {
        type: "improvement",
        text: "Прехвърляне — при избор на дата наличността на източника се показва само до тази дата и не може да се прехвърля повече от наличното към нея (партидите и цените също са към датата).",
      },
      {
        type: "improvement",
        text: "Разнасяне на отчети — когато има няколко неразнесени отчета, по подразбиране се избира най-старият (отчетите са подредени от стар към нов, за да се разнасят по ред).",
      },
      {
        type: "improvement",
        text: "Недостиг — страницата показва недостига за ВСИЧКИ складове, с нова колона „Склад“ и сортиране/филтриране по колоните.",
      },
      {
        type: "feature",
        text: "Недостиг — клик на ред показва как се е натрупал недостигът по отделните отчети (дата, количество, ед. цена, сума без ДДС и сума).",
      },
      {
        type: "improvement",
        text: "Недостиг — компенсирането се прави с доставка със ЗАДНА ДАТА (по подразбиране датата на най-стария отчет-причинител, в склада на продукта). Доставката покрива отчетите от датата ѝ напред, хронологично (по-старият първи) — по-старите остават, докато не се върне доставка преди тях.",
      },
      {
        type: "improvement",
        text: "Маркиране — при вход с код (пин) въведеният код се скрива със звездички вместо истинските символи.",
      },
    ],
  },
  {
    version: "0.0.110",
    date: "2026-06-26",
    entries: [
      {
        type: "improvement",
        text: "Вход с код — кодът вече не е ограничен до 4 цифри: може да е с произволна дължина и да съдържа цифри, букви и символи. Вместо 4-те квадратчета има едно поле (като при „Нова маса“) — пишеш с цифровия панел или с клавиатурата, а влизаш с бутона „Вход“ или Enter.",
      },
      {
        type: "improvement",
        text: "Маркиране (Монитори) — горе вдясно на всяка поръчка вече се показва името на сервитьора, а не потребителското му име.",
      },
      {
        type: "improvement",
        text: "Складова база — филтрите по колоните в таблиците са по-удобни: избор или махане на отметка филтрира веднага, без бутони „Приложи/Нулирай“, а прозорчето се затваря при клик извън него. Текстовете на филтрите вече са на български.",
      },
      {
        type: "improvement",
        text: "Складова база — страницата „Конфигурации“ вече е в отделна секция „Настройки“ в менюто (както „Операции“ и „Справки“). Текстовете са по-ясни: „Единична цена при доставка“, „Въведената единична цена е:“ и опция „С включено ДДС“ / „Без ДДС“.",
      },
      {
        type: "improvement",
        text: "Складова база — мерните единици вече се показват както са записани (напр. „килограм“, „литър“, „брой“), без съкращаване до „кг/л/бр“. Промяната е навсякъде в модула (доставки, изписвания, инвентаризация, прехвърляне, справки и т.н.).",
      },
      {
        type: "feature",
        text: "Доставки — в документа на доставката (след създаване и при клик на ред) има нова колона „Мярка“ до количеството, за да е ясно в каква мерна единица е (литър, брой, килограм…).",
      },
      {
        type: "improvement",
        text: "Доставки — полето „Количество“ при нова/редакция на доставка вече приема и точка, и запетая, показва стойността със запетая и допуска до 3 знака след нея.",
      },
      {
        type: "improvement",
        text: "Доставки — дребни подобрения по изгледа: в документа на доставката количеството се показва с 3 знака след точката (напр. 0,165 / 0,250 / 0,100); в прозореца за нова/редакция на доставка колоните „Сума без ДДС“ и „Сума“ са преместени преди „Партида“ и са центрирани, а полето „Количество“ е разширено, за да се събира информацията при избрана разфасовка.",
      },
      {
        type: "feature",
        text: "Доставки — ако за продукт е включено следене на партида и/или срок на годност, тези полета стават задължителни при заприходяване. При „Заприходи“ изскача съобщение точно кои полета липсват (по продукт) и самите полета светват в червено; важи и за двете полета.",
      },
      {
        type: "improvement",
        text: "Доставки — таблицата вече показва всички доставки от всички складове (а не само от избрания склад). Колоната „Склад“ показва склада на доставката, а при разпределена доставка — всички засегнати складове (напр. „Бар, Кухня“); филтърът по склад показва доставките, които имат ред в избрания склад. „Нова доставка“ продължава да ползва избрания вляво склад.",
      },
      {
        type: "feature",
        text: "Доставки — нова колона „Сума без ДДС“ до „Сума“ (в списъка, в документа и в прозореца за нова/редакция на доставка). Двете суми се смятат спрямо ДДС-ставката на всеки продукт. „Сума без ДДС“ и „Сума (с ДДС)“ се запазват като снимка на самата доставка в момента на въвеждане — затова по-късна смяна на настройката НЕ променя стари доставки.",
      },
      {
        type: "feature",
        text: "Складова база — нова страница „Конфигурации“ най-долу в менюто. Засега с една настройка: дали въведената при доставка ед. цена е „С ДДС“ или „Без ДДС“ (по подразбиране „С ДДС“). От избора зависи как се пресмятат колоните „Сума без ДДС“ и „Сума“ при нова доставка.",
      },
      {
        type: "improvement",
        text: "Складова база — всяка страница от менюто вече е истинска страница със собствен адрес (напр. /inventory/delivery, /inventory/stock). Така презареждането на страницата, бутоните Назад/Напред на браузъра и запазването в отметки вече работят и оставаш на същата страница, вместо да се връщаш в началото. Избраният склад се запазва при преминаване между страниците.",
      },
      {
        type: "improvement",
        text: "Складова база — в таба на браузъра вече се изписва „{име на страницата} – {име на ресторанта}“ (напр. „Доставка – central“), за да се ориентираш по-лесно кога имаш отворени няколко таба.",
      },
    ],
  },
  {
    version: "0.0.109",
    date: "2026-06-16",
    entries: [
      {
        type: "feature",
        text: "Нов раздел „Разнасяне на отчети“ в Складова база (Операции) — в края на деня избираш неразнесен отчет на заведението и го разнасяш по склада на един екран с две колони. Вляво е целият отчет (продадените рецепти и продукти с количества; рецепта само с 1 продукт се показва като „продукт“), а вдясно — какво ще се изпише: рецептите са разбити на съставни продукти, с наличност (само за информация), избор от кой склад (може и от няколко склада за един продукт), партида (FIFO по подразбиране или конкретна) и точна себестойност по партидите. Продуктите с недостиг се отбелязват с „не достигат …“ и обобщение колко са. С „Компенсирай липсите“ покриваш недостиг от взаимозаменяем продукт (същия прозорец като при инвентаризация), а с „Изпиши и затвори деня“ разнасяш отчета — само тук липсващите количества се изписват с отрицателна наличност. Един отчет се разнася само веднъж; с „Редактирай“ (по дата) можеш да отвориш вече разнесен отчет и да го коригираш.",
      },
      {
        type: "feature",
        text: "Две нови справки в Складова база (раздел Справки) — „Продадени продукти“ и „Продадени рецепти“. С период, търсене и сортиране по колоните (без сортиране по подразбиране). „Продукт“ е продаваемо с една съставка, а „рецепта“ — с повече от една; показват се продаденото количество, средна цена и оборот.",
      },
      {
        type: "feature",
        text: "Нов раздел „Прехвърляне“ в Складова база (Операции) — премества стока между два склада: избираш от кой и към кой склад, дата и няколко продукта. На всеки ред се вижда наличността в склада-източник (информативно) и може да избереш FIFO или конкретна партида (с партида, остатък и срок на годност). Прехвърлянето запазва партидата, срока на годност и себестойността — продуктът просто сменя склада. Има обобщение, сортиране и филтри по колоните, и документ за печат.",
      },
      {
        type: "improvement",
        text: "Взаимозаменяеми продукти — вече са по склад, а не общи за всички складове (всеки склад има собствени групи). Така и покриването на липси при инвентаризация гледа само групите и наличността на избрания склад. (Заб.: групи, създадени преди тази промяна, трябва да се създадат наново за съответния склад.)",
      },
      {
        type: "feature",
        text: "Нов раздел „Бракуване“ в Складова база (Операции) — за изписване на негодна стока (изтекъл срок, развала, счупване…). Работи 1:1 като „Изписване“ (по продукт или рецепта, по FIFO или избрана партида, с редакция/триене и документ за печат), но причината се избира от готов списък и бракуването се води отделно от обикновените изписвания. Има обобщение и сортиране/филтриране по колоните.",
      },
      {
        type: "improvement",
        text: "Изписване и Бракуване — в падащото меню за избор на партида вече се вижда и срокът на годност на всяка партида (или „без срок на годност“), освен партидата и остатъка.",
      },
      {
        type: "feature",
        text: "Нов раздел „Недостиг“ в Складова база (Операции) — показва само продуктите с отрицателна наличност, с обобщение колко са и каква е стойността на недостига. При клик на ред се отваря хронология на движенията за продукта (доставки, изписвания, инвентаризации, замени) с натрупването на наличността — за да се вижда как се е стигнало до минуса. Над таблицата има бутон „Добави наличност“: маркираш редове с чекбокс и той отваря нова доставка с предварително попълнени продукти (количество = недостига, ед. цена = последната доставна цена); без маркирани редове отваря празна доставка.",
      },
      {
        type: "feature",
        text: "Нов раздел „Взаимозаменяеми продукти“ в Складова база — задаваш ГРУПИ от заменяеми продукти (напр. кола = фанта = спрайт). Всеки продукт в групата има коефициент (1:1 за равностойни, или напр. 1 пюре = 0.7 сок) и приоритет — кой да се ползва пръв при покриване; без приоритет се хваща продуктът с най-стара доставка (за да се изчерпват старите наличности). Може и подсказка. Добавя се през „Нова група“.",
      },
      {
        type: "feature",
        text: "Замяна при инвентаризация — вече е отделна стъпка ПРЕДИ инвентаризацията. При недостиг на продукт, който има наличен взаимозаменяем, при натискане на „Нова инвентаризация“ изскача прозорец с предложение от кой продукт да се покрие (може да смениш донора или да оставиш като липса); покрива се целият недостиг, а прозорецът показва точно колко ще се изпише от избрания заместител. Така самата инвентаризация остава чиста (показва реалното състояние на продукта, без „покрито от друг“), а замените се водят отделно.",
      },
      {
        type: "feature",
        text: "Нова справка „Взаимозаменяеми продукти“ (раздел Справки) — в стила на „Наличности“: таблица с търсене, филтри и сортиране, с ясни колони Дата · Тип (засега „При инвентаризация“) · От (донор) → На (получател) · Изписано · Покрито · Стойност, с мерните единици. Всеки ред е една замяна (без разпъване).",
      },
      {
        type: "fix",
        text: "Инвентаризация — при редакция колоната „Системно“ вече показва очакваното количество ОТПРЕДИ инвентаризацията (а не текущото, което вече е равно на преброеното), за да се вижда реалната разлика. Поправено и заглавието „Редакция на инвентаризация №…“ (показваше се номерът буквално). Ако инвентаризацията има замяна от взаимозаменяем продукт — при редакция, когато промениш преброеното, количеството от заместителя се преизчислява спрямо новия недостиг (отваря се пак прозорецът за покриване, можеш да коригираш), без двойно изписване на донора; а при триене на инвентаризацията замяната се изтрива заедно с нея (донорът се възстановява).",
      },
      {
        type: "feature",
        text: "Складова база — наличността на всеки продукт е едно число. Доставка я увеличава, изписване я намалява, а инвентаризацията я установява на реално преброеното. При изписване вече НЕ може да се изпише повече от наличното — системата отказва, а модалът маркира реда в червено. Липса и излишък възникват само при инвентаризация — те са чисто информативни (разликата спрямо очакваното) и се пазят в историята на самата инвентаризация; доставка и изписване не ги пипат. Преизчисляват се само при операция със задна дата.",
      },
      {
        type: "improvement",
        text: "Справка „Наличности“ — добавени колони „Средно претеглена“ и „Последна доставна цена“ за всеки продукт. Наличността се показва знаково (отрицателното е в червено); липса и излишък вече не са колони тук, а се виждат в документа на инвентаризацията.",
      },
      {
        type: "fix",
        text: "Складова база — ед. цена вече е закръглена на 2 знака навсякъде. Поправен и проблем, при който изтриването на ед. цена при изписване я връщаше към предишната стойност и не позволяваше въвеждане на нова.",
      },
      {
        type: "improvement",
        text: "Инвентаризация — вече се запазват всички преброени продукти, дори когато преброеното съвпада със системното количество (показват се със статус „равно“, нито липса, нито излишък). Премахната е грешката „Няма редове с разлика“ — записва се, стига да е въведен поне един брой.",
      },
      {
        type: "feature",
        text: "Складова база — „Инвентаризация“ вече е една страница: бутон „Нова инвентаризация“ и отдолу таблица с всички направени инвентаризации. Всяка може да се редактира (икона ✎) или трие (икона 🗑) по всяко време; редакцията отваря модал, попълнен с преброеното, и пита за потвърждение при незапазени промени преди затваряне.",
      },
      {
        type: "feature",
        text: "Нова справка „Наличности“ (раздел Справки) — за избрания склад показва всички продукти с тяхната категория, наличност, минимална наличност и заложена фира. Има търсачка по всичко (продукт, категория, фира…), филтри по колоните и обобщение колко продукта са под минимума, до 20% над минимума и над 20% над минимума.",
      },
      {
        type: "improvement",
        text: "Складова база — редактирането на запис вече става само чрез иконата за редакция (без двоен клик) в Доставка, Изписване и Инвентаризация. В инвентаризацията разликата вече се показва с мерната единица (напр. „+4 кг“).",
      },
      {
        type: "feature",
        text: "Доставка и Изписване — всеки запис вече може да се редактира и трие по всяко време (икони върху реда). Редакцията отваря същия модал, попълнен с данните; при доставка се зарежда целият запис (включително разпределението по складове). Системата преизчислява засегнатите наличности след всяка промяна.",
      },
      {
        type: "feature",
        text: "Складова база — при изписване не може да се изпише повече от наличното количество (системата отказва записа). Себестойността се определя по партидите (FIFO) или по избрана партида, с възможност за ръчна корекция на ед. цена.",
      },
      {
        type: "improvement",
        text: "Изписване — при редакция на изписване от рецепта вече се запазва кое е рецепта (редовете ѝ се събират обратно в един ред-рецепта), вместо да се разпада на отделни продукти.",
      },
      {
        type: "improvement",
        text: "Складова база — наличностите се зареждат по-бързо (поддържа се текущ баланс на продукт), без преизчисляване върху цялата история при всяко отваряне.",
      },
      {
        type: "feature",
        text: "Нов раздел „Инвентаризация“ в Складова база — пълностранична страница: показват се всички продукти със системното им количество, въвеждаш преброеното, а системата смята разликата и статуса (равен/излишък/липса). Има търсачка по име, обобщение (преброени, излишък, липси, стойност на разликата) и бутон „Потвърди инвентаризацията“. При потвърждаване излишъците се заприходяват (нова партида), а липсите се изписват по FIFO — в един документ.",
      },
      {
        type: "feature",
        text: "Инвентаризация — системното количество се преизчислява в момента на потвърждаване (а не при зареждане). Ед. цена по подразбиране е последната цена и може да се коригира ръчно за всеки ред (при липса по подразбиране се ползва FIFO себестойност). След потвърждаване се отваря документ за печат, а в раздел „Инвентаризации“ има справка с историята.",
      },
      {
        type: "feature",
        text: "Изписване — добавени колони „Ед. цена“ и „Сума“ и ред „Общо“ (закотвен в дъното, винаги видим). Ед. цена по подразбиране е цената на партидата (при FIFO — претеглената на партидите, които ще се изпишат), но може да се коригира ръчно; сумата се изчислява на живо. Модалът е разширен, а колоните са пренаредени (Продукт · Наличност · Количество · Партида · Ед. цена · Сума · Бележка).",
      },
      {
        type: "feature",
        text: "Изписване — след „Изпиши“ се отваря документ (като при доставка): дата, причина и склад, таблица с редовете (продукт, рецепта, партида, количество, ед. цена, сума) и ред „Общо“, с бутони „Затвори“ и „Принтирай“. Печатът извежда само документа, без горния ред с дата/заглавие от браузъра (важи и за документа за доставка).",
      },
      {
        type: "improvement",
        text: "Изписване и Доставка — преди изтриване на ред, както и преди разделяне на рецепта и връщане в рецепта, се иска потвърждение. Бутонът за изтриване вече е винаги активен — изтриването на последния ред го изчиства до празен. При рецепта няма колона „Партида“, а „Раздели на продукти“ е иконка до кошчето.",
      },
      {
        type: "feature",
        text: "Backend — изписването приема ръчно въведена ед. цена на продуктов ред: тя се записва вместо изчислената от партидата (партидите се изписват по същия начин по FIFO/конкретна партида, сменя се само записаната цена и сума).",
      },
      {
        type: "fix",
        text: "Поправено непоявяване на изскачащите прозорци за потвърждение и на съобщенията в модалите за изписване и доставка.",
      },
      {
        type: "fix",
        text: "Изписване — падащото меню „Рецепта“ беше празно (грешка при зареждане). Поправено.",
      },
      {
        type: "improvement",
        text: "Изписване на рецепта — изборът на рецепта вече не разгъва автоматично съставките. Ред-рецепта показва само рецепта, „Порции“ и бележка; въведените порции умножават количествата на всички продукти (порции × съставка). Рецептата винаги се изписва по FIFO (без избор на партида).",
      },
      {
        type: "feature",
        text: "Изписване на рецепта — бутон „Раздели на продукти“ разгъва рецептата в редове по продукти (с количества според порциите), където вече се виждат наличност, количество, партида и бележка и всеки ред е редактируем. Над разделените редове има бутон „Върни в рецепта“, който ги събира обратно в един ред-рецепта.",
      },
      {
        type: "feature",
        text: "Backend — изписването вече помни кога е на рецепта: при изписване на рецепта движението се разгъва до продуктите ѝ (включително през вложени рецепти) и всеки ред се отбелязва с рецептата и порциите. Така изписаните рецепти и изписаните продукти ще се разделят в две отделни справки. Разделените на продукти редове се водят като продуктово изписване.",
      },
      {
        type: "feature",
        text: "Доставка — нова колона „Склад“ на всеки продуктов ред (по подразбиране избрания склад вляво). Един продукт може да се раздели между няколко склада: при избор на повече от 1 склад се появява ред за разпределяне на количеството, който работи огледално — пишеш в единия склад, другият автоматично поема остатъка (при 3+ склада последният поема остатъка), а превишаване на наличното се маркира в червено. Под продуктите има и обобщаващ ред „Общо“.",
      },
      {
        type: "feature",
        text: "Доставка — при „Заприходи“ се отваря документ за доставката (като преглед на отчет): дата, фактура, доставчик и таблица с всички редове (продукт, склад, количество, ед. цена, сума) и ред „Общо“, с бутони „Затвори“ и „Принтирай“. Печатът извежда само документа (без страницата отзад). Списъкът с доставки се филтрира по склад — разделена доставка се вижда под всеки склад само със своята част (брой и стойност за тази част).",
      },
      {
        type: "feature",
        text: "Backend — складът на складовото движение вече е на ниво ред (stock_movement_lines), а не на заглавката, така че едно движение може да обхваща няколко склада (разделена доставка); колоната беше премахната от stock_movements (миграция). Изписването остава едно-складово. За всяко движение се пази кой потребител го е извършил (created_by — id-то от JWT) и кога (created_at).",
      },
      {
        type: "feature",
        text: "Backend — при всяко складово движение цените на продуктите се записват обратно в организационната база (нова таблица product_restaurant_prices, по двойка продукт + ресторант): „последна доставна цена“ (само при доставка) и „средно претеглена цена“ (при доставка И при изписване). Средно претеглената се смята в ресторанта като Σ(остатък × цена) / Σ(остатък) по отворените партиди на продукта във всички складове на ресторанта; при нулева наличност се записва празна стойност. Записът е upsert по продукт+ресторант (паралелни доставки от различни ресторанти не си пречат) и е изолиран — ако записът в организационната база се провали, самата доставка/изписване минава. Това е единственото място, на което restaurant-be пише в организационната база (иначе само за четене).",
      },
      {
        type: "feature",
        text: "Нов модул „Складова база“ с първа страница „Доставка“ (приход). Sidebar в стила на Справки с избор на склад най-отгоре (компактен dropdown със складовете на ресторанта от организационната база). Над таблицата има обобщение (брой доставки, обща стойност, продукти) и период — същият date picker като в справките, до който стои бутонът „Нова доставка“. Таблицата показва доставките (дата, фактура №, доставчик, склад, брой продукти, стойност), а разгъването на ред показва редовете ѝ в компактна под-таблица: продукт, разфасовка, брой, количество, ед. цена, партида, срок на годност, сума и бележка.",
      },
      {
        type: "feature",
        text: "Модал „Нова доставка“ — двуколонен: вляво данни за доставката (дата, фактура №, доставчик, склад, бележка на 2 реда) и живо „Общо“; вдясно компактна таблица с продуктови редове, всеки на един ред, с бутон „Добави ред“ и кошче за изтриване. Разфасовката показва разбивка с мерна единица (напр. „Стек Вода · 6×1.5 л“, „Кашон Картофи · 10 кг“), а количеството се смята на живо като бледосив суфикс в полето „Брой“ (напр. 5 → „= 15 л“). Сумата на всеки ред и общото се изчисляват автоматично. Бутони „Заприходи“ и „Отказ“.",
      },
      {
        type: "feature",
        text: "Backend — нова двойка таблици stock_movements + stock_movement_lines (в основната база), универсални за приход и разход чрез поле type. Заприходяването записва заглавка (склад, дата, фактура, доставчик, бележка, обща стойност) и редове (продукт, разфасовка, брой разфасовки, изчислено количество = брой × базови единици на разфасовката, ед. цена, сума, партиден номер, срок, бележка). Справочниците (складове, доставчици, продукти, разфасовки, мерни единици) се четат от организационната база и имената им се резолвят при четене.",
      },
      {
        type: "feature",
        text: "Поддръжка на режим „със склад“ (organizations.uses_warehouse). Когато организацията работи със склад, продаваемият артикул е рецепта (recipes) вместо артикул (items): менюто в модул Маркиране връща рецептите, а всички места, които показват име на ред по поръчка — справки (Асортименти, Сторно, персонални/обектни отчети), История на операциите, екранът на сметката, кухненските и фискалните бележки — резолвят името от рецептите. Форматът на отговорите остава същият, така че интерфейсът не се променя. Модул „Складова база“ се вижда само при съответната роля.",
      },
      {
        type: "improvement",
        text: "Таблицата на доставките — всяка колона има сортиране, а колоните Фактура №, Доставчик, Склад и Продукти имат и филтър с търсене (Дата и Стойност са само със сортиране). Периодът по подразбиране е днешният ден и се нормализира до цял ден, така че избор на една дата показва точно нея. Редовете се разгъват с клик (без отделна „+“ колона), за да започва колоната „Дата“ плътно отляво. В горния десен ъгъл е добавен часовник, а KPI „Обща стойност“ ползва евро иконка.",
      },
      {
        type: "feature",
        text: "Нова страница „Изписване“ (разход) в Складова база, в стила на „Доставка“: период, обобщение (брой изписвания, обща стойност, продукти) и таблица (дата, причина, продукти, стойност) с разгъване на ред. Модалът „Изписване“ е двуколонен — вляво дата, склад, причина и коментар; вдясно всеки ред е продукт или рецепта (превключвател + търсачка), показва наличността в склада и позволява изписване по метод FIFO (първа влязла) или от конкретна партида. Избор на рецепта автоматично добавя нейните продукти, включително от вложени рецепти.",
      },
      {
        type: "feature",
        text: "Партидна наличност — всяка доставка отваря партида с остатък, а наличността на продукт е сборът от остатъците по отворените партиди. Изписванията намаляват най-старите партиди (FIFO) или избрана партида и пресмятат себестойност по съответните цени; при недостатъчна наличност изписването се отказва с ясно съобщение.",
      },
      {
        type: "improvement",
        text: "Единичната цена при доставка вече е за базовата мерна единица (напр. лв/кг, лв/л), а не за цялата разфасовка. Сумата на реда се смята като общо количество × единична цена (напр. 2 кашона × 10 кг × 3 = 60,00), а до полето за цена се показва мерната единица (напр. „/кг“).",
      },
      {
        type: "improvement",
        text: "Доставка — ред с продукт стана по-ясен: полето „Разфасовка“ по подразбиране показва мерната единица на продукта (напр. „Килограм“), така че ако не се избере разфасовка, количеството е директно в нея (25 = 25 кг); показват се само разфасовките, закачени към избрания продукт (ако няма — само мерната единица). Колоната „Брой“ е преименувана на „Количество“, а заглавията на колоните са подравнени със стойностите. Единичната цена се попълва автоматично с последната доставна цена на продукта (ако е първа доставка — остава празна).",
      },
      {
        type: "improvement",
        text: "Изписване — добавен е бутон „Добави ред“ до превключвателя Продукт/Рецепта: новият ред е със селект за продукт или за рецепта според избора на превключвателя. Продуктът/рецептата се избира директно в реда; при избор на рецепта редът се разгъва на нейните продукти (включително от вложени рецепти). Заглавията на колоните са подравнени със стойностите, а коментарът в разгънат ред се показва като „Коментар: …“ с курсив, без фон.",
      },
    ],
  },
  {
    version: "0.0.108",
    date: "2026-06-08",
    entries: [
      {
        type: "fix",
        text: "Фактуриране — нетото, ДДС-то и общата сума вече се реконсилират до стотинка. Сборът на редовете винаги е точно равен на „Облагаема сума“ и „ДДС“, а те — на „Обща стойност“. Въведен е единен алгоритъм за разпределяне на остатъка (largest remainder): за всяка ДДС ставка ДДС-то се закръгля нагоре (half-up), нетото е остатъкът, а остатъчните центове се разпределят по редовете с най-голям остатък — ако един продукт се закръгли нагоре, друг компенсира надолу. Преди това всеки ред се закръгляше независимо и сборът можеше да се разминава с 1 цент спрямо тоталите.",
      },
      {
        type: "fix",
        text: "ДДС разбивката на фактурата се смята с един и същ алгоритъм 1:1 във frontend-а и backend-а — числата преди запис, в прегледа след запис и съхранените в базата съвпадат точно. Закръглянето е изрично half-up (счетоводната норма): напр. 0.63 с ДДС 20% дава нето 0.53. Преди backend-ът ползваше подразбиращото се банкерско закръгляне (half-even), което при половин стотинка даваше различен резултат.",
      },
      {
        type: "improvement",
        text: "Редовете на фактурата преди запис (InvoiceCreateModal) вече се показват без ДДС (нето), консистентно с прегледа след запис — преди се виждаха с включено ДДС и създаваха разминаване с обобщението. Таблицата за издаване добавя отделни колони „Ед. цена“ (нето), „Сума на ДДС“, „Сума“ (нето) и „Сума с ДДС“ (бруто), за да се вижда разбивката на всеки ред.",
      },
      {
        type: "improvement",
        text: "Прегледът на готовата фактура (InvoicePreviewModal) добавя колона „ДДС %“ със ставката на всеки ред (9%, 20% …), по аналог с класическия POS формуляр.",
      },
    ],
  },
  {
    version: "0.0.106",
    date: "2026-06-03",
    entries: [
      {
        type: "feature",
        text: "Справки → История на операциите: бутонът „Фактуриране“ вече отваря стъпка за избор на сметки преди InvoiceCreateModal, по аналог с модул Маркиране. Позволява фактуриране на една или повече нефактурирани затворени сметки, затворени през последните 5 дни; сметката, от която е натиснат бутонът, е пред-избрана. Нов hook useInvoiceableBills (closed + not invoiced + closed_at в 5-дневния прозорец) и нов InvoiceBillPickerModal; самата логика на фактуриране и downstream модалите остават непроменени.",
      },
      {
        type: "improvement",
        text: "Backend CLAUDE.md — документацията за разработка е сверена 1:1 с кода и обновена: пълен списък на feature модулите в app/features (добавени audit_logs, companies, customers, invoices) и app/external (премахнат празният stations пакет), реалните таблици по двете бази, целият списък с environment променливи и default стойностите им (JWT, lockout, MQTT, CORS, Sentry, timezone), отбелязан вторият middleware AuditLogMiddleware и опционалността на DATABASE_READONLY_URL.",
      },
      {
        type: "improvement",
        text: "Frontend CLAUDE.md — документацията е сверена с кода и обновена: поправено твърдението за pages/ (auditLog и changelog нямат components/ подпапка), допълнен tech stack-ът с реално ползваните Sentry, Framer Motion и xlsx, описана PWA реализацията (статичен manifest.json без vite-plugin-pwa, InstallBanner + useInstallPrompt) и runtime конфигурацията през public/config.js, изброени реалните файлове в lib/ и utils/.",
      },
    ],
  },
  {
    version: "0.0.105",
    date: "2026-06-02",
    entries: [
      {
        type: "feature",
        text: "Нов бутон „Премахни отстъпка“ в модала за отстъпка на продукт — показва се само когато артикулът вече има активна отстъпка. Появява се над футъра като flat danger-tinted бутон и вика новия endpoint за премахване на item-level отстъпка. Преди единственият начин да се махне отстъпка от продукт беше да се сторнира целият артикул.",
      },
      {
        type: "feature",
        text: "Timeline-ът на „История на операциите“ вече рендерира събитие „Премахване на отстъпка“ (discount_remove) с червен MinusCircle badge. Преди премахването на отстъпка не оставяше следа в timeline-а — виждаше се само apply-ът.",
      },
      {
        type: "improvement",
        text: "Item-level отстъпки (apply / remove) в timeline-а показват процента inline пред името на продукта в мono-виолетов цвят, на същия ред с qty × price и общата сума. Премахнат е дублиращият подред с процент. Bill-level отстъпките запазват подреда с процент + клиент, тъй като нямат item ред над който да се показват.",
      },
      {
        type: "improvement",
        text: "Headline-ите на отстъпки в timeline-а правят разлика между item-level и bill-level: „Отстъпка върху продукт“ vs „Отстъпка върху сметката“ (същото и за премахване). Backend-ът подава нов is_item_level флаг в event payload-а.",
      },
      {
        type: "improvement",
        text: "Всеки ред в timeline-а носи цялото описание в цветния badge (напр. „Отстъпка върху продукт“, „Отваряне на маса 99“) и премахнатия отделен headline до него. Опционалният sub-line запазва контекстния детайл — причина за сторно, продължителност, разпределение на плащане, клиент, сектор.",
      },
      {
        type: "fix",
        text: "Процентите на отстъпки вече се рендерират с десетична точност — преди toFixed(0) закръгляше 15.5% до 16%.",
      },
      {
        type: "fix",
        text: "Фактурата вече игнорира split-out placeholder редове на оригиналната сметка. При разделяне BE-ът оставя дубликат-item (is_split=true, split_from_bill_id=null) за преместените продукти; без филтър фактурата събираше и тях и излизаше с цялата оригинална сума вместо реалния остатък след split.",
      },
      {
        type: "fix",
        text: "Audit log /audit-log: на голям екран търсачката и toggle-ът за GET вече са плътно в ляво, а DatePicker-ът в дясно (преди трите контрола бяха центрирани заедно). Текстът „50 / page“ в pagination footer-а вече е вертикално центриран на същата линия с номерата на страниците — глобалното правило `.ant-select-single { height: 40px }` го избутваше нагоре с 6px.",
      },
    ],
  },
  {
    version: "0.0.104",
    date: "2026-06-02",
    entries: [
      {
        type: "feature",
        text: "Нов модал „История на операциите“ — отваря се при клик на ред в Справки → История на маси / Сторно / Отстъпки. Представя пълния жизнен цикъл на сметката като хронологичен timeline с 8 типа събития: Отваряне на маса, Добавяне на артикул, Разделяне на сметка (входящо/изходящо), Сторно, Отстъпка, Плащане, Затваряне на маса. Заменя стария BillDetailsModal на трите места без триене на стария файл.",
      },
      {
        type: "feature",
        text: "Нов backend ендпойнт GET /bills/{id}/operations — връща структуриран event stream, summary с 5 показателя (Брутен/Сторнирано/Отстъпки/Прехвърлено/Финален оборот) и BillBrief. Изграден изцяло от съществуващи domain таблици (bills, bill_elements, cancellations, discount_applied), без миграции.",
      },
      {
        type: "feature",
        text: "Table-style timeline с 5 колони (ЧАС / иконка / ОПЕРАЦИЯ / ПРОМЯНА / БАЛАНС): всеки ред има цветно-кодиран badge + headline + sub-line + user avatar chip (инициали + име + #id). Прогрес бар под „Баланс“ показва пропорцията на текущия баланс спрямо пика в timeline-а — визуално напълване на сметката.",
      },
      {
        type: "feature",
        text: "Цветова палитра по тип събитие — зелено за Отваряне и Плащане, амбър за Добавяне на артикул, синьо за Разделяне (различава го ясно от добавянето), червено за Сторно (целият ред е с лек червен фон), виолетово за Отстъпка, сив slate за Затваряне. Status pill горе вдясно е „Затворена · X мин“ в slate за приключени сметки.",
      },
      {
        type: "feature",
        text: "Summary cards с math-closed формула: Брутен = Финален + |Сторнирано| + |Отстъпки| + |Прехвърлено|. Брутен включва всички редукции (тоест „originally“ оборот), Финален е реално платеното (= активни несторнирани items). Всеки междинен ред намалява visually брутния до финалния.",
      },
      {
        type: "feature",
        text: "Split chip-ове „A → B“ показват името на маса дестинация/източник; ако сервитьорът на другата сметка е различен от сервитьора на текущата, името му се изписва в десно от chip-овете. Когато split-ът е 100% (нищо активно не остава) — badge-ът става „Прехвърляне на маса“ със синя hue.",
      },
      {
        type: "feature",
        text: "Footer бутони (само за History/Cancellations/Discounts контекст): „Сторнирай всичко“ — активен само ако има активни items; „Възстанови“ — активен само ако сметката е затворена И има сторнирани items; „Фактуриране“ — активен само ако сметката е затворена, не е фактурирана и е в 5-дневния прозорец. Фактурирането ползва съществуващия InvoiceCreate/Preview workflow.",
      },
      {
        type: "improvement",
        text: "Едно действие на Разделяне = 1 ред в timeline-а, независимо колко продукта или различни оригинални order_times засяга. Преди едно split действие, което местеше items от 5 различни поръчки, показваше 5 отделни реда; сега се групира в 1 ред с всички items.",
      },
      {
        type: "improvement",
        text: "Часът на split събитието вече е реалното време на разделянето (от bill.created_at на дестинацията), а не наследеният оригинален order_time на премествания продукт. Преди продукт поръчан в 10:00 и разделен в 11:00 се показваше в timeline-а с час 10:00; сега в 11:00.",
      },
      {
        type: "fix",
        text: "Брутен оборот вече се изчислява правилно като оригиналната стойност преди редукциите. Преди показваше pos-discount стойност и summary math-ът даваше грешен Финален (-19.00 при сметка със split + сторно + отстъпка). Сега формулата е math-closed и Финален съвпада с реално платеното.",
      },
      {
        type: "fix",
        text: "Split_out events не вадят от running balance — BE прави COPY на items в дестинацията (а не MOVE), оригиналите остават в нашата сметка. Преди running balance отиваше в минус след split; сега завършва точно на платената сума.",
      },
      {
        type: "fix",
        text: "Discount_apply event е informational (change=0) — item.total_sum идва от BE-то вече post-discount, затова отделното изваждане на отстъпката от баланса беше двойно. Същото за trace bill_elements (дубликати от split) — изключени от всички сборове.",
      },
      {
        type: "improvement",
        text: "Модалът refetch-ва при всяко отваряне (staleTime: 0, gcTime: 0, refetchOnMount: „always“). Преди първоначалното извикване се кешираше за 30 сек и при промени в сметката (добавяне/сторно отвън) повторното отваряне показваше стари данни до изтичане на cache-а.",
      },
      {
        type: "improvement",
        text: "Иконка за Плащане е EuroOutlined (€) — универсална за всички видове плащане (в брой/карта/банка/смесено), вместо предишната CreditCardOutlined която подсказваше само карта.",
      },
      {
        type: "improvement",
        text: "Бутонът „Възстанови“ има отделен гейт от „Сторнирай всичко“ — активен само за затворени сметки с поне 1 сторниран item. Преди двата бутона ползваха общо условие, което позволяваше възстановяване и на отворени сметки.",
      },
      {
        type: "improvement",
        text: "Секундите участват в хронологичното сортиране на event-ите, но не се показват визуално. Така две операции в една и съща минута се появяват винаги в правилен ред, без да трупат шум в UI-я.",
      },
    ],
  },
  {
    version: "0.0.103",
    date: "2026-06-01",
    entries: [
      {
        type: "feature",
        text: "Нов администраторски модул „Дневник на действията“ (/audit-log) — достъпен само за потребител с id=1 (admin), не присъства в навигацията. Регистрира всяко HTTP действие на оператор/админ в нова audit_logs таблица: timestamp, user, HTTP метод, path, status code, latency (ms), плюс контекст за bills заявките (bill_id + snapshot на името на масата в момента на действието).",
      },
      {
        type: "feature",
        text: "Audit log обхваща почти целия backend — 81 ендпойнта в 13 модула: Bills (отваряне/затваряне/сторно/разделяне/отстъпки/възстановяване), Касови операции (X/Z отчет, внасяне/изваждане), Отчети (персонални + на заведението + analytics), Фактури, Монитори, Клиенти, Конфигурация, Cleanup, Начини на плащане, Фирми, Устройства, Достъп, Потребители (вход/изход/проверка на парола), Меню. Извън са само WebSocket-ите, самият audit log, /health и FastAPI auto-docs.",
      },
      {
        type: "feature",
        text: "Лейбли на операциите на български, унифицирани с имената от sidebar-а — напр. „Преглед на История на маси“, „Преглед на Дашборд“, „Преглед на Справка по сервитьори“, „Издаване на фактура“, „Сторниране на продукт“, „Разделяне и плащане“, „Z отчет“, „Внасяне в касата“. POST /bills се детайлизира на „Нова сметка“ vs „Добавяне към сметка“ според billId в body-то.",
      },
      {
        type: "feature",
        text: "Таблица със сортиране, pagination (25/50/100/200), per-column филтри (Операция / Метод / Потребител / Статус), search bar по всички полета и date range picker. По подразбиране GET заявките са скрити (filter switch „Покажи прегледи (GET)“) — намалява шума с ~80%, тъй като read endpoint-и се викат автоматично по много пъти на сесия.",
      },
      {
        type: "feature",
        text: "Клик на ред отваря Detail модал с пълните данни за заявката, подредени по HTTP спецификация в 2×2 grid: ЗАЯВКА · Headers, ЗАЯВКА · Query string, ЗАЯВКА · Body, ОТГОВОР · Body. Всяка клетка е markdown-style code block с независим scroll, бутон „Копирай“ (към clipboard) и toggle { } / — (pretty-printed vs single-line raw JSON).",
      },
      {
        type: "improvement",
        text: "Detail модал е responsive — 2×2 grid на tablet/desktop, 1×4 stacked + scroll на narrow (<640px). Section titles („ЗАЯВКА · HEADERS“) не wrap-ват при тесни клетки. Модалът е 1440px на desktop, 920px на tablet, full-bleed на phone.",
      },
      {
        type: "improvement",
        text: "Filter card e responsive в три режима: ≥1024 (desktop) — search + switch + datepicker inline на един ред; 640–1023 (tablet) — search + switch на ред 1, datepicker на ред 2, всичко центрирано; <640 (narrow) — всеки контрол на свой ред, центриран. Switch използва brand orange цвят (не default antd син).",
      },
      {
        type: "security",
        text: "Detail модалът не съхранява чувствителна информация: HTTP хедъри Authorization / Cookie / Set-Cookie / X-Api-Key / Proxy-Authorization се записват като *** в audit log-а; body полета password / current_password / new_password / token / access_token / refresh_token / jti / secret / api_key се scrub-ват рекурсивно. Защитата е на backend ниво, преди insert в БД-та.",
      },
      {
        type: "improvement",
        text: "Storage защита — request/response body-та се capнат на 10 KB; ако payload-ът е по-голям, се записва само маркер с оригиналния размер и UI-ят показва съответен warning банер. /menu/ response (1MB+) изобщо не се запазва, тъй като би натрупало storage без бизнес стойност.",
      },
      {
        type: "improvement",
        text: "Audit log endpoint-ите са защитени на 3 нива: route guard в UI-я (redirect към / ако user.id !== 1), filter hook disabled за non-admin, и backend dependency 403 Forbidden за всички 3 ендпойнта (list / filters / detail). Дори при директна заявка с user token без admin права — 403.",
      },
      {
        type: "improvement",
        text: "Pagination styling — изравнен page-size селектор (28px height) с останалите items, активната страница е в brand tint, hover състоянията тонирани. Page item-ите са rounded 8px.",
      },
      {
        type: "feature",
        text: "Backend документация: нов файл docs/AUDIT_LOG_COVERAGE.md описва всеки backend ендпойнт и дали се логва (с BG operation label), плюс кратко обяснение защо непокритите са извън (websocket, self-reference, k8s probe, FastAPI auto-generated).",
      },
    ],
  },
  {
    version: "0.0.102",
    date: "2026-05-28",
    entries: [
      {
        type: "feature",
        text: "Печат на фактура → реална многостранична подредба: при натискане на „Печат“ paper-ът се изважда от центрирания Ant Modal и flow-ва в body, така че Chrome пагинира коректно при дълги фактури. Заглавието на PDF/print диалога вече предлага „invoice-{номер}“ вместо URL-а на текущата страница.",
      },
      {
        type: "feature",
        text: "Брандинг ред в дъното на отпечатаната фактура: „Този документ е отпечатан от софтуер на фирма ЪнриълСофт ООД — www.unrealsoft.bg“. Никога не се изолира на собствена страница (page-break-before: avoid).",
      },
      {
        type: "improvement",
        text: "Печат: на всяка отпечатана страница се резервира 16mm горно поле (table-thead spacer трик), за да не залепя продължението на съдържанието за горния ръб на 2-та, 3-та и т.н. страница. Без браузърски header/footer (URL, дата, page numbers) — @page margin остава 0.",
      },
      {
        type: "feature",
        text: "Анулиране на фактура от справката за фактури: нов червен бутон „Анулирай“ в preview модала (само от справките, не от Маркиране), с потвърждение „Сигурни ли сте, че искате да анулирате фактура с № …?“. Анулираните фактури показват голям полупрозрачен стикер „АНУЛИРАНА“ върху документа (и в preview, и в print), а в таблицата на справката номерът се рендира в червено със strikethrough.",
      },
      {
        type: "improvement",
        text: "Анулирана фактура освобождава своите сметки за повторно фактуриране — backend-ската проверка „вече фактурирана сметка“ игнорира анулирани фактури.",
      },
      {
        type: "feature",
        text: "Бутон „Печат на дубликат“ в preview модала (само от справките): втори print бутон със същата логика, но временно превключва заглавието на документа от „ФАКТУРА ОРИГИНАЛ“ на „ФАКТУРА ДУБЛИКАТ“ за времетраенето на печата. Скрит при опростена фактура.",
      },
      {
        type: "feature",
        text: "Фактури — снапшот на оператор: backend-ът запазва името на потребителя, издал фактурата (created_by_name), и UI-ят го показва в полето „Съставил“ вместо името на фирмата.",
      },
      {
        type: "improvement",
        text: "Фактура — оформление на print/preview: чисто скриване на браузърските header/footer през @page margin: 0; адресът на получател/изпълнител е inline до етикета „Адрес:“ с естествен word-wrap; колоните Получател/Изпълнител са разделени с column-gap, за да не залепват един за друг текстове; при попълнени банкови данни на фирмата се показват „Банка / BIC / IBAN“ под МОЛ в колоната „Изпълнител“.",
      },
      {
        type: "improvement",
        text: "Фактура — суми и ДДС етикети: артикулите се показват с цени БЕЗ ДДС в print/preview; редовете в обобщението сега са разбити по ДДС група — отделни „Дан. основа (X%)“ и „ДДС (X%)“ за всяка ставка (напр. 9% + 20%); „Облагаема сума“ → „Дан. основа“; „Обща стойност“ запазва „(EUR)“.",
      },
      {
        type: "improvement",
        text: "Обобщено в един ред (в InvoiceCreateModal) сега групира по ДДС ставка — ако продуктите са в няколко ДДС групи, се получава по един обобщен ред на група, а не един общ с осреднена ставка.",
      },
      {
        type: "feature",
        text: "Справки → История на маси: нов pill-style чекбокс „Само с фактура“ до останалите филтри (status / плащане / сервитьор). По подразбиране изключен. При включване — показва само сметки, които вече са във фактура (преизползва съществуващия in_invoice филтър на /bills/history). Влиза в „Изчисти филтри“.",
      },
      {
        type: "feature",
        text: "Справки → Фактури: нов pill-style чекбокс „Само анулирани“ до търсачката. Client-side филтър по cancelled_at; интегриран с hasActiveFilters / clearFilters.",
      },
      {
        type: "fix",
        text: "Справки → Фактури: input-ът за търсене вече е с правилна височина (40px) — преди беше прекалено висок заради двойно прилагане на min-height и padding в .inv-scope.",
      },
    ],
  },
  {
    version: "0.0.101",
    date: "2026-05-27",
    entries: [
      {
        type: "feature",
        text: "Права — Конфигурация: всеки подраздел (Монитори, Устройства, Нефискален дисплей, Видове плащане, Фирми) има собствено право и се скрива от страничното меню, ако ролята не го притежава. Прякото отваряне на URL също е защитено — AuthorizedRoute вече приема requiredPermissionName и блокира маршрута, ако правото липсва.",
      },
      {
        type: "feature",
        text: "Права — Справки: страничното меню в /reports се филтрира по право за всеки отделен отчет (view_*). При смяна на роля или премахване на право, ако текущо отвореният отчет вече не е разрешен, изборът автоматично се префиксва към първия разрешен — защита и за state-базираната навигация, която няма URL guard.",
      },
      {
        type: "improvement",
        text: "Глобален toast при 403 от заявки: queryCache на React Query слуша за неуспешни заявки и при 403 показва локализирано съобщение („Нямате необходимото право“ / „Missing permission“). Покрива всички useQuery-та наведнъж, без всеки модул да дублира error handler. Реализирано през messageBridge, който пази App.useApp().message instance-а и буферира извикванията до монтиране на portal-а.",
      },
      {
        type: "improvement",
        text: "Грешки от backend-а сега се показват като toast в Маркиране, вместо да остават мълчаливи или общи: отказ на ред (TableFooter), отстъпки по продукт (ItemDiscountModal), клиенти по ред (ClientsModal), затваряне на празна сметка, прехвърляне на сервитьор, разделяне на сметка (SplitBillModal), операции с маса (OperationsModal). Toast-ът чете response.data.detail и пада на общо съобщение, ако backend-ът не върне специфично.",
      },
      {
        type: "improvement",
        text: "Грешки от backend-а в Конфигурация: модалите за устройства и за нефискален дисплей вече показват точното съобщение от сървъра при неуспешен запис, вместо генерично „Грешка при запис“.",
      },
      {
        type: "improvement",
        text: "Axios interceptor: 403 без backend detail вече се локализира на езика на потребителя („Нямате необходимото право“ / „Missing permission“), вместо да оставя суров текст от сървъра.",
      },
      {
        type: "fix",
        text: "SplitBillModal: error handler-ът четеше грешен ключ от response-а и пропускаше backend detail. Сега визуализира коректното съобщение при неуспешно разделяне на сметка.",
      },
    ],
  },
  {
    version: "0.0.99",
    date: "2026-05-22",
    entries: [
      {
        type: "breaking",
        text: "Меню: „заключена цена“ вече е на ниво меню, а не на ниво продукт. Колоната locked_price е преместена от items в junction таблицата menu_items, така че един и същ артикул може да е със заключена цена в едно меню (напр. „Обедно меню“) и с отключена в друго („Вечерно меню“). /menu връща lockedPrice от менюто с най-висок приоритет за ресторанта.",
      },
      {
        type: "fix",
        text: "Поправен 500 на GET /menu — ORM моделът Item все още описваше вече несъществуваща колона items.locked_price, което чупеше всяко зареждане на менюто.",
      },
      {
        type: "improvement",
        text: "Маркиране → долна лента: при избран ред със заключена цена бутонът „Клиенти“ вече не отваря модала, а показва нотификация „На този продукт не може да се присвои клиент — заключена цена.“ Същата защита вече съществуваше за „Отстъпки“ и сега покрива и присвояването на клиент.",
      },
      {
        type: "improvement",
        text: "Сметки: при създаване и добавяне към сметка locked_price на реда се взима директно от payload-а на клиента (както и цената), вместо от вече остарелия глобален флаг в items. Снапшотът остава върху bill_element_items, така че последващи промени в менюто не засягат вече откритите сметки.",
      },
    ],
  },
  {
    version: "0.0.98",
    date: "2026-05-21",
    entries: [
      {
        type: "feature",
        text: "Права — ново право „invoicing“ (Фактуриране). Бутонът „Фактуриране“ в долната лента на Маркиране (/ordering) се показва само на роли с това право; ако ролята го няма, бутонът се скрива напълно, както и останалите permission-gated бутони там.",
      },
    ],
  },
  {
    version: "0.0.97",
    date: "2026-05-21",
    entries: [
      {
        type: "feature",
        text: "Конфигурация → Фирми: нов екран за управление на фирмите на търговеца. Поддържа добавяне, редакция и изтриване на фирми, валидация на ЕИК / ДДС № / IBAN / BIC, маркиране на фирма по подразбиране, начален номер на фактура и проформа, банкови сметки с банка по подразбиране.",
      },
      {
        type: "feature",
        text: "Клиенти (получатели на фактура): нова доменна функция — фирмата запомня кой човек обикновено получава фактурата (last_received_by), което автоматично попълва полето при следваща фактура за същия клиент.",
      },
      {
        type: "feature",
        text: "Маркиране → Фактуриране: цялостен поток за издаване на фактура. Избор на сметки за фактуриране, модал за редакция на редове и обобщение, snapshot на доставчик и получател в момента на издаване (за правна неизменност), автоматично преглеждане след запис.",
      },
      {
        type: "feature",
        text: "Преглед на фактура: модал с печатна визия (получател, изпълнител, артикули, сума с думи на български, банкови сметки, методи на плащане). Печатът сваля целия app chrome и оставя само листа.",
      },
      {
        type: "feature",
        text: "Справки → Фактури: нов отчет, който показва издадените фактури с филтри по дата и търсене по номер / получател / ЕИК. Две bento KPI карти за оборот и ДДС разбивка. От реда се отваря същият преглед на фактурата.",
      },
      {
        type: "feature",
        text: "История на маси → детайл на сметка: трети бутон „Фактуриране“. Издава фактура за затворена сметка през последните 5 дни. Предупреждение, ако сметката е затворена преди повече от 5 дни или вече има издадена фактура за нея.",
      },
      {
        type: "improvement",
        text: "Конфигурация → Фирми: премахнат превключвателят „Отделна номерация на фактурите“. Полетата за начален номер фактура / проформа се показват винаги, всяка фирма има собствен брояч (per-фирма уникалност в backend-а). Колоната „Режим на номерация“ в таблицата е премахната, защото вече няма какво да разграничава.",
      },
      {
        type: "improvement",
        text: "Конфигурация → Фирми: модалът минава на една колона още от таблет надолу, разширен е на по-широки екрани, и IBAN-ите в банковата таблица се рендерират на един ред с групиране на 4 знака (вместо да се чупят по цифри).",
      },
      {
        type: "improvement",
        text: "Конфигурация → Фирми: пребалансирани ширини на колоните в таблицата — името вече не доминира над останалите.",
      },
      {
        type: "improvement",
        text: "Модал Издаване на фактура: полетата с allowClear (Получил, ДДС № и др.) са изравнени по височина с DatePicker / Select. Премахната е тънка бяла ивица под header-а на таблицата в справка Фактури.",
      },
      {
        type: "improvement",
        text: "Backend: нов единен шаблон за локализирани грешки (LocalizedError) — всички грешки от Фирми / Клиенти / Фактури връщат двуезичен detail (bg + en), който frontend-ът пише в зависимост от избрания език.",
      },
      {
        type: "improvement",
        text: "Backend → /bills/history: добавени филтри in_report и in_invoice (за да скрие сметки, които вече са в отчет или фактура от потока на Фактуриране), и поле is_invoiced на всеки ред, което позволява UI-я да блокира повторно фактуриране без допълнителна заявка.",
      },
      {
        type: "improvement",
        text: "Backend → /bills/history и /reports: scope правилото е унифицирано — admin (id=1) вижда сметките на всички, всеки друг потребител вижда само своите.",
      },
    ],
  },
  {
    version: "0.0.95",
    date: "2026-05-11",
    entries: [
      {
        type: "improvement",
        text: "Маркиране — в десния панел с продуктите на избраната сметка подредбата е обърната: най-старо поръчаният продукт е най-отгоре, последно добавеният — най-отдолу.",
      },
      {
        type: "improvement",
        text: "Маркиране — на широк екран (когато всички бутони на долната лента са видими) бутонът 'Закрий' е преместен на трета позиция, веднага след 'Добави', преди вторичните действия.",
      },
    ],
  },
  {
    version: "0.0.93",
    date: "2026-05-11",
    entries: [
      {
        type: "fix",
        text: "Маркиране - оправен е проблема с коментара към продукт, който не се показваше в Мониторите и в Pos принтерите. Сега коментарите се рендерират правилно в тези места, като се взимат от modifiers с modifier_id = текст на коментара.",
      },
    ],
  },
  {
    version: "0.0.92",
    date: "2026-05-08",
    entries: [
      {
        type: "feature",
        text: "Маркиране — нова секция 'Коментар' в модала Промени, под модификаторите. Текстът се пази на ниво продукт (две идентични позиции с различни коментари остават отделни редове), показва се в Прегледа на поръчката редом с модификаторите и се изпраща към backend-а като допълнителен запис в modifiers (modifier_id = текстът на коментара).",
      },
      {
        type: "feature",
        text: "Справки — Личен отчет и Отчет на заведение: разбивката по плащания (payment_breakdown) се рендерира динамично от backend-а — няма твърдо закодирани методи. Премахнати са колоните 'Сам' / 'Бригада'; стойностите идват в стотинки и се форматират в левове.",
      },
      {
        type: "feature",
        text: "Справки (Backend) — endpoint-ите /preview и /get-by-id за Личен и Заведение отчет връщат нов списък payment_breakdown с всички активни методи на плащане (плюс исторически методи, по които има сметки в обхвата). Сметките със смесено плащане (pm_id=3) се разпределят пропорционално между 'В брой' и 'С карта', за да съвпадат с агрегатите.",
      },
      {
        type: "feature",
        text: "Справки — след нулиране на отчет (Z-отчет) се отваря нов модал за потвърждение на печат към POS принтера, в Личен и в Отчет на заведение.",
      },
      {
        type: "improvement",
        text: "Справки — потвърждението за нулиране на Z-отчет е със скъсен и по-ясен текст (BG + EN).",
      },
      {
        type: "feature",
        text: "Backend — поддръжка за downgrade на версии. Досега системата изпълняваше само upgrade миграции; вече може да се връща към по-стара версия с автоматично прилагане на обратните стъпки.",
      },
      {
        type: "feature",
        text: "Backend — нулиране на база: ново действие, което изчиства работните таблици (сметки, поръчки, отчети и свързаните оперативни данни), без да пипа конфигурацията — устройства, потребители, методи на плащане, меню и права остават.",
      },
    ],
  },
  {
    version: "0.0.91",
    date: "2026-05-07",
    entries: [
      {
        type: "feature",
        text: "Справки — в долната лента на Преглед на отчета е добавен бутон 'Печат от браузъра' за Личен и Отчет на заведение.",
      },
      {
        type: "improvement",
        text: "Справки — заглавието на ресторанта в отчетите вече се взима от полето restaurant_display_name, върнато от /user/info.",
      },
    ],
  },
  {
    version: "0.0.90",
    date: "2026-05-07",
    entries: [
      {
        type: "feature",
        text: "Справки — печат на Личен отчет и на Отчет на заведение: нови действия за изпращане към принтера директно от модалите за преглед, с пълен превод BG/EN.",
      },
      {
        type: "feature",
        text: "Backend — endpoint-ът /user/info връща ново поле display_name за ресторанта, което фронтът ползва в заглавията на отчетите.",
      },
    ],
  },
  {
    version: "0.0.89",
    date: "2026-05-07",
    entries: [
      {
        type: "breaking",
        text: "Конфигурация / Устройства — типът 'POS терминал' е преименуван на 'POS принтер' навсякъде в UI и преводите.",
      },
      {
        type: "feature",
        text: "Конфигурация / Устройства — POS принтерите вече могат да са закачени към 'Станции' (4-та секция в модалите за създаване и редакция, видима само при тип POS). Работни точки и Станции могат да са празни, стига поне една от двете да е попълнена.",
      },
      {
        type: "improvement",
        text: "Конфигурация / Устройства — таблицата вече показва списъците с потребители и станции като компактен брояч (pill с tooltip) вместо разлят текст, така че редовете не се разтягат при много записи.",
      },
      {
        type: "feature",
        text: "Backend — нов kitchen_handler за рутиране на кухненски поръчки и сторно на артикули към ESC/POS кухненски/бар принтери през MQTT. Поръчките се групират по station_id, добавки през друга станция получават собствен талон с parent_ref, а идемпотентността е гарантирана с детерминистичен request_id hash.",
      },
      {
        type: "feature",
        text: "Backend — печат на Личен и Заведение отчет през MQTT: нови payload builder-и, FiscalAPI топици fiscal/{guid}/print/report_personal и .../report_establishment, и обновена MQTT/reports документация.",
      },
    ],
  },
  {
    version: "0.0.88",
    date: "2026-05-04",
    entries: [
      {
        type: "improvement",
        text: "Конфигурация на устройство — Създаване: секцията 'Методи на плащане' е премахната от формата за ново устройство. Всички типове устройства показват едни и същи полета (Име, Тип, Работни точки); настройката на стойностите за методите се прави след създаване — в Редакция.",
      },
      {
        type: "improvement",
        text: "Конфигурация на устройство — Редакция: модалът е по-широк, с двуколонна подредба на десктоп — секциите Име/Тип/Работни точки са отляво, а 'Методи на плащане' стои отдясно като отделен панел.",
      },
      {
        type: "feature",
        text: "Конфигурация на устройство — Методи на плащане: стойността вече се избира от dropdown със слотовете на фискалния драйвер (полето paymentTypes от устройството). Показват се само конфигурираните слотове, лейбълът е името от драйвера, а в базата се записва символът на слота. Когато устройството няма paymentTypes, полето остава текстов вход (както досега).",
      },
      {
        type: "improvement",
        text: "Смесено плащане (id=3) — показва се само когато на устройството са конфигурирани едновременно 'В брой' (id=1) и 'С карта' (id=2). Ако backend-ът не върне id=3 в активния списък, frontend-ът го синтезира от мастър списъка. Старата логика, която показваше id=3 само ако има самостоятелна стойност, е премахната — важи и в Закриване, и в 'Раздели и плати'.",
      },
      {
        type: "improvement",
        text: "Конфигурация на устройство — Методи на плащане: 'Смесено' (id=3) вече не се показва в редакцията. Това е изчислен метод, който се извежда от наличието на В брой и С карта.",
      },
      {
        type: "breaking",
        text: "Конфигурация на устройство — Методи на плащане: премахната проверката за уникалност на стойностите. Два различни метода (например на едно или на различни устройства) вече могат да имат еднаква стойност — червената рамка и блокирането на submit при дубликати са премахнати.",
      },
    ],
  },
  {
    version: "0.0.87",
    date: "2026-05-04",
    entries: [
      {
        type: "fix",
        text: "Reports — списъкът по дата вече работи коректно. Endpoints GET /reports и GET /reports/establishment/list интерпретираха date_from/date_to като UTC, което изместваше резултатите с 2–3 часа: отчети от рано сутрин не се показваха за избрания ден, а отчети от късна вечер попадаха в следващия. Сега naive datetime стойностите се третират като локално време, така че date_from=2026-05-04 00:00:00 & date_to=2026-05-04 23:59:59 връща точно отчетите за този ден по местно време.",
      },
    ],
  },
  {
    version: "0.0.86",
    date: "2026-05-01",
    entries: [
      {
        type: "improvement",
        text: "Конфигурация на устройство — Методи на плащане: стойността вече приема комбинация от букви и/или цифри (до 10 знака), не само цели числа. Празно поле = методът не се ползва на устройството; дублирани стойности продължават да се блокират.",
      },
    ],
  },
  {
    version: "0.0.85",
    date: "2026-04-30",
    entries: [
      {
        type: "feature",
        text: "Видове плащания — нов подмодул в Конфигурация: добавяне, преименуване и изтриване на собствени методи на плащане. Системните методи (1–4) са заключени — на тях може да се сменя само подредбата.",
      },
      {
        type: "feature",
        text: "Нов системен метод 'По сметка' — четвърта системна опция за плащане.",
      },
      {
        type: "feature",
        text: "Подредба на методите на плащане — всеки метод има поле 'Подредба' (sort index), което определя реда му в касовия модул и в админ панела.",
      },
      {
        type: "feature",
        text: "Конфигурация на устройство — Методи на плащане: за всяко устройство (фискален принтер, POS принтер, терминал) може да се зададе уникална стойност (код) за всеки активен метод. Например на принтер 1 — 'В брой' = 1, 'Карта' = 2; на втори принтер — друг ред.",
      },
      {
        type: "feature",
        text: "Подразбиращо се скриване — ако даден метод няма зададена стойност за устройство, се счита за изключен и не се показва като опция в касовия модул.",
      },
      {
        type: "feature",
        text: "Активни методи спрямо устройство — в касовия модул се показват само методите, конфигурирани за устройствата на текущия акаунт. Нов endpoint GET /payment-methods/active връща точно филтрирания списък.",
      },
      {
        type: "feature",
        text: "Споделен акаунт + личен код — при влизане през общ/споделен акаунт и след това отваряне на личен профил с код, всички печатни операции (закриване, повторен печат, сторно, X/Z отчет, служебно въвеждане/извеждане, разделяне с плащане) ползват принтера на общия акаунт. При директен личен login принтерът остава на личния — както досега.",
      },
      {
        type: "feature",
        text: "Филтриране на сметки по дата на затваряне — в GET /bills/history има нов параметър date_field със стойности created_at (по подразбиране) или closed_at, за да се търсят сметки в период по момента на тяхното приключване.",
      },
      {
        type: "feature",
        text: "Закриване / Раздели и плати — опцията 'По сметка' се показва само ако сметката има избран клиент. При избор не се отпечатва фискална бележка (изпраща се обща сума 0). Заменя стария трик 'три клика върху В брой' за този метод.",
      },
      {
        type: "feature",
        text: "Конфигурация на устройство — Методи на плащане: дублирани стойности между методите се маркират с червена рамка и съобщение под полето; submit е блокиран, докато не се оправят.",
      },
      {
        type: "improvement",
        text: "Разделяне на сметка — клиентът от изходната сметка автоматично се прехвърля в новата сметка.",
      },
      {
        type: "improvement",
        text: "Автоматично почистване — при изтриване на устройство или метод на плащане свързаните настройки се освобождават автоматично, без ръчно поддържане.",
      },
      {
        type: "fix",
        text: "Възстановяване на сметка — прозорецът работи коректно и при сметки с име от букви/цифри. Преди името се отрязваше от кръгла иконка с фиксиран размер; сега името стои като заглавие на реда, с автоматично подрязване и tooltip при дълги имена.",
      },
      {
        type: "improvement",
        text: "Възстановяване на сметка — по подразбиране се търсят сметки, затворени през последните 2 часа, групирани в секции 'до 30 / 30–60 / 60–120 минути'. Една и съща сметка не може да се появи в повече от една група.",
      },
      {
        type: "improvement",
        text: "Възстановяване на сметка — филтрирането в този екран е по момента на закриване на сметката, а не по момента на отваряне.",
      },
      {
        type: "improvement",
        text: "Възстановяване на сметка — прозорецът зарежда данни само когато е отворен (преди се извикваше при всяко влизане в 'Маркиране').",
      },
      {
        type: "improvement",
        text: "Конфигурация — премахната е пагинацията в таблиците (Устройства, Монитори, Видове плащания) — всички редове се виждат на един екран.",
      },
      {
        type: "improvement",
        text: "Конфигурация — бутоните 'Откажи / Запази' в модалите вече винаги заемат еднакво място (50/50), независимо от устройството — без 'сбутване' вдясно или редене едно под друго на телефон.",
      },
      {
        type: "improvement",
        text: "Конфигурация — стегнат изглед на горната лента на таблиците (без излишни заоблени ъгли).",
      },
      {
        type: "improvement",
        text: "Маркиране — картичка на маса: името на сервитьора е преместено в горния десен ъгъл, така че името на масата стои отделно отдолу.",
      },
      {
        type: "fix",
        text: "Маркиране — на телефон името на сервитьора отново се показва (с подрязване с многоточие при дълги имена); преди беше скрито, за да не чупи layout-а.",
      },
      {
        type: "improvement",
        text: "Маркиране — шрифтът на името на масата е намален леко (от 20px → 17px) за по-добър баланс с общата сума.",
      },
      {
        type: "improvement",
        text: "Закриване / Раздели и плати — когато за устройството няма конфигурирани активни методи на плащане, на мястото на бутоните за избор се показва ясно празно състояние с икона и инструкция 'Добавете и активирайте методи от Конфигурация → Методи на плащане'.",
      },
      {
        type: "fix",
        text: "Конфигурация на устройство — Методи на плащане: вече може да се изчисти въведена стойност, като се въведе 0 или полето се остави празно. Преди формата клампваше към 1 и не позволяваше връщане към 'без стойност'.",
      },
      {
        type: "fix",
        text: "Видове плащания — при въвеждане на нова стойност в полето 'Подредба' водещата нула вече не остава като '02'; полето приема празно, а 0 се записва само при запазване.",
      },
      {
        type: "fix",
        text: "Вход — след успешен вход (вкл. през код или с force-logout) менюто на потребителя се презарежда от сървъра. Изключва ситуация, в която новопоявил се потребител вижда менюто на предходната сесия.",
      },
      {
        type: "improvement",
        text: "Кеш на менюто — свален от 1 час на 5 минути за по-актуални данни.",
      },
      {
        type: "improvement",
        text: "Кеш — при изтриване на устройство автоматично се обновява и списъкът с методи на плащане (тъй като /payment-methods/active зависи от устройствата на акаунта).",
      },
      {
        type: "improvement",
        text: "Кеш — при изтриване на метод на плащане автоматично се обновява и списъкът с устройства (бекендът каскадно чисти device_payment_methods).",
      },
    ],
  },
  {
    version: "0.0.84",
    date: "2026-04-29",
    entries: [
      {
        type: "improvement",
        text: "Нотификации — преработка на всички съобщения (success / error / warning / info / loading) в новия дизайн.",
      },
    ],
  },
  {
    version: "0.0.81",
    date: "2026-04-29",
    entries: [
      {
        type: "improvement",
        text: "Маркиране — Запазване на позицията: по подразбиране най-старата маса е най-отгоре в списъка",
      },
      {
        type: "improvement",
        text: "PWA — банерът за инсталиране се показва само на login страницата, а не във всички модули",
      },
      {
        type: "improvement",
        text: "Маркиране / Монитори — премахнато автоматично активиране на fullscreen при клик върху страницата",
      },
      {
        type: "feature",
        text: "Монитори — поле 'Време за приготвяне' става червено при просрочване; цветът се изключва ако в конфигурацията няма зададени данни (с промени в Backend-а)",
      },
      {
        type: "fix",
        text: "Монитори — ако мониторът не е настроен, нотификацията се взима директно от response-а на заявката",
      },
      {
        type: "fix",
        text: "Конфигурация — модалът за добавяне на монитор не се затваря при клик извън него; затваря се само от 'Отказ'",
      },
      {
        type: "fix",
        text: "Конфигурация — модалът за добавяне на устройство не се затваря при клик извън него; затваря се само от 'Отказ'",
      },
      {
        type: "feature",
        text: "Конфигурация / Монитори — ново поле в конфигурацията на монитора: изпълняване на всички количества от един артикул с един клик (с промени в Backend-а и миграция)",
      },
      {
        type: "improvement",
        text: "Монитори — по-голям шрифт на продуктите без нужда от допълнителна конфигурация",
      },
      {
        type: "improvement",
        text: "Монитори — shortcut стрелките в долната лента се скриват на телефон и таблет",
      },
      {
        type: "feature",
        text: "Монитори — нов 'Инфо' бутон с допълнителна информация и снимка на продукта",
      },
      {
        type: "improvement",
        text: "Маркиране — кликовете за достигане на функция намалени от 5 на 3",
      },
      {
        type: "improvement",
        text: "Маркиране — стрелката '>' в категориите се показва само ако има подгрупа",
      },
      {
        type: "improvement",
        text: "Маркиране — категориите са в 1 колона; реорганизация на екрана с настройка за брой колони на продуктите",
      },
      {
        type: "feature",
        text: "Справки — добавен експорт към Excel",
      },
      {
        type: "feature",
        text: "Справки — TimePicker (избор на час) в 4-те справки с часове (с UI и Backend промени)",
      },
      {
        type: "feature",
        text: "Справки — Справка по асортименти: филтър по артикул със search (с UI и Backend промени)",
      },
      {
        type: "fix",
        text: "Маркиране — при натискане на 'EXPay' с маркирани продукти излиза потвърждение преди изтриване; преди това действието се изпълняваше директно и зачистваше всичко",
      },
      {
        type: "feature",
        text: "Маркиране — F9 shortcut за бутона 'Промени' (модификатори/добавки), за да не е нужно ходене до долното меню с мишка/тъч (както в TouchSale)",
      },
      {
        type: "fix",
        text: "Мобилен изглед — оправен нежелан zoom при клик върху input полета",
      },
      {
        type: "improvement",
        text: "Мобилен UI — общи подобрения и по-ясни текстове, изравнени с останалите модули",
      },
    ],
  },
  {
    version: "0.0.80",
    date: "2026-04-27",
    entries: [
      {
        type: "fix",
        text: "Раздели и плати — цената на всеки артикул и общата избрана сума вече включват и добавките към него. Преди това се показваше само цената на основния продукт без добавките.",
      },
      {
        type: "fix",
        text: "Разделяне на сметка с отстъпка — отстъпката вече се пренася пропорционално към новата сметка. В справката за отстъпки се виждат двата коректни записа (за оригиналната и за разделената сметка), вместо завишена сума на оригинала и липсващ запис за новата.",
      },
      {
        type: "improvement",
        text: "Справка „История на сметки“ — филтрите, сортирането и страниците вече се обработват от сървъра. Това прави справката по-бърза и по-точна при голям обем данни, а обобщението (брой сметки, оборот, среден чек) и графиката за активността отговарят директно на избраните филтри.",
      },
      {
        type: "improvement",
        text: "Възстановяване на сметка — списъкът със затворени сметки се зарежда по-бързо и показва най-скоро затворените най-отгоре.",
      },
    ],
  },
  {
    version: "0.0.77",
    date: "2026-04-24",
    entries: [
      {
        type: "feature",
        text: "Конфигурация на монитори — нова стъпка 'Изглед' в създаване/редакция: избор между 'Решетка' и 'Списък'; стойността се пази в конфигурацията и се показва като нова колона в списъка с мониторите",
      },
      {
        type: "feature",
        text: "Монитори — пълен редизайн на страницата (горна лента, продуктови карти, empty states, layout), съобразен с общия design system",
      },
      {
        type: "feature",
        text: "Монитори — нов 'Списък' изглед: плътна таблица с колони Статус / Маса / Артикул / Време / Количество / (Общо) / Станция / Поръчано, със sticky header и автоматично скролиране към селектирания ред",
      },
      {
        type: "feature",
        text: "Списък изглед — иконка за статус на всеки ред: неначат (⊘), в процес (⚡), изпълнен (✓), сторниран (подпис), разделен (merge)",
      },
      {
        type: "feature",
        text: "Списък изглед — всяка маса получава уникален пастелен фонов цвят (детерминистичен по името), като основен продукт + неговите добавки са маркирани с леко подсилен нюанс за визуално свързване",
      },
      {
        type: "feature",
        text: "Списък изглед — добавките са показани с indent + стрелка '↳', модификаторите като sub-редове под продукта с ⚠ иконка в курсив, без собствен separator",
      },
      {
        type: "feature",
        text: "Списък изглед — сторнираните/разделените редове са с намалена opacity и задраскан текст; не могат да бъдат селектирани",
      },
      {
        type: "feature",
        text: "Списък изглед — при количество > 1 с частично изпълнени бройки се показва прогрес '2 / 5 бр.'; колоната 'Общо' (при 'Групиране') сумира количеството по артикул през всички поръчки",
      },
      {
        type: "feature",
        text: "Списък изглед — селектираният ред става бял с 3px кехлибарена лента отляво (same pattern като active елементите в sidebar-а)",
      },
      {
        type: "feature",
        text: "Списък изглед — при преименувана маса в колона 'Маса' се показва '#старо » ново'; колоната 'Време' показва реалното изминало време и изчезва когато цялата поръчка е приключена",
      },
      {
        type: "improvement",
        text: "Монитори — Grid и List изгледите са изнесени в отделни компоненти (MonitorsGridView и MonitorsListView) за по-лесна поддръжка",
      },
      {
        type: "feature",
        text: "Монитори — навигация с клавишни стрелки през продуктите: ↑/↓ местят с 1, Shift+↑/↓ местят с 2; добавени бутони в долната лента с визуални shortcut подсказки",
      },
      {
        type: "improvement",
        text: "Монитори — увеличени визуални подсказки за shortcut-ите (+ / −) в долната лента",
      },
      {
        type: "fix",
        text: "Монитори (Списък) — селектираният ред вече не застъпва залепения header; автоматичният scrollIntoView вече не го оставя частично скрит под header-а",
      },
      {
        type: "feature",
        text: "Монитори — при клик върху страницата (независимо от изгледа) автоматично се активира fullscreen режим преди първото взаимодействие",
      },
      {
        type: "feature",
        text: "Маркиране — при клик върху страницата на десктоп автоматично се активира fullscreen режим преди първото взаимодействие",
      },
      {
        type: "improvement",
        text: "Маркиране — в модала 'Нова маса' проверката дали име на маса вече съществува се прави само при натискане на OK, а не при всяко въведено символче",
      },
    ],
  },
  {
    version: "0.0.76",
    date: "2026-04-24",
    entries: [
      {
        type: "feature",
        text: "Маркиране — търсачка на масите по име, сума и име на сервитьор (без нужда от клик в полето)",
      },
      {
        type: "feature",
        text: "Маркиране — масите вече могат да се преименуват със свободно име",
      },
      {
        type: "feature",
        text: "Маркиране — ново действие 'Смяна на маса' в меню Опции",
      },
      {
        type: "feature",
        text: "Маркиране — ново действие 'Прехвърляне на друг сервитьор' в долното меню с избор на сервитьор в отделен модал",
      },
      {
        type: "feature",
        text: "Маркиране — при Раздели, след избора на целева маса се отваря модал за избор на сервитьор; ако са прехвърлени всички продукти, оригиналната сметка остава с 0 и може да бъде прехвърлена",
      },
      {
        type: "feature",
        text: "Маркиране — нов бутон 'Раздели и плати' в долното меню на Раздели: отваря модал за избор на метод на плащане",
      },
      {
        type: "feature",
        text: "Маркиране — заключена (фиксирана) цена в долната лента на ниво меню",
      },
      {
        type: "feature",
        text: "Потребители — ново право 'Деление на сметка и прехвърляне към нова сметка на друг оператор'",
      },
      {
        type: "improvement",
        text: "Маркиране — стрелката 'назад' в горната лента се показва само ако потребителят има повече от една роля",
      },
      {
        type: "improvement",
        text: "Маркиране — нов empty state дизайн при списъка с маси и при поръчаните продукти",
      },
      {
        type: "improvement",
        text: "Маркиране — клавиатурната търсачка вече изкарва потребителя от избраната категория, когато започне ново търсене",
      },
      {
        type: "improvement",
        text: "Маркиране — при отговор 'Не' на диалога за затваряне на сметка, при повторен опит потребителят отново получава потвърждение 'Сигурни ли сте, че искате да закриете сметката?'",
      },
      {
        type: "improvement",
        text: "Маркиране — disabled бутоните в долното меню вече са визуално с намалена opacity, за да е ясно че не са активни",
      },
      {
        type: "improvement",
        text: "Операции (Служебно въвеждане/извеждане) — текстът в input полето е центриран вертикално, стойността не се инкрементира с 0.01 при стрелки, въвеждат се само числа и запетаята автоматично става точка",
      },
      {
        type: "improvement",
        text: "Справки — подобрено визуалното представяне на сумата при Генериране на Персонален отчет",
      },
      {
        type: "improvement",
        text: "Всички модули — горните ленти (NavBar) са уеднаквени с идентично лого и стил 'CloudT...'",
      },
      {
        type: "fix",
        text: "Маркиране — клавиатурната търсачка вече не се зачиства автоматично, ако продуктът отваря модал за добавки",
      },
      {
        type: "fix",
        text: "Маркиране — отворените модали (Закрий, Сторно, Раздели, Клиенти, Отстъпки, Отчет, Операции, Възстановяване) вече не пренасочват натисканите клавиши към търсачката на масите",
      },
      {
        type: "fix",
        text: "Маркиране — shortcut-ите в долното меню вече не работят, ако потребителят няма съответните права",
      },
      {
        type: "fix",
        text: "Маркиране — закритите маси с проблем при фискализирането се показват с плътен бордър вместо пунктиран, за да са визуално по-различими",
      },
      {
        type: "fix",
        text: "Справки — при Персонален отчет с права за достъп (втори код) всички включени сметки изчезват от списъка с маси веднага, без да е нужен ръчен рефреш (преди това оставаха сметките с total === 0)",
      },
      {
        type: "fix",
        text: "Маркиране — POS принтерът вече не е задължителен и липсата му не хвърля грешка",
      },
    ],
  },
  {
    version: "0.0.75",
    date: "2026-04-22",
    entries: [
      {
        type: "feature",
        text: "Всички модули — единен профилен панел при клик върху аватара: карта с инициали, име и потребителско име, бутон 'Изход' / 'Отказване на достъп'",
      },
      {
        type: "feature",
        text: "Всички модули — добавена иконка за цял екран в горната лента на Маркиране, Справки, Конфигурация и История на промените",
      },
      {
        type: "feature",
        text: "Всички модули — стрелка за връщане към модулите в горната лента",
      },
      {
        type: "improvement",
        text: "Преглед на поръчката — нов плътен дизайн на редовете, както в отворените сметки: име и контролите за брой на един ред, добавки под него, модификатор вляво и тотал вдясно най-долу",
      },
      {
        type: "improvement",
        text: "Отворени сметки — на телефонни екрани редът на продукта е по-стегнат: име и статус на един ред, количество × цена в края, модификатор вляво и тотал вдясно най-долу",
      },
      {
        type: "improvement",
        text: "Отворени сметки — отстъпката вече се прилага и върху добавките; преди тотала се показва старата сума задраскана с процента, а новата крайна цена — в черно",
      },
      {
        type: "improvement",
        text: "Долни менюта — на телефонни екрани вторичните бутони (Назад, Коментар, Инфо, Редактирай, Нова маса, Затвори, Опции) остават само с текст без икона, за да се събират всички действия по ширина",
      },
      {
        type: "improvement",
        text: "История на промените — версията е преместена под заглавието в горната лента и е премахната водещата точка",
      },
    ],
  },
  {
    version: "0.0.74",
    date: "2026-04-22",
    entries: [
      {
        type: "improvement",
        text: "Цялостна промяна на визуалния език — 'Bento light-warm': топъл paper фон, amber акцент, bento карти с 1px граници вместо сенки, единна типография (Plus Jakarta Sans + JetBrains Mono за числа) във всички модули",
      },
      {
        type: "improvement",
        text: "Вход — преработен в Bento стил: hero панел отляво с бранд, функции и amber декорация; бяла bento карта с формата отдясно без синия фокус на Ant Design",
      },
      {
        type: "improvement",
        text: "История на промените — нов Bento дизайн: горна лента със стрелка за връщане, amber chip с текущата версия, легенда с цветни индикатори по тип промяна и карти за всяка версия с amber radial-gradient за най-новата",
      },
      {
        type: "improvement",
        text: "Справки — обновен Дашборд в Bento стил: KPI карти за отворени маси, затворени днес, split по брой/карта, линейна графика за оборот по дни с tooltip и среден пунктир, вертикална графика за статус на масите",
      },
      {
        type: "improvement",
        text: "Справки — преработен sidebar в топло бежово с левия amber rail за активна секция и компактен рипл при hover",
      },
      {
        type: "improvement",
        text: "Справки — опростен и унифициран date picker: presets (Вчера / Днес / 7 дни / Този месец) + stepper с inline RangePicker, винаги центриран над списъка без обвиваща карта",
      },
      {
        type: "improvement",
        text: "Справки (История на сметки) — inline филтри в header-а на таблицата, bento KPI (общо сметки, среден чек, payment split), activity chart с bucket по час или ден според избрания период",
      },
      {
        type: "improvement",
        text: "Справки — преработен модал за детайл на сметка: icon chip + статус pill в header, бежова scroll зона с под-карти за всяка поръчка, inline footer с Orders · Products · Cancelled",
      },
      {
        type: "improvement",
        text: "Справки — всички справки (Анулирания, Разделени сметки, Асортимент, Отстъпки, Сервитьори, Обекти, Станции, Лични) преработени към bento layout с единни KPI редове, филтри и таблици",
      },
      {
        type: "improvement",
        text: "Справки (Сервитьори) — преработен detail модал с per-day bento карти вместо единна таблица",
      },
      {
        type: "improvement",
        text: "Конфигурация — преработени страниците Устройства, Монитори и Non-fiscal display в Bento стил с единна горна лента, bento таблици и модали",
      },
      {
        type: "improvement",
        text: "Маркиране — нов светъл/топъл дизайн на горната лента, списъците с маси/сметки, детайла на поръчката и категориите с продукти; единни bento карти и пропорции",
      },
      {
        type: "improvement",
        text: "Маркиране — преработени всички модали (Анулиране, Разделяне, Клиенти, Отстъпки, Възстановяване, Затваряне на маса) с единна рамка, icon chip, заглавие и подзаглавие, бели ghost/amber бутони и консистентно поведение на телефон/таблет/десктоп",
      },
      {
        type: "improvement",
        text: "Маркиране — обновени долното меню и статус индикаторите: компактни бутони с shortcut на голям екран, adaptive ширини и icon-only за икономия на място",
      },
      {
        type: "improvement",
        text: "Маркиране — намален контраст на белия фон в таблиците с маси/сметки и продукти — по-меко четене върху warm paper bg",
      },
      {
        type: "improvement",
        text: "Адаптивност — всички нови екрани се огъват правилно на телефон/таблет/десктоп по единна breakpoint стълбица (isMobile <480, isNarrow <640, isTablet/isDesktop/isWide)",
      },
    ],
  },
  {
    version: "0.0.73",
    date: "2026-04-16",
    entries: [
      {
        type: "improvement",
        text: "Възстановяване на сметка — скриват се изцяло сторнираните сметки (без активни продукти) от списъка",
      },
      {
        type: "feature",
        text: "Възстановяване на сметка — добавени клавишни shortcut-и на големи екрани: Esc за отказ и Enter за потвърждение",
      },
      {
        type: "improvement",
        text: "Справки (История на маси) — при изцяло сторнирана маса в колоната 'Сума' се показва оригиналната сума задраскана, последвана от 0.00 за яснота",
      },
      {
        type: "improvement",
        text: "Възстановяване на сметка — подобрена обработка на fiscal резултата (success / timeout / error) и по-ясни съобщения при грешки от сървъра",
      },
    ],
  },
  {
    version: "0.0.72",
    date: "2026-04-16",
    entries: [
      {
        type: "feature",
        text: "Маркиране — добавен нов бутон 'Възстановяване' в долното меню (с право restore_last_bill), който отваря модал със списък на затворени сметки за последните 30 / 60 / 120 минути и позволява връщането им в неплатено състояние",
      },
      {
        type: "feature",
        text: "Справки — в детайлите на сметка вече има бутон 'Възстановяване' до 'Анулиране', който връща закрита сметка обратно като неплатена",
      },
      {
        type: "feature",
        text: "Конфигурация — в монитори е добавена опция 'Групирани количества' (checkbox при създаване и редакция), която показва общия брой за готвене на всеки продукт от всички поръчки",
      },
      {
        type: "improvement",
        text: "Конфигурация — преработени модалите за редакция на устройства и монитори с по-чист дизайн, последователни размери на полетата и бутоните",
      },
      {
        type: "improvement",
        text: "Конфигурация — типовете устройства (фискален принтер, POS терминал, терминал за плащане) вече са с превод на български и английски в таблицата и във всички select-и",
      },
      {
        type: "improvement",
        text: "Конфигурация — филтърът по тип устройство е преместен директно в колоната на таблицата с custom dropdown",
      },
      {
        type: "improvement",
        text: "Конфигурация — при добавяне на монитор се показват само потребители без вече закачена конфигурация",
      },
      {
        type: "fix",
        text: "Анулиране — преводът 'Сторниране' е променен на 'Анулиране' за по-ясно разграничаване от сторниране на отделен продукт",
      },
    ],
  },
  {
    version: "0.0.71",
    date: "2026-04-14",
    entries: [
      {
        type: "feature",
        text: "Справки — добавено ново Табло (Dashboard) с обобщена информация за заведението: отворени маси, затворени сметки, разбивка по плащания и дневни обороти",
      },
      {
        type: "fix",
        text: "Поръчки — оправен проблем в списъка с масите",
      },
      {
        type: "fix",
        text: "Маркиране — оправен проблем със скрола в списъка с масите",
      },
      {
        type: "improvement",
        text: "Маркиране — автоматичният скрол работи само при навигация с клавиатура",
      },
      {
        type: "feature",
        text: "Конфигурация — една работна точка вече може да има 2 устройства",
      },
    ],
  },
  {
    version: "0.0.69",
    date: "2026-04-09",
    entries: [
      {
        type: "feature",
        text: "Справки — добавена нова справка 'Справка по Сервитьори'",
      },
      {
        type: "feature",
        text: "Справки — добавена нова справка 'Справка по Обекти'",
      },
      {
        type: "fix",
        text: "Маркиране — оправен проблем при default-но селектиране на сметка след рефреш",
      },
      {
        type: "improvement",
        text: "Отчети — изцяло нов UI на страниците с отчети",
      },
      {
        type: "feature",
        text: "Отчети — добавен нов компонент с потвърждение за нулиране на дневен финансов отчет",
      },
      {
        type: "feature",
        text: "Права за достъп — добавено ново право за достъп до операциите",
      },
      {
        type: "feature",
        text: "Права за достъп — добавени нови права за отчетите на заведението",
      },
      {
        type: "feature",
        text: "Права за достъп — добавени нови права за персоналните отчети",
      },
    ],
  },
  {
    version: "0.0.68",
    date: "2026-04-08",
    entries: [
      {
        type: "improvement",
        text: 'Маркиране — бутонът "Закрий" е disabled и показва loading състояние докато заявката за затваряне на маса е в процес на изпълнение',
      },
      {
        type: "improvement",
        text: "Маркиране — незакритите маси се показват най-отгоре в списъка с маси за по-лесен достъп",
      },
    ],
  },
  {
    version: "0.0.64",
    date: "2026-04-07",
    entries: [
      {
        type: "feature",
        text: "Сметки — добавени 4 нови полета: сериен номер, фискална памет, терминал ID и номер на бон",
      },
      {
        type: "breaking",
        text: 'Устройства — преименуване на цялата структура от "Фискални принтери" на "Устройства" (таблици, ендпойнти и UI)',
      },
      {
        type: "feature",
        text: 'Устройства — добавена нова колона "Тип устройство" с предефинирани стойности (enum)',
      },
      {
        type: "feature",
        text: "Устройства — нов ендпойнт за извличане на типовете устройства и нови ендпойнти за работа с устройства",
      },
      {
        type: "improvement",
        text: "Конфигурация / Устройства — обновен UI на страницата с устройства",
      },
      {
        type: "feature",
        text: "Конфигурация / Устройства — добавени сортиране, търсене и филтри за по-лесно управление",
      },
      {
        type: "improvement",
        text: "Мрежови заявки — намален timeout от 45 на 10 секунди за по-бърза обратна връзка при проблеми с връзката",
      },
      {
        type: "feature",
        text: "Устройства — добавени 2 нови ендпойнта за служебен внос (Cash In) и служебен разход (Cash Out)",
      },
    ],
  },
  {
    version: "0.0.63",
    date: "2026-04-03",
    entries: [
      {
        type: "fix",
        text: "Монитор — оправен проблем с отброяването на времето под името на сервитьора при работа в различни часови зони",
      },
      {
        type: "fix",
        text: "Монитор — оправен проблем с 23:59, причинен от разминаване между секундите от backend-а и показването само на часове и минути",
      },
      {
        type: "fix",
        text: "Монитор — оправен проблем, при който сторниран единствен продукт оставаше видим в монитора и не можеше да бъде скрит",
      },
      {
        type: "fix",
        text: "Маркиране — оправен проблем, при който артикул с добавка с цена не се калкулираше в сметката след запис (оставаше 0.00)",
      },
      {
        type: "improvement",
        text: "Маркиране — при маркиране на асортимент с препоръчителна добавка вече се отваря модал, но изборът не е задължителен",
      },
      {
        type: "improvement",
        text: 'Справка Сторно — колоната "Сервитьор" е преименувана на "Потребител" (може да е сторнирано от сервитьор, управител, админ и др.)',
      },
      {
        type: "feature",
        text: "Справка Сторно — при клик на ред се отваря модал с визуализация на сметката, както е в История на масата",
      },
      {
        type: "improvement",
        text: "Справка История на маса — ако е избран клиент (напр. Иван Иванов), той се визуализира при прегледа на масата/сметката",
      },
      {
        type: "feature",
        text: "Справка Отстъпки — при клик на ред се отваря модал с информация за сметката/масата, както е в История на масата",
      },
      {
        type: "improvement",
        text: "Справка История на маса — модификаторите вече се виждат в прегледа на масата/сметката",
      },
      {
        type: "improvement",
        text: "Персонален отчет — не може да се избира бъдеща дата, по подразбиране показва датата на първата поръчка",
      },
      {
        type: "improvement",
        text: "Отчет Заведение — не може да се избира бъдеща дата, по подразбиране показва датата на първата поръчка",
      },
      {
        type: "improvement",
        text: 'Отчет Заведение — секцията "Разбивка по потребители" е преместена под "Обороти по видове плащания"',
      },
      {
        type: "feature",
        text: "Нефинализирани маси — добавен нов endpoint и бутон за повторен опит за финализиране на маса",
      },
      {
        type: "improvement",
        text: "Нефинализирани маси — по подразбиране винаги показва НЕ в конфигурацията",
      },
      {
        type: "fix",
        text: "Поръчки — оправен проблем с губене на фокус след създаване на нова маса, фокусът вече остава на създадената маса",
      },
      {
        type: "improvement",
        text: "Преработка на нотификациите — за консистентност навсякъде използваме message.success вместо notifications",
      },
      {
        type: "improvement",
        text: "Нова маса — валидацията за съществуваща маса вече проверява на глобално ниво, не само масите на текущия потребител",
      },
      {
        type: "improvement",
        text: "Добавки — вече се появяват и ако са закачени към категории, и ако са закачени към продукти",
      },
      {
        type: "improvement",
        text: "Справки — оптимизиран модал с детайли за поръчката за по-добра производителност",
      },
      {
        type: "feature",
        text: "Progressive Web App — приложението вече може да се инсталира като PWA на мобилни устройства и desktop",
      },
      {
        type: "fix",
        text: "Модал за закриване на сметка — оправен проблем, при който контейнерът се свиваше при многократно кликане",
      },
      {
        type: "improvement",
        text: 'Терминология — променена думата "нефинализирани" в конфигурацията за по-добра яснота',
      },
    ],
  },
  {
    version: "0.0.60",
    date: "2026-04-03",
    entries: [
      {
        type: "feature",
        text: "Подобрена функционалност по закриване на сметки... (и още...)",
      },
    ],
  },
  {
    version: "0.0.58",
    date: "2026-03-18",
    entries: [
      {
        type: "feature",
        text: 'Права за достъп — коригирана обработка на опцията "all" за ресторанти, роли и права, така че системата да ги чете и проверява коректно',
      },
    ],
  },
  {
    version: "0.0.57",
    date: "2026-03-18",
    entries: [
      {
        type: "fix",
        text: "Персонален отчет / Отчет на заведението — в заглавието вече се показва името на потребителя, а не потребителското име (username)",
      },
      {
        type: "improvement",
        text: "Страничното меню (sidebar) е винаги разгънато по подразбиране във всички модули",
      },
      {
        type: "feature",
        text: 'Справка Разделени маси — добавена колона "Сервитьор"',
      },
      {
        type: "feature",
        text: 'Справка Сторно — добавена колона "Сервитьор" и информация кой е извършил сторнирането',
      },
      {
        type: "improvement",
        text: "Справки — всички филтри вече поддържат множествен избор (multiple select), напр. Категория и Станция в Справка по асортименти",
      },
      {
        type: "fix",
        text: 'Модал "Отстъпка на ред" — добавена валидация: полето приема само числа от 0 до 100',
      },
      {
        type: "feature",
        text: "Справка по маси — добавено показване на отстъпка, ако има приложена такава",
      },
      {
        type: "feature",
        text: 'Справки — добавена нова справка "Отстъпки"',
      },
    ],
  },
  {
    version: "0.0.56",
    date: "2026-03-18",
    entries: [
      {
        type: "improvement",
        text: "Архитектура — целият проект е мигриран към React Query за използване на кеширащи механизми и по-ефективно управление на сървърното състояние",
      },
      {
        type: "improvement",
        text: "Модул Поръчки — всички бутони във footer-а са деактивирани, ако няма отворени маси",
      },
      {
        type: "fix",
        text: "Монитори — оправен проблем при показването на сторнираните продукти",
      },
      {
        type: "fix",
        text: "Модал Разделяне на сметка — оправен проблем, при който не се виждаха имената на продуктите",
      },
      {
        type: "improvement",
        text: "Монитори — оптимизация на WebSocket връзките за намаляване на броя заявки към базата данни",
      },
      {
        type: "improvement",
        text: "Монитори — оптимизиран навигационен бар за по-добро изживяване на малки екрани",
      },
      {
        type: "fix",
        text: "Модал Сторниране — полето за количество вече е зададено на 1 по подразбиране вместо на максималното количество",
      },
      {
        type: "improvement",
        text: "Модал за Справки — изцяло нов дизайн за по-добра четимост и визуална йерархия",
      },
      {
        type: "feature",
        text: "Модал за Справки — добавени клавишни комбинации (shortcuts) и подсказки (hints) в бутоните за по-бърза работа",
      },
    ],
  },
  {
    version: "0.0.55",
    date: "2026-03-17",
    entries: [
      {
        type: "improvement",
        text: "Навигация — обновено лого в главния Navbar за по-добра визуална идентичност",
      },
      {
        type: "improvement",
        text: "Поръчки — списъкът с маси се опреснява автоматично при избор на друга маса, за да отразява актуалното състояние на сметките",
      },
      {
        type: "improvement",
        text: "Конфигурация — sidebar-ът е отворен по подразбиране и е отстранен бъг, при който двe менюта се маркираха като активни едновременно при навигация назад",
      },
    ],
  },
  {
    version: "0.0.54",
    date: "2026-03-13",
    entries: [
      {
        type: "improvement",
        text: "Начална страница (Модули) — обновен дизайн с персонализиран поздрав, по-описателни заглавия на модулите и подобрена визуална йерархия",
      },
      {
        type: "improvement",
        text: "Всички модали в приложението — уеднаквен визуален стил: закръглени ъгли (28px), размазан фон (blur), сянка и консистентни бутони с еднаква височина и оформление",
      },
    ],
  },
  {
    version: "0.0.53",
    date: "2026-03-10",
    entries: [
      {
        type: "improvement",
        text: "Справки — премахнати бутони 'Приложи' и 'Изчисти' от всички справки, филтрите се прилагат автоматично при промяна",
      },
      {
        type: "improvement",
        text: "Справки — само смяната на датите прави нова заявка към сървъра в История на маси, Разделени маси, Справка за сторнирани продукти и Персонални отчети, останалите справки изпращат всички филтри към backend-а",
      },
      {
        type: "improvement",
        text: "Разделени маси / Справка за сторнирани продукти — добавен debounce (500ms) за текстовите полета, за да не се изпращат излишни заявки при бързо писане",
      },
      {
        type: "feature",
        text: "Справки — добавена нова страница 'Справка по асортименти' с филтриране по категория и станция (локално) и по дата (заявка към сървъра)",
      },
      {
        type: "improvement",
        text: "Персонални отчети / Отчети на заведението — уеднаквен дизайн с останалите справки: заглавие, бутон 'Обнови', секция 'Филтри' с иконка",
      },
      {
        type: "improvement",
        text: "Справки — разширен sidebar за по-добра четимост на имената на справките",
      },
    ],
  },
  {
    version: "0.0.52",
    date: "2026-03-09",
    entries: [
      {
        type: "improvement",
        text: "Поръчани продукти — подобрен UI на поръчаните продукти: по-добра четимост, отстояния и цветова йерархия",
      },
      {
        type: "feature",
        text: "Поръчани продукти — добавена функционалност за смяна на статус от 'Сготвено' на 'Сервирано' с мигновено опресняване и записване в базата",
      },
      {
        type: "fix",
        text: "Монитори — оправен бъг, при който сервираните продукти се виждаха в активните поръчки на станцията",
      },
    ],
  },
  {
    version: "0.0.51",
    date: "2026-03-09",
    entries: [
      {
        type: "improvement",
        text: "Модал за отстъпка на ред — добавени shortcut-и (Enter/Esc) и autofocus на input полето при отваряне на голям екран",
      },
      { type: "improvement", text: "Модал за отстъпка на ред — подобрен UI" },
      {
        type: "improvement",
        text: "Модалза Сторниране  — добавени shortcut-и (Enter за потвърждение, Esc за затваряне)",
      },
      {
        type: "improvement",
        text: "Модалa Разделяне — добавени shortcut-и (Enter за потвърждение, Esc за затваряне)",
      },
      {
        type: "breaking",
        text: "Нова маса — бутонът за потвърждение вече използва иконка ⏎ вместо Enter shortcut hint",
      },
      {
        type: "improvement",
        text: "Модал за избор на клиент — добавени shortcut-и: първи Esc изчиства search полето, втори Esc затваря модала; Enter потвърждава избора",
      },
      {
        type: "improvement",
        text: "Модал за избор на клиент — подобрен UI, голям input консистентен с останалите бутони в модала",
      },
      {
        type: "feature",
        text: 'Права за достъп — добавена е проверка дали имаме достъп до операция: "Задаване на процент за ред или цялата сметка"',
      },
      {
        type: "feature",
        text: 'Права за достъп — добавена е проверка дали имаме достъп до операция: "Избор на клиент от списък"',
      },
      {
        type: "feature",
        text: "Changelog — нова страница за следене на промените по версии на системата",
      },
    ],
  },
];
